export const battery0 = [
  '50 40',
  `
  <defs
     id="defs32" />
  
  <g
     transform="matrix(0.10893852,0,0,0.10893852,-10.056627,-474.27267)"
     id="pathtppath"
     style="clip-rule:evenodd;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision">
    <path
       id="bat-border"
       style="clip-rule:evenodd;fill:inherit;fill-rule:nonzero;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       d="m 350.80194,4398.1707 v -20 h -59 v 20 h -45 c -1,0 -3,0 -4,1 -1,1 -1,2 -1,4 v 290.0001 c 0,1 0,3 1,4 1,1 2,1 4,1 h 148 c 1,0 3,0 4,-1 1,-1 1,-2 1,-4 v -290.0001 c 0,-1 0,-3 -1,-4 -1,-1 -2,-1 -4,-1 h -45 z m -59,-40 h 59 c 5,0 10,2 14,6 4,4 6,9 6,14 h 25 c 7,0 13,2 17,7 5,5 7,11 7,17 v 290.0001 c 0,7 -2,13 -7,17 -5,5 -11,7 -17,7 h -148 c -7,0 -13,-2 -17,-7 -5,-5 -7,-11 -7,-17 v -290.0001 c 0,-7 2,-13 7,-17 5,-5 11,-7 17,-7 h 25 c 0,-5 2,-10 6,-14 4,-4 9,-6 14,-6 z" />
  </g>
  `
]
export const battery100 = [
  '50 40',
  `
  <defs
     id="defs32" />
  
  <g
     transform="matrix(0.10964656,0,0,0.10964656,-10.284476,-477.48516)"
     id="g8">
    <path
       d="m 350.80194,4398.1707 v -20 h -59 v 20 h -45 c -1,0 -3,0 -4,1 -1,1 -1,2 -1,4 v 290.0001 c 0,1 0,3 1,4 1,1 2,1 4,1 h 148 c 1,0 3,0 4,-1 1,-1 1,-2 1,-4 v -290.0001 c 0,-1 0,-3 -1,-4 -1,-1 -2,-1 -4,-1 h -45 z m -59,-40 h 59 c 5,0 10,2 14,6 4,4 6,9 6,14 h 25 c 7,0 13,2 17,7 5,5 7,11 7,17 v 290.0001 c 0,7 -2,13 -7,17 -5,5 -11,7 -17,7 h -148 c -7,0 -13,-2 -17,-7 -5,-5 -7,-11 -7,-17 v -290.0001 c 0,-7 2,-13 7,-17 5,-5 11,-7 17,-7 h 25 c 0,-5 2,-10 6,-14 4,-4 9,-6 14,-6 z"
       style="clip-rule:evenodd;fill:inherit;fill-rule:nonzero;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       id="bat-border" />
    <path
       class="e-board-svg-bat-level-100"
       d="m 261.80274,4474.1698 h 118.9996 v 36.0006 h -119 z m 0,112.0004 h 118.9996 v 36.0006 h -119 z m -5e-4,56.0005 h 119 l -2e-4,36.0001 h -119 z m 1e-4,-112.0009 h 118.9996 v 36.0006 h -119 z m 0,-112.0004 h 118.9996 v 36.0006 h -119 z"
       style="clip-rule:evenodd;fill:inherit;fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-opacity:1;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       id="bat-level-100" />
  </g>
  `
]
export const battery20 = [
  '50 40',
  `
  <defs
     id="defs32" />
  
  <g
     transform="matrix(0.10893852,0,0,0.10893852,-46.15196,-474.11776)"
     id="g20">
    <path
       d="m 682.13867,4396.7487 v -20 h -59 v 20 h -45 c -1,0 -3,0 -4,1 -1,1 -1,2 -1,4 v 290.0001 c 0,1 0,3 1,4 1,1 2,1 4,1 h 148 c 1,0 3,0 4,-1 1,-1 1,-2 1,-4 v -290.0001 c 0,-1 0,-3 -1,-4 -1,-1 -2,-1 -4,-1 h -45 z m -59,-40 h 59 c 5,0 10,2 14,6 4,4 6,9 6,14 h 25 c 7,0 13,2 17,7 5,5 7,11 7,17 v 290.0001 c 0,7 -2,13 -7,17 -5,5 -11,7 -17,7 h -148 c -7,0 -13,-2 -17,-7 -5,-5 -7,-11 -7,-17 v -290.0001 c 0,-7 2,-13 7,-17 5,-5 11,-7 17,-7 h 25 c 0,-5 2,-10 6,-14 4,-4 9,-6 14,-6 z"
       style="clip-rule:evenodd;fill:inherit;fill-rule:nonzero;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       id="bat-border" />
    <path
       id="bat-level-20"
       class="e-board-svg-bat-level-20"
       d="m 593.13867,4640.7483 h 119 v 36.0005 h -119 z"
       style="clip-rule:evenodd;fill: inherit;fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-opacity:1;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision" />
  </g>
  `
]
export const battery40 = [
  '50 40',
  `
  <defs
     id="defs32" />
  
  <g
     id="g12"
     transform="matrix(0.10893852,0,0,0.10893852,-72.487611,-474.73742)">
    <path
       d="m 923.8865,4402.4369 v -20 h -59 v 20 h -45 c -1,0 -3,0 -4,1 -1,1 -1,2 -1,4 v 290.0001 c 0,1 0,3 1,4 1,1 2,1 4,1 h 148 c 1,0 3,0 4,-1 1,-1 1,-2 1,-4 v -290.0001 c 0,-1 0,-3 -1,-4 -1,-1 -2,-1 -4,-1 h -45 z m -59,-40 h 59 c 5,0 10,2 14,6 4,4 6,9 6,14 h 25 c 7,0 13,2 17,7 5,5 7,11 7,17 v 290.0001 c 0,7 -2,13 -7,17 -5,5 -11,7 -17,7 h -148 c -7,0 -13,-2 -17,-7 -5,-5 -7,-11 -7,-17 v -290.0001 c 0,-7 2,-13 7,-17 5,-5 11,-7 17,-7 h 25 c 0,-5 2,-10 6,-14 4,-4 9,-6 14,-6 z"
       style="clip-rule:evenodd;fill:inherit;fill-rule:nonzero;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       id="bat-border" />
    <path
       class="e-board-svg-bat-level-40"
       style="clip-rule:evenodd;fill:inherit;fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-opacity:1;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       d="m 834.8871,4590.4366 h 118.9996 v 36.0005 h -119 z m -3e-4,56.0003 h 119 l -2e-4,36.0001 h -119 z"
       id="bat-level-40" />
  </g>
  `
]
export const battery60 = [
  '50 40',
  `
  <defs
     id="defs32" />
  
  <g
     transform="matrix(0.10893852,0,0,0.10893852,-45.532298,-431.98072)"
     id="g16">
    <path
       d="m 676.45049,4009.9522 v -20 h -59 v 20 h -45 c -1,0 -3,0 -4,1 -1,1 -1,2 -1,4 v 290.0001 c 0,1 0,3 1,4 1,1 2,1 4,1 h 148 c 1,0 3,0 4,-1 1,-1 1,-2 1,-4 v -290.0001 c 0,-1 0,-3 -1,-4 -1,-1 -2,-1 -4,-1 h -45 z m -59,-40 h 59 c 5,0 10,2 14,6 4,4 6,9 6,14 h 25 c 7,0 13,2 17,7 5,5 7,11 7,17 v 290.0001 c 0,7 -2,13 -7,17 -5,5 -11,7 -17,7 h -148 c -7,0 -13,-2 -17,-7 -5,-5 -7,-11 -7,-17 v -290.0001 c 0,-7 2,-13 7,-17 5,-5 11,-7 17,-7 h 25 c 0,-5 2,-10 6,-14 4,-4 9,-6 14,-6 z"
       style="clip-rule:evenodd;fill:inherit;fill-rule:nonzero;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       id="bat-border" />
    <path
       class="e-board-svg-bat-level-60"
       style="clip-rule:evenodd;fill:inherit;fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-width:1;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       d="m 587.45129,4197.9517 h 118.9996 v 36.0006 h -119 z m -5e-4,56.0005 h 119 l -2e-4,36.0001 h -119 z m 5e-4,-112.0005 h 118.9996 v 36.0006 h -119 z"
       id="bat-level-60" />
  </g>
  `
]
export const battery80 = [
  '50 40',
  `
  <defs
     id="defs32" />
  
  <g
     transform="matrix(0.10682223,0,0,0.10682223,-8.7679757,-420.92174)"
     id="g4">
    <path
       d="m 286.11375,3948.6215 h 59 c 5,0 10,2 14,6 4,4 6,9 6,14 h 25 c 7,0 13,2 17,7 5,5 7,11 7,17 v 290.0001 c 0,7 -2,13 -7,17 -5,5 -11,7 -17,7 h -148 c -7,0 -13,-2 -17,-7 -5,-5 -7,-11 -7,-17 v -290.0001 c 0,-7 2,-13 7,-17 5,-5 11,-7 17,-7 h 25 c 0,-5 2,-10 6,-14 4,-4 9,-6 14,-6 z m 59,40 v -20 h -59 v 20 h -45 c -1,0 -3,0 -4,1 -1,1 -1,2 -1,4 v 290.0001 c 0,1 0,3 1,4 1,1 2,1 4,1 h 148 c 1,0 3,0 4,-1 1,-1 1,-2 1,-4 v -290.0001 c 0,-1 0,-3 -1,-4 -1,-1 -2,-1 -4,-1 h -45 z"
       style="clip-rule:evenodd;fill:inherit;fill-rule:nonzero;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       id="bat-border" />
    <path
       class="e-board-svg-bat-level-80"
       d="m 256.11455,4120.6206 h 118.9996 v 36.0006 h -119 z m -5e-4,112.0009 h 119 l -2e-4,36.0001 h -119 z m 5e-4,-56.0005 h 118.9996 v 36.0006 h -119 z m 0,-112.0004 h 118.9996 v 36.0006 h -119 z"
       style="clip-rule:evenodd;fill:inherit;fill-opacity:1;fill-rule:nonzero;stroke:#000000;stroke-opacity:1;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       id="bat-level-80" />
  </g>
  `
]
export const chp = [
  '50 40',
  `
  <defs
     id="defs21182" />
  
   <g
     id="g4094"
     transform="matrix(0.94222653,0,0,0.94222653,1.6891763,3.2907803)">
    <path
       style="stroke-miterlimit: 10; stroke-width: .5px;"
       d="m 27.61768,35.21749 c -0.57617,0 -1.20605,-0.0068 -1.9043,-0.02051 -2.12793,-0.04395 -3.646,-0.12695 -4.6416,-0.25293 -1.18359,-0.15137 -1.8999,-0.3877 -2.47266,-0.81543 C 18.22656,33.85225 17.95068,33.52608 17.56933,33.07589 17.43017,32.91085 17.27392,32.72726 17.08984,32.5173 16.72851,32.10714 16.2583,31.59933 15.78808,31.09152 15.37841,30.64914 14.96874,30.20675 14.63037,29.82785 L 14.28271,29.43723 C 13.7871,28.87668 13.45996,28.50657 13.08154,28.29563 12.67822,28.072 12.13183,27.98313 11.60351,27.89719 l -0.2373,-0.04004 C 10.64844,27.73508 10.03369,27.58567 9.36719,27.25266 8.63281,26.88352 7.91407,26.3386 7.39405,25.75657 6.80274,25.09446 6.45948,24.37278 6.22706,23.81809 5.90919,23.05735 5.7256,22.42063 5.63136,21.75266 5.52687,21.01828 5.52687,20.2009 5.52687,19.71262 c 0,-0.3291 0,-0.54199 -0.03174,-0.5957 C 5.47267,19.07883 5.38575,18.99192 5.22511,18.94407 5.06593,18.89622 4.85304,18.89622 4.67042,18.94114 4.5713,18.96751 4.4961,18.98704 4.41261,19.31126 4.28224,19.81614 4.23585,20.81028 4.20216,21.70286 4.16359,22.68235 4.13429,23.80247 4.10987,24.73509 L 4.10303,24.98997 C 4.07422,26.09446 4.05664,26.78099 3.91407,27.16575 3.79151,27.50071 3.57423,27.62376 3.41358,27.66673 3.01172,27.77708 2.65333,27.48216 2.48145,27.33958 2.0127,26.95579 1.54883,26.35228 1.33448,24.55638 1.20704,23.5056 1.1626,22.0388 1.11915,20.62083 1.09083,19.67747 1.06349,18.78392 1.01319,18.12278 0.90284,16.68919 0.69239,16.5012 0.62305,16.43919 0.28223,16.1345 0.25,15.87669 0.25,14.80833 0.25,13.74778 0.30225,11.59983 0.49854,10.27659 0.68116,9.05979 1.00147,8.35032 1.56983,7.90305 2.0171,7.54709 2.48829,7.44309 2.84815,7.39182 3.11573,7.35178 3.67237,7.27317 4.0171,7.85178 4.24366,8.23215 4.34571,8.87912 4.38087,10.1594 4.40724,11.13889 4.3921,12.55393 4.37989,13.69065 L 4.3711,14.60911 c -0.00684,0.89209 4.9e-4,1.4043 0.05811,1.55322 0.00684,0.002 0.03809,0.01367 0.10889,0.03027 0.18359,0.04395 0.43164,0.06982 0.66699,0.06982 0.06348,0 0.09033,-0.0029 0.10156,-0.0054 -0.00293,-0.0039 0.05762,-0.08154 0.11426,-0.34619 L 5.4795,15.57492 C 5.55811,15.20773 5.58643,14.74826 5.61622,14.26193 5.64308,13.82736 5.67188,13.36935 5.7339,12.91964 5.87794,11.88595 6.1382,11.24874 6.72902,10.4836 7.30568,9.73214 8.16213,8.89034 8.8589,8.38936 9.62941,7.83565 10.25978,7.6711 10.563,7.592 10.69874,7.55782 10.80177,7.53194 10.82618,7.51778 10.93018,7.35909 10.99024,7.23458 11.0586,7.09639 11.18067,6.84932 11.33204,6.5417 11.5171,6.27657 11.79981,5.87081 12.17042,5.53927 12.61866,5.29024 13.0752,5.03829 13.51124,4.94405 14.48585,4.88545 15.04493,4.85127 15.81202,4.83174 16.5254,4.81367 17.07472,4.8 17.59181,4.78681 17.95313,4.76826 18.1294,4.75898 18.25001,4.74971 18.33204,4.74043 18.3296,4.49824 18.32276,4.22383 18.31593,4.00947 18.20655,4.00703 18.06886,4.00556 17.9214,4.0041 16.98829,3.99482 15.29738,3.97724 14.30958,3.86738 13.3672,3.7624 12.75636,3.53681 12.62403,2.73945 12.53516,2.2082 12.64747,1.47822 12.88526,1.0417 13.23389,0.41133 13.77344,0.35176 16.65088,0.3 c 1.42773,-0.02539 3.49316,-0.04248 5.55225,-0.04785 2.06006,-0.00586 4.11377,0 5.52002,0.021 2.84863,0.04346 3.28418,0.11963 3.58203,0.62598 0.19238,0.32568 0.26953,0.78174 0.31543,1.14258 0.04395,0.32861 0.07324,0.67676 -9.8e-4,0.98779 C 31.53565,3.38741 31.32666,3.66671 31.01709,3.83419 30.71631,3.98849 30.3999,4.02755 29.39795,4.03683 28.46436,4.04464 26.86768,4.02804 26.06885,4.01925 25.9624,4.01827 25.85791,4.01339 25.76905,4.0173 v 0.77637 c 0.17676,0.0083 0.43945,0.01172 0.74316,0.01611 1.20605,0.0166 3.70215,0.05127 5.10938,0.16211 1.45996,0.11523 1.82812,0.32227 2.18945,0.60303 0.35352,0.2749 0.61621,0.5459 0.80273,0.82861 0.22754,0.3457 0.34277,0.71777 0.43457,1.06885 0.08789,0.3418 0.1709,0.73242 0.23633,1.04004 0.04297,0.19336 0.08398,0.38428 0.11816,0.43018 0.04492,0.0249 0.28711,0.06592 0.52051,0.10596 l 0.12402,0.021 c 0.51758,0.08984 1.22949,0.22754 1.69238,0.37646 0.54688,0.17529 0.79004,0.38086 1.05176,0.63037 0.36035,0.34619 0.61719,0.66162 0.78516,0.96484 0.21973,0.39746 0.29688,0.79199 0.36133,1.38135 0.06055,0.55322 0.10938,1.32031 0.13574,1.8208 0.02637,0.50684 0.02832,0.75049 0.02832,0.93799 v 0.0039 c 0.10547,0.01367 0.30957,0.0293 0.69043,0.03418 0.62695,0.0093 1.62305,-0.0078 2.28613,-0.03369 l 0.4668,-0.021 c 0.4209,-0.01953 0.78711,-0.03613 1.45117,-0.03125 0.78027,0.0078 1.98145,0.04736 2.74414,0.07275 l 0.29883,0.0098 c 0.64844,0.02344 1.16016,0.04199 1.1377,0.85596 -0.0078,0.30518 -9.8e-4,0.74512 0.0088,1.45117 l 0.01465,1.10156 c 0.01758,1.39355 0.03613,3.42383 0.02734,5.28906 -0.0088,1.86621 -0.04492,3.56055 -0.07617,4.63867 -0.0332,1.05469 -0.06445,1.62988 -0.34961,2.16211 -0.24414,0.45508 -0.69141,0.90625 -1.25781,1.26953 -0.50195,0.32129 -1.02539,0.52734 -1.64551,0.64648 -0.65625,0.12793 -1.3584,0.15332 -1.92578,0.06543 -0.53223,-0.08105 -1.01758,-0.26465 -1.5293,-0.57715 -0.4541,-0.27832 -0.79004,-0.57812 -1.02734,-0.91504 -0.2373,-0.34473 -0.37402,-0.72461 -0.48633,-1.08301 -0.0918,-0.29785 -0.1709,-0.5625 -0.20312,-0.80078 -0.0166,-0.12793 -0.01953,-0.23828 -0.01855,-0.33789 -0.16699,-0.0068 -0.39844,-9.8e-4 -0.63477,0.02051 -0.20898,0.01855 -0.26855,0.03809 -0.28418,0.04492 -0.0033,0.03871 0.02344,0.15527 -0.002,0.44727 l -0.01758,0.21094 c -0.04199,0.54004 -0.09961,1.28027 -0.26855,1.84863 -0.23828,0.80371 -0.68555,1.20508 -1.13379,1.51953 -0.49512,0.34473 -1.1582,0.67969 -1.91895,0.96875 -0.77539,0.2959 -1.58887,0.5166 -2.55859,0.69336 -1.0918,0.2041 -2.35254,0.34863 -3.64453,0.41895 -0.77344,0.04199 -1.62012,0.0625 -2.62793,0.0625 v 0 z M 5.50293,18.0046 c 0.36377,0.10742 0.66797,0.33105 0.83545,0.61328 0.16797,0.28516 0.16797,0.55371 0.16797,1.08789 0,0.46973 0,1.24316 0.09473,1.90918 0.08252,0.58203 0.24561,1.14551 0.52979,1.8252 0.20264,0.4834 0.49902,1.11035 0.99365,1.66406 0.43457,0.48633 1.06299,0.96191 1.68164,1.27246 0.55957,0.2793 1.07471,0.4043 1.72461,0.51562 l 0.23096,0.03809 c 0.61084,0.09961 1.24219,0.20312 1.79492,0.50879 0.52588,0.29297 0.91797,0.73535 1.45996,1.34863 l 0.34326,0.38672 c 0.33594,0.375 0.74121,0.81348 1.14746,1.25195 0.47559,0.51367 0.95166,1.02832 1.31787,1.44336 0.18945,0.21582 0.34912,0.4043 0.4917,0.57227 0.35156,0.41602 0.58447,0.69043 0.86719,0.90039 0.31299,0.23438 0.77197,0.47168 2.01123,0.62891 0.96094,0.12207 2.44531,0.20312 4.5376,0.24707 1.89453,0.03418 3.26855,0.02246 4.45996,-0.04199 1.25,-0.06836 2.4668,-0.20703 3.51953,-0.40332 0.91113,-0.16699 1.66895,-0.37207 2.3877,-0.64648 0.6875,-0.26074 1.27734,-0.55664 1.70605,-0.85547 0.42969,-0.30176 0.62793,-0.5625 0.75586,-0.99512 0.13965,-0.46973 0.17222,-0.90182 0.21129,-1.39791 l 0.03773,-0.46537 c 0.04395,-0.51758 0.08301,-0.84668 0.31934,-1.08398 0.23047,-0.22754 0.53613,-0.27246 0.85547,-0.30176 0.20898,-0.01953 0.72754,-0.05664 1.04395,0.0068 0.39648,0.07812 0.62793,0.33203 0.6543,0.71484 0.0049,0.05859 0.0049,0.12207 0.0039,0.19141 -9.8e-4,0.07227 -0.002,0.1543 0.0098,0.25 0.02344,0.16992 0.08691,0.37793 0.16797,0.63867 0.08301,0.26562 0.18555,0.57031 0.35449,0.81445 0.15625,0.22266 0.39746,0.43359 0.73535,0.63965 0.39648,0.24219 0.7666,0.38379 1.16504,0.44434 0.45312,0.06738 1.04883,0.0459 1.59277,-0.05762 0.49414,-0.0957 0.9082,-0.25781 1.30273,-0.50977 0.42188,-0.27148 0.75879,-0.60254 0.92285,-0.9082 0.16504,-0.30859 0.2002,-0.66504 0.23438,-1.72949 0.03125,-1.07129 0.06543,-2.75586 0.07422,-4.6123 0.0088,-1.85938 -0.0098,-3.88379 -0.02734,-5.27344 L 48.20659,17.5368 c -0.0088,-0.63623 -0.01465,-1.06152 -0.01172,-1.33545 -0.05469,-0.002 -0.11719,-0.0034 -0.18848,-0.0064 l -0.29883,-0.0098 c -0.75586,-0.0249 -1.94727,-0.06445 -2.7207,-0.07227 -0.64355,-0.0083 -0.99121,0.01074 -1.39453,0.03027 l -0.47656,0.021 c -0.67676,0.02686 -1.69434,0.04541 -2.33691,0.03467 -0.75781,-0.0098 -1.05957,-0.05615 -1.29004,-0.19873 -0.36719,-0.22461 -0.36719,-0.59424 -0.36719,-0.81494 0,-0.18164 -0.0019,-0.41162 -0.02637,-0.89111 C 39.07083,13.80832 39.022,13.06564 38.9634,12.52902 38.90481,11.98947 38.84524,11.74338 38.71926,11.51584 38.6011,11.30246 38.39797,11.05637 38.11477,10.78391 37.91848,10.59739 37.79934,10.49387 37.43997,10.37864 37.12063,10.2761 36.56692,10.15403 35.8804,10.03489 L 35.75931,10.01438 C 35.29154,9.9343 35.00931,9.88645 34.77103,9.68918 34.4888,9.45578 34.41556,9.11936 34.33646,8.76291 34.26419,8.42062 34.18412,8.04611 34.09916,7.71848 34.02982,7.44895 33.94486,7.16868 33.79545,6.9426 33.66947,6.75119 33.47807,6.55686 33.20951,6.34836 33.02885,6.20822 32.82474,6.04953 31.54545,5.94846 30.16947,5.84006 27.69389,5.80588 26.50443,5.78928 25.25443,5.7717 24.78861,5.76535 24.78861,4.98948 v -1.1748 c 0,-0.15283 0,-0.38379 0.18848,-0.57031 0.21582,-0.21436 0.46191,-0.21191 1.10254,-0.20459 0.79395,0.00879 2.37988,0.02588 3.30957,0.01758 0.73926,-0.00684 1.05762,-0.03125 1.1709,-0.08984 0.0332,-0.01807 0.08105,-0.05615 0.10645,-0.16357 0.03809,-0.15918 0.0127,-0.41064 -0.0166,-0.63623 -0.0498,-0.3833 -0.1123,-0.64258 -0.18848,-0.77148 -0.2168,-0.10498 -2.05859,-0.13281 -2.75293,-0.14355 -1.40137,-0.02148 -3.44775,-0.02637 -5.50244,-0.021 -2.0542,0.00537 -4.11377,0.02246 -5.5376,0.04785 -1.01123,0.01807 -2.70361,0.04883 -2.90869,0.20605 -0.14795,0.27002 -0.22217,0.7793 -0.16992,1.09277 0.01953,0.11719 0.03809,0.22754 0.82812,0.31543 0.93896,0.10449 2.66113,0.12207 3.48828,0.13037 0.88477,0.00879 1.35889,0.01318 1.38232,0.74268 0.0088,0.26221 0.0249,0.79053 0.0249,1.08887 0,0.82324 -0.63623,0.85596 -1.31006,0.89111 -0.36816,0.01855 -0.89404,0.03223 -1.45312,0.04639 -0.70117,0.01758 -1.45557,0.03662 -2.00537,0.06982 -0.97607,0.05908 -1.21729,0.15479 -1.45215,0.28418 -0.31543,0.17529 -0.57568,0.40723 -0.77197,0.68896 -0.1499,0.21533 -0.2749,0.47266 -0.38379,0.69385 -0.08398,0.16992 -0.15967,0.32178 -0.22852,0.43311 -0.25586,0.41553 -0.5332,0.48535 -0.854,0.56592 -0.32764,0.08496 -0.80127,0.2085 -1.42432,0.65625 -0.6167,0.44287 -1.4082,1.22266 -1.9248,1.896 -0.48633,0.62939 -0.68066,1.10889 -0.80127,1.97314 -0.05859,0.42432 -0.08496,0.85742 -0.11035,1.26758 -0.03223,0.52441 -0.0625,1.01953 -0.15283,1.44043 l -0.05859,0.33594 c -0.1709,0.79639 -0.53271,1.14355 -1.17725,1.14355 -0.31201,0 -0.63721,-0.03516 -0.89209,-0.0957 C 4.13334,17.10425 3.70707,17.00464 3.51713,16.51929 3.40434,16.23023 3.38188,15.8899 3.39164,14.60181 l 0.00879,-0.92139 c 0.01221,-1.125 0.02734,-2.5249 9.8e-4,-3.49463 C 3.37407,9.17505 3.29789,8.55835 3.17534,8.35278 3.17534,8.34399 3.12846,8.34155 2.98589,8.36157 2.73394,8.39721 2.44048,8.46216 2.1773,8.67114 1.94,8.85815 1.64703,9.22387 1.46734,10.42114 c -0.1875,1.26611 -0.23779,3.35352 -0.23779,4.38721 0,0.52734 0.01416,0.83496 0.04199,0.91455 0.30664,0.25586 0.58887,0.6377 0.71826,2.32568 0.05176,0.67285 0.07959,1.58203 0.10889,2.54297 0.04248,1.39551 0.08643,2.83984 0.2085,3.84863 0.18164,1.52051 0.52588,1.91211 0.74268,2.09863 C 3.09235,26.18139 3.107,25.61791 3.12214,25.031 l 0.0083,-0.32227 c 0.02441,-0.93652 0.0542,-2.06055 0.09326,-3.04395 0.04492,-1.20215 0.10059,-2.05664 0.24072,-2.59863 0.15723,-0.6084 0.45361,-0.93945 0.96143,-1.07324 0.17139,-0.04297 0.3453,-0.06026 0.52103,-0.06444 0.14583,-0.0035 0.38466,0.02534 0.55605,0.07612 z"
       id="path3590" />
    <path
       style="stroke: none"
       d="m 14.02344,12.72858 h 2.39922 c 0.09409,0 0.15828,0.03294 0.22385,0.09567 0.06272,0.06272 0.09375,0.125 0.09375,0.22194 0,0.03136 -0.0012,0.093 -0.03252,0.12436 l -1.26275,3.37881 2.90623,-0.72704 h 0.09375 c 0.09354,0 0.15486,0.03176 0.22002,0.09375 0.09409,0.09409 0.06198,0.22067 0.03061,0.3176 L 14.75047,24.696 c -0.06272,0.12545 -0.15794,0.1875 -0.3176,0.1875 h -0.09375 c -0.09409,-0.03136 -0.15614,-0.06356 -0.1875,-0.12627 -0.03136,-0.06272 -0.06389,-0.15636 -0.03252,-0.22194 l 1.45216,-5.90431 -2.96746,0.72704 h -0.09567 c -0.09409,0 -0.15636,-0.03101 -0.22194,-0.09375 -0.09409,-0.06272 -0.12511,-0.15678 -0.09375,-0.28508 l 1.48277,-6.03058 c 0.03136,-0.06272 0.06164,-0.12553 0.12436,-0.15689 0.06272,-0.03136 0.12692,-0.06313 0.22385,-0.06314 z"
       id="path3592" />
    <g
       id="g3602">
      <path
         d="m 26.0708,25.2585 c -0.10156,0 -0.2041,-0.03223 -0.29199,-0.09668 -0.69727,-0.51855 -1.65186,-1.22754 -1.97363,-2.31055 -0.10596,-0.35645 -0.14307,-0.74512 -0.11719,-1.22363 0.06738,-1.20508 0.51465,-2.3916 1.25977,-3.33984 0.09766,-0.12402 0.2002,-0.24512 0.30371,-0.36621 0.2041,-0.23828 0.39551,-0.46289 0.5332,-0.70703 0.33594,-0.59717 0.36816,-1.40137 0.08594,-2.15088 -0.24902,-0.66553 -0.73145,-1.30078 -1.43359,-1.88867 -0.20752,-0.17383 -0.23486,-0.48242 -0.06104,-0.68994 0.17334,-0.2085 0.48193,-0.23438 0.68994,-0.06104 0.83301,0.69775 1.41211,1.46973 1.72266,2.29492 0.38184,1.0166 0.3252,2.12939 -0.15039,2.97559 -0.18457,0.32764 -0.41699,0.6001 -0.6416,0.86279 -0.09473,0.11133 -0.18945,0.22168 -0.27832,0.33594 -0.62305,0.79199 -0.99609,1.78223 -1.05176,2.78906 -0.02002,0.36133 0.0049,0.64453 0.07812,0.88965 0.21094,0.71289 0.85742,1.23828 1.61816,1.80273 0.2168,0.16211 0.2627,0.46875 0.10156,0.68555 -0.09668,0.12988 -0.24414,0.19824 -0.39355,0.19824 z"
         id="path3594" />
      <path
         d="m 30.05615,25.2585 c -0.10156,0 -0.2041,-0.03223 -0.29199,-0.09668 -0.69727,-0.51855 -1.65332,-1.22852 -1.97461,-2.31055 -0.10645,-0.35645 -0.14355,-0.74512 -0.11719,-1.22363 0.06738,-1.2041 0.51465,-2.39062 1.25879,-3.33984 0.09863,-0.12402 0.20117,-0.24512 0.30469,-0.36621 0.2041,-0.23828 0.39551,-0.46289 0.5332,-0.70703 0.33594,-0.59717 0.36816,-1.40137 0.08594,-2.15088 -0.25,-0.6665 -0.73242,-1.30176 -1.43359,-1.88867 -0.20703,-0.17334 -0.23438,-0.48242 -0.06152,-0.68994 0.17383,-0.2085 0.4834,-0.23438 0.69043,-0.06104 0.83203,0.69629 1.41211,1.46826 1.72266,2.29492 0.38184,1.0166 0.3252,2.12939 -0.15039,2.97559 -0.18457,0.32764 -0.41699,0.6001 -0.6416,0.86279 -0.09473,0.11133 -0.18945,0.22168 -0.27832,0.33594 -0.62305,0.79199 -0.99609,1.7832 -1.05176,2.78906 -0.02051,0.36133 0.0049,0.64453 0.07812,0.88965 0.21094,0.71191 0.8584,1.2373 1.61914,1.80273 0.2168,0.16211 0.2627,0.46875 0.10156,0.68555 -0.09668,0.12988 -0.24414,0.19824 -0.39356,0.19824 z"
         id="path3596" />
      <path
         d="m 34.42334,25.2585 c -0.10156,0 -0.2041,-0.03223 -0.29199,-0.09668 -0.69727,-0.51855 -1.65332,-1.22852 -1.97461,-2.31055 -0.10645,-0.35645 -0.14355,-0.74512 -0.11719,-1.22363 0.06738,-1.2041 0.51465,-2.39062 1.25879,-3.33984 0.09863,-0.12402 0.20117,-0.24512 0.30469,-0.36621 0.2041,-0.23828 0.39551,-0.46289 0.5332,-0.70703 0.33594,-0.59814 0.36816,-1.40234 0.08691,-2.15039 -0.25098,-0.66699 -0.7334,-1.30225 -1.43457,-1.88916 -0.20703,-0.17334 -0.23438,-0.48242 -0.06152,-0.68994 0.17285,-0.2085 0.48242,-0.23438 0.69043,-0.06104 0.83203,0.69629 1.41211,1.46826 1.72266,2.29492 0.38184,1.01514 0.32617,2.12793 -0.15039,2.97559 -0.18457,0.32764 -0.41699,0.6001 -0.6416,0.86279 -0.09473,0.11133 -0.18945,0.22168 -0.27832,0.33594 -0.62305,0.79199 -0.99609,1.7832 -1.05176,2.78906 -0.02051,0.36133 0.0049,0.64453 0.07812,0.88965 0.21094,0.71191 0.8584,1.2373 1.61914,1.80273 0.2168,0.16211 0.2627,0.46875 0.10156,0.68555 -0.09668,0.12988 -0.24414,0.19824 -0.39355,0.19824 z"
         id="path3598" />
      <path
         d="m 36.21631,25.63253 h -13.021 c -0.27051,0 -0.48975,-0.21973 -0.48975,-0.49023 0,-0.2705 0.21924,-0.49023 0.48975,-0.49023 h 13.021 c 0.27051,0 0.49023,0.21973 0.49023,0.49023 0,0.2705 -0.21973,0.49023 -0.49023,0.49023 z"
         id="path3600" />
    </g>
  </g>
  `
]
export const container = [
  '50 40',
  `
  <defs
     id="defs2" />
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21161124,0,0,0.2456282,51.72743,126.23038)">
      <path
         style="fill:none;stroke: inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;stroke: inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
  </g>
  `
]
export const containerAlarm = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21193464,0,0,0.24600356,51.938646,126.37029)"
       style="fill:none;fill-opacity:1;stroke:inherit;stroke-opacity:1">
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
    <circle
       style="fill:#f92224;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="15.267975"
       cy="137.63654"
       r="4.4884591" />
  </g>
  `
]
export const containerOk = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21193464,0,0,0.24600356,51.938646,126.37029)"
       style="fill:none;fill-opacity:1;stroke:inherit;stroke-opacity:1">
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
    <circle
       style="fill:#5ec44e;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="15.267975"
       cy="137.63654"
       r="4.4884591" />
  </g>
  `
]
export const containerWarning = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1"
     transform="translate(-6.0000038,-132.16438)">
    <g
       id="g26887"
       transform="matrix(-0.21193464,0,0,0.24600356,51.938646,126.37029)"
       style="fill:none;fill-opacity:1;stroke:inherit;stroke-opacity:1">
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 86.900993,149.77917 V 99.779163 l -4,-2.999996 v 50.000003 z"
         id="path19468"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 59.950993,132 V 81.999986 l -4,-2.99999 V 129 Z"
         id="path19468-9"
         sodipodi:nodetypes="ccccc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 32.900993,114.25 V 64.249985 l -4,-2.99999 V 111.25 Z"
         id="path19468-9-1"
         sodipodi:nodetypes="ccccc" />
      <rect
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         id="rect7608"
         width="80"
         height="80"
         x="-191.901"
         y="101.05833"
         transform="scale(-1,1)" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="M 111.94531,101.188 3.9006233,29.999517"
         id="path7619-5"
         sodipodi:nodetypes="cc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
         d="m 111.99324,181.20633 c 0,0 -108.1214667,-70.17681 -108.0922467,-71.20633 0.0647,-2.27934 -0.10351,-80.608706 0,-80 0,0 2.65227,-0.0064 11.9279797,0 20.00275,0.01381 67.45079,-0.100276 68.07202,0 0.91981,0.148471 107.866097,70.66985 107.866097,70.66985"
         id="path7619-5-3"
         sodipodi:nodetypes="cssssc" />
      <path
         style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:5;stroke-linecap:butt;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1"
         d="m 166.901,180 v -40 h -30 v 40"
         id="path26851"
         sodipodi:nodetypes="cccc" />
    </g>
    <circle
       style="fill:#fafb5c;fill-opacity:1;stroke:inherit;stroke-width:1;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:17;stroke-dasharray:none;stroke-opacity:1"
       id="path499"
       cx="15.267975"
       cy="137.63654"
       r="4.4884591" />
  </g>
  `
]
export const dashboardCenterIcon = [
  '810.00001 810',
  `
  </sodipodi:namedview>
  <!-- Generator: Adobe Illustrator 29.8.2, SVG Export Plug-In . SVG Version: 2.1.1 Build 3)  -->
  <defs
     id="defs32">
    <style
       id="style1">
      .schulz-dashboard-center-icon-styling-0, .schulz-dashboard-center-icon-styling-1, .schulz-dashboard-center-icon-styling-2, .schulz-dashboard-center-icon-styling-3, .schulz-dashboard-center-icon-styling-4 {
        fill: none;
      }
      .schulz-dashboard-center-icon-styling-5 {
        fill: #e9e9ea;
      }
      .schulz-dashboard-center-icon-styling-6 {
        fill: #ff2c5d;
      }
      .schulz-dashboard-center-icon-styling-7 {
        fill: #6d6e71;
      }
      .schulz-dashboard-center-icon-styling-8, .schulz-dashboard-center-icon-styling-9, .schulz-dashboard-center-icon-styling-10, .schulz-dashboard-center-icon-styling-11, .schulz-dashboard-center-icon-styling-12, .schulz-dashboard-center-icon-styling-13, .schulz-dashboard-center-icon-styling-14, .schulz-dashboard-center-icon-styling-15 {
        mix-blend-mode: multiply;
      }
      .schulz-dashboard-center-icon-styling-8, .schulz-dashboard-center-icon-styling-16, .schulz-dashboard-center-icon-styling-11, .schulz-dashboard-center-icon-styling-17 {
        opacity: .1;
      }
      .schulz-dashboard-center-icon-styling-9, .schulz-dashboard-center-icon-styling-18, .schulz-dashboard-center-icon-styling-14 {
        opacity: .5;
      }
      .schulz-dashboard-center-icon-styling-10 {
        opacity: .9;
      }
      .schulz-dashboard-center-icon-styling-19 {
        fill: #444051;
      }
      .schulz-dashboard-center-icon-styling-20 {
        fill: #ebebeb;
      }
      .schulz-dashboard-center-icon-styling-21 {
        fill: #00c48b;
      }
      .schulz-dashboard-center-icon-styling-22 {
        fill: #005a56;
        opacity: .71;
      }
      .schulz-dashboard-center-icon-styling-23 {
        fill: #00123e;
      }
      .schulz-dashboard-center-icon-styling-16, .schulz-dashboard-center-icon-styling-24, .schulz-dashboard-center-icon-styling-25, .schulz-dashboard-center-icon-styling-26, .schulz-dashboard-center-icon-styling-27 {
        fill: #fff;
      }
      .schulz-dashboard-center-icon-styling-24, .schulz-dashboard-center-icon-styling-28, .schulz-dashboard-center-icon-styling-12, .schulz-dashboard-center-icon-styling-13 {
        opacity: .2;
      }
      .schulz-dashboard-center-icon-styling-25, .schulz-dashboard-center-icon-styling-29 {
        opacity: .3;
      }
      .schulz-dashboard-center-icon-styling-26 {
        opacity: .75;
      }
      .schulz-dashboard-center-icon-styling-30 {
        fill: #ee9059;
      }
      .schulz-dashboard-center-icon-styling-31, .schulz-dashboard-center-icon-styling-14, .schulz-dashboard-center-icon-styling-15 {
        fill: #001230;
      }
      .schulz-dashboard-center-icon-styling-32 {
        fill: #5d6e81;
      }
      .schulz-dashboard-center-icon-styling-33 {
        isolation: isolate;
      }
      .schulz-dashboard-center-icon-styling-34 {
        clip-path: url(#clippath-17);
      }
      .schulz-dashboard-center-icon-styling-35 {
        clip-path: url(#clippath-19);
      }
      .schulz-dashboard-center-icon-styling-36 {
        clip-path: url(#clippath-11);
      }
      .schulz-dashboard-center-icon-styling-37 {
        clip-path: url(#clippath-16);
      }
      .schulz-dashboard-center-icon-styling-38 {
        clip-path: url(#clippath-18);
      }
      .schulz-dashboard-center-icon-styling-39 {
        clip-path: url(#clippath-10);
      }
      .schulz-dashboard-center-icon-styling-40 {
        clip-path: url(#clippath-15);
      }
      .schulz-dashboard-center-icon-styling-41 {
        clip-path: url(#clippath-13);
      }
      .schulz-dashboard-center-icon-styling-42 {
        clip-path: url(#clippath-14);
      }
      .schulz-dashboard-center-icon-styling-43 {
        clip-path: url(#clippath-12);
      }
      .schulz-dashboard-center-icon-styling-44 {
        clip-path: url(#clippath-27);
      }
      .schulz-dashboard-center-icon-styling-45 {
        clip-path: url(#clippath-26);
      }
      .schulz-dashboard-center-icon-styling-46 {
        clip-path: url(#clippath-28);
      }
      .schulz-dashboard-center-icon-styling-47 {
        clip-path: url(#clippath-20);
      }
      .schulz-dashboard-center-icon-styling-48 {
        clip-path: url(#clippath-21);
      }
      .schulz-dashboard-center-icon-styling-49 {
        clip-path: url(#clippath-22);
      }
      .schulz-dashboard-center-icon-styling-50 {
        clip-path: url(#clippath-23);
      }
      .schulz-dashboard-center-icon-styling-51 {
        clip-path: url(#clippath-24);
      }
      .schulz-dashboard-center-icon-styling-52 {
        clip-path: url(#clippath-25);
      }
      .schulz-dashboard-center-icon-styling-53 {
        fill: #f1f2f2;
      }
      .schulz-dashboard-center-icon-styling-1 {
        stroke: #00c48b;
        stroke-linecap: round;
        stroke-width: 3px;
      }
      .schulz-dashboard-center-icon-styling-1, .schulz-dashboard-center-icon-styling-2, .schulz-dashboard-center-icon-styling-3, .schulz-dashboard-center-icon-styling-4 {
        stroke-miterlimit: 10;
      }
      .schulz-dashboard-center-icon-styling-28, .schulz-dashboard-center-icon-styling-11, .schulz-dashboard-center-icon-styling-12, .schulz-dashboard-center-icon-styling-54 {
        fill: #242b52;
      }
      .schulz-dashboard-center-icon-styling-55 {
        clip-path: url(#clippath-1);
      }
      .schulz-dashboard-center-icon-styling-56 {
        clip-path: url(#clippath-3);
      }
      .schulz-dashboard-center-icon-styling-57 {
        clip-path: url(#clippath-4);
      }
      .schulz-dashboard-center-icon-styling-58 {
        clip-path: url(#clippath-2);
      }
      .schulz-dashboard-center-icon-styling-59 {
        clip-path: url(#clippath-7);
      }
      .schulz-dashboard-center-icon-styling-60 {
        clip-path: url(#clippath-6);
      }
      .schulz-dashboard-center-icon-styling-61 {
        clip-path: url(#clippath-9);
      }
      .schulz-dashboard-center-icon-styling-62 {
        clip-path: url(#clippath-8);
      }
      .schulz-dashboard-center-icon-styling-63 {
        clip-path: url(#clippath-5);
      }
      .schulz-dashboard-center-icon-styling-64 {
        fill: #007874;
      }
      .schulz-dashboard-center-icon-styling-65 {
        fill: #b4bdc5;
      }
      .schulz-dashboard-center-icon-styling-66 {
        fill: #404079;
      }
      .schulz-dashboard-center-icon-styling-67 {
        fill: #f0f0f0;
      }
      .schulz-dashboard-center-icon-styling-2 {
        stroke-width: 1.07px;
      }
      .schulz-dashboard-center-icon-styling-2, .schulz-dashboard-center-icon-styling-3, .schulz-dashboard-center-icon-styling-4 {
        stroke: #231f32;
      }
      .schulz-dashboard-center-icon-styling-68 {
        fill: #9fa8b6;
      }
      .schulz-dashboard-center-icon-styling-13 {
        fill: #2f1d00;
      }
      .schulz-dashboard-center-icon-styling-69 {
        opacity: .82;
      }
      .schulz-dashboard-center-icon-styling-3 {
        stroke-width: .96px;
      }
      .schulz-dashboard-center-icon-styling-4 {
        stroke-width: 1px;
      }
      .schulz-dashboard-center-icon-styling-70 {
        fill: #d0d2d3;
      }
      .schulz-dashboard-center-icon-styling-15 {
        opacity: .8;
      }
      .schulz-dashboard-center-icon-styling-71 {
        fill: #87ad54;
      }
      .schulz-dashboard-center-icon-styling-72 {
        fill: #ffde96;
        opacity: .13;
      }
      .schulz-dashboard-center-icon-styling-73 {
        fill: url(#Unbenannter_Verlauf_14);
      }
      .schulz-dashboard-center-icon-styling-74 {
        fill: #00a88a;
      }
      .schulz-dashboard-center-icon-styling-75 {
        fill: #303a66;
      }
      .schulz-dashboard-center-icon-styling-76 {
        fill: #43596d;
      }
      .schulz-dashboard-center-icon-styling-77 {
        fill: #7d8191;
      }
      .schulz-dashboard-center-icon-styling-78 {
        fill: #e6e7e8;
      }
      .schulz-dashboard-center-icon-styling-79 {
        fill: #1c75bc;
      }
      .schulz-dashboard-center-icon-styling-80 {
        clip-path: url(#clippath);
      }
      .schulz-dashboard-center-icon-styling-29 {
        fill: #f1f3be;
      }
    </style>
    <clipPath
       id="clippath">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 511.89,332.19 v 6.92 c 0,0.61 0.87,1.23 2.62,1.7 3.49,0.94 9.16,0.94 12.66,0 1.75,-0.47 2.62,-1.08 2.62,-1.7 v -6.92 z"
         id="path4" />
    </clipPath>
    <clipPath
       id="clippath-1">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 517.17,214.12 -1.48,117.38 c 0,0.5 0.49,1 1.5,1.38 2.01,0.76 5.29,0.76 7.3,0 1,-0.38 1.5,-0.88 1.5,-1.38 l -1.48,-117.38 z"
         id="path5" />
    </clipPath>
    <clipPath
       id="clippath-2">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 535.68,207.7 c -0.82,-3.05 -3.29,-5.04 -5.53,-4.44 l -16.04,4.3 2.96,11.06 16.04,-4.3 c 2.24,-0.6 3.38,-3.56 2.57,-6.61 z"
         id="path6" />
    </clipPath>
    <clipPath
       id="clippath-3">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 417.07,362.91 v 6.92 c 0,0.61 0.87,1.23 2.62,1.7 3.49,0.94 9.16,0.94 12.66,0 1.75,-0.47 2.62,-1.08 2.62,-1.7 v -6.92 z"
         id="path7" />
    </clipPath>
    <clipPath
       id="clippath-4">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 422.35,244.84 -1.48,117.38 c 0,0.5 0.49,1 1.5,1.38 2.01,0.76 5.29,0.76 7.3,0 1,-0.38 1.5,-0.88 1.5,-1.38 l -1.48,-117.38 z"
         id="path8" />
    </clipPath>
    <clipPath
       id="clippath-5">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 440.86,238.42 c -0.82,-3.05 -3.29,-5.04 -5.53,-4.44 l -16.04,4.3 2.96,11.06 16.04,-4.3 c 2.24,-0.6 3.38,-3.56 2.57,-6.61 z"
         id="path9" />
    </clipPath>
    <clipPath
       id="clippath-6">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 607.09,360.7 v 6.92 c 0,0.61 0.87,1.23 2.62,1.7 3.49,0.94 9.16,0.94 12.66,0 1.75,-0.47 2.62,-1.08 2.62,-1.7 v -6.92 z"
         id="path10" />
    </clipPath>
    <clipPath
       id="clippath-7">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 612.37,242.63 -1.48,117.38 c 0,0.5 0.49,1 1.5,1.38 2.01,0.76 5.29,0.76 7.3,0 1,-0.38 1.5,-0.88 1.5,-1.38 l -1.48,-117.38 z"
         id="path11" />
    </clipPath>
    <clipPath
       id="clippath-8">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 630.88,236.21 c -0.82,-3.05 -3.29,-5.04 -5.53,-4.44 l -16.04,4.3 2.96,11.06 16.04,-4.3 c 2.24,-0.6 3.38,-3.56 2.57,-6.61 z"
         id="path12" />
    </clipPath>
    <clipPath
       id="clippath-9">
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 529.41,332.79 c -0.03,-0.98 -0.03,-1.74 0.05,-2.96 -2.73,-0.94 -4.32,-8.51 -4.32,-8.51 2.06,4.42 3.71,6.69 4.56,6.93 0.1,-0.95 0.22,-3.21 0.27,-4.16 0.05,-0.84 0.1,-1.63 0.21,-2.29 0.17,-1.03 -0.35,-5.68 0.11,-6.12 0,0 0.86,6.8 1.22,6.05 1.13,-2.36 1.74,-2.72 3.08,-4.72 0.17,-0.25 -3.09,6.64 -3.05,7.03 0.14,1.55 0.31,3.8 0.53,7.07 1.02,-0.57 2.57,-1.67 3.43,-2.4 -0.59,-2.01 1.31,-5.96 1.31,-5.96 -0.06,2.13 -0.87,4.96 -0.49,5.23 0.83,-0.99 5.02,-4.12 6,-5.4 0,0 -5.85,7.68 -10.1,10.64 0.2,2.49 0.28,6.6 0.38,7.39 0.22,1.66 0.55,3.59 0.88,5.04 0.26,0.3 -1.35,1.28 -2.83,1.01 -1.37,-0.24 -2.35,-0.39 -2.12,-1.01 0.08,-0.72 0.26,-1.41 0.28,-2.18 0.03,-1.53 0.08,-6.93 0.25,-8.01 -6.17,-3.07 -11.36,-10.47 -11.36,-10.47 4.44,4.34 9.85,7.68 11.7,7.83 z"
         id="path13" />
    </clipPath>
    <clipPath
       id="clippath-10">
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 515.42,356.27 c 0.03,-0.98 0.03,-1.76 -0.05,-2.99 2.76,-0.95 4.36,-8.59 4.36,-8.59 -2.08,4.46 -3.74,6.75 -4.61,6.99 -0.1,-0.96 -0.22,-3.24 -0.27,-4.2 -0.05,-0.85 -0.1,-1.65 -0.21,-2.31 -0.18,-1.04 0.35,-5.74 -0.11,-6.18 0,0 -0.87,6.87 -1.23,6.1 -1.14,-2.38 -1.76,-2.75 -3.11,-4.77 -0.17,-0.25 3.12,6.7 3.08,7.09 -0.14,1.57 -0.31,3.84 -0.53,7.13 -1.02,-0.57 -2.59,-1.69 -3.46,-2.43 0.6,-2.03 -1.32,-6.02 -1.32,-6.02 0.06,2.15 0.88,5.01 0.49,5.27 -0.84,-1 -5.06,-4.15 -6.06,-5.45 0,0 5.9,7.75 10.19,10.74 -0.2,2.51 -0.28,6.66 -0.38,7.46 -0.22,1.68 -0.55,3.62 -0.89,5.08 -0.26,0.3 1.36,1.29 2.86,1.02 1.38,-0.24 2.38,-0.39 2.14,-1.02 -0.08,-0.73 -0.27,-1.42 -0.28,-2.2 -0.03,-1.55 -0.08,-7 -0.26,-8.08 6.23,-3.1 11.46,-10.56 11.46,-10.56 -4.48,4.38 -9.94,7.75 -11.81,7.9 z"
         id="path14" />
    </clipPath>
    <clipPath
       id="clippath-11">
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 426.48,351.52 c -0.04,-1.32 -0.04,-2.36 0.07,-4.02 -3.71,-1.27 -5.86,-11.55 -5.86,-11.55 2.79,6 5.04,9.08 6.19,9.4 0.13,-1.29 0.3,-4.36 0.37,-5.64 0.06,-1.14 0.14,-2.21 0.29,-3.11 0.24,-1.4 -0.47,-7.71 0.15,-8.31 0,0 1.17,9.23 1.66,8.2 1.53,-3.21 2.36,-3.69 4.18,-6.41 0.23,-0.34 -4.19,9.01 -4.14,9.53 0.18,2.11 0.42,5.16 0.72,9.59 1.38,-0.77 3.48,-2.27 4.65,-3.26 -0.8,-2.73 1.77,-8.09 1.77,-8.09 -0.08,2.89 -1.19,6.74 -0.66,7.09 1.13,-1.34 6.81,-5.59 8.15,-7.33 0,0 -7.94,10.42 -13.7,14.44 0.27,3.38 0.37,8.95 0.51,10.03 0.29,2.26 0.74,4.86 1.2,6.84 0.35,0.41 -1.83,1.73 -3.84,1.38 -1.85,-0.33 -3.19,-0.52 -2.88,-1.38 0.11,-0.98 0.36,-1.91 0.38,-2.96 0.04,-2.08 0.1,-9.41 0.34,-10.87 -8.38,-4.17 -15.41,-14.2 -15.41,-14.2 6.02,5.89 13.37,10.42 15.87,10.62 z"
         id="path15" />
    </clipPath>
    <clipPath
       id="clippath-12">
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 391.08,369.26 c -0.21,1.49 -0.25,2.6 -2.95,2.72 -3.18,0.15 -9.08,-0.95 -9.27,-2.72 0,0 0.31,-12.83 3.97,-21.7 3.67,-8.86 3.35,-26.58 3.66,-29.94 0.31,-3.37 1.84,-5.04 1.84,-5.04 l 2.75,2.42 c 0,0 0.61,15.76 0,21.57 -0.61,5.81 -1.99,11.68 -2.44,18.14 -0.38,5.39 2.44,14.56 2.44,14.56 z"
         id="path16" />
    </clipPath>
    <clipPath
       id="clippath-13">
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 477.42,366.53 c -0.17,1.22 -0.2,2.13 -2.42,2.23 -2.6,0.12 -7.44,-0.78 -7.6,-2.23 0,0 0.25,-10.52 3.26,-17.78 3.01,-7.26 2.75,-21.78 3,-24.54 0.25,-2.76 1.51,-4.13 1.51,-4.13 l 2.25,1.98 c 0,0 0.5,12.92 0,17.67 -0.5,4.76 -1.63,9.57 -2,14.86 -0.31,4.42 2,11.93 2,11.93 z"
         id="path17" />
    </clipPath>
    <clipPath
       id="clippath-14">
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 703.99,432.91 c -0.17,1.22 -0.2,2.13 -2.42,2.23 -2.6,0.12 -7.44,-0.78 -7.6,-2.23 0,0 0.25,-10.52 3.26,-17.78 3.01,-7.26 2.75,-21.78 3,-24.54 0.25,-2.76 1.51,-4.13 1.51,-4.13 l 2.25,1.98 c 0,0 0.5,12.92 0,17.67 -0.5,4.76 -1.63,9.57 -2,14.86 -0.31,4.42 2,11.93 2,11.93 z"
         id="path18" />
    </clipPath>
    <clipPath
       id="clippath-15">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 437.75,425.46 v 6.89 c 0,0.61 0.87,1.22 2.61,1.69 3.48,0.93 9.12,0.93 12.6,0 1.74,-0.47 2.61,-1.08 2.61,-1.69 v -6.89 h -17.81 z"
         id="path19" />
    </clipPath>
    <clipPath
       id="clippath-16">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 440.86,407.46 v 17.94 c 0,0.4 0.57,0.79 1.7,1.1 2.26,0.61 5.93,0.61 8.19,0 1.13,-0.3 1.7,-0.7 1.7,-1.1 v -17.94 h -11.58 z"
         id="path20" />
    </clipPath>
    <clipPath
       id="clippath-17">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 551.8,414.24 v 6.89 c 0,0.61 0.87,1.22 2.61,1.69 3.48,0.93 9.12,0.93 12.6,0 1.74,-0.47 2.61,-1.08 2.61,-1.69 v -6.89 h -17.81 z"
         id="path21" />
    </clipPath>
    <clipPath
       id="clippath-18">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 554.92,396.24 v 17.94 c 0,0.4 0.57,0.79 1.7,1.1 2.26,0.61 5.93,0.61 8.19,0 1.13,-0.3 1.7,-0.7 1.7,-1.1 v -17.94 h -11.58 z"
         id="path22" />
    </clipPath>
    <clipPath
       id="clippath-19">
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 599.25,458.14 c 0.04,-1.31 0.04,-2.34 -0.06,-3.98 3.67,-1.26 5.8,-11.43 5.8,-11.43 -2.77,5.95 -4.99,8.99 -6.13,9.31 -0.13,-1.28 -0.29,-4.32 -0.36,-5.59 -0.06,-1.13 -0.14,-2.19 -0.28,-3.08 -0.23,-1.39 0.47,-7.64 -0.15,-8.23 0,0 -1.16,9.14 -1.64,8.13 -1.52,-3.18 -2.34,-3.66 -4.14,-6.35 -0.23,-0.34 4.15,8.92 4.1,9.44 -0.18,2.09 -0.42,5.11 -0.71,9.49 -1.36,-0.76 -3.45,-2.25 -4.61,-3.23 0.8,-2.7 -1.75,-8.01 -1.75,-8.01 0.07,2.86 1.17,6.67 0.66,7.02 -1.12,-1.33 -6.74,-5.53 -8.07,-7.26 0,0 7.86,10.32 13.57,14.3 -0.26,3.35 -0.37,8.86 -0.51,9.94 -0.29,2.23 -0.73,4.82 -1.19,6.77 -0.35,0.4 1.81,1.71 3.81,1.36 1.84,-0.32 3.16,-0.52 2.85,-1.36 -0.11,-0.97 -0.35,-1.89 -0.38,-2.93 -0.04,-2.06 -0.1,-9.32 -0.34,-10.76 8.3,-4.13 15.26,-14.06 15.26,-14.06 -5.96,5.83 -13.24,10.32 -15.72,10.52 z"
         id="path23" />
    </clipPath>
    <clipPath
       id="clippath-20">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 608.15,484.17 v 6.89 c 0,0.61 0.87,1.22 2.61,1.69 3.48,0.93 9.12,0.93 12.6,0 1.74,-0.47 2.61,-1.08 2.61,-1.69 v -6.89 h -17.81 z"
         id="path24" />
    </clipPath>
    <clipPath
       id="clippath-21">
      <path
         class="schulz-dashboard-center-icon-styling-70"
         d="m 611.26,466.17 v 17.94 c 0,0.4 0.57,0.79 1.7,1.1 2.26,0.61 5.93,0.61 8.19,0 1.13,-0.3 1.7,-0.7 1.7,-1.1 v -17.94 h -11.58 z"
         id="path25" />
    </clipPath>
    <clipPath
       id="clippath-22">
      <path
         class="schulz-dashboard-center-icon-styling-0"
         d="m 358.89,477.28 c -0.14,-8.05 0.82,-68.01 -2.22,-69.01 -7.06,-2.46 -52.43,-15.14 -56.05,-14.18 -3.62,0.96 -190.74,51.13 -221,59.24 -8.91,2.39 -21.89,5.71 -22.79,12.26 -0.78,5.66 -7.8,67.95 -7.85,68.8 -0.62,10.74 2.29,18.5 6.23,20.39 7.21,3.47 36.43,10.59 48.64,13.06 5.78,0.77 11.15,1.34 15.48,0.23 13.11,-3.36 29.93,-8.02 29.93,-8.02 -0.28,-4.4 -0.29,-12.41 0.65,-17.16 2.18,-10.93 11.33,-18.26 18.89,-17.02 7.2,1.18 12.46,10.68 10.07,26.24 L 286.39,523.3 c 0,0 0.38,-13.21 1.71,-18.56 2.68,-10.8 11.71,-17.43 19.06,-15.46 6.93,1.86 10.35,12.29 9.16,21.55 13.63,-5.56 37.21,-13.21 41.03,-17.69 1.38,-1.62 1.68,-7.46 1.54,-15.87 z"
         id="path26" />
    </clipPath>
    <clipPath
       id="clippath-23">
      <path
         class="schulz-dashboard-center-icon-styling-75"
         d="m 108.01,476.73 5.74,1.54 c 0.71,0.19 1.21,0.84 1.21,1.58 v 14.32 c 0,0.83 -0.59,1.54 -1.4,1.7 l -1.14,0.22 c -0.3,0.06 -0.61,0.05 -0.9,-0.03 l -5.1,-1.34 c -1.02,-0.27 -1.73,-1.19 -1.73,-2.24 v -12.84 c 0,-0.94 0.41,-1.82 1.13,-2.43 v 0 c 0.61,-0.51 1.42,-0.69 2.18,-0.48 z"
         id="path27" />
    </clipPath>
    <clipPath
       id="clippath-24">
      <path
         class="schulz-dashboard-center-icon-styling-75"
         d="m 115.74,493.64 5.74,1.54 c 0.71,0.19 1.21,0.84 1.21,1.58 v 14.32 c 0,0.83 -0.59,1.54 -1.4,1.7 l -1.14,0.22 c -0.3,0.06 -0.61,0.05 -0.9,-0.03 l -5.1,-1.34 c -1.02,-0.27 -1.73,-1.19 -1.73,-2.24 v -12.84 c 0,-0.94 0.41,-1.82 1.13,-2.43 v 0 c 0.61,-0.51 1.42,-0.69 2.18,-0.48 z"
         id="path28" />
    </clipPath>
    <clipPath
       id="clippath-25">
      <path
         class="schulz-dashboard-center-icon-styling-0"
         d="m 278.22,491.9 c -8.18,2.19 -18.43,5.72 -20.93,11.26 -2.74,6.07 -5.68,34.27 -5.47,60.77 0,0.75 -0.83,1.5 -0.84,2.25 -0.1,9.03 1.47,11.12 4.81,12.73 6.63,3.19 33.46,9.73 44.67,12 5.31,0.7 10.24,1.23 14.22,0.21 12.04,-3.09 13.05,-3.44 13.05,-3.44 -0.26,-4.04 -0.27,-5.24 0.6,-9.6 2,-10.04 10.41,-16.77 17.35,-15.63 6.61,1.08 10.46,6.79 9.25,20.4 l 3.01,-0.81 V 498.95 L 304.9,484.74 c -11.78,3.16 -21.26,5.7 -26.68,7.16 z"
         id="path29" />
    </clipPath>
    <clipPath
       id="clippath-26">
      <path
         class="schulz-dashboard-center-icon-styling-32"
         d="m 311.78,577.84 v 6.22 c 0,2.78 1.4,4.6 4.32,4.11 2.93,-0.48 9.02,-2.51 9.02,-2.51 l 1.73,-11.95 z"
         id="path30" />
    </clipPath>
    <clipPath
       id="clippath-27">
      <path
         class="schulz-dashboard-center-icon-styling-5"
         d="m 551.32,565.62 c 0,0 4.74,-5 6.96,-5.05 1.73,-0.03 5.76,0.13 6.7,2.42 0.93,2.29 -1.89,3.52 -5.47,4.26 -3.59,0.74 -6.03,0.18 -6.9,-0.29 -0.87,-0.47 -1.28,-1.33 -1.28,-1.33 z"
         id="path31" />
    </clipPath>
    <clipPath
       id="clippath-28">
      <path
         class="schulz-dashboard-center-icon-styling-0"
         d="m 635.05,533.56 c 0,0 -1.39,-1.7 -1.2,-2.63 -19.72,-6.36 -60.05,-18.82 -85.27,-11.52 -25.73,7.45 -51.16,32.32 -51.16,32.32 0,0 -15.06,7.77 -22.51,13.76 -7.98,6.41 -7.89,18.87 -6.07,25.66 1.41,5.25 37.15,13.46 45.32,13.39 2.35,0.49 5.96,0.47 9.46,0.43 l 1.62,-0.43 c -0.23,-3.67 -0.08,-7.18 0.71,-11.14 1.82,-9.12 9.45,-15.23 15.76,-14.2 6.01,0.99 10.09,7.58 8.1,20.57 l 9.08,-4.26 c 14.97,-5.02 31.2,-9.45 49.04,-13.14 l 6.64,-0.79 c 0,-4.05 0.28,-7.62 1.39,-12.08 2.23,-9.01 9.77,-14.54 15.9,-12.9 5.78,1.55 8.63,8.02 7.64,15.74 2.59,-1.33 4.04,-2.89 4.85,-5.25 1.45,-4.24 1.77,-9.59 1.55,-11.75 -0.1,-1.06 -0.32,-2.17 -0.62,-3.3 -1.85,-6.87 -6.96,-14.61 -10.23,-18.48 z"
         id="path32" />
    </clipPath>
    <clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath832">
      <rect
         style="fill:#000000"
         id="rect832"
         width="810"
         height="810"
         x="2.3239074"
         y="3.8731792"
         rx="2.7933492e-17" />
    </clipPath>
  </defs>
  <g
     class="schulz-dashboard-center-icon-styling-33"
     id="g830"
     transform="translate(-2.3239074,-3.8731792)"
     clip-path="url(#clipPath832)"
     inkscape:export-filename="schulz.svg"
     inkscape:export-xdpi="96"
     inkscape:export-ydpi="96">
    <g
       id="Ebene_1">
      <rect
         class="schulz-dashboard-center-icon-styling-73"
         x="-21.9"
         y="-17.780001"
         width="837.33002"
         height="1639.11"
         id="rect32"
         style="fill:url(#Unbenannter_Verlauf_14)" />
      <g
         id="g33">
        <ellipse
           class="schulz-dashboard-center-icon-styling-28"
           cx="533.78998"
           cy="338.98999"
           rx="25.120001"
           ry="7.5500002"
           id="ellipse32" />
        <ellipse
           class="schulz-dashboard-center-icon-styling-28"
           cx="522.27002"
           cy="338.63"
           rx="10.92"
           ry="3.6600001"
           id="ellipse33" />
        <path
           class="schulz-dashboard-center-icon-styling-28"
           d="m 518.81,341.51 v -5.77 c 0,0 50.76,0 52.67,2.88 v 0 c 0,1.59 -52.67,2.88 -52.67,2.88 z"
           id="path33" />
      </g>
      <g
         id="g58">
        <g
           id="g37">
          <g
             id="g36">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 511.89,332.19 v 6.92 c 0,0.61 0.87,1.23 2.62,1.7 3.49,0.94 9.16,0.94 12.66,0 1.75,-0.47 2.62,-1.08 2.62,-1.7 v -6.92 z"
               id="path34" />
            <g
               class="schulz-dashboard-center-icon-styling-80"
               clip-path="url(#clippath)"
               id="g35">
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="523.72998"
                 y="331.26001"
                 width="4.8299999"
                 height="11.54"
                 id="rect34" />
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="513.10999"
                 y="331.26001"
                 width="4.8299999"
                 height="11.54"
                 id="rect35" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 514.51,330.5 c 3.49,-0.94 9.16,-0.94 12.66,0 3.49,0.94 3.49,2.45 0,3.39 -3.49,0.94 -9.16,0.94 -12.66,0 -3.5,-0.94 -3.49,-2.45 0,-3.39 z"
             id="path36" />
        </g>
        <g
           id="g40">
          <g
             id="g39">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 517.17,214.12 -1.48,117.38 c 0,0.5 0.49,1 1.5,1.38 2.01,0.76 5.29,0.76 7.3,0 1,-0.38 1.5,-0.88 1.5,-1.38 l -1.48,-117.38 z"
               id="path37" />
            <g
               class="schulz-dashboard-center-icon-styling-55"
               clip-path="url(#clippath-1)"
               id="g38">
              <polygon
                 class="schulz-dashboard-center-icon-styling-28"
                 points="522.51,334.5 522.02,213.73 524,213.73 525.31,334.5 "
                 id="polygon37" />
              <path
                 class="schulz-dashboard-center-icon-styling-28"
                 d="m 516.95,231.53 c 1.74,-1.91 5.62,1.11 7.87,7.08 l -0.31,-24.49 h -7.34 z"
                 id="path38" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-25"
                 points="516.36,334.5 517.67,213.73 519.65,213.73 519.16,334.5 "
                 id="polygon38" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 518.25,213.42 c 1.43,-0.38 3.75,-0.38 5.18,0 1.43,0.38 1.44,1.01 0.01,1.4 -1.43,0.39 -3.77,0.39 -5.2,0 -1.43,-0.39 -1.42,-1.01 0.01,-1.4 z"
             id="path39" />
        </g>
        <g
           id="g43">
          <g
             id="g42">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 535.68,207.7 c -0.82,-3.05 -3.29,-5.04 -5.53,-4.44 l -16.04,4.3 2.96,11.06 16.04,-4.3 c 2.24,-0.6 3.38,-3.56 2.57,-6.61 z"
               id="path40" />
            <g
               class="schulz-dashboard-center-icon-styling-58"
               clip-path="url(#clippath-2)"
               id="g41">
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="514.90997"
                 y="205.47"
                 width="19.82"
                 height="2.1500001"
                 transform="rotate(-15,524.8177,206.52549)"
                 id="rect40" />
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="516.59003"
                 y="210.7"
                 width="21.02"
                 height="4.2399998"
                 transform="rotate(-15,527.081,212.8122)"
                 id="rect41" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-7"
             d="m 519.72,211.97 c 0.82,3.05 -0.33,6.01 -2.57,6.61 -2.24,0.6 -4.71,-1.39 -5.53,-4.44 -0.82,-3.05 0.33,-6.01 2.57,-6.61 2.24,-0.6 4.71,1.39 5.53,4.44 z"
             id="path42" />
        </g>
        <g
           id="g55">
          <g
             id="g46">
            <polygon
               class="schulz-dashboard-center-icon-styling-70"
               points="513.49,213.52 509.53,186.12 486.5,143.9 484.83,144.65 "
               id="polygon43" />
            <polygon
               class="schulz-dashboard-center-icon-styling-25"
               points="513.49,213.52 512.43,206.18 486.5,143.9 484.83,144.65 "
               id="polygon44" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="484.83,144.65 486.23,148.02 488.3,147.1 486.5,143.9 "
               id="polygon45" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="487.63,151.39 489.04,154.76 491.77,153.55 490.01,150.34 "
               id="polygon46" />
          </g>
          <g
             id="g50">
            <polygon
               class="schulz-dashboard-center-icon-styling-70"
               points="513.49,213.52 496.96,226.5 483.15,265.4 484.83,267.04 "
               id="polygon47" />
            <polygon
               class="schulz-dashboard-center-icon-styling-25"
               points="513.49,213.52 509.06,217 483.15,265.4 484.83,267.04 "
               id="polygon48" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="484.83,267.04 486.23,264.42 484.16,262.4 483.15,265.4 "
               id="polygon49" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="487.63,261.8 489.04,259.18 486.31,256.51 485.25,259.47 "
               id="polygon50" />
          </g>
          <g
             id="g54">
            <polygon
               class="schulz-dashboard-center-icon-styling-70"
               points="513.49,213.52 533.98,227.96 570.82,231.27 570.82,228.89 "
               id="polygon51" />
            <polygon
               class="schulz-dashboard-center-icon-styling-25"
               points="513.49,213.52 518.98,217.39 570.82,231.27 570.82,228.89 "
               id="polygon52" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="570.82,228.89 568.01,228.13 568.01,231.07 570.82,231.27 "
               id="polygon53" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="565.21,227.38 562.4,226.63 562.4,230.52 565.21,230.77 "
               id="polygon54" />
          </g>
        </g>
        <g
           id="g57">
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 517.48,212.6 c -0.71,-2.66 -2.87,-4.4 -4.82,-3.87 -0.63,0.17 -1.16,0.55 -1.56,1.08 v 0 c 0,0 0,0 0,0 -0.05,0.07 -0.1,0.13 -0.14,0.2 l -2.4,3.39 c -0.67,0.94 -0.33,2.26 0.7,2.77 l 3.54,1.73 c 0.77,0.49 1.63,0.67 2.46,0.45 1.95,-0.52 2.95,-3.1 2.24,-5.76 z"
             id="path55" />
          <path
             class="schulz-dashboard-center-icon-styling-25"
             d="m 508.97,213.44 2.58,-3.42 c 0.19,-0.25 0.44,-0.46 0.73,-0.59 0.51,-0.23 0.9,-0.25 1.16,-0.04 0.32,0.26 0.26,0.77 -0.07,1 z"
             id="path56" />
          <path
             class="schulz-dashboard-center-icon-styling-28"
             d="m 509.46,215.73 4.05,1.9 c 0.62,0.29 1.35,0.22 1.9,-0.2 0.56,-0.43 1.02,-1.08 1.19,-1.65 0.1,-0.36 -0.19,-0.71 -0.57,-0.68 l -6.57,0.62 z"
             id="path57" />
        </g>
      </g>
      <g
         id="g59">
        <ellipse
           class="schulz-dashboard-center-icon-styling-12"
           cx="438.76001"
           cy="369.72"
           rx="25.120001"
           ry="7.5500002"
           id="ellipse58" />
        <ellipse
           class="schulz-dashboard-center-icon-styling-12"
           cx="427.23999"
           cy="369.37"
           rx="10.92"
           ry="3.6600001"
           id="ellipse59" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 423.77,372.25 v -5.77 c 0,0 50.76,0 52.67,2.88 v 0 c 0,1.59 -52.67,2.88 -52.67,2.88 z"
           id="path59" />
      </g>
      <g
         id="g84">
        <g
           id="g63">
          <g
             id="g62">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 417.07,362.91 v 6.92 c 0,0.61 0.87,1.23 2.62,1.7 3.49,0.94 9.16,0.94 12.66,0 1.75,-0.47 2.62,-1.08 2.62,-1.7 v -6.92 z"
               id="path60" />
            <g
               class="schulz-dashboard-center-icon-styling-56"
               clip-path="url(#clippath-3)"
               id="g61">
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="428.91"
                 y="361.98001"
                 width="4.8299999"
                 height="11.54"
                 id="rect60" />
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="418.29001"
                 y="361.98001"
                 width="4.8299999"
                 height="11.54"
                 id="rect61" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 419.69,361.22 c 3.49,-0.94 9.16,-0.94 12.66,0 3.49,0.94 3.49,2.45 0,3.39 -3.49,0.94 -9.16,0.94 -12.66,0 -3.49,-0.94 -3.49,-2.45 0,-3.39 z"
             id="path62" />
        </g>
        <g
           id="g66">
          <g
             id="g65">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 422.35,244.84 -1.48,117.38 c 0,0.5 0.49,1 1.5,1.38 2.01,0.76 5.29,0.76 7.3,0 1,-0.38 1.5,-0.88 1.5,-1.38 l -1.48,-117.38 z"
               id="path63" />
            <g
               class="schulz-dashboard-center-icon-styling-57"
               clip-path="url(#clippath-4)"
               id="g64">
              <polygon
                 class="schulz-dashboard-center-icon-styling-28"
                 points="427.69,365.22 427.2,244.46 429.18,244.46 430.49,365.22 "
                 id="polygon63" />
              <path
                 class="schulz-dashboard-center-icon-styling-28"
                 d="m 422.13,262.25 c 1.74,-1.91 5.62,1.11 7.87,7.08 l -0.31,-24.49 h -7.34 z"
                 id="path64" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-25"
                 points="421.54,365.22 422.85,244.46 424.83,244.46 424.34,365.22 "
                 id="polygon64" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 423.43,244.14 c 1.43,-0.38 3.75,-0.38 5.18,0 1.43,0.38 1.44,1.01 0.01,1.4 -1.43,0.39 -3.77,0.39 -5.2,0 -1.43,-0.39 -1.42,-1.01 0.01,-1.4 z"
             id="path65" />
        </g>
        <g
           id="g69">
          <g
             id="g68">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 440.86,238.42 c -0.82,-3.05 -3.29,-5.04 -5.53,-4.44 l -16.04,4.3 2.96,11.06 16.04,-4.3 c 2.24,-0.6 3.38,-3.56 2.57,-6.61 z"
               id="path66" />
            <g
               class="schulz-dashboard-center-icon-styling-63"
               clip-path="url(#clippath-5)"
               id="g67">
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="420.09"
                 y="236.19"
                 width="19.82"
                 height="2.1500001"
                 transform="rotate(-15,430.01056,237.27873)"
                 id="rect66" />
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="421.76999"
                 y="241.42"
                 width="21.02"
                 height="4.2399998"
                 transform="rotate(-15,432.27886,243.52746)"
                 id="rect67" />
            </g>
          </g>
          <ellipse
             class="schulz-dashboard-center-icon-styling-7"
             cx="420.85999"
             cy="243.78"
             rx="4.1900001"
             ry="5.7199998"
             transform="rotate(-15,420.85013,243.76151)"
             id="ellipse68" />
        </g>
        <g
           id="g81">
          <g
             id="g72">
            <polygon
               class="schulz-dashboard-center-icon-styling-70"
               points="418.76,244.25 426.02,220.94 420.69,174.11 418.76,173.59 "
               id="polygon69" />
            <polygon
               class="schulz-dashboard-center-icon-styling-25"
               points="418.76,244.25 420.7,238.01 420.69,174.11 418.76,173.59 "
               id="polygon70" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="418.76,173.59 418.76,177.05 421.14,177.69 420.69,174.11 "
               id="polygon71" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="418.76,180.51 418.76,183.97 421.91,184.81 421.5,181.24 "
               id="polygon72" />
          </g>
          <g
             id="g76">
            <polygon
               class="schulz-dashboard-center-icon-styling-70"
               points="418.76,244.25 397.38,243.4 368.14,263.95 369.11,266.28 "
               id="polygon73" />
            <polygon
               class="schulz-dashboard-center-icon-styling-25"
               points="418.76,244.25 413.03,244.02 368.14,263.95 369.11,266.28 "
               id="polygon74" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="369.11,266.28 371.54,265.2 370.35,262.33 368.14,263.95 "
               id="polygon75" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="373.97,264.12 376.4,263.04 374.82,259.26 372.6,260.82 "
               id="polygon76" />
          </g>
          <g
             id="g80">
            <polygon
               class="schulz-dashboard-center-icon-styling-70"
               points="418.76,244.25 432.88,268.41 467.44,294.69 468.41,292.89 "
               id="polygon77" />
            <polygon
               class="schulz-dashboard-center-icon-styling-25"
               points="418.76,244.25 422.54,250.72 467.44,294.69 468.41,292.89 "
               id="polygon78" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="468.41,292.89 465.98,290.5 464.78,292.73 467.44,294.69 "
               id="polygon79" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="463.55,288.12 461.12,285.74 459.54,288.69 462.17,290.69 "
               id="polygon80" />
          </g>
        </g>
        <g
           id="g83">
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 422.66,243.32 c -0.71,-2.66 -2.87,-4.4 -4.82,-3.87 -0.63,0.17 -1.16,0.55 -1.56,1.08 v 0 c 0,0 0,0 0,0 -0.05,0.07 -0.1,0.13 -0.14,0.2 l -2.4,3.39 c -0.67,0.94 -0.33,2.26 0.7,2.77 l 3.54,1.73 c 0.77,0.49 1.63,0.67 2.46,0.45 1.95,-0.52 2.95,-3.1 2.24,-5.76 z"
             id="path81" />
          <path
             class="schulz-dashboard-center-icon-styling-25"
             d="m 414.15,244.16 2.58,-3.42 c 0.19,-0.25 0.44,-0.46 0.73,-0.59 0.51,-0.23 0.9,-0.25 1.16,-0.04 0.32,0.26 0.26,0.77 -0.07,1 z"
             id="path82" />
          <path
             class="schulz-dashboard-center-icon-styling-28"
             d="m 414.64,246.45 4.05,1.9 c 0.62,0.29 1.35,0.22 1.9,-0.2 0.56,-0.43 1.02,-1.08 1.19,-1.65 0.1,-0.36 -0.19,-0.71 -0.57,-0.68 l -6.57,0.62 z"
             id="path83" />
        </g>
      </g>
      <g
         id="g85">
        <ellipse
           class="schulz-dashboard-center-icon-styling-12"
           cx="628.78003"
           cy="367.51999"
           rx="25.120001"
           ry="7.5500002"
           id="ellipse84" />
        <ellipse
           class="schulz-dashboard-center-icon-styling-12"
           cx="617.26001"
           cy="367.16"
           rx="10.92"
           ry="3.6600001"
           id="ellipse85" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 613.79,370.04 v -5.77 c 0,0 50.76,0 52.67,2.88 v 0 c 0,1.59 -52.67,2.88 -52.67,2.88 z"
           id="path85" />
      </g>
      <g
         id="g110">
        <g
           id="g89">
          <g
             id="g88">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 607.09,360.7 v 6.92 c 0,0.61 0.87,1.23 2.62,1.7 3.49,0.94 9.16,0.94 12.66,0 1.75,-0.47 2.62,-1.08 2.62,-1.7 v -6.92 z"
               id="path86" />
            <g
               class="schulz-dashboard-center-icon-styling-60"
               clip-path="url(#clippath-6)"
               id="g87">
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="618.92999"
                 y="359.76999"
                 width="4.8299999"
                 height="11.54"
                 id="rect86" />
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="608.31"
                 y="359.76999"
                 width="4.8299999"
                 height="11.54"
                 id="rect87" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 609.71,359.01 c 3.49,-0.94 9.16,-0.94 12.66,0 3.5,0.94 3.49,2.45 0,3.39 -3.49,0.94 -9.16,0.94 -12.66,0 -3.5,-0.94 -3.49,-2.45 0,-3.39 z"
             id="path88" />
        </g>
        <g
           id="g92">
          <g
             id="g91">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 612.37,242.63 -1.48,117.38 c 0,0.5 0.49,1 1.5,1.38 2.01,0.76 5.29,0.76 7.3,0 1,-0.38 1.5,-0.88 1.5,-1.38 l -1.48,-117.38 z"
               id="path89" />
            <g
               class="schulz-dashboard-center-icon-styling-59"
               clip-path="url(#clippath-7)"
               id="g90">
              <polygon
                 class="schulz-dashboard-center-icon-styling-28"
                 points="617.71,363.01 617.22,242.25 619.2,242.25 620.51,363.01 "
                 id="polygon89" />
              <path
                 class="schulz-dashboard-center-icon-styling-28"
                 d="m 612.15,260.04 c 1.74,-1.91 5.62,1.11 7.87,7.08 l -0.31,-24.49 h -7.34 z"
                 id="path90" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-25"
                 points="611.56,363.01 612.87,242.25 614.85,242.25 614.36,363.01 "
                 id="polygon90" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 613.45,241.93 c 1.43,-0.38 3.75,-0.38 5.18,0 1.43,0.38 1.44,1.01 0.01,1.4 -1.43,0.39 -3.77,0.39 -5.2,0 -1.43,-0.39 -1.42,-1.01 0.01,-1.4 z"
             id="path91" />
        </g>
        <g
           id="g95">
          <g
             id="g94">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 630.88,236.21 c -0.82,-3.05 -3.29,-5.04 -5.53,-4.44 l -16.04,4.3 2.96,11.06 16.04,-4.3 c 2.24,-0.6 3.38,-3.56 2.57,-6.61 z"
               id="path92" />
            <g
               class="schulz-dashboard-center-icon-styling-62"
               clip-path="url(#clippath-8)"
               id="g93">
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="610.10999"
                 y="233.98"
                 width="19.82"
                 height="2.1500001"
                 transform="rotate(-15,620.01133,235.0537)"
                 id="rect92" />
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="611.78998"
                 y="239.21001"
                 width="21.02"
                 height="4.2399998"
                 transform="rotate(-15,622.31261,241.34541)"
                 id="rect93" />
            </g>
          </g>
          <ellipse
             class="schulz-dashboard-center-icon-styling-7"
             cx="610.88"
             cy="241.57001"
             rx="4.1900001"
             ry="5.7199998"
             transform="rotate(-15,610.88387,241.57945)"
             id="ellipse94" />
        </g>
        <g
           id="g107">
          <g
             id="g98">
            <polygon
               class="schulz-dashboard-center-icon-styling-70"
               points="608.78,242.04 616.04,218.73 610.71,171.9 608.78,171.38 "
               id="polygon95" />
            <polygon
               class="schulz-dashboard-center-icon-styling-25"
               points="608.78,242.04 610.72,235.8 610.71,171.9 608.78,171.38 "
               id="polygon96" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="608.78,171.38 608.78,174.84 611.16,175.48 610.71,171.9 "
               id="polygon97" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="608.78,178.3 608.78,181.76 611.93,182.6 611.52,179.03 "
               id="polygon98" />
          </g>
          <g
             id="g102">
            <polygon
               class="schulz-dashboard-center-icon-styling-70"
               points="608.78,242.04 587.4,241.19 558.16,261.74 559.13,264.07 "
               id="polygon99" />
            <polygon
               class="schulz-dashboard-center-icon-styling-25"
               points="608.78,242.04 603.05,241.81 558.16,261.74 559.13,264.07 "
               id="polygon100" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="559.13,264.07 561.56,262.99 560.37,260.12 558.16,261.74 "
               id="polygon101" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="563.99,261.91 566.42,260.83 564.84,257.05 562.62,258.61 "
               id="polygon102" />
          </g>
          <g
             id="g106">
            <polygon
               class="schulz-dashboard-center-icon-styling-70"
               points="608.78,242.04 622.9,266.2 657.46,292.48 658.43,290.68 "
               id="polygon103" />
            <polygon
               class="schulz-dashboard-center-icon-styling-25"
               points="608.78,242.04 612.56,248.51 657.46,292.48 658.43,290.68 "
               id="polygon104" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="658.43,290.68 656,288.29 654.8,290.52 657.46,292.48 "
               id="polygon105" />
            <polygon
               class="schulz-dashboard-center-icon-styling-6"
               points="653.57,285.91 651.14,283.53 649.56,286.48 652.19,288.48 "
               id="polygon106" />
          </g>
        </g>
        <g
           id="g109">
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 612.68,241.11 c -0.71,-2.66 -2.87,-4.4 -4.82,-3.87 -0.63,0.17 -1.16,0.55 -1.56,1.08 v 0 c 0,0 0,0 0,0 -0.05,0.07 -0.1,0.13 -0.14,0.2 l -2.4,3.39 c -0.67,0.94 -0.33,2.26 0.7,2.77 l 3.54,1.73 c 0.77,0.49 1.63,0.67 2.46,0.45 1.95,-0.52 2.95,-3.1 2.24,-5.76 z"
             id="path107" />
          <path
             class="schulz-dashboard-center-icon-styling-25"
             d="m 604.17,241.95 2.58,-3.42 c 0.19,-0.25 0.44,-0.46 0.73,-0.59 0.51,-0.23 0.9,-0.25 1.16,-0.04 0.32,0.26 0.26,0.77 -0.07,1 z"
             id="path108" />
          <path
             class="schulz-dashboard-center-icon-styling-28"
             d="m 604.66,244.24 4.05,1.9 c 0.62,0.29 1.35,0.22 1.9,-0.2 0.56,-0.43 1.02,-1.08 1.19,-1.65 0.1,-0.36 -0.19,-0.71 -0.57,-0.68 l -6.57,0.62 z"
             id="path109" />
        </g>
      </g>
      <g
         id="g111">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 542.31,346.03 c 0,1.81 -4.46,3.28 -9.97,3.28 -5.51,0 -9.97,-1.47 -9.97,-3.28 0,-1.81 4.46,-3.28 9.97,-3.28 5.51,0 9.97,1.47 9.97,3.28 z"
           id="path110" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 537.91,346.2 c 0,1.21 -3.35,2.19 -7.48,2.19 -4.13,0 -7.48,-0.98 -7.48,-2.19 0,-1.21 3.35,-2.19 7.48,-2.19 4.13,0 7.48,0.98 7.48,2.19 z"
           id="path111" />
      </g>
      <g
         id="g116">
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 529.41,332.79 c -0.03,-0.98 -0.03,-1.74 0.05,-2.96 -2.73,-0.94 -4.32,-8.51 -4.32,-8.51 2.06,4.42 3.71,6.69 4.56,6.93 0.1,-0.95 0.22,-3.21 0.27,-4.16 0.05,-0.84 0.1,-1.63 0.21,-2.29 0.17,-1.03 -0.35,-5.68 0.11,-6.12 0,0 0.86,6.8 1.22,6.05 1.13,-2.36 1.74,-2.72 3.08,-4.72 0.17,-0.25 -3.09,6.64 -3.05,7.03 0.14,1.55 0.31,3.8 0.53,7.07 1.02,-0.57 2.57,-1.67 3.43,-2.4 -0.59,-2.01 1.31,-5.96 1.31,-5.96 -0.06,2.13 -0.87,4.96 -0.49,5.23 0.83,-0.99 5.02,-4.12 6,-5.4 0,0 -5.85,7.68 -10.1,10.64 0.2,2.49 0.28,6.6 0.38,7.39 0.22,1.66 0.55,3.59 0.88,5.04 0.26,0.3 -1.35,1.28 -2.83,1.01 -1.37,-0.24 -2.35,-0.39 -2.12,-1.01 0.08,-0.72 0.26,-1.41 0.28,-2.18 0.03,-1.53 0.08,-6.93 0.25,-8.01 -6.17,-3.07 -11.36,-10.47 -11.36,-10.47 4.44,4.34 9.85,7.68 11.7,7.83 z"
           id="path112" />
        <g
           class="schulz-dashboard-center-icon-styling-61"
           clip-path="url(#clippath-9)"
           id="g115">
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 532.23,333.19 c 0,0 -0.66,1.46 -0.66,2.31 0,0.85 -0.21,6.54 0,7.06 0.21,0.52 0.66,5.69 0.66,5.69 0,0 0.32,-6.3 0.38,-7.67 0.04,-0.97 -0.38,-7.39 -0.38,-7.39 z"
             id="path113" />
          <path
             class="schulz-dashboard-center-icon-styling-72"
             d="m 530.02,347.93 c 0,0 0.5,-3.27 0.29,-5.17 -0.21,-1.9 -0.63,-2.21 -0.32,-4.85 0.32,-2.64 0.74,-5.17 0.63,-6.54 -0.11,-1.37 -0.11,-4.74 -0.11,-4.74 l -1.06,3.19 c 0,0 0.21,-0.77 -0.74,-1.29 -0.95,-0.52 -1.37,0 -1.37,0 l 2.06,4.26 c 0,0 0.26,1.65 -0.16,1.44 -0.42,-0.21 -2.21,-0.53 -3.06,-1.05 -0.84,-0.53 -2.74,-0.32 -1.58,0.11 1.16,0.43 4.01,6.33 4.01,6.85 0,0.52 0.32,4.85 0.21,6.43 -0.11,1.58 1.19,1.37 1.19,1.37 z"
             id="path114" />
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 535.26,333.28 c 0,0 -1.79,-0.95 -2.11,-1.05 -0.32,-0.1 -1.48,0.11 -1.58,0.63 -0.1,0.52 -1.05,2.42 -1.58,2.21 -0.53,-0.21 -0.53,-2 -1.27,-2.53 -0.74,-0.53 -2.95,-0.74 -3.8,-0.21 -0.84,0.53 -9.38,-3.8 -9.38,-3.8 0,0 0.63,-14.13 1.05,-14.13 0.42,0 18.87,0.32 18.87,0.32 l 2.74,12.76 -2.95,5.8 z"
             id="path115" />
        </g>
      </g>
      <g
         id="g118">
        <path
           class="schulz-dashboard-center-icon-styling-64"
           d="m 508.9,320.67 c -0.58,2.27 -0.12,4.79 1.48,6.76 1.75,2.15 4.4,3.1 6.94,2.77 3.37,4.02 9.25,4.77 13.36,1.62 0.98,-0.75 1.75,-1.65 2.35,-2.65 3.41,3.71 9.07,4.32 13.06,1.26 4.22,-3.24 4.95,-9.36 1.63,-13.69 -1.36,-1.77 -3.19,-2.95 -5.16,-3.52 0,-0.01 0,-0.02 0,-0.04 3.14,-3.39 3.44,-8.72 0.46,-12.6 -0.45,-0.59 -0.96,-1.11 -1.5,-1.57 -0.2,-1.77 -1.59,-3.26 -3.48,-3.52 -1.01,-0.14 -1.97,0.09 -2.76,0.59 -2.75,-2.66 -7.1,-2.92 -10.12,-0.46 -2.7,2.19 -3.49,5.85 -2.19,8.91 -1.61,0.61 -2.95,1.92 -3.58,3.68 -2.24,-0.16 -4.53,0.45 -6.44,1.92 -1.31,1.01 -2.28,2.29 -2.9,3.71 -0.97,-0.19 -2.02,0.03 -2.85,0.7 -1.48,1.21 -1.71,3.39 -0.5,4.88 0.58,0.71 1.37,1.13 2.21,1.24 z"
           id="path116" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 508.9,320.67 c -0.84,-0.11 -1.64,-0.53 -2.21,-1.24 -1.21,-1.49 -0.99,-3.67 0.5,-4.88 0.83,-0.68 1.88,-0.9 2.85,-0.7 0.62,-1.42 1.59,-2.7 2.9,-3.71 1.91,-1.46 4.2,-2.08 6.44,-1.92 0.63,-1.76 1.97,-3.06 3.58,-3.68 -1.3,-3.06 -0.51,-6.72 2.19,-8.91 3.02,-2.46 7.37,-2.2 10.12,0.46 0.79,-0.5 1.75,-0.73 2.76,-0.59 0.31,0.04 0.59,0.13 0.87,0.23 -0.35,0.28 -0.77,0.63 -1.25,1.04 -1.35,1.16 -1.6,1.59 -1.6,1.59 0,0 -4.5,-0.41 -6.41,2.26 -4.04,5.64 0.64,10.46 0.64,10.46 0,0 -5.37,-1.72 -8.79,-0.07 -2.87,1.39 -5.52,3.94 -6.5,6.65 -2.31,6.42 4.32,8.94 4.32,8.94 0,0 2.16,0.04 0.6,2.35 -0.69,1.02 -0.76,2.12 -0.64,3.03 -0.71,-0.5 -1.37,-1.09 -1.96,-1.78 -2.54,0.33 -5.2,-0.63 -6.94,-2.77 -1.6,-1.97 -2.06,-4.48 -1.48,-6.76 z m 10.16,0.93 c 0.89,-0.73 1.03,-2.04 0.3,-2.94 -0.73,-0.89 -2.04,-1.03 -2.93,-0.3 -0.89,0.73 -1.03,2.04 -0.3,2.93 0.73,0.89 2.04,1.03 2.93,0.3 z m 0.9,-4.41 c 0.57,-0.46 0.65,-1.29 0.19,-1.86 -0.46,-0.57 -1.29,-0.65 -1.86,-0.19 -0.57,0.46 -0.65,1.29 -0.19,1.86 0.46,0.57 1.29,0.65 1.86,0.19 z m 14.83,-14.91 c 0.57,-0.46 0.65,-1.29 0.19,-1.86 -0.46,-0.57 -1.29,-0.65 -1.86,-0.19 -0.57,0.46 -0.65,1.29 -0.19,1.86 0.46,0.57 1.29,0.65 1.86,0.19 z m -14.59,21.28 c 0.42,-0.34 0.48,-0.95 0.14,-1.37 -0.34,-0.42 -0.95,-0.48 -1.37,-0.14 -0.42,0.34 -0.48,0.95 -0.14,1.37 0.34,0.42 0.95,0.48 1.37,0.14 z m 14.06,-18.29 c 0.42,-0.34 0.48,-0.95 0.14,-1.37 -0.34,-0.42 -0.95,-0.48 -1.37,-0.14 -0.42,0.34 -0.48,0.95 -0.14,1.37 0.34,0.42 0.95,0.48 1.37,0.14 z"
           id="path117" />
        <path
           class="schulz-dashboard-center-icon-styling-22"
           d="m 537.66,315.51 c -2.74,1.1 -3.41,1.31 -3.17,0.53 0.66,-2.12 1.13,-2.67 4.27,-4.22 5.14,-2.54 3.82,-10.34 3.3,-12.3 0.34,0.33 0.66,0.68 0.95,1.06 2.98,3.88 2.68,9.21 -0.46,12.6 0,0.01 0,0.02 0,0.04 1.97,0.57 3.81,1.75 5.16,3.52 3.32,4.32 2.59,10.45 -1.63,13.69 -2.51,1.93 -5.7,2.4 -8.56,1.55 -7.94,-8.95 5.06,-1.15 7.86,-4.73 5.31,-6.77 -1.78,-14.11 -7.74,-11.73 z m -2.62,9.67 c -0.09,-1.73 -0.29,-0.23 -2.7,1.21 -2.64,1.59 -8.32,-0.06 -10.55,1.48 -0.82,0.56 2.5,5.42 1.97,5.83 2.4,0.29 4.88,-0.31 6.92,-1.88 0.98,-0.75 1.75,-1.65 2.35,-2.65 0,0 2.1,-2.26 2,-3.99 z m -23.67,-6.74 c 0.57,-0.46 0.65,-1.29 0.19,-1.86 -0.46,-0.57 -1.29,-0.65 -1.86,-0.19 -0.57,0.46 -0.65,1.29 -0.19,1.86 0.46,0.57 1.29,0.65 1.86,0.19 z m -0.26,2.35 c 0.36,-0.3 0.42,-0.83 0.12,-1.2 -0.3,-0.37 -0.83,-0.42 -1.2,-0.12 -0.37,0.3 -0.42,0.83 -0.12,1.2 0.3,0.36 0.83,0.42 1.2,0.12 z m 34.14,2.6 c 0.57,-0.46 0.65,-1.29 0.19,-1.86 -0.46,-0.57 -1.29,-0.65 -1.86,-0.19 -0.57,0.46 -0.65,1.29 -0.19,1.86 0.46,0.57 1.29,0.65 1.86,0.19 z m -5.14,-13.24 c 0.93,-0.75 1.07,-2.11 0.31,-3.04 -0.75,-0.92 -2.11,-1.06 -3.04,-0.31 -0.92,0.75 -1.07,2.11 -0.31,3.04 0.75,0.92 2.11,1.06 3.04,0.31 z m 5.12,15.45 c 0.27,-0.22 0.31,-0.61 0.09,-0.87 -0.22,-0.27 -0.61,-0.31 -0.87,-0.09 -0.27,0.22 -0.31,0.61 -0.09,0.87 0.22,0.27 0.61,0.31 0.87,0.09 z m -10.57,-2.15 c 0.27,-0.22 0.31,-0.61 0.09,-0.88 -0.22,-0.27 -0.61,-0.31 -0.87,-0.09 -0.27,0.22 -0.31,0.61 -0.09,0.87 0.22,0.27 0.61,0.31 0.88,0.09 z"
           id="path118" />
      </g>
      <g
         id="g120">
        <path
           class="schulz-dashboard-center-icon-styling-11"
           d="m 340.46,345.24 c 0,0 0.33,0.83 1.82,1.82 1.49,0.99 -0.17,2.97 -0.17,2.97 l -7.27,3.47 -5.12,-0.33 -8.92,2.64 -9.25,-4.29 -3.96,-2.97 c 0,0 3.14,-4.79 3.63,-4.96 0.5,-0.17 11.73,-1.98 12.22,-1.98 0.49,0 5.78,-1.65 5.78,-1.65 l 11.23,5.29 z"
           id="path119" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 314.7,346.32 c 0,0 -0.25,0.4 -1.36,0.88 -1.11,0.48 0.12,1.44 0.12,1.44 l 5.43,1.68 3.83,-0.16 6.67,1.28 6.91,-2.08 2.96,-1.44 c 0,0 -2.35,-2.33 -2.72,-2.41 -0.37,-0.08 -8.77,-0.96 -9.14,-0.96 -0.37,0 -4.32,-0.8 -4.32,-0.8 l -8.39,2.57 z"
           id="path120" />
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 322.28,348.71 c 0.82,1.19 4.64,1.19 5.62,0 l -0.98,-13.43 h -3.86 l 0.04,6.44 z"
         id="path121" />
      <g
         id="g145">
        <polygon
           class="schulz-dashboard-center-icon-styling-64"
           points="310.43,315.03 313.43,318.04 306.56,326.33 311.35,328.54 302.69,332.78 304.7,335.66 309.94,337.41 320.91,344.01 336.68,341.45 350.21,333.15 341.92,330.38 345.61,328.54 337.32,319.15 340.83,315.8 335.85,309.11 340.45,307.17 335.85,304.04 334.4,301.45 336.98,300.54 332.38,295.75 334.74,294.65 329.43,289.12 331.79,288.02 326.3,278.48 320.62,289.49 322.09,289.15 321.48,291.15 315.46,297.57 317.04,299.1 315.77,302.38 312.27,305.64 315.4,307.91 "
           id="polygon121" />
        <polygon
           class="schulz-dashboard-center-icon-styling-22"
           points="335.85,304.04 334.4,301.45 336.98,300.54 332.38,295.75 334.74,294.65 329.43,289.12 331.79,288.02 326.7,279.19 327.19,287.28 324.61,288.94 328.48,290.61 328.11,295.94 323.93,297.41 328.48,302.2 324.43,308.93 334.25,315.35 328.48,318.15 322.03,318.78 334.62,328.97 327.99,332.64 309.71,337.34 309.94,337.41 320.91,344.01 336.68,341.45 350.21,333.15 341.92,330.38 345.61,328.54 337.32,319.15 340.83,315.8 335.85,309.11 340.45,307.17 "
           id="polygon122" />
        <g
           id="g140">
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="313.43,318.04 306.56,326.33 321.23,317.08 "
             id="polygon123" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="310.43,315.03 312.72,317.08 318.75,308.58 315.4,307.91 "
             id="polygon124" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="315.77,302.38 312.27,305.64 313.49,306.53 317.3,302.81 317.47,299.67 "
             id="polygon125" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="311.35,328.54 302.69,332.78 326.45,328.54 "
             id="polygon126" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="324.21,290.7 321.62,290.7 321.48,291.15 315.46,297.57 316.46,297.58 "
             id="polygon127" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="324.67,286.52 326.3,278.48 320.62,289.49 321.56,289.28 "
             id="polygon128" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="315.46,305.95 317.47,304.23 317.47,305.71 "
             id="polygon129" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="325.25,290.7 325.25,292.25 326.3,291.48 "
             id="polygon130" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="316.47,315.35 318.75,315.35 318.75,313.37 "
             id="polygon131" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="326.45,327.46 324.21,325.29 323.12,326.88 "
             id="polygon132" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="333.46,334.26 331.22,332.09 330.13,333.69 "
             id="polygon133" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="341.69,329.63 339.45,327.46 338.35,329.05 "
             id="polygon134" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="322.46,325.29 321.23,327.46 319.39,327.46 "
             id="polygon135" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="326.45,301.95 325.25,303.1 324.21,301.95 "
             id="polygon136" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="330.72,306.77 329.52,307.91 328.48,306.77 "
             id="polygon137" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="338.93,306.77 337.73,307.91 336.69,306.77 "
             id="polygon138" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="332.91,294.44 331.72,295.58 330.67,294.44 "
             id="polygon139" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="328.48,316.08 330.48,315.5 327.99,314.36 "
             id="polygon140" />
        </g>
        <g
           class="schulz-dashboard-center-icon-styling-69"
           id="g144">
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="340.02,330.66 337.81,330.66 340.02,332.17 "
             id="polygon141" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="335.85,319.76 333.14,320.52 335.85,321.7 "
             id="polygon142" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="327.99,309.11 330.48,309.87 328.48,311.17 "
             id="polygon143" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="331.79,296.18 330.48,296.18 331.79,297.58 "
             id="polygon144" />
        </g>
      </g>
      <g
         id="g146">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 525.37,369.63 c 0,1.83 -4.51,3.31 -10.06,3.31 -5.55,0 -10.06,-1.48 -10.06,-3.31 0,-1.83 4.51,-3.31 10.06,-3.31 5.55,0 10.06,1.48 10.06,3.31 z"
           id="path145" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 520.93,369.8 c 0,1.22 -3.38,2.21 -7.55,2.21 -4.17,0 -7.55,-0.99 -7.55,-2.21 0,-1.22 3.38,-2.21 7.55,-2.21 4.17,0 7.55,0.99 7.55,2.21 z"
           id="path146" />
      </g>
      <g
         id="g151">
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 515.42,356.27 c 0.03,-0.98 0.03,-1.76 -0.05,-2.99 2.76,-0.95 4.36,-8.59 4.36,-8.59 -2.08,4.46 -3.74,6.75 -4.61,6.99 -0.1,-0.96 -0.22,-3.24 -0.27,-4.2 -0.05,-0.85 -0.1,-1.65 -0.21,-2.31 -0.18,-1.04 0.35,-5.74 -0.11,-6.18 0,0 -0.87,6.87 -1.23,6.1 -1.14,-2.38 -1.76,-2.75 -3.11,-4.77 -0.17,-0.25 3.12,6.7 3.08,7.09 -0.14,1.57 -0.31,3.84 -0.53,7.13 -1.02,-0.57 -2.59,-1.69 -3.46,-2.43 0.6,-2.03 -1.32,-6.02 -1.32,-6.02 0.06,2.15 0.88,5.01 0.49,5.27 -0.84,-1 -5.06,-4.15 -6.06,-5.45 0,0 5.9,7.75 10.19,10.74 -0.2,2.51 -0.28,6.66 -0.38,7.46 -0.22,1.68 -0.55,3.62 -0.89,5.08 -0.26,0.3 1.36,1.29 2.86,1.02 1.38,-0.24 2.38,-0.39 2.14,-1.02 -0.08,-0.73 -0.27,-1.42 -0.28,-2.2 -0.03,-1.55 -0.08,-7 -0.26,-8.08 6.23,-3.1 11.46,-10.56 11.46,-10.56 -4.48,4.38 -9.94,7.75 -11.81,7.9 z"
           id="path147" />
        <g
           class="schulz-dashboard-center-icon-styling-39"
           clip-path="url(#clippath-10)"
           id="g150">
          <path
             class="schulz-dashboard-center-icon-styling-72"
             d="m 512.58,356.67 c 0,0 0.67,1.48 0.67,2.33 0,0.85 0.21,6.6 0,7.13 -0.21,0.53 -0.67,5.74 -0.67,5.74 0,0 -0.33,-6.35 -0.38,-7.74 -0.04,-0.98 0.38,-7.46 0.38,-7.46 z"
             id="path148" />
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 514.81,371.55 c 0,0 -0.5,-3.3 -0.29,-5.21 0.21,-1.91 0.64,-2.23 0.32,-4.89 -0.32,-2.66 -0.74,-5.21 -0.64,-6.6 0.11,-1.38 0.11,-4.79 0.11,-4.79 l 1.07,3.22 c 0,0 -0.21,-0.77 0.74,-1.3 0.96,-0.53 1.38,0 1.38,0 l -2.08,4.29 c 0,0 -0.26,1.66 0.16,1.45 0.43,-0.21 2.23,-0.53 3.09,-1.06 0.85,-0.53 2.77,-0.32 1.6,0.11 -1.17,0.43 -4.04,6.38 -4.04,6.91 0,0.53 -0.32,4.89 -0.21,6.49 0.11,1.6 -1.2,1.38 -1.2,1.38 z"
             id="path149" />
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 509.52,356.76 c 0,0 1.81,-0.96 2.13,-1.06 0.32,-0.1 1.49,0.11 1.6,0.64 0.11,0.53 1.06,2.45 1.6,2.23 0.54,-0.22 0.53,-2.02 1.28,-2.55 0.74,-0.53 2.98,-0.74 3.83,-0.21 0.85,0.53 9.47,-3.83 9.47,-3.83 0,0 -0.64,-14.26 -1.06,-14.26 -0.42,0 -19.04,0.32 -19.04,0.32 l -2.77,12.87 2.98,5.85 z"
             id="path150" />
        </g>
      </g>
      <g
         id="g163">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 533.03,350.59 c 1.9,-1.41 3.14,-3.67 3.14,-6.23 0,-2.79 -1.47,-5.23 -3.67,-6.59 -0.08,-5.29 -4.21,-9.63 -9.43,-9.77 -1.24,-0.04 -2.43,0.18 -3.53,0.58 -0.31,-5.08 -4.35,-9.16 -9.42,-9.3 -5.37,-0.15 -9.84,4.18 -9.99,9.68 -0.06,2.25 0.62,4.34 1.8,6.04 0,0.01 -0.01,0.02 -0.02,0.03 -4.62,0.66 -8.24,4.64 -8.38,9.57 -0.02,0.75 0.05,1.48 0.18,2.18 -0.97,1.51 -0.83,3.57 0.48,4.97 0.7,0.75 1.6,1.18 2.54,1.29 0.46,3.83 3.7,6.81 7.63,6.81 3.51,0 6.46,-2.36 7.39,-5.59 1.65,0.54 3.53,0.38 5.15,-0.6 1.65,1.55 3.84,2.53 6.26,2.6 1.66,0.05 3.24,-0.34 4.63,-1.06 0.64,0.77 1.6,1.27 2.68,1.27 1.93,0 3.49,-1.56 3.49,-3.5 0,-0.92 -0.36,-1.76 -0.94,-2.38 z"
           id="path151" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 508.65,322.21 c 4.48,-1.02 6.28,-0.13 9.17,1.3 -1.7,-2.49 -4.49,-4.15 -7.69,-4.24 -5.37,-0.15 -9.84,4.18 -9.99,9.68 -0.06,2.25 0.62,4.34 1.8,6.04 0,0.01 -0.01,0.02 -0.02,0.03 -4.62,0.66 -8.24,4.64 -8.38,9.57 -0.01,0.49 0.01,0.97 0.07,1.44 0.84,-1.87 4.77,-8.81 10.42,-7.53 3.44,0.79 4.16,0.66 6.03,-0.58 0.68,-0.45 0.03,-0.72 -2.82,-1.6 -6.18,-1.92 -7.05,-12.18 1.41,-14.11 z"
           id="path152" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 515.44,330.42 c -1.03,1.41 0.15,1.5 2.89,0.77 1.59,-0.42 4.62,-1.11 7.34,-0.89 1,0.08 3.35,0.61 4.03,0.63 -1.69,-1.75 -4.02,-2.86 -6.62,-2.94 -1.24,-0.04 -2.43,0.18 -3.53,0.58 0,0 -3.08,0.44 -4.11,1.85 z"
           id="path153" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g159">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 536.18,344.36 c 0,-2.79 -1.47,-5.23 -3.67,-6.59 -0.01,-0.92 -0.16,-1.8 -0.4,-2.64 -0.48,0.8 -1.24,1.61 -2.43,1.97 -2.7,0.81 -1.03,2.22 -1.03,2.22 0,0 3.59,6.19 -2.31,9.75 -2.49,1.5 -6.19,1.81 -9.32,1.07 -3.73,-0.88 -6.84,-5.64 -6.84,-5.64 0,0 0.6,6.76 -6.16,8.6 -3.2,0.87 -6.46,-2.31 -6.46,-2.31 0,0 -0.46,0.18 -2.26,0.22 -0.64,0.02 -1.19,0.02 -1.64,0.02 0.15,0.26 0.32,0.51 0.54,0.74 0.7,0.75 1.6,1.18 2.54,1.29 0.46,3.83 3.7,6.81 7.63,6.81 3.51,0 6.46,-2.36 7.39,-5.59 1.65,0.54 3.53,0.38 5.15,-0.6 1.65,1.55 3.84,2.53 6.26,2.6 1.66,0.05 3.24,-0.34 4.63,-1.06 0.64,0.77 1.6,1.27 2.68,1.27 1.93,0 3.49,-1.56 3.49,-3.5 0,-0.92 -0.36,-1.76 -0.94,-2.38 1.9,-1.41 3.14,-3.67 3.14,-6.23 z"
             id="path154" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 527.78,345.51 c 0,1.16 -0.94,2.1 -2.1,2.1 -1.16,0 -2.11,-0.94 -2.11,-2.1 0,-1.16 0.94,-2.1 2.11,-2.1 1.17,0 2.1,0.94 2.1,2.1 z"
             id="path155" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 523.49,347.61 c 0,0.74 -0.6,1.34 -1.33,1.34 -0.73,0 -1.34,-0.6 -1.34,-1.34 0,-0.74 0.6,-1.33 1.34,-1.33 0.74,0 1.33,0.6 1.33,1.33 z"
             id="path156" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 502.39,349.84 c 0,0.74 -0.6,1.33 -1.33,1.33 -0.73,0 -1.34,-0.6 -1.34,-1.33 0,-0.73 0.6,-1.33 1.34,-1.33 0.74,0 1.33,0.6 1.33,1.33 z"
             id="path157" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 527.01,342.11 c 0,0.54 -0.44,0.98 -0.98,0.98 -0.54,0 -0.98,-0.44 -0.98,-0.98 0,-0.54 0.44,-0.98 0.98,-0.98 0.54,0 0.98,0.44 0.98,0.98 z"
             id="path158" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 504.36,347.48 c 0,0.54 -0.44,0.98 -0.98,0.98 -0.54,0 -0.98,-0.44 -0.98,-0.98 0,-0.54 0.44,-0.98 0.98,-0.98 0.54,0 0.98,0.44 0.98,0.98 z"
             id="path159" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 507.64,326.65 c 0,0.74 -0.6,1.34 -1.33,1.34 -0.73,0 -1.33,-0.6 -1.33,-1.34 0,-0.74 0.6,-1.33 1.33,-1.33 0.73,0 1.33,0.6 1.33,1.33 z"
           id="path160" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 504.08,341.13 c 0,1.2 -0.98,2.18 -2.18,2.18 -1.2,0 -2.18,-0.97 -2.18,-2.18 0,-1.21 0.97,-2.18 2.18,-2.18 1.21,0 2.18,0.97 2.18,2.18 z"
           id="path161" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 508.36,324.23 c 0,0.35 -0.28,0.63 -0.63,0.63 -0.35,0 -0.63,-0.28 -0.63,-0.63 0,-0.35 0.28,-0.63 0.63,-0.63 0.35,0 0.63,0.28 0.63,0.63 z"
           id="path162" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 515.26,332.65 c 0,0.35 -0.28,0.63 -0.63,0.63 -0.35,0 -0.63,-0.28 -0.63,-0.63 0,-0.35 0.28,-0.63 0.63,-0.63 0.35,0 0.63,0.28 0.63,0.63 z"
           id="path163" />
      </g>
      <g
         id="g165">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 443.98,369.48 c 0,2.46 -6.06,4.45 -13.53,4.45 -7.47,0 -13.53,-1.99 -13.53,-4.45 0,-2.46 6.06,-4.45 13.53,-4.45 7.47,0 13.53,1.99 13.53,4.45 z"
           id="path164" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 438.01,369.72 c 0,1.64 -4.54,2.97 -10.15,2.97 -5.61,0 -10.15,-1.33 -10.15,-2.97 0,-1.64 4.54,-2.97 10.15,-2.97 5.61,0 10.15,1.33 10.15,2.97 z"
           id="path165" />
      </g>
      <g
         id="g170">
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 426.48,351.52 c -0.04,-1.32 -0.04,-2.36 0.07,-4.02 -3.71,-1.27 -5.86,-11.55 -5.86,-11.55 2.79,6 5.04,9.08 6.19,9.4 0.13,-1.29 0.3,-4.36 0.37,-5.64 0.06,-1.14 0.14,-2.21 0.29,-3.11 0.24,-1.4 -0.47,-7.71 0.15,-8.31 0,0 1.17,9.23 1.66,8.2 1.53,-3.21 2.36,-3.69 4.18,-6.41 0.23,-0.34 -4.19,9.01 -4.14,9.53 0.18,2.11 0.42,5.16 0.72,9.59 1.38,-0.77 3.48,-2.27 4.65,-3.26 -0.8,-2.73 1.77,-8.09 1.77,-8.09 -0.08,2.89 -1.19,6.74 -0.66,7.09 1.13,-1.34 6.81,-5.59 8.15,-7.33 0,0 -7.94,10.42 -13.7,14.44 0.27,3.38 0.37,8.95 0.51,10.03 0.29,2.26 0.74,4.86 1.2,6.84 0.35,0.41 -1.83,1.73 -3.84,1.38 -1.85,-0.33 -3.19,-0.52 -2.88,-1.38 0.11,-0.98 0.36,-1.91 0.38,-2.96 0.04,-2.08 0.1,-9.41 0.34,-10.87 -8.38,-4.17 -15.41,-14.2 -15.41,-14.2 6.02,5.89 13.37,10.42 15.87,10.62 z"
           id="path166" />
        <g
           class="schulz-dashboard-center-icon-styling-36"
           clip-path="url(#clippath-11)"
           id="g169">
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 430.3,352.06 c 0,0 -0.9,1.99 -0.9,3.13 0,1.14 -0.29,8.87 0,9.58 0.29,0.71 0.9,7.72 0.9,7.72 0,0 0.44,-8.54 0.51,-10.41 0.05,-1.32 -0.51,-10.03 -0.51,-10.03 z"
             id="path167" />
          <path
             class="schulz-dashboard-center-icon-styling-72"
             d="m 427.3,372.07 c 0,0 0.67,-4.43 0.39,-7.01 -0.29,-2.57 -0.86,-3 -0.43,-6.58 0.43,-3.58 1,-7.01 0.86,-8.87 -0.14,-1.86 -0.14,-6.44 -0.14,-6.44 l -1.43,4.33 c 0,0 0.29,-1.04 -1,-1.75 -1.29,-0.72 -1.86,0 -1.86,0 l 2.79,5.78 c 0,0 0.35,2.24 -0.22,1.95 -0.57,-0.29 -3,-0.72 -4.15,-1.43 -1.14,-0.72 -3.72,-0.43 -2.15,0.14 1.57,0.57 5.44,8.58 5.44,9.3 0,0.72 0.43,6.58 0.29,8.73 -0.14,2.15 1.61,1.86 1.61,1.86 z"
             id="path168" />
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 434.41,352.18 c 0,0 -2.43,-1.29 -2.86,-1.43 -0.43,-0.14 -2,0.14 -2.15,0.86 -0.14,0.72 -1.43,3.29 -2.15,3 -0.72,-0.29 -0.72,-2.72 -1.72,-3.43 -1,-0.72 -4.01,-1 -5.15,-0.29 -1.14,0.72 -12.73,-5.15 -12.73,-5.15 0,0 0.86,-19.17 1.43,-19.17 0.57,0 25.61,0.43 25.61,0.43 l 3.72,17.31 -4.01,7.87 z"
             id="path169" />
        </g>
      </g>
      <g
         id="g172">
        <path
           class="schulz-dashboard-center-icon-styling-64"
           d="m 398.65,335.08 c -0.79,3.09 -0.16,6.5 2.01,9.17 2.37,2.91 5.97,4.21 9.42,3.76 4.57,5.45 12.56,6.47 18.12,2.2 1.32,-1.01 2.38,-2.24 3.19,-3.6 4.63,5.03 12.31,5.86 17.72,1.71 5.73,-4.4 6.72,-12.71 2.22,-18.57 -1.84,-2.4 -4.33,-4 -7.01,-4.77 0,-0.02 0,-0.03 -0.01,-0.05 4.26,-4.61 4.66,-11.83 0.62,-17.09 -0.61,-0.8 -1.3,-1.5 -2.04,-2.13 -0.27,-2.4 -2.16,-4.42 -4.72,-4.78 -1.36,-0.19 -2.67,0.13 -3.74,0.8 -3.73,-3.61 -9.63,-3.96 -13.73,-0.63 -3.66,2.97 -4.73,7.94 -2.97,12.09 -2.18,0.83 -4.01,2.6 -4.86,4.99 -3.04,-0.22 -6.15,0.62 -8.74,2.6 -1.78,1.36 -3.09,3.11 -3.94,5.03 -1.32,-0.26 -2.74,0.04 -3.87,0.95 -2.01,1.64 -2.32,4.6 -0.68,6.62 0.78,0.96 1.86,1.53 3,1.69 z"
           id="path170" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 398.65,335.08 c -1.14,-0.16 -2.22,-0.72 -3,-1.69 -1.64,-2.02 -1.34,-4.98 0.68,-6.62 1.13,-0.92 2.55,-1.22 3.87,-0.95 0.84,-1.93 2.16,-3.67 3.94,-5.03 2.59,-1.99 5.69,-2.82 8.74,-2.6 0.86,-2.39 2.68,-4.15 4.86,-4.99 -1.77,-4.15 -0.69,-9.12 2.97,-12.09 4.1,-3.34 10,-2.98 13.73,0.63 1.07,-0.68 2.38,-1 3.74,-0.8 0.41,0.06 0.8,0.17 1.18,0.31 -0.47,0.38 -1.04,0.85 -1.69,1.41 -1.83,1.57 -2.17,2.15 -2.17,2.15 0,0 -6.11,-0.55 -8.7,3.07 -5.48,7.65 0.87,14.19 0.87,14.19 0,0 -7.29,-2.33 -11.92,-0.09 -3.89,1.88 -7.5,5.34 -8.82,9.02 -3.14,8.71 5.86,12.13 5.86,12.13 0,0 2.94,0.05 0.82,3.19 -0.93,1.38 -1.04,2.87 -0.87,4.11 -0.97,-0.67 -1.86,-1.47 -2.65,-2.42 -3.45,0.44 -7.05,-0.85 -9.42,-3.76 -2.17,-2.67 -2.8,-6.08 -2.01,-9.17 z m 13.78,1.25 c 1.21,-0.99 1.4,-2.77 0.41,-3.98 -0.98,-1.21 -2.77,-1.39 -3.98,-0.41 -1.21,0.99 -1.4,2.77 -0.41,3.98 0.99,1.21 2.77,1.4 3.98,0.41 z m 1.23,-5.98 c 0.77,-0.63 0.89,-1.76 0.26,-2.53 -0.63,-0.77 -1.76,-0.89 -2.53,-0.26 -0.77,0.63 -0.88,1.76 -0.26,2.52 0.63,0.77 1.75,0.89 2.52,0.26 z m 20.11,-20.23 c 0.77,-0.63 0.89,-1.76 0.26,-2.52 -0.63,-0.77 -1.75,-0.89 -2.52,-0.26 -0.77,0.63 -0.89,1.75 -0.26,2.52 0.63,0.77 1.75,0.89 2.52,0.26 z M 413.98,339 c 0.56,-0.46 0.65,-1.29 0.19,-1.85 -0.46,-0.57 -1.29,-0.65 -1.86,-0.19 -0.57,0.46 -0.65,1.29 -0.19,1.86 0.46,0.56 1.29,0.65 1.85,0.19 z m 19.08,-24.82 c 0.57,-0.46 0.65,-1.29 0.19,-1.86 -0.46,-0.56 -1.29,-0.65 -1.86,-0.19 -0.56,0.46 -0.65,1.29 -0.19,1.86 0.46,0.56 1.29,0.65 1.86,0.19 z"
           id="path171" />
        <path
           class="schulz-dashboard-center-icon-styling-22"
           d="m 437.67,328.08 c -3.72,1.49 -4.63,1.78 -4.3,0.72 0.89,-2.88 1.54,-3.62 5.79,-5.72 6.98,-3.45 5.19,-14.03 4.48,-16.69 0.45,0.44 0.89,0.92 1.29,1.44 4.04,5.26 3.64,12.49 -0.62,17.09 0,0.02 0,0.03 0.01,0.05 2.68,0.77 5.16,2.37 7.01,4.77 4.5,5.86 3.51,14.18 -2.22,18.57 -3.41,2.62 -7.73,3.25 -11.62,2.1 -10.77,-12.15 6.86,-1.56 10.67,-6.42 7.2,-9.19 -2.42,-19.15 -10.5,-15.91 z m -3.56,13.11 c -0.13,-2.34 -0.39,-0.32 -3.66,1.65 -3.58,2.15 -11.29,-0.08 -14.31,2.01 -1.11,0.76 3.39,7.35 2.68,7.91 3.25,0.39 6.62,-0.42 9.4,-2.55 1.32,-1.01 2.38,-2.24 3.19,-3.6 0,0 2.84,-3.07 2.72,-5.41 z M 402,332.05 c 0.77,-0.63 0.89,-1.76 0.26,-2.53 -0.62,-0.77 -1.76,-0.88 -2.52,-0.26 -0.77,0.63 -0.89,1.76 -0.26,2.52 0.63,0.77 1.76,0.89 2.53,0.26 z m -0.36,3.19 c 0.49,-0.4 0.57,-1.13 0.17,-1.62 -0.4,-0.5 -1.13,-0.57 -1.62,-0.17 -0.5,0.4 -0.57,1.13 -0.17,1.62 0.4,0.49 1.13,0.57 1.62,0.17 z m 46.33,3.53 c 0.77,-0.63 0.89,-1.75 0.26,-2.52 -0.63,-0.77 -1.76,-0.89 -2.52,-0.26 -0.76,0.63 -0.89,1.76 -0.26,2.53 0.63,0.77 1.76,0.88 2.52,0.26 z M 441,320.8 c 1.26,-1.02 1.45,-2.86 0.43,-4.12 -1.02,-1.25 -2.86,-1.44 -4.12,-0.42 -1.25,1.02 -1.45,2.86 -0.43,4.12 1.02,1.25 2.87,1.44 4.12,0.42 z m 6.94,20.97 c 0.36,-0.29 0.42,-0.82 0.12,-1.19 -0.29,-0.36 -0.82,-0.42 -1.19,-0.12 -0.36,0.29 -0.42,0.83 -0.12,1.19 0.3,0.36 0.82,0.42 1.19,0.12 z m -14.34,-2.93 c 0.36,-0.29 0.42,-0.83 0.12,-1.19 -0.29,-0.36 -0.83,-0.41 -1.19,-0.12 -0.36,0.29 -0.42,0.82 -0.12,1.19 0.29,0.36 0.83,0.42 1.19,0.12 z"
           id="path172" />
      </g>
      <g
         id="g174">
        <path
           class="schulz-dashboard-center-icon-styling-11"
           d="m 414.48,370.72 c 0,4.24 -10.43,7.67 -23.3,7.67 -12.87,0 -23.3,-3.43 -23.3,-7.67 0,-4.24 10.43,-7.67 23.3,-7.67 12.87,0 23.3,3.43 23.3,7.67 z"
           id="path173" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 396.42,370.11 c 0,1.72 -4.78,3.12 -10.67,3.12 -5.89,0 -10.67,-1.4 -10.67,-3.12 0,-1.72 4.78,-3.12 10.67,-3.12 5.89,0 10.67,1.4 10.67,3.12 z"
           id="path174" />
      </g>
      <g
         id="g179">
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 391.08,369.26 c -0.21,1.49 -0.25,2.6 -2.95,2.72 -3.18,0.15 -9.08,-0.95 -9.27,-2.72 0,0 0.31,-12.83 3.97,-21.7 3.67,-8.86 3.35,-26.58 3.66,-29.94 0.31,-3.37 1.84,-5.04 1.84,-5.04 l 2.75,2.42 c 0,0 0.61,15.76 0,21.57 -0.61,5.81 -1.99,11.68 -2.44,18.14 -0.38,5.39 2.44,14.56 2.44,14.56 z"
           id="path175" />
        <g
           class="schulz-dashboard-center-icon-styling-43"
           clip-path="url(#clippath-12)"
           id="g178">
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 387.6,372.69 c 0,0 -3.57,-11.34 -1.97,-16.38 1.6,-5.04 4.13,-22.69 4.13,-25.67 0,-2.98 0.46,-10.54 -0.92,-11.69 -1.38,-1.15 -2.75,2.06 -2.75,2.06 0,0 -2.06,-11.92 -1.38,-11.92 0.68,0 14.9,1.38 14.9,1.38 l -6.19,53.63 0.23,6.65 -6.05,1.95 z"
             id="path176" />
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 379.94,354.36 c 0,0 3.19,-1.17 3.72,-0.43 0.53,0.74 0.11,0.96 1.17,2.66 1.06,1.7 4.68,1.6 5,1.38 0.32,-0.21 4.04,-0.11 3.3,-1.28 -0.74,-1.17 0.32,-11.06 -1.6,-11.28 -1.91,-0.21 -10.21,-0.85 -10.21,-0.53 0,0.32 -1.38,9.47 -1.38,9.47 z"
             id="path177" />
          <path
             class="schulz-dashboard-center-icon-styling-72"
             d="m 381.44,372.41 c 0,0 -0.3,-6.21 -0.03,-9.21 0.27,-3.01 1.52,-3.33 1.4,-5.43 -0.12,-2.11 -1.06,-4.15 -1.06,-4.15 0,0 -0.7,2.45 -1.06,4.26 -0.37,1.81 -0.47,4.87 -0.6,6.83 -0.12,1.96 0,6.77 0,6.77 l 1.36,0.94 z"
             id="path178" />
        </g>
      </g>
      <g
         id="g193">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 413.71,341.87 c 2.81,-2.08 4.64,-5.42 4.64,-9.2 0,-4.12 -2.17,-7.72 -5.42,-9.74 -0.12,-7.82 -6.22,-14.22 -13.92,-14.43 -1.83,-0.05 -3.58,0.26 -5.21,0.86 -0.46,-7.5 -6.43,-13.53 -13.91,-13.74 -7.92,-0.22 -14.53,6.17 -14.76,14.29 -0.09,3.32 0.92,6.41 2.66,8.92 0,0.02 -0.02,0.03 -0.02,0.05 -6.82,0.97 -12.17,6.85 -12.38,14.13 -0.03,1.11 0.07,2.18 0.27,3.22 -1.44,2.23 -1.22,5.27 0.71,7.34 1.03,1.11 2.37,1.74 3.75,1.91 0.68,5.66 5.46,10.05 11.27,10.05 5.18,0 9.54,-3.48 10.91,-8.25 2.44,0.8 5.22,0.56 7.6,-0.88 2.44,2.29 5.67,3.74 9.25,3.84 2.46,0.07 4.79,-0.5 6.84,-1.56 0.94,1.14 2.36,1.87 3.96,1.87 2.85,0 5.16,-2.31 5.16,-5.17 0,-1.36 -0.53,-2.6 -1.39,-3.52 z"
           id="path179" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 377.69,299.97 c 6.61,-1.5 9.27,-0.19 13.54,1.92 -2.51,-3.68 -6.63,-6.13 -11.35,-6.26 -7.92,-0.22 -14.53,6.17 -14.76,14.29 -0.09,3.32 0.92,6.41 2.66,8.92 0,0.02 -0.02,0.03 -0.02,0.05 -6.82,0.97 -12.17,6.85 -12.38,14.13 -0.02,0.72 0.02,1.43 0.1,2.13 1.25,-2.76 7.05,-13.02 15.39,-11.12 5.08,1.16 6.15,0.98 8.9,-0.86 1.01,-0.67 0.04,-1.06 -4.17,-2.36 -9.12,-2.84 -10.42,-17.99 2.08,-20.84 z"
           id="path180" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 387.73,312.09 c -1.51,2.08 0.22,2.22 4.26,1.13 2.34,-0.62 6.82,-1.63 10.84,-1.32 1.47,0.12 4.95,0.91 5.95,0.93 -2.5,-2.59 -5.94,-4.23 -9.78,-4.33 -1.83,-0.05 -3.58,0.26 -5.21,0.86 0,0 -4.55,0.64 -6.07,2.73 z"
           id="path181" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g187">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 418.35,332.67 c 0,-4.12 -2.17,-7.72 -5.42,-9.74 -0.02,-1.35 -0.23,-2.66 -0.59,-3.9 -0.71,1.18 -1.84,2.38 -3.59,2.91 -3.98,1.2 -1.52,3.28 -1.52,3.28 0,0 -2.42,-5.86 -11.13,-0.61 -3.67,2.22 -5.03,5.49 -9.65,4.4 -5.5,-1.3 -6.36,1.28 -6.49,3.85 -0.13,2.57 0.88,9.98 -9.09,12.7 -4.72,1.28 -9.54,-3.42 -9.54,-3.42 0,0 -0.69,0.26 -3.34,0.33 -0.94,0.03 -1.75,0.03 -2.42,0.03 0.23,0.38 0.48,0.75 0.79,1.09 1.03,1.11 2.37,1.74 3.75,1.91 0.68,5.66 5.46,10.05 11.27,10.05 5.18,0 9.54,-3.48 10.91,-8.25 2.44,0.8 5.22,0.56 7.6,-0.88 2.44,2.29 5.67,3.74 9.25,3.84 2.46,0.07 4.79,-0.5 6.84,-1.56 0.94,1.14 2.36,1.87 3.96,1.87 2.85,0 5.16,-2.31 5.16,-5.17 0,-1.36 -0.53,-2.6 -1.39,-3.52 2.81,-2.08 4.64,-5.42 4.64,-9.2 z"
             id="path182" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 405.94,334.37 c 0,1.71 -1.39,3.11 -3.11,3.11 -1.72,0 -3.11,-1.39 -3.11,-3.11 0,-1.72 1.39,-3.11 3.11,-3.11 1.72,0 3.11,1.39 3.11,3.11 z"
             id="path183" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 399.61,337.47 c 0,1.09 -0.88,1.97 -1.97,1.97 -1.09,0 -1.97,-0.88 -1.97,-1.97 0,-1.09 0.88,-1.97 1.97,-1.97 1.09,0 1.97,0.88 1.97,1.97 z"
             id="path184" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 368.45,340.77 c 0,1.09 -0.88,1.97 -1.97,1.97 -1.09,0 -1.97,-0.88 -1.97,-1.97 0,-1.09 0.88,-1.97 1.97,-1.97 1.09,0 1.97,0.88 1.97,1.97 z"
             id="path185" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 404.8,329.36 c 0,0.8 -0.65,1.45 -1.45,1.45 -0.8,0 -1.45,-0.65 -1.45,-1.45 0,-0.8 0.65,-1.45 1.45,-1.45 0.8,0 1.45,0.65 1.45,1.45 z"
             id="path186" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 371.35,337.29 c 0,0.8 -0.65,1.45 -1.45,1.45 -0.8,0 -1.45,-0.65 -1.45,-1.45 0,-0.8 0.65,-1.45 1.45,-1.45 0.8,0 1.45,0.65 1.45,1.45 z"
             id="path187" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-71"
           d="m 410.72,344.1 c 0,1.09 -0.88,1.97 -1.97,1.97 -1.09,0 -1.97,-0.88 -1.97,-1.97 0,-1.09 0.88,-1.97 1.97,-1.97 1.09,0 1.97,0.88 1.97,1.97 z"
           id="path188" />
        <path
           class="schulz-dashboard-center-icon-styling-71"
           d="m 412.53,340.93 c 0,0.7 -0.57,1.27 -1.27,1.27 -0.7,0 -1.27,-0.56 -1.27,-1.27 0,-0.71 0.57,-1.27 1.27,-1.27 0.7,0 1.27,0.57 1.27,1.27 z"
           id="path189" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 376.2,306.52 c 0,1.09 -0.88,1.97 -1.97,1.97 -1.09,0 -1.97,-0.88 -1.97,-1.97 0,-1.09 0.88,-1.97 1.97,-1.97 1.09,0 1.97,0.88 1.97,1.97 z"
           id="path190" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 370.95,327.91 c 0,1.78 -1.44,3.21 -3.22,3.21 -1.78,0 -3.22,-1.44 -3.22,-3.21 0,-1.77 1.44,-3.21 3.22,-3.21 1.78,0 3.22,1.44 3.22,3.21 z"
           id="path191" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 377.27,302.94 c 0,0.51 -0.41,0.93 -0.93,0.93 -0.52,0 -0.92,-0.41 -0.92,-0.93 0,-0.52 0.41,-0.93 0.92,-0.93 0.51,0 0.93,0.41 0.93,0.93 z"
           id="path192" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 387.46,315.38 c 0,0.51 -0.41,0.92 -0.93,0.92 -0.52,0 -0.93,-0.41 -0.93,-0.92 0,-0.51 0.42,-0.93 0.93,-0.93 0.51,0 0.93,0.42 0.93,0.93 z"
           id="path193" />
      </g>
      <g
         id="g207">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 418.17,334.88 c -1.55,-0.61 -3.24,-0.17 -4.36,0.96 -1.89,-2.52 -5.09,-3.73 -8.13,-2.99 0.39,-1.63 0.29,-3.4 -0.42,-5.08 -1.73,-4.07 -6.35,-6 -10.32,-4.3 -3.75,1.59 -5.58,5.84 -4.32,9.73 -0.94,0.02 -1.9,0.21 -2.81,0.6 -3.97,1.69 -5.79,6.36 -4.06,10.42 0.35,0.83 0.83,1.57 1.4,2.21 -0.18,1.39 -0.02,2.85 0.58,4.25 1.73,4.07 6.35,5.99 10.33,4.3 1.25,-0.53 2.28,-1.36 3.06,-2.37 0.09,0.04 0.16,0.09 0.25,0.13 2.52,0.99 5.37,-0.28 6.37,-2.84 0.2,-0.5 0.3,-1.01 0.33,-1.51 1.52,0.34 3.15,0.23 4.67,-0.42 0.9,-0.38 1.69,-0.93 2.35,-1.58 0.32,0.47 0.77,0.85 1.32,1.07 1.52,0.6 3.25,-0.18 3.86,-1.73 0.42,-1.06 0.21,-2.21 -0.45,-3.03 1.15,-0.37 2.13,-1.24 2.61,-2.46 0.84,-2.14 -0.17,-4.53 -2.25,-5.35 z"
           id="path194" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 399.15,327.04 c 0.29,0.75 -0.07,1.59 -0.82,1.88 -0.75,0.29 -1.59,-0.08 -1.89,-0.82 -0.29,-0.75 0.07,-1.59 0.82,-1.89 0.75,-0.29 1.59,0.08 1.88,0.82 z"
           id="path195" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 395.72,327.65 c 0.14,0.35 -0.03,0.75 -0.39,0.89 -0.35,0.14 -0.75,-0.04 -0.89,-0.39 -0.14,-0.35 0.04,-0.75 0.39,-0.89 0.35,-0.14 0.75,0.04 0.89,0.39 z"
           id="path196" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 416.22,336.13 c 0.14,0.35 -0.04,0.75 -0.39,0.89 -0.35,0.14 -0.75,-0.03 -0.89,-0.39 -0.14,-0.35 0.03,-0.75 0.39,-0.89 0.35,-0.14 0.75,0.03 0.89,0.39 z"
           id="path197" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g203">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 396.05,354.98 c 1.25,-0.53 2.28,-1.36 3.06,-2.37 0.09,0.04 0.16,0.09 0.25,0.13 2.52,0.99 5.37,-0.28 6.37,-2.84 0.2,-0.5 0.3,-1.01 0.33,-1.51 1.52,0.34 3.15,0.23 4.67,-0.42 0.9,-0.38 1.69,-0.93 2.35,-1.58 0.32,0.47 0.77,0.85 1.32,1.07 1.52,0.6 3.25,-0.18 3.86,-1.73 0.42,-1.06 0.21,-2.21 -0.45,-3.03 1.15,-0.37 2.13,-1.24 2.61,-2.46 0.72,-1.83 0.08,-3.85 -1.44,-4.91 -0.02,1.34 -0.16,3.02 -0.64,3.9 -0.88,1.59 -3.26,-0.27 -5.09,-1.05 -1.83,-0.78 -1.88,0.89 -3.34,2.52 -1.46,1.64 -3.9,0.68 -7,0.89 -3.1,0.21 -6.35,5.99 -7.71,7.13 -1.35,1.14 -3.13,3.48 -6.51,3.3 -1.07,-0.05 -1.97,-0.37 -2.7,-0.77 1.9,3.67 6.27,5.34 10.05,3.74 z"
             id="path198" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 408.37,338.9 c 0.34,0.86 -0.09,1.83 -0.95,2.17 -0.86,0.34 -1.83,-0.09 -2.17,-0.95 -0.34,-0.86 0.09,-1.83 0.95,-2.17 0.86,-0.34 1.83,0.09 2.17,0.94 z"
             id="path199" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 390.01,344.06 c 0.28,0.73 -0.07,1.54 -0.8,1.82 -0.72,0.28 -1.54,-0.07 -1.82,-0.8 -0.28,-0.72 0.07,-1.54 0.79,-1.82 0.72,-0.28 1.54,0.07 1.82,0.8 z"
             id="path200" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 410.08,337.69 c 0.16,0.4 -0.04,0.84 -0.43,0.99 -0.39,0.15 -0.84,-0.04 -0.99,-0.43 -0.15,-0.39 0.04,-0.84 0.43,-1 0.4,-0.16 0.84,0.04 1,0.43 z"
             id="path201" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 386.74,345.2 c 0.16,0.4 -0.04,0.84 -0.43,0.99 -0.39,0.15 -0.84,-0.04 -1,-0.43 -0.15,-0.39 0.04,-0.84 0.43,-0.99 0.39,-0.15 0.84,0.04 0.99,0.43 z"
             id="path202" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 389.92,341.64 c 0.16,0.4 -0.04,0.86 -0.44,1.02 -0.41,0.16 -0.86,-0.04 -1.02,-0.44 -0.16,-0.4 0.04,-0.86 0.45,-1.02 0.4,-0.16 0.86,0.04 1.01,0.44 z"
             id="path203" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 394.94,323.46 c -3.75,1.59 -5.58,5.84 -4.32,9.73 -0.94,0.02 -1.89,0.21 -2.81,0.6 -2.76,1.17 -4.48,3.79 -4.69,6.64 2.22,-3.57 7.38,-4.83 9.97,-5.25 0.21,-0.03 0.37,-0.2 0.41,-0.41 0.03,-0.21 -0.07,-0.42 -0.26,-0.52 l -1.07,-0.57 c -0.33,-0.18 -0.52,-0.55 -0.46,-0.92 0.36,-2.18 2.17,-9.2 10.59,-8.59 -2.13,-1.42 -4.88,-1.79 -7.37,-0.73 z"
           id="path204" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 405.69,332.82 c -3.84,2.01 -5.83,5.36 -5.83,5.36 0,0 4.1,-3.14 8.43,-4.34 0.61,-0.17 1.66,-0.32 2.73,-0.34 -1.62,-0.82 -3.51,-1.09 -5.33,-0.65 0,0 0,-0.02 0,-0.03 z"
           id="path205" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 401.77,346.14 c 0.29,0.75 -0.07,1.59 -0.82,1.89 -0.75,0.29 -1.59,-0.08 -1.89,-0.82 -0.29,-0.75 0.08,-1.59 0.82,-1.88 0.75,-0.29 1.59,0.07 1.88,0.82 z"
           id="path206" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 401.29,343.69 c 0.14,0.35 -0.04,0.75 -0.39,0.89 -0.35,0.14 -0.75,-0.04 -0.89,-0.39 -0.14,-0.35 0.04,-0.75 0.39,-0.89 0.35,-0.14 0.75,0.03 0.89,0.39 z"
           id="path207" />
      </g>
      <g
         id="g209">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 490.26,367.72 c 0,2.72 -6.7,4.93 -14.97,4.93 -8.27,0 -14.97,-2.21 -14.97,-4.93 0,-2.72 6.7,-4.93 14.97,-4.93 8.27,0 14.97,2.21 14.97,4.93 z"
           id="path208" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 481.8,367.22 c 0,1.41 -3.91,2.56 -8.74,2.56 -4.83,0 -8.74,-1.15 -8.74,-2.56 0,-1.41 3.91,-2.56 8.74,-2.56 4.83,0 8.74,1.15 8.74,2.56 z"
           id="path209" />
      </g>
      <g
         id="g214">
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 477.42,366.53 c -0.17,1.22 -0.2,2.13 -2.42,2.23 -2.6,0.12 -7.44,-0.78 -7.6,-2.23 0,0 0.25,-10.52 3.26,-17.78 3.01,-7.26 2.75,-21.78 3,-24.54 0.25,-2.76 1.51,-4.13 1.51,-4.13 l 2.25,1.98 c 0,0 0.5,12.92 0,17.67 -0.5,4.76 -1.63,9.57 -2,14.86 -0.31,4.42 2,11.93 2,11.93 z"
           id="path210" />
        <g
           class="schulz-dashboard-center-icon-styling-41"
           clip-path="url(#clippath-13)"
           id="g213">
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 474.57,369.34 c 0,0 -2.93,-9.29 -1.61,-13.43 1.31,-4.13 3.38,-18.59 3.38,-21.04 0,-2.45 0.38,-8.64 -0.75,-9.58 -1.13,-0.94 -2.25,1.69 -2.25,1.69 0,0 -1.69,-9.77 -1.13,-9.77 0.56,0 12.21,1.13 12.21,1.13 l -5.07,43.95 0.19,5.45 -4.96,1.59 z"
             id="path211" />
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 468.29,354.32 c 0,0 2.62,-0.96 3.05,-0.35 0.43,0.61 0.09,0.78 0.96,2.18 0.87,1.39 3.84,1.31 4.1,1.13 0.26,-0.17 3.31,-0.09 2.7,-1.05 -0.61,-0.96 0.26,-9.07 -1.31,-9.24 -1.57,-0.17 -8.37,-0.7 -8.37,-0.44 0,0.26 -1.13,7.76 -1.13,7.76 z"
             id="path212" />
          <path
             class="schulz-dashboard-center-icon-styling-72"
             d="m 469.52,369.11 c 0,0 -0.24,-5.09 -0.03,-7.55 0.22,-2.47 1.25,-2.73 1.15,-4.45 -0.1,-1.72 -0.87,-3.4 -0.87,-3.4 0,0 -0.57,2.01 -0.87,3.49 -0.3,1.48 -0.39,3.99 -0.49,5.6 -0.1,1.6 0,5.55 0,5.55 l 1.11,0.77 z"
             id="path213" />
        </g>
      </g>
      <g
         id="g228">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 495.96,344.08 c 2.3,-1.71 3.8,-4.44 3.8,-7.54 0,-3.38 -1.78,-6.33 -4.44,-7.98 -0.1,-6.41 -5.09,-11.65 -11.41,-11.83 -1.5,-0.04 -2.94,0.22 -4.27,0.7 -0.38,-6.14 -5.27,-11.09 -11.4,-11.26 -6.49,-0.18 -11.91,5.06 -12.09,11.71 -0.08,2.72 0.75,5.25 2.18,7.31 0,0.01 -0.01,0.03 -0.02,0.04 -5.59,0.79 -9.98,5.61 -10.14,11.58 -0.02,0.91 0.06,1.79 0.22,2.64 -1.18,1.83 -1,4.32 0.58,6.01 0.84,0.91 1.94,1.43 3.07,1.56 0.56,4.64 4.48,8.24 9.24,8.24 4.24,0 7.81,-2.86 8.94,-6.76 2,0.66 4.28,0.46 6.23,-0.72 2,1.88 4.65,3.06 7.58,3.14 2.01,0.06 3.92,-0.41 5.61,-1.28 0.77,0.93 1.94,1.53 3.25,1.53 2.33,0 4.23,-1.89 4.23,-4.24 0,-1.11 -0.43,-2.13 -1.14,-2.88 z"
           id="path214" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 466.45,309.74 c 5.42,-1.23 7.59,-0.16 11.1,1.57 -2.06,-3.01 -5.43,-5.02 -9.3,-5.13 -6.49,-0.18 -11.91,5.06 -12.09,11.71 -0.08,2.72 0.75,5.25 2.18,7.31 0,0.01 -0.01,0.03 -0.02,0.04 -5.59,0.79 -9.98,5.61 -10.14,11.58 -0.01,0.59 0.02,1.17 0.08,1.74 1.02,-2.26 5.78,-10.67 12.61,-9.11 4.16,0.95 5.04,0.8 7.29,-0.7 0.83,-0.55 0.03,-0.87 -3.41,-1.94 -7.48,-2.33 -8.54,-14.75 1.71,-17.07 z"
           id="path215" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 474.67,319.67 c -1.24,1.71 0.18,1.82 3.49,0.93 1.92,-0.51 5.59,-1.34 8.89,-1.08 1.21,0.1 4.06,0.74 4.87,0.76 -2.05,-2.12 -4.86,-3.46 -8.01,-3.55 -1.5,-0.04 -2.94,0.22 -4.27,0.7 0,0 -3.73,0.53 -4.97,2.24 z"
           id="path216" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g222">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 499.77,336.54 c 0,-3.38 -1.78,-6.33 -4.44,-7.98 -0.02,-1.11 -0.19,-2.18 -0.48,-3.2 -0.58,0.96 -1.51,1.95 -2.94,2.38 -3.26,0.98 -1.24,2.69 -1.24,2.69 0,0 -1.99,-4.8 -9.12,-0.5 -3.01,1.82 -4.12,4.5 -7.9,3.6 -4.51,-1.06 -5.21,1.05 -5.32,3.16 -0.11,2.1 0.72,8.18 -7.45,10.4 -3.87,1.05 -7.82,-2.8 -7.82,-2.8 0,0 -0.56,0.21 -2.74,0.27 -0.77,0.02 -1.44,0.03 -1.98,0.02 0.19,0.31 0.39,0.62 0.65,0.89 0.84,0.91 1.94,1.43 3.07,1.56 0.56,4.64 4.48,8.24 9.24,8.24 4.24,0 7.81,-2.86 8.94,-6.76 2,0.66 4.28,0.46 6.23,-0.72 2,1.88 4.65,3.06 7.58,3.14 2.01,0.06 3.92,-0.41 5.61,-1.28 0.77,0.93 1.94,1.53 3.25,1.53 2.33,0 4.23,-1.89 4.23,-4.24 0,-1.11 -0.43,-2.13 -1.14,-2.88 2.3,-1.71 3.8,-4.44 3.8,-7.54 z"
             id="path217" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 489.6,337.93 c 0,1.4 -1.14,2.54 -2.55,2.54 -1.41,0 -2.55,-1.14 -2.55,-2.54 0,-1.4 1.14,-2.55 2.55,-2.55 1.41,0 2.55,1.14 2.55,2.55 z"
             id="path218" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 484.41,340.48 c 0,0.89 -0.72,1.62 -1.61,1.62 -0.89,0 -1.62,-0.72 -1.62,-1.62 0,-0.9 0.72,-1.61 1.62,-1.61 0.9,0 1.61,0.72 1.61,1.61 z"
             id="path219" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 458.88,343.18 c 0,0.89 -0.72,1.61 -1.62,1.61 -0.9,0 -1.62,-0.72 -1.62,-1.61 0,-0.89 0.72,-1.61 1.62,-1.61 0.9,0 1.62,0.72 1.62,1.61 z"
             id="path220" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 488.67,333.83 c 0,0.66 -0.53,1.19 -1.19,1.19 -0.66,0 -1.19,-0.53 -1.19,-1.19 0,-0.66 0.53,-1.19 1.19,-1.19 0.66,0 1.19,0.53 1.19,1.19 z"
             id="path221" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 461.25,340.33 c 0,0.65 -0.53,1.19 -1.19,1.19 -0.66,0 -1.19,-0.53 -1.19,-1.19 0,-0.66 0.53,-1.19 1.19,-1.19 0.66,0 1.19,0.53 1.19,1.19 z"
             id="path222" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-71"
           d="m 493.52,345.91 c 0,0.89 -0.72,1.61 -1.62,1.61 -0.9,0 -1.62,-0.72 -1.62,-1.61 0,-0.89 0.72,-1.62 1.62,-1.62 0.9,0 1.62,0.72 1.62,1.62 z"
           id="path223" />
        <path
           class="schulz-dashboard-center-icon-styling-71"
           d="m 495,343.31 c 0,0.57 -0.46,1.04 -1.04,1.04 -0.58,0 -1.04,-0.46 -1.04,-1.04 0,-0.58 0.47,-1.04 1.04,-1.04 0.57,0 1.04,0.46 1.04,1.04 z"
           id="path224" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 465.23,315.11 c 0,0.89 -0.72,1.62 -1.62,1.62 -0.9,0 -1.61,-0.72 -1.61,-1.62 0,-0.9 0.72,-1.61 1.61,-1.61 0.89,0 1.62,0.72 1.62,1.61 z"
           id="path225" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 460.92,332.64 c 0,1.46 -1.18,2.63 -2.64,2.63 -1.46,0 -2.64,-1.18 -2.64,-2.63 0,-1.45 1.18,-2.63 2.64,-2.63 1.46,0 2.64,1.18 2.64,2.63 z"
           id="path226" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 466.1,312.18 c 0,0.42 -0.34,0.76 -0.76,0.76 -0.42,0 -0.76,-0.34 -0.76,-0.76 0,-0.42 0.34,-0.76 0.76,-0.76 0.42,0 0.76,0.34 0.76,0.76 z"
           id="path227" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 474.45,322.37 c 0,0.42 -0.34,0.76 -0.76,0.76 -0.42,0 -0.76,-0.34 -0.76,-0.76 0,-0.42 0.34,-0.76 0.76,-0.76 0.42,0 0.76,0.34 0.76,0.76 z"
           id="path228" />
      </g>
      <g
         id="g242">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 499.62,338.35 c -1.27,-0.5 -2.66,-0.14 -3.57,0.79 -1.55,-2.07 -4.17,-3.05 -6.66,-2.45 0.32,-1.33 0.24,-2.79 -0.35,-4.16 -1.42,-3.33 -5.2,-4.91 -8.46,-3.53 -3.07,1.31 -4.57,4.79 -3.54,7.97 -0.77,0.02 -1.55,0.17 -2.31,0.49 -3.25,1.38 -4.75,5.21 -3.33,8.54 0.29,0.68 0.68,1.29 1.15,1.81 -0.15,1.14 -0.01,2.34 0.47,3.48 1.42,3.33 5.21,4.91 8.46,3.53 1.02,-0.44 1.87,-1.12 2.51,-1.94 0.07,0.03 0.13,0.07 0.21,0.1 2.07,0.81 4.4,-0.23 5.22,-2.32 0.16,-0.41 0.24,-0.83 0.27,-1.24 1.25,0.28 2.58,0.19 3.83,-0.35 0.74,-0.31 1.38,-0.76 1.93,-1.29 0.26,0.38 0.63,0.69 1.08,0.87 1.25,0.49 2.66,-0.15 3.16,-1.42 0.34,-0.87 0.17,-1.81 -0.37,-2.48 0.94,-0.3 1.75,-1.01 2.14,-2.02 0.69,-1.75 -0.14,-3.71 -1.85,-4.38 z"
           id="path229" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 484.04,331.93 c 0.24,0.61 -0.06,1.3 -0.67,1.54 -0.61,0.24 -1.31,-0.06 -1.55,-0.67 -0.24,-0.61 0.06,-1.31 0.67,-1.55 0.61,-0.24 1.3,0.06 1.54,0.67 z"
           id="path230" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 481.23,332.43 c 0.11,0.29 -0.03,0.61 -0.32,0.73 -0.29,0.11 -0.61,-0.03 -0.73,-0.32 -0.11,-0.29 0.03,-0.61 0.32,-0.73 0.29,-0.11 0.61,0.03 0.73,0.32 z"
           id="path231" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 498.02,339.38 c 0.11,0.29 -0.03,0.61 -0.32,0.73 -0.29,0.11 -0.61,-0.03 -0.73,-0.32 -0.11,-0.29 0.03,-0.61 0.32,-0.73 0.29,-0.11 0.61,0.03 0.73,0.32 z"
           id="path232" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g238">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 481.49,354.82 c 1.02,-0.44 1.87,-1.12 2.51,-1.94 0.07,0.03 0.13,0.07 0.21,0.1 2.07,0.81 4.4,-0.23 5.22,-2.32 0.16,-0.41 0.24,-0.83 0.27,-1.24 1.25,0.28 2.58,0.19 3.83,-0.35 0.74,-0.31 1.38,-0.76 1.93,-1.29 0.26,0.38 0.63,0.69 1.08,0.87 1.25,0.49 2.66,-0.15 3.16,-1.42 0.34,-0.87 0.17,-1.81 -0.37,-2.48 0.94,-0.3 1.75,-1.01 2.14,-2.02 0.59,-1.5 0.06,-3.16 -1.18,-4.02 -0.02,1.09 -0.13,2.47 -0.52,3.19 -0.72,1.3 -2.67,-0.22 -4.17,-0.86 -1.5,-0.64 -1.54,0.73 -2.74,2.07 -1.19,1.34 -3.2,0.56 -5.74,0.73 -2.54,0.17 -5.21,4.91 -6.32,5.84 -1.11,0.93 -2.57,2.85 -5.33,2.7 -0.88,-0.04 -1.62,-0.3 -2.21,-0.63 1.56,3.01 5.14,4.38 8.23,3.06 z"
             id="path233" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 491.59,341.65 c 0.28,0.71 -0.07,1.5 -0.78,1.78 -0.71,0.28 -1.5,-0.07 -1.78,-0.78 -0.28,-0.7 0.07,-1.5 0.78,-1.78 0.7,-0.28 1.5,0.07 1.78,0.77 z"
             id="path234" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 476.54,345.88 c 0.23,0.59 -0.06,1.26 -0.65,1.5 -0.59,0.23 -1.26,-0.06 -1.49,-0.65 -0.23,-0.59 0.06,-1.26 0.65,-1.5 0.59,-0.23 1.26,0.06 1.49,0.65 z"
             id="path235" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 492.99,340.66 c 0.13,0.32 -0.03,0.69 -0.36,0.81 -0.32,0.13 -0.69,-0.03 -0.81,-0.35 -0.13,-0.32 0.03,-0.69 0.36,-0.82 0.32,-0.13 0.69,0.03 0.82,0.36 z"
             id="path236" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 473.87,346.81 c 0.13,0.32 -0.03,0.69 -0.36,0.81 -0.32,0.13 -0.69,-0.03 -0.82,-0.36 -0.13,-0.32 0.03,-0.69 0.36,-0.82 0.32,-0.13 0.69,0.03 0.81,0.36 z"
             id="path237" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 476.47,343.9 c 0.13,0.33 -0.03,0.7 -0.36,0.83 -0.33,0.13 -0.7,-0.03 -0.83,-0.36 -0.13,-0.33 0.03,-0.7 0.36,-0.83 0.33,-0.13 0.7,0.03 0.83,0.36 z"
             id="path238" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 480.58,328.99 c -3.07,1.31 -4.57,4.78 -3.54,7.97 -0.77,0.02 -1.55,0.17 -2.31,0.49 -2.26,0.96 -3.67,3.11 -3.84,5.44 1.82,-2.93 6.05,-3.96 8.17,-4.3 0.17,-0.03 0.31,-0.16 0.33,-0.33 0.03,-0.17 -0.06,-0.34 -0.21,-0.42 l -0.88,-0.47 c -0.27,-0.14 -0.42,-0.45 -0.37,-0.75 0.29,-1.79 1.78,-7.54 8.68,-7.04 -1.74,-1.17 -4,-1.47 -6.04,-0.6 z"
           id="path239" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 489.39,336.66 c -3.15,1.64 -4.78,4.39 -4.78,4.39 0,0 3.36,-2.57 6.91,-3.56 0.5,-0.14 1.36,-0.26 2.24,-0.28 -1.33,-0.68 -2.87,-0.89 -4.37,-0.53 0,0 0,-0.01 0,-0.02 z"
           id="path240" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 486.18,347.58 c 0.24,0.61 -0.06,1.3 -0.67,1.55 -0.61,0.24 -1.3,-0.06 -1.55,-0.67 -0.24,-0.61 0.06,-1.3 0.67,-1.54 0.61,-0.24 1.3,0.06 1.54,0.67 z"
           id="path241" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 485.79,345.57 c 0.11,0.29 -0.03,0.61 -0.32,0.73 -0.29,0.11 -0.61,-0.03 -0.73,-0.32 -0.11,-0.29 0.03,-0.61 0.32,-0.73 0.29,-0.11 0.61,0.03 0.73,0.32 z"
           id="path242" />
      </g>
      <g
         id="g244">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 716.82,434.1 c 0,2.72 -6.7,4.93 -14.97,4.93 -8.27,0 -14.97,-2.21 -14.97,-4.93 0,-2.72 6.7,-4.93 14.97,-4.93 8.27,0 14.97,2.21 14.97,4.93 z"
           id="path243" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 708.36,433.61 c 0,1.41 -3.91,2.56 -8.74,2.56 -4.83,0 -8.74,-1.15 -8.74,-2.56 0,-1.41 3.91,-2.56 8.74,-2.56 4.83,0 8.74,1.15 8.74,2.56 z"
           id="path244" />
      </g>
      <g
         id="g249">
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 703.99,432.91 c -0.17,1.22 -0.2,2.13 -2.42,2.23 -2.6,0.12 -7.44,-0.78 -7.6,-2.23 0,0 0.25,-10.52 3.26,-17.78 3.01,-7.26 2.75,-21.78 3,-24.54 0.25,-2.76 1.51,-4.13 1.51,-4.13 l 2.25,1.98 c 0,0 0.5,12.92 0,17.67 -0.5,4.76 -1.63,9.57 -2,14.86 -0.31,4.42 2,11.93 2,11.93 z"
           id="path245" />
        <g
           class="schulz-dashboard-center-icon-styling-42"
           clip-path="url(#clippath-14)"
           id="g248">
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 701.13,435.72 c 0,0 -2.93,-9.29 -1.61,-13.43 1.31,-4.13 3.38,-18.59 3.38,-21.04 0,-2.45 0.38,-8.64 -0.75,-9.58 -1.13,-0.94 -2.25,1.69 -2.25,1.69 0,0 -1.69,-9.77 -1.13,-9.77 0.56,0 12.21,1.13 12.21,1.13 l -5.07,43.95 0.19,5.45 -4.96,1.59 z"
             id="path246" />
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 694.85,420.7 c 0,0 2.62,-0.96 3.05,-0.35 0.44,0.61 0.09,0.78 0.96,2.18 0.87,1.39 3.84,1.31 4.1,1.13 0.26,-0.17 3.31,-0.09 2.7,-1.05 -0.61,-0.96 0.26,-9.07 -1.31,-9.24 -1.57,-0.17 -8.37,-0.7 -8.37,-0.44 0,0.26 -1.13,7.76 -1.13,7.76 z"
             id="path247" />
          <path
             class="schulz-dashboard-center-icon-styling-72"
             d="m 696.09,435.49 c 0,0 -0.24,-5.09 -0.03,-7.55 0.22,-2.47 1.25,-2.73 1.15,-4.45 -0.1,-1.73 -0.87,-3.4 -0.87,-3.4 0,0 -0.57,2.01 -0.87,3.49 -0.3,1.48 -0.39,3.99 -0.49,5.6 -0.1,1.6 0,5.55 0,5.55 l 1.11,0.77 z"
             id="path248" />
        </g>
      </g>
      <g
         id="g263">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 722.53,410.47 c 2.3,-1.71 3.8,-4.44 3.8,-7.54 0,-3.38 -1.78,-6.33 -4.44,-7.98 -0.1,-6.41 -5.09,-11.65 -11.41,-11.83 -1.5,-0.04 -2.94,0.22 -4.27,0.7 -0.38,-6.14 -5.27,-11.09 -11.4,-11.26 -6.49,-0.18 -11.91,5.06 -12.09,11.71 -0.08,2.72 0.75,5.25 2.18,7.31 0,0.01 -0.01,0.03 -0.02,0.04 -5.59,0.79 -9.98,5.61 -10.14,11.58 -0.02,0.91 0.06,1.79 0.22,2.64 -1.18,1.83 -1,4.32 0.58,6.01 0.84,0.91 1.94,1.43 3.07,1.56 0.56,4.64 4.48,8.24 9.24,8.24 4.24,0 7.81,-2.86 8.94,-6.76 2,0.66 4.28,0.46 6.23,-0.72 2,1.88 4.65,3.06 7.58,3.14 2.01,0.06 3.92,-0.41 5.61,-1.28 0.77,0.93 1.94,1.53 3.25,1.53 2.33,0 4.23,-1.89 4.23,-4.24 0,-1.11 -0.43,-2.13 -1.14,-2.88 z"
           id="path249" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 693.02,376.12 c 5.42,-1.23 7.59,-0.16 11.1,1.57 -2.06,-3.01 -5.43,-5.02 -9.3,-5.13 -6.49,-0.18 -11.91,5.06 -12.09,11.71 -0.08,2.72 0.75,5.25 2.18,7.31 0,0.01 -0.01,0.03 -0.02,0.04 -5.59,0.79 -9.98,5.61 -10.14,11.58 -0.01,0.59 0.02,1.17 0.08,1.74 1.02,-2.26 5.78,-10.67 12.61,-9.11 4.16,0.95 5.04,0.8 7.29,-0.7 0.83,-0.55 0.03,-0.87 -3.41,-1.94 -7.48,-2.33 -8.54,-14.75 1.71,-17.07 z"
           id="path250" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 701.24,386.06 c -1.24,1.71 0.18,1.82 3.49,0.93 1.92,-0.51 5.59,-1.34 8.89,-1.08 1.21,0.1 4.06,0.74 4.87,0.76 -2.05,-2.12 -4.86,-3.46 -8.01,-3.55 -1.5,-0.04 -2.94,0.22 -4.27,0.7 0,0 -3.73,0.53 -4.97,2.24 z"
           id="path251" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g257">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 726.33,402.92 c 0,-3.38 -1.78,-6.33 -4.44,-7.98 -0.02,-1.11 -0.19,-2.18 -0.48,-3.2 -0.58,0.96 -1.51,1.95 -2.94,2.38 -3.26,0.98 -1.24,2.69 -1.24,2.69 0,0 -1.99,-4.8 -9.12,-0.5 -3.01,1.82 -4.12,4.5 -7.9,3.6 -4.51,-1.06 -5.21,1.05 -5.32,3.16 -0.11,2.1 0.72,8.18 -7.45,10.4 -3.87,1.05 -7.82,-2.8 -7.82,-2.8 0,0 -0.56,0.21 -2.74,0.27 -0.77,0.02 -1.44,0.03 -1.98,0.02 0.18,0.31 0.39,0.62 0.65,0.89 0.84,0.91 1.94,1.43 3.07,1.56 0.56,4.64 4.48,8.24 9.24,8.24 4.24,0 7.81,-2.86 8.94,-6.76 2,0.66 4.28,0.46 6.23,-0.72 2,1.88 4.65,3.06 7.58,3.14 2.01,0.06 3.92,-0.41 5.61,-1.28 0.77,0.93 1.94,1.53 3.25,1.53 2.33,0 4.23,-1.89 4.23,-4.24 0,-1.11 -0.43,-2.13 -1.14,-2.88 2.3,-1.71 3.8,-4.44 3.8,-7.54 z"
             id="path252" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 716.17,404.31 c 0,1.4 -1.14,2.54 -2.55,2.54 -1.41,0 -2.55,-1.14 -2.55,-2.54 0,-1.4 1.14,-2.55 2.55,-2.55 1.41,0 2.55,1.14 2.55,2.55 z"
             id="path253" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 710.98,406.86 c 0,0.89 -0.72,1.62 -1.61,1.62 -0.89,0 -1.62,-0.72 -1.62,-1.62 0,-0.9 0.72,-1.61 1.62,-1.61 0.9,0 1.61,0.72 1.61,1.61 z"
             id="path254" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 685.44,409.56 c 0,0.89 -0.72,1.61 -1.62,1.61 -0.9,0 -1.62,-0.72 -1.62,-1.61 0,-0.89 0.72,-1.61 1.62,-1.61 0.9,0 1.62,0.72 1.62,1.61 z"
             id="path255" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 715.23,400.21 c 0,0.66 -0.53,1.19 -1.19,1.19 -0.66,0 -1.19,-0.53 -1.19,-1.19 0,-0.66 0.53,-1.19 1.19,-1.19 0.66,0 1.19,0.53 1.19,1.19 z"
             id="path256" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 687.82,406.71 c 0,0.65 -0.53,1.19 -1.19,1.19 -0.66,0 -1.19,-0.53 -1.19,-1.19 0,-0.66 0.53,-1.19 1.19,-1.19 0.66,0 1.19,0.53 1.19,1.19 z"
             id="path257" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-71"
           d="m 720.09,412.3 c 0,0.89 -0.72,1.61 -1.62,1.61 -0.9,0 -1.62,-0.72 -1.62,-1.61 0,-0.89 0.72,-1.62 1.62,-1.62 0.9,0 1.62,0.72 1.62,1.62 z"
           id="path258" />
        <path
           class="schulz-dashboard-center-icon-styling-71"
           d="m 721.57,409.69 c 0,0.57 -0.46,1.04 -1.04,1.04 -0.58,0 -1.04,-0.46 -1.04,-1.04 0,-0.58 0.47,-1.04 1.04,-1.04 0.57,0 1.04,0.46 1.04,1.04 z"
           id="path259" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 691.8,381.5 c 0,0.89 -0.72,1.62 -1.62,1.62 -0.9,0 -1.61,-0.72 -1.61,-1.62 0,-0.9 0.72,-1.61 1.61,-1.61 0.89,0 1.62,0.72 1.62,1.61 z"
           id="path260" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 687.49,399.02 c 0,1.46 -1.18,2.63 -2.64,2.63 -1.46,0 -2.64,-1.18 -2.64,-2.63 0,-1.45 1.18,-2.63 2.64,-2.63 1.46,0 2.64,1.18 2.64,2.63 z"
           id="path261" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 692.67,378.56 c 0,0.42 -0.34,0.76 -0.76,0.76 -0.42,0 -0.76,-0.34 -0.76,-0.76 0,-0.42 0.34,-0.76 0.76,-0.76 0.42,0 0.76,0.34 0.76,0.76 z"
           id="path262" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 701.02,388.76 c 0,0.42 -0.34,0.76 -0.76,0.76 -0.42,0 -0.76,-0.34 -0.76,-0.76 0,-0.42 0.34,-0.76 0.76,-0.76 0.42,0 0.76,0.34 0.76,0.76 z"
           id="path263" />
      </g>
      <g
         id="g277">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 726.19,404.73 c -1.27,-0.5 -2.66,-0.14 -3.57,0.79 -1.55,-2.07 -4.17,-3.05 -6.66,-2.45 0.32,-1.33 0.24,-2.79 -0.35,-4.16 -1.42,-3.33 -5.2,-4.91 -8.46,-3.53 -3.07,1.31 -4.57,4.79 -3.54,7.97 -0.77,0.02 -1.55,0.17 -2.31,0.49 -3.25,1.38 -4.75,5.21 -3.33,8.54 0.29,0.68 0.68,1.29 1.15,1.81 -0.15,1.14 -0.01,2.34 0.47,3.48 1.42,3.33 5.21,4.91 8.46,3.53 1.02,-0.44 1.87,-1.12 2.51,-1.94 0.07,0.03 0.13,0.07 0.21,0.1 2.07,0.81 4.4,-0.23 5.22,-2.32 0.16,-0.41 0.24,-0.83 0.27,-1.24 1.25,0.28 2.58,0.19 3.83,-0.35 0.74,-0.31 1.38,-0.76 1.93,-1.29 0.26,0.38 0.63,0.69 1.08,0.87 1.25,0.49 2.66,-0.15 3.16,-1.42 0.34,-0.87 0.17,-1.81 -0.37,-2.48 0.94,-0.3 1.75,-1.01 2.14,-2.02 0.69,-1.75 -0.14,-3.71 -1.85,-4.38 z"
           id="path264" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 710.6,398.31 c 0.24,0.61 -0.06,1.3 -0.67,1.54 -0.61,0.24 -1.31,-0.06 -1.55,-0.67 -0.24,-0.61 0.06,-1.31 0.67,-1.55 0.61,-0.24 1.3,0.06 1.54,0.67 z"
           id="path265" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 707.79,398.81 c 0.11,0.29 -0.03,0.61 -0.32,0.73 -0.29,0.11 -0.61,-0.03 -0.73,-0.32 -0.11,-0.29 0.03,-0.61 0.32,-0.73 0.29,-0.11 0.61,0.03 0.73,0.32 z"
           id="path266" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 724.59,405.76 c 0.11,0.29 -0.03,0.61 -0.32,0.73 -0.29,0.11 -0.61,-0.03 -0.73,-0.32 -0.11,-0.29 0.03,-0.61 0.32,-0.73 0.29,-0.11 0.61,0.03 0.73,0.32 z"
           id="path267" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g273">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 708.06,421.21 c 1.02,-0.44 1.87,-1.12 2.51,-1.94 0.07,0.03 0.13,0.07 0.21,0.1 2.07,0.81 4.4,-0.23 5.22,-2.32 0.16,-0.41 0.24,-0.83 0.27,-1.24 1.25,0.28 2.58,0.19 3.83,-0.35 0.74,-0.31 1.38,-0.76 1.93,-1.29 0.26,0.38 0.63,0.69 1.08,0.87 1.25,0.49 2.66,-0.15 3.16,-1.42 0.34,-0.87 0.17,-1.81 -0.37,-2.48 0.94,-0.3 1.75,-1.01 2.14,-2.02 0.59,-1.5 0.06,-3.16 -1.18,-4.02 -0.02,1.09 -0.13,2.47 -0.52,3.19 -0.72,1.3 -2.67,-0.22 -4.17,-0.86 -1.5,-0.64 -1.54,0.73 -2.74,2.07 -1.19,1.34 -3.2,0.56 -5.74,0.73 -2.54,0.17 -5.21,4.91 -6.32,5.84 -1.11,0.93 -2.57,2.85 -5.33,2.7 -0.88,-0.04 -1.62,-0.3 -2.21,-0.63 1.56,3.01 5.14,4.38 8.23,3.06 z"
             id="path268" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 718.16,408.03 c 0.28,0.71 -0.07,1.5 -0.78,1.78 -0.71,0.28 -1.5,-0.07 -1.78,-0.78 -0.28,-0.7 0.07,-1.5 0.78,-1.78 0.7,-0.28 1.5,0.07 1.78,0.77 z"
             id="path269" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 703.11,412.26 c 0.23,0.59 -0.06,1.26 -0.65,1.5 -0.59,0.23 -1.26,-0.06 -1.49,-0.65 -0.23,-0.59 0.06,-1.26 0.65,-1.5 0.59,-0.23 1.26,0.06 1.49,0.65 z"
             id="path270" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 719.56,407.04 c 0.13,0.32 -0.03,0.69 -0.36,0.81 -0.32,0.13 -0.69,-0.03 -0.81,-0.35 -0.13,-0.32 0.03,-0.69 0.36,-0.82 0.32,-0.13 0.69,0.03 0.82,0.36 z"
             id="path271" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 700.43,413.2 c 0.13,0.32 -0.03,0.69 -0.36,0.81 -0.32,0.13 -0.69,-0.03 -0.82,-0.36 -0.13,-0.32 0.03,-0.69 0.36,-0.82 0.32,-0.13 0.69,0.03 0.81,0.36 z"
             id="path272" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 703.04,410.28 c 0.13,0.33 -0.03,0.7 -0.36,0.83 -0.33,0.13 -0.7,-0.03 -0.83,-0.36 -0.13,-0.33 0.03,-0.7 0.36,-0.83 0.33,-0.13 0.7,0.03 0.83,0.36 z"
             id="path273" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 707.15,395.38 c -3.07,1.31 -4.57,4.78 -3.54,7.97 -0.77,0.02 -1.55,0.17 -2.31,0.49 -2.26,0.96 -3.67,3.11 -3.84,5.44 1.82,-2.93 6.05,-3.96 8.17,-4.3 0.17,-0.03 0.31,-0.16 0.33,-0.33 0.03,-0.17 -0.06,-0.34 -0.21,-0.42 l -0.88,-0.47 c -0.27,-0.14 -0.42,-0.45 -0.37,-0.75 0.29,-1.79 1.78,-7.54 8.68,-7.04 -1.74,-1.17 -4,-1.47 -6.04,-0.6 z"
           id="path274" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 715.96,403.05 c -3.15,1.64 -4.78,4.39 -4.78,4.39 0,0 3.36,-2.57 6.91,-3.56 0.5,-0.14 1.36,-0.26 2.24,-0.28 -1.33,-0.68 -2.87,-0.89 -4.37,-0.53 0,0 0,-0.01 0,-0.02 z"
           id="path275" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 712.75,413.96 c 0.24,0.61 -0.06,1.3 -0.67,1.55 -0.61,0.24 -1.3,-0.06 -1.55,-0.67 -0.24,-0.61 0.06,-1.3 0.67,-1.54 0.61,-0.24 1.3,0.06 1.54,0.67 z"
           id="path276" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 712.35,411.96 c 0.11,0.29 -0.03,0.61 -0.32,0.73 -0.29,0.11 -0.61,-0.03 -0.73,-0.32 -0.11,-0.29 0.03,-0.61 0.32,-0.73 0.29,-0.11 0.61,0.03 0.73,0.32 z"
           id="path277" />
      </g>
      <g
         id="g279">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 677.69,413.13 c 0,0 0.44,1.09 2.4,2.4 1.96,1.31 -0.22,3.92 -0.22,3.92 l -9.59,4.58 -6.76,-0.44 -11.77,3.49 -12.2,-5.67 -5.23,-3.92 c 0,0 4.14,-6.32 4.79,-6.54 0.65,-0.22 15.47,-2.61 16.12,-2.61 0.65,0 7.63,-2.18 7.63,-2.18 l 14.82,6.97 z"
           id="path278" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 643.71,414.56 c 0,0 -0.33,0.53 -1.79,1.16 -1.47,0.63 0.16,1.9 0.16,1.9 l 7.17,2.22 5.05,-0.21 8.79,1.69 9.12,-2.75 3.91,-1.9 c 0,0 -3.09,-3.07 -3.58,-3.17 -0.49,-0.11 -11.56,-1.27 -12.05,-1.27 -0.49,0 -5.7,-1.06 -5.7,-1.06 l -11.07,3.39 z"
           id="path279" />
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 653.7,417.71 c 1.08,1.57 6.12,1.57 7.41,0 l -1.29,-17.72 h -5.09 l 0.05,8.49 z"
         id="path280" />
      <g
         id="g304">
        <polygon
           class="schulz-dashboard-center-icon-styling-64"
           points="638.07,373.28 642.03,377.24 632.96,388.19 639.28,391.1 627.86,396.69 630.52,400.5 637.43,402.8 651.9,411.51 672.7,408.13 690.55,397.18 679.62,393.53 684.48,391.1 673.54,378.72 678.17,374.29 671.6,365.46 677.67,362.91 671.6,358.78 669.7,355.36 673.1,354.17 667.02,347.85 670.14,346.39 663.13,339.1 666.25,337.64 659,325.06 651.51,339.59 653.46,339.14 652.64,341.77 644.71,350.24 646.79,352.26 645.11,356.59 640.5,360.89 644.63,363.89 "
           id="polygon280" />
        <polygon
           class="schulz-dashboard-center-icon-styling-22"
           points="671.6,358.78 669.7,355.36 673.1,354.17 667.02,347.85 670.14,346.39 663.13,339.1 666.25,337.64 659.54,325.99 660.18,336.67 656.77,338.86 661.88,341.06 661.39,348.09 655.88,350.04 661.88,356.35 656.53,365.23 669.49,373.7 661.88,377.39 653.37,378.22 669.98,391.67 661.23,396.51 637.12,402.71 637.43,402.8 651.9,411.51 672.7,408.13 690.55,397.18 679.62,393.53 684.48,391.1 673.54,378.72 678.17,374.29 671.6,365.46 677.67,362.91 "
           id="polygon281" />
        <g
           id="g299">
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="642.03,377.24 632.96,388.19 652.32,375.98 "
             id="polygon282" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="638.07,373.28 641.09,375.98 649.04,364.77 644.63,363.89 "
             id="polygon283" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="645.11,356.59 640.5,360.89 642.11,362.06 647.14,357.16 647.36,353.02 "
             id="polygon284" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="639.28,391.1 627.86,396.69 659.2,391.1 "
             id="polygon285" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="656.25,341.18 652.83,341.18 652.64,341.77 644.71,350.24 646.03,350.25 "
             id="polygon286" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="656.86,335.67 659,325.06 651.51,339.59 652.75,339.3 "
             id="polygon287" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="644.71,361.3 647.36,359.03 647.36,360.99 "
             id="polygon288" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="657.63,341.18 657.63,343.23 659,342.2 "
             id="polygon289" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="646.04,373.7 649.04,373.7 649.04,371.08 "
             id="polygon290" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="659.2,389.67 656.25,386.81 654.81,388.92 "
             id="polygon291" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="668.45,398.65 665.49,395.78 664.05,397.89 "
             id="polygon292" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="679.3,392.54 676.35,389.67 674.91,391.78 "
             id="polygon293" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="653.94,386.81 652.32,389.67 649.89,389.67 "
             id="polygon294" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="659.2,356.03 657.63,357.54 656.25,356.03 "
             id="polygon295" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="664.84,362.38 663.26,363.89 661.88,362.38 "
             id="polygon296" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="675.67,362.38 674.09,363.89 672.71,362.38 "
             id="polygon297" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="667.73,346.11 666.15,347.62 664.77,346.11 "
             id="polygon298" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="661.88,374.66 664.52,373.9 661.23,372.39 "
             id="polygon299" />
        </g>
        <g
           class="schulz-dashboard-center-icon-styling-69"
           id="g303">
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="677.11,393.9 674.19,393.9 677.11,395.88 "
             id="polygon300" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="671.6,379.52 668.03,380.52 671.6,382.08 "
             id="polygon301" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="661.23,365.46 664.52,366.47 661.88,368.18 "
             id="polygon302" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="666.25,348.41 664.52,348.41 666.25,350.25 "
             id="polygon303" />
        </g>
      </g>
      <g
         id="g305">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 571.8,359.09 c 0,0 -0.56,1.41 -3.09,3.09 -2.53,1.69 0.28,5.06 0.28,5.06 l 12.38,5.91 8.72,-0.56 15.19,4.5 15.75,-7.31 6.75,-5.06 c 0,0 -5.34,-8.16 -6.19,-8.44 -0.84,-0.28 -19.97,-3.38 -20.81,-3.38 -0.84,0 -9.84,-2.81 -9.84,-2.81 l -19.13,9 z"
           id="path304" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 615.67,360.93 c 0,0 0.42,0.68 2.31,1.5 1.89,0.82 -0.21,2.46 -0.21,2.46 l -9.25,2.87 -6.52,-0.27 -11.35,2.18 -11.77,-3.55 -5.05,-2.46 c 0,0 3.99,-3.96 4.62,-4.1 0.63,-0.14 14.93,-1.64 15.56,-1.64 0.63,0 7.36,-1.37 7.36,-1.37 l 14.29,4.37 z"
           id="path305" />
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 599.01,365.92 c -1.05,1.54 -5.98,1.54 -7.24,0 l 1.51,-9.41 h 4.97 l 0.06,4.15 z"
         id="path306" />
      <g
         id="g331">
        <polygon
           class="schulz-dashboard-center-icon-styling-64"
           points="571.73,323.59 577.39,328.82 567.72,336.44 573.07,341.69 564.69,349.22 570.43,353.61 573.38,357.09 588.47,362.47 612.09,360.36 624.68,348.68 617.59,342.67 622.55,340.44 611.14,330.72 615.85,328.19 610.19,317.96 615.6,314.48 607.45,307.52 610.19,304.38 604.71,300.6 607.9,299.26 602.19,293.27 603.93,291.2 596.52,283.26 588.87,293 590.85,292.58 590.02,295.01 581.91,302.81 584.98,304.24 582.32,308.66 577.61,312.61 581.19,316.58 "
           id="polygon306" />
        <polygon
           class="schulz-dashboard-center-icon-styling-22"
           points="607.45,307.52 608.49,305.64 604.71,300.6 607.9,299.26 602.19,293.27 603.93,291.2 597.07,284.11 597.72,290.31 594.24,292.32 599.46,294.35 598.96,300.83 593.33,302.62 599.46,308.44 595.11,316.82 607.24,324.41 604.9,326.78 595.22,329.77 602.16,339.12 609.39,343.92 592.68,354.45 573.07,357 573.38,357.09 588.47,362.47 612.09,360.36 624.68,348.68 617.59,342.67 622.55,340.44 611.14,330.72 615.85,328.19 610.19,317.96 614.09,315.05 "
           id="polygon307" />
        <g
           id="g323">
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="567.72,336.44 595.22,329.77 583.27,328.69 577.39,328.82 "
             id="polygon308" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="571.73,323.59 577.39,328.82 586.34,316.18 581.19,316.58 "
             id="polygon309" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="582.32,308.66 577.61,312.61 579.26,313.69 591.35,305.64 584.62,305.36 "
             id="polygon310" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="573.07,341.69 564.69,349.22 587.81,341.11 "
             id="polygon311" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="593.7,294.46 590.21,294.46 590.02,295.01 581.91,302.81 583.26,302.82 "
             id="polygon312" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="594.33,289.39 596.52,283.26 588.87,293 590.13,292.74 "
             id="polygon313" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="584.99,314.74 587.7,312.64 587.7,314.45 "
             id="polygon314" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="599.12,313.69 601.83,311.6 601.83,313.41 "
             id="polygon315" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="591.89,300.18 591.89,302.07 593.3,301.12 "
             id="polygon316" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="583.27,324.41 586.34,324.41 586.34,322 "
             id="polygon317" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="598.34,292.15 601.41,292.15 601.41,289.74 "
             id="polygon318" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="606.03,320.53 609.11,320.53 609.11,318.12 "
             id="polygon319" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="583.45,339.22 580.42,336.58 578.95,338.52 "
             id="polygon320" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="585.34,344.83 583.68,347.47 581.2,347.47 "
             id="polygon321" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="590.38,302.12 588.76,303.52 587.35,302.12 "
             id="polygon322" />
          <polygon
             class="schulz-dashboard-center-icon-styling-29"
             points="591.58,326.34 594.28,325.64 590.92,324.25 "
             id="polygon323" />
        </g>
        <g
           class="schulz-dashboard-center-icon-styling-69"
           id="g330">
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="618,340.23 615.02,340.23 618,342.06 "
             id="polygon324" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="602.85,331.47 599.87,331.47 602.85,333.3 "
             id="polygon325" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="609.06,347.87 606.08,347.87 609.06,349.7 "
             id="polygon326" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="609.39,326.5 605.75,327.42 609.39,328.86 "
             id="polygon327" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="598.8,316.82 602.16,317.75 599.46,319.33 "
             id="polygon328" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="601.36,295.37 604.73,296.3 602.03,297.88 "
             id="polygon329" />
          <polygon
             class="schulz-dashboard-center-icon-styling-22"
             points="604.81,309.53 603.04,309.53 604.81,311.22 "
             id="polygon330" />
        </g>
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-11"
         points="496.84,451.91 534.29,441.87 434.44,415.12 396.99,425.15 "
         id="polygon331" />
      <g
         id="g332">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 466.84,432.2 c 0,2.79 -6.87,5.05 -15.33,5.05 -8.46,0 -15.33,-2.26 -15.33,-5.05 0,-2.79 6.87,-5.05 15.33,-5.05 8.46,0 15.33,2.26 15.33,5.05 z"
           id="path331" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 460.07,432.46 c 0,1.86 -5.15,3.37 -11.5,3.37 -6.35,0 -11.5,-1.51 -11.5,-3.37 0,-1.86 5.15,-3.37 11.5,-3.37 6.35,0 11.5,1.51 11.5,3.37 z"
           id="path332" />
      </g>
      <g
         id="g340">
        <g
           id="g336">
          <g
             id="g335">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 437.75,425.46 v 6.89 c 0,0.61 0.87,1.22 2.61,1.69 3.48,0.93 9.12,0.93 12.6,0 1.74,-0.47 2.61,-1.08 2.61,-1.69 v -6.89 h -17.81 z"
               id="path333" />
            <g
               class="schulz-dashboard-center-icon-styling-40"
               clip-path="url(#clippath-15)"
               id="g334">
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="449.53"
                 y="424.53"
                 width="4.8099999"
                 height="11.49"
                 id="rect333" />
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="438.97"
                 y="424.53"
                 width="4.8099999"
                 height="11.49"
                 id="rect334" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 440.36,423.77 c 3.48,-0.93 9.12,-0.93 12.6,0 3.48,0.93 3.48,2.44 0,3.38 -3.48,0.93 -9.12,0.93 -12.6,0 -3.48,-0.93 -3.48,-2.44 0,-3.38 z"
             id="path335" />
        </g>
        <g
           id="g339">
          <g
             id="g338">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 440.86,407.46 v 17.94 c 0,0.4 0.57,0.79 1.7,1.1 2.26,0.61 5.93,0.61 8.19,0 1.13,-0.3 1.7,-0.7 1.7,-1.1 v -17.94 h -11.58 z"
               id="path336" />
            <g
               class="schulz-dashboard-center-icon-styling-37"
               clip-path="url(#clippath-16)"
               id="g337">
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="448.53"
                 y="406.85001"
                 width="3.1300001"
                 height="20.93"
                 id="rect336" />
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="441.66"
                 y="406.85001"
                 width="3.1300001"
                 height="20.93"
                 id="rect337" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 442.56,406.36 c 2.26,-0.61 5.93,-0.61 8.19,0 2.26,0.61 2.26,1.59 0,2.19 -2.26,0.61 -5.93,0.61 -8.19,0 -2.26,-0.61 -2.26,-1.59 0,-2.19 z"
             id="path338" />
        </g>
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-68"
         points="512.73,355.78 512.07,353.28 479.11,421.96 479.78,424.46 "
         id="polygon340" />
      <polygon
         class="schulz-dashboard-center-icon-styling-70"
         points="512.07,353.28 479.11,421.96 390.14,398.12 423.09,329.44 "
         id="polygon341" />
      <g
         id="g342">
        <path
           class="schulz-dashboard-center-icon-styling-20"
           d="m 456.35,364.03 -42.69,-11.44 10.36,-21.6 42.69,11.44 z m -0.34,0.71 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m 54.02,-10.71 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m -10.78,22.46 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m -54.02,10.73 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m 43.31,11.6 -42.69,-11.44 -10.36,21.6 42.69,11.44 z"
           id="path341" />
        <path
           class="schulz-dashboard-center-icon-styling-79"
           d="m 429.18,334.12 -1.76,3.68 -0.74,0.35 -3.8,-1.02 -0.27,-0.63 1.76,-3.68 0.74,-0.35 3.8,1.02 z m 4.83,0.74 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -39.29,-2.07 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.06,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 25.44,-35.1 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.06,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -39.36,-1.94 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -82.61,-13.66 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 14.72,-12.78 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z"
           id="path342" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-24"
         points="423.09,329.44 512.07,353.28 390.14,398.12 "
         id="polygon342" />
      <polygon
         class="schulz-dashboard-center-icon-styling-68"
         points="479.78,424.46 479.11,421.96 390.14,398.12 390.77,400.5 "
         id="polygon343" />
      <polygon
         class="schulz-dashboard-center-icon-styling-11"
         points="610.9,440.69 648.34,430.65 548.49,403.9 511.05,413.93 "
         id="polygon344" />
      <g
         id="g345">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 580.9,420.98 c 0,2.79 -6.87,5.05 -15.33,5.05 -8.46,0 -15.33,-2.26 -15.33,-5.05 0,-2.79 6.87,-5.05 15.33,-5.05 8.46,0 15.33,2.26 15.33,5.05 z"
           id="path344" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 574.13,421.24 c 0,1.86 -5.15,3.37 -11.5,3.37 -6.35,0 -11.5,-1.51 -11.5,-3.37 0,-1.86 5.15,-3.37 11.5,-3.37 6.35,0 11.5,1.51 11.5,3.37 z"
           id="path345" />
      </g>
      <g
         id="g353">
        <g
           id="g349">
          <g
             id="g348">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 551.8,414.24 v 6.89 c 0,0.61 0.87,1.22 2.61,1.69 3.48,0.93 9.12,0.93 12.6,0 1.74,-0.47 2.61,-1.08 2.61,-1.69 v -6.89 h -17.81 z"
               id="path346" />
            <g
               class="schulz-dashboard-center-icon-styling-34"
               clip-path="url(#clippath-17)"
               id="g347">
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="563.59003"
                 y="413.31"
                 width="4.8099999"
                 height="11.49"
                 id="rect346" />
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="553.02002"
                 y="413.31"
                 width="4.8099999"
                 height="11.49"
                 id="rect347" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 554.41,412.55 c 3.48,-0.93 9.12,-0.93 12.6,0 3.48,0.93 3.48,2.44 0,3.38 -3.48,0.93 -9.12,0.93 -12.6,0 -3.48,-0.93 -3.48,-2.44 0,-3.38 z"
             id="path348" />
        </g>
        <g
           id="g352">
          <g
             id="g351">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 554.92,396.24 v 17.94 c 0,0.4 0.57,0.79 1.7,1.1 2.26,0.61 5.93,0.61 8.19,0 1.13,-0.3 1.7,-0.7 1.7,-1.1 v -17.94 h -11.58 z"
               id="path349" />
            <g
               class="schulz-dashboard-center-icon-styling-38"
               clip-path="url(#clippath-18)"
               id="g350">
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="562.58002"
                 y="395.63"
                 width="3.1300001"
                 height="20.93"
                 id="rect349" />
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="555.71002"
                 y="395.63"
                 width="3.1300001"
                 height="20.93"
                 id="rect350" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 556.61,395.14 c 2.26,-0.61 5.93,-0.61 8.19,0 2.26,0.61 2.26,1.59 0,2.19 -2.26,0.61 -5.93,0.61 -8.19,0 -2.26,-0.61 -2.26,-1.59 0,-2.19 z"
             id="path351" />
        </g>
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-68"
         points="626.79,344.56 626.12,342.06 593.16,410.74 593.83,413.24 "
         id="polygon353" />
      <polygon
         class="schulz-dashboard-center-icon-styling-70"
         points="626.12,342.06 593.16,410.74 504.19,386.9 537.15,318.22 "
         id="polygon354" />
      <g
         id="g355">
        <path
           class="schulz-dashboard-center-icon-styling-20"
           d="m 570.41,352.81 -42.69,-11.44 10.36,-21.6 42.69,11.44 z m -0.34,0.71 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m 54.02,-10.71 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m -10.78,22.46 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m -54.03,10.72 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m 43.31,11.61 -42.69,-11.44 -10.36,21.6 42.69,11.44 z"
           id="path354" />
        <path
           class="schulz-dashboard-center-icon-styling-79"
           d="m 543.24,322.9 -1.76,3.68 -0.74,0.35 -3.8,-1.02 -0.27,-0.63 1.76,-3.68 0.74,-0.35 3.8,1.02 z m 4.83,0.74 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.06,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -39.29,-2.07 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 25.43,-35.1 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -39.36,-1.94 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.06,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -82.61,-13.66 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.06,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.06,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 14.73,-12.78 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z"
           id="path355" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-24"
         points="537.15,318.22 626.12,342.06 504.19,386.9 "
         id="polygon355" />
      <polygon
         class="schulz-dashboard-center-icon-styling-68"
         points="593.83,413.24 593.16,410.74 504.19,386.9 504.83,389.27 "
         id="polygon356" />
      <g
         id="g357">
        <path
           class="schulz-dashboard-center-icon-styling-11"
           d="m 316.17,357.33 c 0,2.84 8.86,5.15 19.78,5.15 10.92,0 19.78,-2.31 19.78,-5.15 0,-2.84 -8.86,-5.15 -19.78,-5.15 -10.92,0 -19.78,2.31 -19.78,5.15 z"
           id="path356" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 324.9,357.6 c 0,1.9 6.64,3.43 14.84,3.43 8.2,0 14.84,-1.54 14.84,-3.43 0,-1.89 -6.64,-3.43 -14.84,-3.43 -8.2,0 -14.84,1.54 -14.84,3.43 z"
           id="path357" />
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 335,353.06 c 0.45,-0.26 -0.5,-3.02 -0.56,-5.1 0,0 2.19,3.85 1.51,5.82 0.99,0.72 2.78,1.79 3.96,2.35 0.25,-3.18 0.45,-5.38 0.61,-6.89 0.04,-0.38 -3.72,-7.1 -3.53,-6.86 1.55,1.95 2.26,2.3 3.56,4.61 0.42,0.74 1.41,-5.9 1.41,-5.9 0.53,0.43 -0.07,4.96 0.13,5.97 0.13,0.64 0.19,1.41 0.25,2.24 0.06,0.93 0.2,3.13 0.31,4.06 0.99,-0.23 2.89,-2.44 5.27,-6.76 0,0 -1.83,7.39 -4.99,8.3 0.03,0.36 0.05,0.67 0.06,0.96 3.84,-1.38 10.72,-3.4 13.51,-5.71 0,0 -1.31,3.34 -12.85,6.45 l -0.49,0.51 c 0,0 0,0.78 -0.93,0.82 -0.68,0.03 -1.5,-0.1 -1.88,0.45 -0.37,0.56 -0.76,-0.14 -1.92,-0.86 -0.37,-0.23 -1.02,-0.93 -1.02,-0.93 -4.48,-3.4 -9.35,-8.81 -9.35,-8.81 1.14,1.26 5.97,4.31 6.93,5.27 z"
         id="path358" />
      <g
         id="g372">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 321.79,344.15 c 1.37,-1.28 3.33,-1.52 4.97,-0.79 0.94,-3.43 3.81,-6.01 7.3,-6.49 -1.08,-1.55 -1.71,-3.45 -1.65,-5.51 0.14,-4.98 4.2,-8.91 9.06,-8.77 4.59,0.13 8.26,3.83 8.54,8.44 1,-0.37 2.08,-0.56 3.2,-0.53 4.87,0.14 8.7,4.29 8.56,9.27 -0.03,1.02 -0.23,1.99 -0.56,2.9 0.76,1.38 1.19,2.99 1.15,4.7 -0.14,4.98 -4.2,8.91 -9.07,8.78 -1.53,-0.04 -2.95,-0.49 -4.19,-1.23 -0.08,0.08 -0.13,0.16 -0.21,0.24 -2.24,2.08 -5.76,1.92 -7.86,-0.35 -0.41,-0.44 -0.73,-0.94 -0.97,-1.45 -1.46,0.98 -3.21,1.54 -5.08,1.48 -1.11,-0.03 -2.15,-0.28 -3.12,-0.69 -0.14,0.62 -0.46,1.2 -0.95,1.66 -1.35,1.25 -3.49,1.15 -4.77,-0.23 -0.87,-0.95 -1.13,-2.24 -0.77,-3.37 -1.35,0.08 -2.75,-0.42 -3.76,-1.51 -1.76,-1.9 -1.69,-4.83 0.16,-6.55 z"
           id="path359" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 338.53,328.08 c 0,0.9 0.73,1.64 1.64,1.64 0.91,0 1.64,-0.74 1.64,-1.64 0,-0.9 -0.73,-1.64 -1.64,-1.64 -0.91,0 -1.64,0.73 -1.64,1.64 z"
           id="path360" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 342.38,327.31 c 0,0.43 0.35,0.77 0.77,0.77 0.42,0 0.77,-0.35 0.77,-0.77 0,-0.42 -0.35,-0.77 -0.77,-0.77 -0.42,0 -0.77,0.35 -0.77,0.77 z"
           id="path361" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 324.35,344.66 c 0,0.43 0.35,0.77 0.77,0.77 0.42,0 0.77,-0.35 0.77,-0.77 0,-0.42 -0.35,-0.77 -0.77,-0.77 -0.42,0 -0.77,0.35 -0.77,0.77 z"
           id="path362" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g368">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 353.3,356.14 c -1.53,-0.04 -2.95,-0.49 -4.19,-1.23 -0.08,0.08 -0.13,0.16 -0.21,0.24 -2.24,2.08 -5.76,1.92 -7.86,-0.35 -0.41,-0.44 -0.73,-0.94 -0.97,-1.45 -1.46,0.98 -3.21,1.54 -5.08,1.48 -1.11,-0.03 -2.15,-0.28 -3.12,-0.69 -0.14,0.62 -0.46,1.2 -0.95,1.66 -1.35,1.25 -3.49,1.15 -4.77,-0.23 -0.87,-0.95 -1.13,-2.24 -0.77,-3.37 -1.35,0.08 -2.75,-0.42 -3.76,-1.51 -1.51,-1.63 -1.67,-4.01 -0.51,-5.75 0.57,1.39 1.41,3.11 2.28,3.83 1.58,1.31 3.31,-1.62 4.91,-3.2 1.6,-1.58 2.34,0.16 4.55,1.27 2.21,1.12 4.38,-0.89 7.72,-1.95 3.35,-1.06 9.14,3.67 11.03,4.3 1.89,0.64 4.72,2.36 8.19,0.78 1.11,-0.5 1.92,-1.2 2.52,-1.92 -0.49,4.64 -4.38,8.19 -9.01,8.06 z"
             id="path363" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 333.74,344.33 c 0,1.04 0.85,1.89 1.89,1.89 1.04,0 1.89,-0.84 1.89,-1.89 0,-1.05 -0.84,-1.89 -1.89,-1.89 -1.05,0 -1.89,0.85 -1.89,1.89 z"
             id="path364" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 355.14,342.18 c 0,0.88 0.71,1.59 1.59,1.59 0.88,0 1.59,-0.71 1.59,-1.59 0,-0.88 -0.71,-1.59 -1.59,-1.59 -0.88,0 -1.59,0.71 -1.59,1.59 z"
             id="path365" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 331.44,343.77 c 0,0.48 0.39,0.86 0.87,0.86 0.48,0 0.87,-0.39 0.87,-0.86 0,-0.47 -0.39,-0.87 -0.87,-0.87 -0.48,0 -0.87,0.39 -0.87,0.87 z"
             id="path366" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 359.04,342.04 c 0,0.48 0.39,0.87 0.87,0.87 0.48,0 0.87,-0.39 0.87,-0.87 0,-0.48 -0.39,-0.87 -0.87,-0.87 -0.48,0 -0.87,0.39 -0.87,0.87 z"
             id="path367" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 354.24,339.61 c 0,0.49 0.39,0.89 0.88,0.89 0.49,0 0.89,-0.4 0.89,-0.89 0,-0.49 -0.4,-0.88 -0.89,-0.88 -0.49,0 -0.88,0.4 -0.88,0.88 z"
             id="path368" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 341.47,322.59 c 4.59,0.13 8.26,3.83 8.54,8.44 1,-0.37 2.08,-0.56 3.2,-0.53 3.38,0.09 6.26,2.13 7.66,5.04 -3.81,-2.84 -9.74,-2.03 -12.63,-1.4 -0.23,0.05 -0.47,-0.05 -0.6,-0.26 -0.12,-0.2 -0.1,-0.47 0.06,-0.65 l 0.89,-1.04 c 0.28,-0.32 0.32,-0.79 0.1,-1.15 -1.28,-2.14 -6.07,-8.76 -14.66,-4.65 1.65,-2.37 4.38,-3.89 7.44,-3.8 z"
           id="path369" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 334.04,336.84 c 4.86,0.52 8.33,3.22 8.33,3.22 0,0 -5.6,-1.61 -10.64,-1.09 -0.71,0.07 -1.87,0.35 -3.01,0.76 1.37,-1.54 3.23,-2.59 5.33,-2.88 0,0 0,-0.02 -0.02,-0.02 z"
           id="path370" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 343.65,349.21 c 0,0.91 0.73,1.64 1.64,1.64 0.91,0 1.64,-0.74 1.64,-1.64 0,-0.9 -0.74,-1.64 -1.64,-1.64 -0.9,0 -1.64,0.73 -1.64,1.64 z"
           id="path371" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 343.15,346.44 c 0,0.43 0.35,0.77 0.77,0.77 0.42,0 0.77,-0.35 0.77,-0.77 0,-0.42 -0.35,-0.77 -0.77,-0.77 -0.42,0 -0.77,0.35 -0.77,0.77 z"
           id="path372" />
      </g>
      <g
         id="g374">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 612.5,475.93 c 0,2.44 -6,4.41 -13.4,4.41 -7.4,0 -13.4,-1.98 -13.4,-4.41 0,-2.43 6,-4.41 13.4,-4.41 7.4,0 13.4,1.98 13.4,4.41 z"
           id="path373" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 606.59,476.16 c 0,1.62 -4.5,2.94 -10.05,2.94 -5.55,0 -10.05,-1.32 -10.05,-2.94 0,-1.62 4.5,-2.94 10.05,-2.94 5.55,0 10.05,1.32 10.05,2.94 z"
           id="path374" />
      </g>
      <g
         id="g379">
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 599.25,458.14 c 0.04,-1.31 0.04,-2.34 -0.06,-3.98 3.67,-1.26 5.8,-11.43 5.8,-11.43 -2.77,5.95 -4.99,8.99 -6.13,9.31 -0.13,-1.28 -0.29,-4.32 -0.36,-5.59 -0.06,-1.13 -0.14,-2.19 -0.28,-3.08 -0.23,-1.39 0.47,-7.64 -0.15,-8.23 0,0 -1.16,9.14 -1.64,8.13 -1.52,-3.18 -2.34,-3.66 -4.14,-6.35 -0.23,-0.34 4.15,8.92 4.1,9.44 -0.18,2.09 -0.42,5.11 -0.71,9.49 -1.36,-0.76 -3.45,-2.25 -4.61,-3.23 0.8,-2.7 -1.75,-8.01 -1.75,-8.01 0.07,2.86 1.17,6.67 0.66,7.02 -1.12,-1.33 -6.74,-5.53 -8.07,-7.26 0,0 7.86,10.32 13.57,14.3 -0.26,3.35 -0.37,8.86 -0.51,9.94 -0.29,2.23 -0.73,4.82 -1.19,6.77 -0.35,0.4 1.81,1.71 3.81,1.36 1.84,-0.32 3.16,-0.52 2.85,-1.36 -0.11,-0.97 -0.35,-1.89 -0.38,-2.93 -0.04,-2.06 -0.1,-9.32 -0.34,-10.76 8.3,-4.13 15.26,-14.06 15.26,-14.06 -5.96,5.83 -13.24,10.32 -15.72,10.52 z"
           id="path375" />
        <g
           class="schulz-dashboard-center-icon-styling-35"
           clip-path="url(#clippath-19)"
           id="g378">
          <path
             class="schulz-dashboard-center-icon-styling-72"
             d="m 595.47,458.67 c 0,0 0.89,1.97 0.89,3.1 0,1.13 0.28,8.78 0,9.49 -0.28,0.71 -0.89,7.65 -0.89,7.65 0,0 -0.44,-8.46 -0.51,-10.31 -0.05,-1.3 0.51,-9.94 0.51,-9.94 z"
             id="path376" />
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 598.44,478.49 c 0,0 -0.67,-4.39 -0.38,-6.94 0.28,-2.55 0.85,-2.98 0.43,-6.52 -0.43,-3.54 -0.99,-6.94 -0.85,-8.78 0.14,-1.84 0.14,-6.38 0.14,-6.38 l 1.42,4.29 c 0,0 -0.29,-1.03 0.99,-1.74 1.28,-0.71 1.84,0 1.84,0 l -2.77,5.72 c 0,0 -0.35,2.21 0.22,1.93 0.57,-0.28 2.98,-0.71 4.11,-1.42 1.13,-0.71 3.68,-0.43 2.13,0.14 -1.56,0.57 -5.38,8.5 -5.38,9.21 0,0.71 -0.43,6.52 -0.28,8.64 0.14,2.13 -1.6,1.84 -1.6,1.84 z"
             id="path377" />
          <path
             class="schulz-dashboard-center-icon-styling-13"
             d="m 591.4,458.8 c 0,0 2.41,-1.28 2.83,-1.42 0.42,-0.14 1.98,0.14 2.13,0.85 0.14,0.71 1.42,3.26 2.13,2.98 0.71,-0.28 0.71,-2.69 1.7,-3.4 0.99,-0.71 3.97,-0.99 5.1,-0.28 1.13,0.71 12.61,-5.1 12.61,-5.1 0,0 -0.85,-18.98 -1.42,-18.98 -0.57,0 -25.36,0.43 -25.36,0.43 l -3.68,17.14 3.97,7.79 z"
             id="path378" />
        </g>
      </g>
      <g
         id="g391">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 622.71,450.57 c 2.53,-1.88 4.18,-4.89 4.18,-8.3 0,-3.72 -1.96,-6.96 -4.89,-8.78 -0.11,-7.05 -5.6,-12.82 -12.55,-13.01 -1.65,-0.05 -3.23,0.24 -4.7,0.78 -0.41,-6.76 -5.8,-12.2 -12.54,-12.39 -7.15,-0.2 -13.1,5.57 -13.31,12.89 -0.08,3 0.83,5.78 2.4,8.04 0,0.02 -0.02,0.03 -0.02,0.05 -6.15,0.87 -10.98,6.18 -11.16,12.75 -0.03,1 0.06,1.97 0.24,2.91 -1.29,2.01 -1.1,4.75 0.64,6.62 0.93,1 2.14,1.57 3.38,1.72 0.61,5.11 4.92,9.06 10.16,9.06 4.67,0 8.6,-3.14 9.84,-7.44 2.2,0.73 4.7,0.51 6.85,-0.79 2.2,2.07 5.11,3.37 8.34,3.46 2.22,0.06 4.32,-0.45 6.17,-1.41 0.85,1.03 2.13,1.69 3.57,1.69 2.57,0 4.65,-2.08 4.65,-4.66 0,-1.23 -0.48,-2.34 -1.25,-3.17 z"
           id="path379" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 590.23,412.79 c 5.96,-1.36 8.36,-0.17 12.21,1.73 -2.27,-3.31 -5.98,-5.53 -10.24,-5.65 -7.15,-0.2 -13.1,5.57 -13.31,12.89 -0.08,3 0.83,5.78 2.4,8.04 0,0.02 -0.02,0.03 -0.02,0.05 -6.15,0.87 -10.98,6.18 -11.16,12.75 -0.02,0.65 0.02,1.29 0.09,1.92 1.12,-2.49 6.36,-11.74 13.87,-10.03 4.58,1.05 5.54,0.88 8.03,-0.77 0.91,-0.6 0.04,-0.95 -3.76,-2.13 -8.23,-2.56 -9.39,-16.23 1.88,-18.79 z"
           id="path380" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 599.28,423.72 c -1.37,1.88 0.2,2 3.85,1.02 2.11,-0.56 6.15,-1.47 9.78,-1.19 1.33,0.11 4.46,0.82 5.36,0.84 -2.25,-2.33 -5.35,-3.81 -8.81,-3.91 -1.65,-0.05 -3.23,0.24 -4.7,0.78 0,0 -4.1,0.58 -5.47,2.46 z"
           id="path381" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g387">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 626.89,442.27 c 0,-3.72 -1.96,-6.96 -4.89,-8.78 -0.02,-1.22 -0.21,-2.4 -0.53,-3.52 -0.64,1.06 -1.66,2.14 -3.24,2.62 -3.59,1.08 -1.37,2.96 -1.37,2.96 0,0 4.78,8.25 -3.07,12.98 -3.31,2 -8.24,2.4 -12.41,1.42 -4.96,-1.17 -9.1,-7.52 -9.1,-7.52 0,0 0.79,9 -8.2,11.45 -4.26,1.16 -8.6,-3.08 -8.6,-3.08 0,0 -0.62,0.24 -3.01,0.3 -0.85,0.02 -1.58,0.03 -2.18,0.03 0.2,0.35 0.43,0.68 0.71,0.98 0.93,1 2.14,1.57 3.38,1.72 0.61,5.11 4.92,9.06 10.16,9.06 4.67,0 8.6,-3.14 9.84,-7.44 2.2,0.73 4.7,0.51 6.85,-0.79 2.2,2.07 5.11,3.37 8.34,3.46 2.22,0.06 4.32,-0.45 6.17,-1.41 0.85,1.03 2.13,1.69 3.57,1.69 2.57,0 4.65,-2.08 4.65,-4.66 0,-1.23 -0.48,-2.34 -1.25,-3.17 2.53,-1.88 4.18,-4.89 4.18,-8.3 z"
             id="path382" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 615.7,443.81 c 0,1.54 -1.25,2.8 -2.8,2.8 -1.55,0 -2.8,-1.26 -2.8,-2.8 0,-1.54 1.26,-2.8 2.8,-2.8 1.54,0 2.8,1.25 2.8,2.8 z"
             id="path383" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 610,446.61 c 0,0.98 -0.79,1.78 -1.78,1.78 -0.99,0 -1.78,-0.8 -1.78,-1.78 0,-0.98 0.8,-1.78 1.78,-1.78 0.98,0 1.78,0.8 1.78,1.78 z"
             id="path384" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 581.9,449.58 c 0,0.98 -0.79,1.78 -1.78,1.78 -0.99,0 -1.78,-0.79 -1.78,-1.78 0,-0.99 0.8,-1.78 1.78,-1.78 0.98,0 1.78,0.8 1.78,1.78 z"
             id="path385" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 614.68,439.29 c 0,0.72 -0.58,1.31 -1.31,1.31 -0.73,0 -1.3,-0.59 -1.3,-1.31 0,-0.72 0.58,-1.3 1.3,-1.3 0.72,0 1.31,0.59 1.31,1.3 z"
             id="path386" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 584.51,446.44 c 0,0.72 -0.59,1.31 -1.31,1.31 -0.72,0 -1.31,-0.59 -1.31,-1.31 0,-0.72 0.58,-1.31 1.31,-1.31 0.73,0 1.31,0.59 1.31,1.31 z"
             id="path387" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 588.89,418.7 c 0,0.98 -0.8,1.78 -1.78,1.78 -0.98,0 -1.78,-0.8 -1.78,-1.78 0,-0.98 0.8,-1.78 1.78,-1.78 0.98,0 1.78,0.8 1.78,1.78 z"
           id="path388" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 584.15,437.98 c 0,1.6 -1.3,2.9 -2.9,2.9 -1.6,0 -2.9,-1.3 -2.9,-2.9 0,-1.6 1.3,-2.9 2.9,-2.9 1.6,0 2.9,1.3 2.9,2.9 z"
           id="path389" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 589.85,415.47 c 0,0.46 -0.37,0.84 -0.84,0.84 -0.47,0 -0.83,-0.37 -0.83,-0.84 0,-0.47 0.37,-0.84 0.83,-0.84 0.46,0 0.84,0.37 0.84,0.84 z"
           id="path390" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 599.04,426.69 c 0,0.46 -0.37,0.83 -0.84,0.83 -0.47,0 -0.84,-0.37 -0.84,-0.83 0,-0.46 0.38,-0.84 0.84,-0.84 0.46,0 0.84,0.38 0.84,0.84 z"
           id="path391" />
      </g>
      <g
         id="g393">
        <path
           class="schulz-dashboard-center-icon-styling-11"
           d="m 647.54,482.78 c 0,2.87 -9.28,5.2 -20.72,5.2 -11.44,0 -20.72,-2.33 -20.72,-5.2 0,-2.87 9.28,-5.2 20.72,-5.2 11.44,0 20.72,2.33 20.72,5.2 z"
           id="path392" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 638.39,483.06 c 0,1.91 -6.96,3.46 -15.54,3.46 -8.58,0 -15.54,-1.55 -15.54,-3.46 0,-1.91 6.96,-3.46 15.54,-3.46 8.58,0 15.54,1.55 15.54,3.46 z"
           id="path393" />
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 616.75,478.48 c 0.45,-0.26 -0.51,-3.05 -0.57,-5.15 0,0 2.21,3.89 1.52,5.87 1,0.73 2.81,1.81 4,2.37 0.25,-3.21 0.46,-5.43 0.62,-6.96 0.04,-0.39 -3.76,-7.17 -3.56,-6.92 1.56,1.97 2.28,2.32 3.59,4.65 0.42,0.74 1.42,-5.96 1.42,-5.96 0.54,0.43 -0.08,5.01 0.13,6.03 0.13,0.65 0.19,1.43 0.25,2.26 0.06,0.93 0.2,3.16 0.31,4.1 1,-0.23 2.92,-2.47 5.32,-6.82 0,0 -1.85,7.46 -5.04,8.38 0.03,0.36 0.05,0.68 0.06,0.97 3.88,-1.39 10.82,-3.43 13.64,-5.76 0,0 -1.33,3.37 -12.97,6.5 l -0.49,0.52 c 0,0 0,0.78 -0.93,0.83 -0.69,0.04 -1.52,-0.11 -1.89,0.46 -0.37,0.56 -0.77,-0.14 -1.94,-0.86 -0.37,-0.23 -1.03,-0.94 -1.03,-0.94 -4.52,-3.43 -9.44,-8.89 -9.44,-8.89 1.15,1.27 6.03,4.35 7,5.32 z"
         id="path394" />
      <g
         id="g408">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 603.41,469.48 c 1.39,-1.29 3.36,-1.53 5.02,-0.8 0.95,-3.46 3.84,-6.06 7.37,-6.55 -1.09,-1.56 -1.72,-3.48 -1.66,-5.56 0.14,-5.03 4.23,-8.99 9.15,-8.86 4.64,0.13 8.34,3.87 8.62,8.51 1.01,-0.37 2.1,-0.57 3.23,-0.53 4.91,0.14 8.78,4.33 8.64,9.36 -0.03,1.03 -0.23,2.01 -0.56,2.93 0.77,1.4 1.2,3.02 1.16,4.74 -0.14,5.03 -4.24,8.99 -9.15,8.86 -1.55,-0.04 -2.98,-0.49 -4.23,-1.24 -0.08,0.08 -0.14,0.16 -0.22,0.24 -2.26,2.09 -5.81,1.94 -7.93,-0.35 -0.41,-0.45 -0.73,-0.95 -0.98,-1.47 -1.47,0.99 -3.24,1.55 -5.13,1.5 -1.12,-0.03 -2.17,-0.28 -3.15,-0.69 -0.14,0.63 -0.46,1.21 -0.96,1.68 -1.36,1.27 -3.52,1.16 -4.81,-0.23 -0.88,-0.95 -1.14,-2.26 -0.78,-3.4 -1.37,0.08 -2.77,-0.42 -3.79,-1.52 -1.78,-1.91 -1.7,-4.87 0.16,-6.61 z"
           id="path395" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 620.3,453.27 c 0,0.91 0.74,1.65 1.65,1.65 0.91,0 1.66,-0.74 1.66,-1.65 0,-0.91 -0.74,-1.66 -1.66,-1.66 -0.92,0 -1.65,0.74 -1.65,1.66 z"
           id="path396" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 624.19,452.49 c 0,0.43 0.35,0.78 0.78,0.78 0.43,0 0.78,-0.35 0.78,-0.78 0,-0.43 -0.35,-0.78 -0.78,-0.78 -0.43,0 -0.78,0.35 -0.78,0.78 z"
           id="path397" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 606,470 c 0,0.43 0.35,0.78 0.78,0.78 0.43,0 0.78,-0.35 0.78,-0.78 0,-0.43 -0.35,-0.78 -0.78,-0.78 -0.43,0 -0.78,0.35 -0.78,0.78 z"
           id="path398" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g404">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 635.21,481.58 c -1.55,-0.04 -2.98,-0.49 -4.23,-1.24 -0.08,0.08 -0.14,0.16 -0.22,0.24 -2.26,2.09 -5.81,1.94 -7.93,-0.35 -0.41,-0.45 -0.73,-0.95 -0.98,-1.47 -1.47,0.99 -3.24,1.55 -5.13,1.5 -1.12,-0.03 -2.17,-0.28 -3.15,-0.69 -0.14,0.63 -0.46,1.21 -0.96,1.68 -1.36,1.27 -3.52,1.16 -4.81,-0.23 -0.88,-0.95 -1.14,-2.26 -0.78,-3.4 -1.37,0.08 -2.77,-0.42 -3.79,-1.52 -1.53,-1.64 -1.68,-4.05 -0.52,-5.8 0.58,1.41 1.42,3.13 2.3,3.86 1.59,1.32 3.34,-1.64 4.95,-3.23 1.62,-1.59 2.36,0.16 4.59,1.28 2.23,1.13 4.42,-0.9 7.79,-1.97 3.38,-1.07 9.22,3.7 11.13,4.34 1.91,0.64 4.77,2.38 8.27,0.79 1.12,-0.51 1.94,-1.21 2.54,-1.94 -0.49,4.68 -4.42,8.27 -9.09,8.14 z"
             id="path399" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 615.47,469.67 c 0,1.05 0.85,1.91 1.91,1.91 1.06,0 1.91,-0.85 1.91,-1.91 0,-1.06 -0.85,-1.9 -1.91,-1.9 -1.06,0 -1.91,0.85 -1.91,1.9 z"
             id="path400" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 637.07,467.49 c 0,0.89 0.72,1.6 1.6,1.6 0.88,0 1.6,-0.72 1.6,-1.6 0,-0.88 -0.72,-1.6 -1.6,-1.6 -0.88,0 -1.6,0.72 -1.6,1.6 z"
             id="path401" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 613.15,469.1 c 0,0.48 0.39,0.87 0.87,0.87 0.48,0 0.87,-0.39 0.87,-0.87 0,-0.48 -0.39,-0.87 -0.87,-0.87 -0.48,0 -0.87,0.39 -0.87,0.87 z"
             id="path402" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 641.01,467.35 c 0,0.48 0.39,0.87 0.87,0.87 0.48,0 0.87,-0.39 0.87,-0.87 0,-0.48 -0.39,-0.87 -0.87,-0.87 -0.48,0 -0.87,0.39 -0.87,0.87 z"
             id="path403" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 636.16,464.9 c 0,0.49 0.4,0.89 0.89,0.89 0.49,0 0.89,-0.4 0.89,-0.89 0,-0.49 -0.4,-0.89 -0.89,-0.89 -0.49,0 -0.89,0.4 -0.89,0.89 z"
             id="path404" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 623.28,447.72 c 4.63,0.13 8.34,3.87 8.62,8.51 1.01,-0.37 2.1,-0.56 3.23,-0.53 3.41,0.1 6.32,2.15 7.73,5.08 -3.84,-2.86 -9.83,-2.05 -12.75,-1.41 -0.24,0.05 -0.48,-0.05 -0.6,-0.26 -0.12,-0.21 -0.1,-0.47 0.06,-0.65 l 0.9,-1.05 c 0.28,-0.33 0.32,-0.79 0.1,-1.16 -1.29,-2.16 -6.13,-8.85 -14.79,-4.69 1.66,-2.39 4.42,-3.92 7.51,-3.84 z"
           id="path405" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 615.78,462.11 c 4.91,0.53 8.41,3.25 8.41,3.25 0,0 -5.65,-1.63 -10.74,-1.1 -0.72,0.08 -1.89,0.35 -3.04,0.77 1.38,-1.55 3.26,-2.61 5.38,-2.9 0,0 0,-0.02 -0.02,-0.03 z"
           id="path406" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 625.48,474.59 c 0,0.91 0.74,1.66 1.65,1.66 0.91,0 1.66,-0.74 1.66,-1.66 0,-0.92 -0.74,-1.65 -1.66,-1.65 -0.92,0 -1.65,0.74 -1.65,1.65 z"
           id="path407" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 624.97,471.8 c 0,0.43 0.35,0.78 0.78,0.78 0.43,0 0.78,-0.35 0.78,-0.78 0,-0.43 -0.35,-0.78 -0.78,-0.78 -0.43,0 -0.78,0.35 -0.78,0.78 z"
           id="path408" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-11"
         points="667.24,510.62 704.69,500.58 604.84,473.83 567.39,483.86 "
         id="polygon408" />
      <g
         id="g410">
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 637.24,490.91 c 0,2.79 -6.87,5.05 -15.33,5.05 -8.46,0 -15.33,-2.26 -15.33,-5.05 0,-2.79 6.87,-5.05 15.33,-5.05 8.46,0 15.33,2.26 15.33,5.05 z"
           id="path409" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 630.47,491.17 c 0,1.86 -5.15,3.37 -11.5,3.37 -6.35,0 -11.5,-1.51 -11.5,-3.37 0,-1.86 5.15,-3.37 11.5,-3.37 6.35,0 11.5,1.51 11.5,3.37 z"
           id="path410" />
      </g>
      <g
         id="g418">
        <g
           id="g414">
          <g
             id="g413">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 608.15,484.17 v 6.89 c 0,0.61 0.87,1.22 2.61,1.69 3.48,0.93 9.12,0.93 12.6,0 1.74,-0.47 2.61,-1.08 2.61,-1.69 v -6.89 h -17.81 z"
               id="path411" />
            <g
               class="schulz-dashboard-center-icon-styling-47"
               clip-path="url(#clippath-20)"
               id="g412">
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="619.92999"
                 y="483.23999"
                 width="4.8099999"
                 height="11.49"
                 id="rect411" />
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="609.37"
                 y="483.23999"
                 width="4.8099999"
                 height="11.49"
                 id="rect412" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 610.76,482.48 c 3.48,-0.93 9.12,-0.93 12.6,0 3.48,0.93 3.48,2.44 0,3.38 -3.48,0.93 -9.12,0.93 -12.6,0 -3.48,-0.93 -3.48,-2.44 0,-3.38 z"
             id="path413" />
        </g>
        <g
           id="g417">
          <g
             id="g416">
            <path
               class="schulz-dashboard-center-icon-styling-70"
               d="m 611.26,466.17 v 17.94 c 0,0.4 0.57,0.79 1.7,1.1 2.26,0.61 5.93,0.61 8.19,0 1.13,-0.3 1.7,-0.7 1.7,-1.1 v -17.94 h -11.58 z"
               id="path414" />
            <g
               class="schulz-dashboard-center-icon-styling-48"
               clip-path="url(#clippath-21)"
               id="g415">
              <rect
                 class="schulz-dashboard-center-icon-styling-28"
                 x="618.92999"
                 y="465.57001"
                 width="3.1300001"
                 height="20.93"
                 id="rect414" />
              <rect
                 class="schulz-dashboard-center-icon-styling-25"
                 x="612.06"
                 y="465.57001"
                 width="3.1300001"
                 height="20.93"
                 id="rect415" />
            </g>
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-78"
             d="m 612.96,465.07 c 2.26,-0.61 5.93,-0.61 8.19,0 2.26,0.61 2.26,1.59 0,2.19 -2.26,0.61 -5.93,0.61 -8.19,0 -2.26,-0.61 -2.26,-1.59 0,-2.19 z"
             id="path416" />
        </g>
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-68"
         points="683.13,414.49 682.47,412 649.51,480.68 650.18,483.17 "
         id="polygon418" />
      <polygon
         class="schulz-dashboard-center-icon-styling-70"
         points="682.47,412 649.51,480.68 560.54,456.84 593.49,388.16 "
         id="polygon419" />
      <g
         id="g420">
        <path
           class="schulz-dashboard-center-icon-styling-20"
           d="m 626.75,422.74 -42.69,-11.44 10.36,-21.6 42.69,11.44 z m -0.34,0.71 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m 54.02,-10.71 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m -10.78,22.46 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m -54.02,10.73 -42.69,-11.44 -10.36,21.6 42.69,11.44 z m 43.31,11.6 -42.69,-11.44 -10.36,21.6 42.69,11.44 z"
           id="path419" />
        <path
           class="schulz-dashboard-center-icon-styling-79"
           d="m 599.59,392.83 -1.76,3.68 -0.74,0.35 -3.8,-1.02 -0.27,-0.63 1.76,-3.68 0.74,-0.35 3.8,1.02 z m 4.82,0.74 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -39.29,-2.07 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.06,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 25.44,-35.1 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.06,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.09,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -39.36,-1.93 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -82.62,-13.66 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.63 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 14.72,-12.78 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m -38.07,-4.62 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.36 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z m 5.1,1.37 -3.8,-1.02 -0.74,0.35 -1.76,3.68 0.27,0.63 3.8,1.02 0.74,-0.35 1.76,-3.68 z"
           id="path420" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-24"
         points="593.49,388.16 682.47,412 560.54,456.84 "
         id="polygon420" />
      <polygon
         class="schulz-dashboard-center-icon-styling-68"
         points="650.18,483.17 649.51,480.68 560.54,456.84 561.17,459.21 "
         id="polygon421" />
      <g
         id="g422">
        <path
           class="schulz-dashboard-center-icon-styling-11"
           d="m 739.44,436.23 c 0,2.54 -7.99,4.6 -17.84,4.6 -9.85,0 -17.84,-2.06 -17.84,-4.6 0,-2.54 7.99,-4.6 17.84,-4.6 9.85,0 17.84,2.06 17.84,4.6 z"
           id="path421" />
        <path
           class="schulz-dashboard-center-icon-styling-12"
           d="m 731.56,436.47 c 0,1.69 -5.99,3.06 -13.38,3.06 -7.39,0 -13.38,-1.37 -13.38,-3.06 0,-1.69 5.99,-3.07 13.38,-3.07 7.39,0 13.38,1.37 13.38,3.07 z"
           id="path422" />
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-76"
         d="m 722.27,432.42 c -0.4,-0.23 0.45,-2.7 0.5,-4.55 0,0 -1.96,3.44 -1.35,5.2 -0.88,0.64 -2.49,1.6 -3.53,2.09 -0.22,-2.84 -0.4,-4.8 -0.55,-6.15 -0.03,-0.34 3.32,-6.34 3.15,-6.12 -1.38,1.74 -2.02,2.06 -3.18,4.12 -0.37,0.66 -1.26,-5.27 -1.26,-5.27 -0.48,0.38 0.07,4.43 -0.11,5.33 -0.11,0.57 -0.17,1.26 -0.22,2 -0.05,0.83 -0.18,2.79 -0.28,3.62 -0.88,-0.21 -2.58,-2.18 -4.71,-6.04 0,0 1.64,6.6 4.46,7.41 -0.03,0.32 -0.04,0.6 -0.05,0.86 -3.43,-1.23 -9.57,-3.03 -12.06,-5.1 0,0 1.17,2.98 11.48,5.76 l 0.43,0.46 c 0,0 0,0.69 0.83,0.73 0.61,0.03 1.34,-0.09 1.67,0.4 0.33,0.5 0.68,-0.12 1.72,-0.76 0.33,-0.21 0.91,-0.83 0.91,-0.83 4,-3.04 8.35,-7.86 8.35,-7.86 -1.02,1.12 -5.33,3.85 -6.19,4.71 z"
         id="path423" />
      <g
         id="g437">
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 734.07,424.46 c -1.23,-1.14 -2.98,-1.36 -4.44,-0.71 -0.84,-3.06 -3.4,-5.37 -6.52,-5.8 0.97,-1.38 1.52,-3.08 1.47,-4.92 -0.12,-4.45 -3.75,-7.96 -8.09,-7.83 -4.1,0.11 -7.38,3.42 -7.63,7.53 -0.89,-0.33 -1.85,-0.5 -2.86,-0.47 -4.35,0.12 -7.77,3.83 -7.64,8.28 0.03,0.91 0.2,1.78 0.5,2.59 -0.68,1.24 -1.07,2.67 -1.02,4.19 0.13,4.45 3.75,7.96 8.1,7.84 1.37,-0.04 2.64,-0.44 3.74,-1.1 0.07,0.07 0.12,0.15 0.19,0.21 2,1.85 5.14,1.71 7.02,-0.31 0.37,-0.39 0.65,-0.84 0.86,-1.3 1.3,0.88 2.87,1.37 4.54,1.33 0.99,-0.03 1.92,-0.25 2.78,-0.61 0.13,0.55 0.41,1.07 0.85,1.49 1.21,1.12 3.11,1.03 4.26,-0.2 0.78,-0.84 1.01,-2 0.69,-3.01 1.21,0.08 2.45,-0.38 3.35,-1.35 1.57,-1.69 1.51,-4.31 -0.14,-5.85 z"
           id="path424" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 719.12,410.11 c 0,0.81 -0.65,1.46 -1.46,1.46 -0.81,0 -1.47,-0.66 -1.47,-1.46 0,-0.8 0.66,-1.47 1.47,-1.47 0.81,0 1.46,0.66 1.46,1.47 z"
           id="path425" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 715.68,409.42 c 0,0.38 -0.31,0.69 -0.69,0.69 -0.38,0 -0.69,-0.31 -0.69,-0.69 0,-0.38 0.31,-0.69 0.69,-0.69 0.38,0 0.69,0.31 0.69,0.69 z"
           id="path426" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 731.78,424.92 c 0,0.38 -0.31,0.69 -0.69,0.69 -0.38,0 -0.69,-0.31 -0.69,-0.69 0,-0.38 0.31,-0.69 0.69,-0.69 0.38,0 0.69,0.31 0.69,0.69 z"
           id="path427" />
        <g
           class="schulz-dashboard-center-icon-styling-18"
           id="g433">
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 705.93,435.16 c 1.37,-0.04 2.64,-0.44 3.74,-1.1 0.07,0.07 0.12,0.15 0.19,0.21 2,1.85 5.14,1.71 7.02,-0.31 0.37,-0.39 0.65,-0.84 0.86,-1.3 1.3,0.88 2.87,1.37 4.54,1.33 0.99,-0.03 1.92,-0.25 2.78,-0.61 0.13,0.55 0.41,1.07 0.85,1.49 1.21,1.12 3.11,1.03 4.26,-0.2 0.78,-0.84 1.01,-2 0.69,-3.01 1.21,0.08 2.45,-0.38 3.35,-1.35 1.35,-1.45 1.49,-3.58 0.46,-5.13 -0.51,1.24 -1.26,2.77 -2.03,3.42 -1.41,1.17 -2.96,-1.45 -4.38,-2.85 -1.43,-1.41 -2.09,0.14 -4.06,1.14 -1.97,1 -3.91,-0.79 -6.89,-1.74 -2.99,-0.95 -8.16,3.28 -9.85,3.84 -1.69,0.57 -4.22,2.11 -7.31,0.7 -0.99,-0.45 -1.71,-1.07 -2.25,-1.71 0.43,4.14 3.91,7.32 8.04,7.2 z"
             id="path428" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 723.4,424.62 c 0,0.93 -0.76,1.69 -1.69,1.69 -0.93,0 -1.69,-0.75 -1.69,-1.69 0,-0.94 0.75,-1.68 1.69,-1.68 0.94,0 1.69,0.76 1.69,1.68 z"
             id="path429" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 704.29,422.7 c 0,0.79 -0.63,1.42 -1.42,1.42 -0.79,0 -1.42,-0.63 -1.42,-1.42 0,-0.79 0.63,-1.42 1.42,-1.42 0.79,0 1.42,0.63 1.42,1.42 z"
             id="path430" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 725.45,424.12 c 0,0.43 -0.35,0.77 -0.77,0.77 -0.42,0 -0.77,-0.34 -0.77,-0.77 0,-0.43 0.35,-0.77 0.77,-0.77 0.42,0 0.77,0.35 0.77,0.77 z"
             id="path431" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 700.8,422.57 c 0,0.43 -0.35,0.77 -0.77,0.77 -0.42,0 -0.77,-0.34 -0.77,-0.77 0,-0.43 0.35,-0.77 0.77,-0.77 0.42,0 0.77,0.35 0.77,0.77 z"
             id="path432" />
          <path
             class="schulz-dashboard-center-icon-styling-22"
             d="m 705.09,420.4 c 0,0.44 -0.35,0.79 -0.79,0.79 -0.44,0 -0.79,-0.35 -0.79,-0.79 0,-0.44 0.35,-0.79 0.79,-0.79 0.44,0 0.79,0.35 0.79,0.79 z"
             id="path433" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 716.49,405.2 c -4.1,0.11 -7.38,3.42 -7.63,7.53 -0.89,-0.33 -1.85,-0.5 -2.86,-0.47 -3.02,0.08 -5.59,1.9 -6.84,4.5 3.4,-2.53 8.7,-1.81 11.28,-1.25 0.21,0.05 0.42,-0.05 0.53,-0.23 0.11,-0.18 0.09,-0.42 -0.05,-0.58 l -0.8,-0.93 c -0.25,-0.29 -0.28,-0.7 -0.09,-1.03 1.14,-1.91 5.42,-7.83 13.09,-4.15 -1.47,-2.12 -3.91,-3.47 -6.64,-3.4 z"
           id="path434" />
        <path
           class="schulz-dashboard-center-icon-styling-29"
           d="m 723.12,417.93 c -4.34,0.47 -7.44,2.88 -7.44,2.88 0,0 5,-1.44 9.5,-0.97 0.64,0.07 1.67,0.31 2.69,0.68 -1.22,-1.37 -2.89,-2.31 -4.76,-2.57 0,0 0,-0.02 0.01,-0.02 z"
           id="path435" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 714.55,428.98 c 0,0.81 -0.65,1.47 -1.46,1.47 -0.81,0 -1.46,-0.66 -1.46,-1.47 0,-0.81 0.66,-1.46 1.46,-1.46 0.8,0 1.46,0.66 1.46,1.46 z"
           id="path436" />
        <path
           class="schulz-dashboard-center-icon-styling-21"
           d="m 715,426.5 c 0,0.38 -0.31,0.69 -0.69,0.69 -0.38,0 -0.69,-0.31 -0.69,-0.69 0,-0.38 0.31,-0.69 0.69,-0.69 0.38,0 0.69,0.31 0.69,0.69 z"
           id="path437" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-17"
         points="650.23,549.69 650.23,557.68 662.73,557.68 680.73,552.86 668.88,549.69 "
         id="polygon437" />
      <g
         id="g486">
        <g
           id="g444">
          <polygon
             class="schulz-dashboard-center-icon-styling-76"
             points="650.08,545.53 666.73,550 650.08,554.46 633.43,550 "
             id="polygon438" />
          <path
             class="schulz-dashboard-center-icon-styling-65"
             d="m 641.09,547.65 v 0 c -4.97,1.33 -8.99,-1.91 -8.99,-7.23 v -12.53 l 17.98,-4.82 v 12.53 c 0,5.32 -4.03,10.72 -8.99,12.05 z"
             id="path438" />
          <polygon
             class="schulz-dashboard-center-icon-styling-65"
             points="637.15,535.21 655.14,540.03 655.14,552.56 637.15,547.74 "
             id="polygon439" />
          <polygon
             class="schulz-dashboard-center-icon-styling-70"
             points="632.1,527.89 650.08,532.71 650.08,545.24 632.1,540.42 "
             id="polygon440" />
          <polygon
             class="schulz-dashboard-center-icon-styling-53"
             points="650.08,523.07 668.07,527.89 650.08,532.71 632.1,527.89 "
             id="polygon441" />
          <g
             id="g443">
            <polygon
               class="schulz-dashboard-center-icon-styling-19"
               points="633.43,553.22 633.43,550 650.08,554.46 650.08,557.68 "
               id="polygon442" />
            <polygon
               class="schulz-dashboard-center-icon-styling-31"
               points="666.73,553.22 666.73,550 650.08,554.46 650.08,557.68 "
               id="polygon443" />
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 659.07,552.47 v 0 c -4.97,1.33 -8.99,-1.91 -8.99,-7.23 v -12.53 l 17.98,-4.82 v 12.53 c 0,5.32 -4.03,10.72 -8.99,12.05 z"
             id="path443" />
        </g>
        <g
           id="g446">
          <polygon
             class="schulz-dashboard-center-icon-styling-78"
             points="632.1,539.23 632.1,489.06 650.08,493.88 650.08,544.05 "
             id="polygon444" />
          <polygon
             class="schulz-dashboard-center-icon-styling-70"
             points="668.07,539.23 668.07,489.06 650.08,493.88 650.08,544.05 "
             id="polygon445" />
          <polygon
             class="schulz-dashboard-center-icon-styling-77"
             points="650.08,484.24 632.1,489.06 650.08,493.88 668.07,489.06 "
             id="polygon446" />
        </g>
        <g
           id="g480">
          <g
             id="g471">
            <g
               id="g449">
              <polygon
                 class="schulz-dashboard-center-icon-styling-76"
                 points="634.31,505.88 634.31,490.56 647.87,494.2 647.87,509.51 "
                 id="polygon447" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-65"
                 points="634.31,505.88 635.89,505.45 640.02,492.09 634.31,490.56 "
                 id="polygon448" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-68"
                 points="634.31,505.88 635.89,505.45 647.87,508.66 647.87,509.51 "
                 id="polygon449" />
            </g>
            <polygon
               class="schulz-dashboard-center-icon-styling-23"
               points="638.09,501.68 640.27,494.48 647.88,496.52 647.87,504.3 "
               id="polygon450" />
            <g
               id="g470">
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="637.87,502.76 638.02,502.29 638.53,502.42 638.38,502.9 "
                 id="polygon451" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="638.7,502.98 638.85,502.51 639.35,502.64 639.2,503.12 "
                 id="polygon452" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="639.52,503.2 639.67,502.73 640.18,502.86 640.03,503.34 "
                 id="polygon453" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="640.34,503.42 640.49,502.95 641,503.08 640.85,503.56 "
                 id="polygon454" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="641.17,503.64 641.32,503.17 641.82,503.3 641.67,503.77 "
                 id="polygon455" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="637.6,503.61 637.75,503.14 638.26,503.27 638.11,503.75 "
                 id="polygon456" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="638.43,503.83 638.58,503.36 639.08,503.49 638.93,503.96 "
                 id="polygon457" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="639.25,504.05 639.4,503.57 639.91,503.71 639.76,504.18 "
                 id="polygon458" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="640.07,504.27 640.22,503.79 640.73,503.93 640.58,504.4 "
                 id="polygon459" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="640.9,504.49 641.05,504.01 641.55,504.15 641.4,504.62 "
                 id="polygon460" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="637.33,504.46 637.48,503.98 637.99,504.12 637.84,504.59 "
                 id="polygon461" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="638.16,504.68 638.31,504.2 638.81,504.34 638.66,504.81 "
                 id="polygon462" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="638.98,504.9 639.13,504.42 639.64,504.56 639.49,505.03 "
                 id="polygon463" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="639.8,505.11 639.95,504.64 640.46,504.77 640.31,505.25 "
                 id="polygon464" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="640.62,505.33 640.78,504.86 641.28,504.99 641.13,505.47 "
                 id="polygon465" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="637.06,505.3 637.21,504.83 637.72,504.96 637.57,505.44 "
                 id="polygon466" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="637.89,505.52 638.04,505.05 638.54,505.18 638.39,505.66 "
                 id="polygon467" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="638.71,505.74 638.86,505.27 639.37,505.4 639.22,505.88 "
                 id="polygon468" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="639.53,505.96 639.68,505.49 640.19,505.62 640.04,506.1 "
                 id="polygon469" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="640.35,506.18 640.51,505.7 641.01,505.84 640.86,506.31 "
                 id="polygon470" />
            </g>
            <path
               class="schulz-dashboard-center-icon-styling-6"
               d="m 644.21,503.99 c 0.07,0.15 0,0.35 -0.15,0.46 -0.15,0.11 -0.32,0.08 -0.39,-0.07 -0.07,-0.15 0,-0.35 0.15,-0.46 0.15,-0.11 0.32,-0.08 0.39,0.07 z"
               id="path470" />
            <path
               class="schulz-dashboard-center-icon-styling-74"
               d="m 645.01,504.21 c 0.07,0.15 0,0.35 -0.15,0.46 -0.15,0.11 -0.32,0.08 -0.39,-0.07 -0.07,-0.15 0,-0.35 0.15,-0.46 0.15,-0.11 0.32,-0.08 0.39,0.07 z"
               id="path471" />
          </g>
          <g
             id="g476">
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="665.48,517.7 665.48,516.43 652.67,519.86 652.67,521.14 "
               id="polygon471" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="665.48,531.37 665.48,530.09 652.67,533.52 652.67,534.8 "
               id="polygon472" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="665.48,528.63 665.48,527.36 652.67,530.79 652.67,532.06 "
               id="polygon473" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="665.48,525.9 665.48,524.63 652.67,528.06 652.67,529.33 "
               id="polygon474" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="665.48,523.17 665.48,521.89 652.67,525.33 652.67,526.6 "
               id="polygon475" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="665.48,520.44 665.48,519.16 652.67,522.59 652.67,523.87 "
               id="polygon476" />
          </g>
          <g
             id="g479">
            <polygon
               class="schulz-dashboard-center-icon-styling-31"
               points="663.65,502.1 663.65,491.76 654.5,494.22 654.5,504.55 "
               id="polygon477" />
            <polygon
               class="schulz-dashboard-center-icon-styling-65"
               points="663.65,502.1 662.58,501.81 662.58,492.05 663.65,491.76 "
               id="polygon478" />
            <polygon
               class="schulz-dashboard-center-icon-styling-78"
               points="663.65,502.1 662.58,501.81 654.5,503.98 654.5,504.55 "
               id="polygon479" />
          </g>
        </g>
        <g
           id="g482">
          <polygon
             class="schulz-dashboard-center-icon-styling-78"
             points="632.1,489.55 632.1,467.92 650.08,472.74 650.08,494.36 "
             id="polygon480" />
          <polygon
             class="schulz-dashboard-center-icon-styling-70"
             points="668.07,489.55 668.07,467.92 650.08,472.74 650.08,494.36 "
             id="polygon481" />
          <polygon
             class="schulz-dashboard-center-icon-styling-53"
             points="650.08,463.11 632.1,467.92 650.08,472.74 668.07,467.92 "
             id="polygon482" />
        </g>
        <g
           id="g484">
          <path
             class="schulz-dashboard-center-icon-styling-67"
             d="m 650.08,474.14 -17.98,4.82 v -12.53 c 0,-5.32 4.03,-10.72 8.99,-12.05 v 0 c 4.97,-1.33 8.99,1.91 8.99,7.23 z"
             id="path482" />
          <polygon
             class="schulz-dashboard-center-icon-styling-67"
             points="632.1,466.42 643.93,454.08 661.91,458.9 650.08,471.24 "
             id="polygon483" />
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 668.07,478.95 -17.98,4.82 v -12.53 c 0,-5.32 4.03,-10.72 8.99,-12.05 v 0 c 4.97,-1.33 8.99,1.91 8.99,7.23 z"
             id="path483" />
          <polygon
             class="schulz-dashboard-center-icon-styling-78"
             points="632.1,466.42 650.08,471.24 650.08,483.77 632.1,478.95 "
             id="polygon484" />
        </g>
        <polygon
           class="schulz-dashboard-center-icon-styling-21"
           points="636.42,481.16 639.38,481.95 639.38,488.29 643.9,480.35 640.94,479.55 640.94,473.21 "
           id="polygon485" />
        <polygon
           class="schulz-dashboard-center-icon-styling-70"
           points="655.47,483.04 658.28,482.28 658.28,488.27 662.54,478.49 659.74,479.24 659.74,473.25 "
           id="polygon486" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-17"
         points="520.83,515.06 520.83,523.05 533.33,523.05 551.33,518.23 539.48,515.06 "
         id="polygon487" />
      <g
         id="g536">
        <g
           id="g494">
          <polygon
             class="schulz-dashboard-center-icon-styling-76"
             points="520.68,510.91 537.33,515.37 520.68,519.83 504.03,515.37 "
             id="polygon488" />
          <path
             class="schulz-dashboard-center-icon-styling-65"
             d="m 511.69,513.02 v 0 c -4.97,1.33 -8.99,-1.91 -8.99,-7.23 v -12.53 l 17.98,-4.82 v 12.53 c 0,5.32 -4.03,10.72 -8.99,12.05 z"
             id="path488" />
          <polygon
             class="schulz-dashboard-center-icon-styling-65"
             points="507.75,500.58 525.74,505.4 525.74,517.93 507.75,513.11 "
             id="polygon489" />
          <polygon
             class="schulz-dashboard-center-icon-styling-70"
             points="502.7,493.26 520.68,498.08 520.68,510.61 502.7,505.79 "
             id="polygon490" />
          <polygon
             class="schulz-dashboard-center-icon-styling-53"
             points="520.68,488.44 538.67,493.26 520.68,498.08 502.7,493.26 "
             id="polygon491" />
          <g
             id="g493">
            <polygon
               class="schulz-dashboard-center-icon-styling-19"
               points="504.03,518.59 504.03,515.37 520.68,519.83 520.68,523.05 "
               id="polygon492" />
            <polygon
               class="schulz-dashboard-center-icon-styling-31"
               points="537.33,518.59 537.33,515.37 520.68,519.83 520.68,523.05 "
               id="polygon493" />
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 529.67,517.84 v 0 c -4.97,1.33 -8.99,-1.91 -8.99,-7.23 v -12.53 l 17.98,-4.82 v 12.53 c 0,5.32 -4.03,10.72 -8.99,12.05 z"
             id="path493" />
        </g>
        <g
           id="g496">
          <polygon
             class="schulz-dashboard-center-icon-styling-78"
             points="502.7,504.6 502.7,454.43 520.68,459.25 520.68,509.42 "
             id="polygon494" />
          <polygon
             class="schulz-dashboard-center-icon-styling-70"
             points="538.67,504.6 538.67,454.43 520.68,459.25 520.68,509.42 "
             id="polygon495" />
          <polygon
             class="schulz-dashboard-center-icon-styling-77"
             points="520.68,449.61 502.7,454.43 520.68,459.25 538.67,454.43 "
             id="polygon496" />
        </g>
        <g
           id="g530">
          <g
             id="g521">
            <g
               id="g499">
              <polygon
                 class="schulz-dashboard-center-icon-styling-76"
                 points="504.91,471.25 504.91,455.93 518.47,459.57 518.47,474.88 "
                 id="polygon497" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-65"
                 points="504.91,471.25 506.49,470.82 510.62,457.47 504.91,455.93 "
                 id="polygon498" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-68"
                 points="504.91,471.25 506.49,470.82 518.47,474.04 518.47,474.88 "
                 id="polygon499" />
            </g>
            <polygon
               class="schulz-dashboard-center-icon-styling-23"
               points="508.69,467.05 510.87,459.85 518.48,461.89 518.47,469.67 "
               id="polygon500" />
            <g
               id="g520">
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="508.47,468.13 508.62,467.66 509.13,467.8 508.98,468.27 "
                 id="polygon501" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="509.3,468.35 509.45,467.88 509.95,468.01 509.8,468.49 "
                 id="polygon502" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="510.12,468.57 510.27,468.1 510.78,468.23 510.63,468.71 "
                 id="polygon503" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="510.94,468.79 511.09,468.32 511.6,468.45 511.45,468.93 "
                 id="polygon504" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="511.76,469.01 511.92,468.54 512.42,468.67 512.27,469.15 "
                 id="polygon505" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="508.2,468.98 508.35,468.51 508.86,468.64 508.71,469.12 "
                 id="polygon506" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="509.03,469.2 509.18,468.73 509.68,468.86 509.53,469.34 "
                 id="polygon507" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="509.85,469.42 510,468.94 510.51,469.08 510.36,469.55 "
                 id="polygon508" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="510.67,469.64 510.82,469.16 511.33,469.3 511.18,469.77 "
                 id="polygon509" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="511.49,469.86 511.65,469.38 512.15,469.52 512,469.99 "
                 id="polygon510" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="507.93,469.83 508.08,469.35 508.59,469.49 508.44,469.96 "
                 id="polygon511" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="508.76,470.05 508.91,469.57 509.41,469.71 509.26,470.18 "
                 id="polygon512" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="509.58,470.27 509.73,469.79 510.24,469.93 510.08,470.4 "
                 id="polygon513" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="510.4,470.48 510.55,470.01 511.06,470.14 510.91,470.62 "
                 id="polygon514" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="511.22,470.7 511.38,470.23 511.88,470.36 511.73,470.84 "
                 id="polygon515" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="507.66,470.67 507.81,470.2 508.32,470.33 508.17,470.81 "
                 id="polygon516" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="508.49,470.89 508.64,470.42 509.14,470.55 508.99,471.03 "
                 id="polygon517" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="509.31,471.11 509.46,470.64 509.97,470.77 509.81,471.25 "
                 id="polygon518" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="510.13,471.33 510.28,470.86 510.79,470.99 510.64,471.47 "
                 id="polygon519" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="510.95,471.55 511.11,471.08 511.61,471.21 511.46,471.68 "
                 id="polygon520" />
            </g>
            <path
               class="schulz-dashboard-center-icon-styling-6"
               d="m 514.81,469.36 c 0.07,0.15 0,0.35 -0.15,0.46 -0.15,0.11 -0.32,0.08 -0.39,-0.07 -0.07,-0.15 0,-0.35 0.15,-0.46 0.15,-0.11 0.32,-0.08 0.39,0.07 z"
               id="path520" />
            <path
               class="schulz-dashboard-center-icon-styling-74"
               d="m 515.61,469.58 c 0.07,0.15 0,0.35 -0.15,0.46 -0.15,0.11 -0.32,0.08 -0.39,-0.07 -0.07,-0.15 0,-0.35 0.15,-0.46 0.15,-0.11 0.32,-0.08 0.39,0.07 z"
               id="path521" />
          </g>
          <g
             id="g526">
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="536.08,483.07 536.08,481.8 523.27,485.23 523.27,486.51 "
               id="polygon521" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="536.08,496.74 536.08,495.46 523.27,498.89 523.27,500.17 "
               id="polygon522" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="536.08,494 536.08,492.73 523.27,496.16 523.27,497.44 "
               id="polygon523" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="536.08,491.27 536.08,490 523.27,493.43 523.27,494.7 "
               id="polygon524" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="536.08,488.54 536.08,487.26 523.27,490.7 523.27,491.97 "
               id="polygon525" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="536.08,485.81 536.08,484.53 523.27,487.96 523.27,489.24 "
               id="polygon526" />
          </g>
          <g
             id="g529">
            <polygon
               class="schulz-dashboard-center-icon-styling-31"
               points="534.25,467.47 534.25,457.13 525.1,459.59 525.1,469.92 "
               id="polygon527" />
            <polygon
               class="schulz-dashboard-center-icon-styling-65"
               points="534.25,467.47 533.18,467.18 533.18,457.42 534.25,457.13 "
               id="polygon528" />
            <polygon
               class="schulz-dashboard-center-icon-styling-78"
               points="534.25,467.47 533.18,467.18 525.1,469.35 525.1,469.92 "
               id="polygon529" />
          </g>
        </g>
        <g
           id="g532">
          <polygon
             class="schulz-dashboard-center-icon-styling-78"
             points="502.7,454.92 502.7,433.29 520.68,438.11 520.68,459.74 "
             id="polygon530" />
          <polygon
             class="schulz-dashboard-center-icon-styling-70"
             points="538.67,454.92 538.67,433.29 520.68,438.11 520.68,459.74 "
             id="polygon531" />
          <polygon
             class="schulz-dashboard-center-icon-styling-53"
             points="520.68,428.48 502.7,433.29 520.68,438.11 538.67,433.29 "
             id="polygon532" />
        </g>
        <g
           id="g534">
          <path
             class="schulz-dashboard-center-icon-styling-67"
             d="m 520.68,439.51 -17.98,4.82 V 431.8 c 0,-5.32 4.03,-10.72 8.99,-12.05 v 0 c 4.97,-1.33 8.99,1.91 8.99,7.23 z"
             id="path532" />
          <polygon
             class="schulz-dashboard-center-icon-styling-67"
             points="502.7,431.8 514.53,419.45 532.51,424.27 520.68,436.61 "
             id="polygon533" />
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 538.67,444.32 -17.98,4.82 v -12.53 c 0,-5.32 4.03,-10.72 8.99,-12.05 v 0 c 4.97,-1.33 8.99,1.91 8.99,7.23 z"
             id="path533" />
          <polygon
             class="schulz-dashboard-center-icon-styling-78"
             points="502.7,431.8 520.68,436.61 520.68,449.14 502.7,444.32 "
             id="polygon534" />
        </g>
        <polygon
           class="schulz-dashboard-center-icon-styling-21"
           points="507.02,446.53 509.98,447.32 509.98,453.67 514.5,445.72 511.54,444.92 511.54,438.58 "
           id="polygon535" />
        <polygon
           class="schulz-dashboard-center-icon-styling-70"
           points="526.07,448.41 528.87,447.66 528.87,453.64 533.14,443.86 530.34,444.61 530.34,438.62 "
           id="polygon536" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-17"
         points="392.67,480.72 392.67,488.71 405.18,488.71 423.17,483.89 411.33,480.72 "
         id="polygon537" />
      <g
         id="g586">
        <g
           id="g544">
          <polygon
             class="schulz-dashboard-center-icon-styling-76"
             points="392.53,476.57 409.18,481.03 392.53,485.49 375.88,481.03 "
             id="polygon538" />
          <path
             class="schulz-dashboard-center-icon-styling-65"
             d="m 383.53,478.68 v 0 c -4.97,1.33 -8.99,-1.91 -8.99,-7.23 v -12.53 l 17.98,-4.82 v 12.53 c 0,5.32 -4.03,10.72 -8.99,12.05 z"
             id="path538" />
          <polygon
             class="schulz-dashboard-center-icon-styling-65"
             points="379.6,466.24 397.58,471.06 397.58,483.59 379.6,478.77 "
             id="polygon539" />
          <polygon
             class="schulz-dashboard-center-icon-styling-70"
             points="374.54,458.92 392.53,463.74 392.53,476.27 374.54,471.45 "
             id="polygon540" />
          <polygon
             class="schulz-dashboard-center-icon-styling-53"
             points="392.53,454.1 410.51,458.92 392.53,463.74 374.54,458.92 "
             id="polygon541" />
          <g
             id="g543">
            <polygon
               class="schulz-dashboard-center-icon-styling-19"
               points="375.88,484.25 375.88,481.03 392.53,485.49 392.53,488.71 "
               id="polygon542" />
            <polygon
               class="schulz-dashboard-center-icon-styling-31"
               points="409.18,484.25 409.18,481.03 392.53,485.49 392.53,488.71 "
               id="polygon543" />
          </g>
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 401.52,483.5 v 0 c -4.97,1.33 -8.99,-1.91 -8.99,-7.23 v -12.53 l 17.98,-4.82 v 12.53 c 0,5.32 -4.03,10.72 -8.99,12.05 z"
             id="path543" />
        </g>
        <g
           id="g546">
          <polygon
             class="schulz-dashboard-center-icon-styling-78"
             points="374.54,470.26 374.54,420.09 392.53,424.91 392.53,475.08 "
             id="polygon544" />
          <polygon
             class="schulz-dashboard-center-icon-styling-70"
             points="410.51,470.26 410.51,420.09 392.53,424.91 392.53,475.08 "
             id="polygon545" />
          <polygon
             class="schulz-dashboard-center-icon-styling-77"
             points="392.53,415.27 374.54,420.09 392.53,424.91 410.51,420.09 "
             id="polygon546" />
        </g>
        <g
           id="g580">
          <g
             id="g571">
            <g
               id="g549">
              <polygon
                 class="schulz-dashboard-center-icon-styling-76"
                 points="376.75,436.91 376.75,421.6 390.31,425.23 390.31,440.54 "
                 id="polygon547" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-65"
                 points="376.75,436.91 378.33,436.49 382.47,423.13 376.75,421.6 "
                 id="polygon548" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-68"
                 points="376.75,436.91 378.33,436.49 390.31,439.7 390.31,440.54 "
                 id="polygon549" />
            </g>
            <polygon
               class="schulz-dashboard-center-icon-styling-23"
               points="380.53,432.71 382.71,425.51 390.32,427.55 390.31,435.33 "
               id="polygon550" />
            <g
               id="g570">
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="380.32,433.8 380.47,433.32 380.98,433.46 380.82,433.93 "
                 id="polygon551" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="381.14,434.02 381.29,433.54 381.8,433.68 381.65,434.15 "
                 id="polygon552" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="381.96,434.23 382.11,433.76 382.62,433.89 382.47,434.37 "
                 id="polygon553" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="382.79,434.45 382.94,433.98 383.44,434.11 383.29,434.59 "
                 id="polygon554" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="383.61,434.67 383.76,434.2 384.27,434.33 384.12,434.81 "
                 id="polygon555" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="380.05,434.64 380.2,434.17 380.71,434.3 380.55,434.78 "
                 id="polygon556" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="380.87,434.86 381.02,434.39 381.53,434.52 381.38,435 "
                 id="polygon557" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="381.69,435.08 381.84,434.61 382.35,434.74 382.2,435.22 "
                 id="polygon558" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="382.52,435.3 382.67,434.83 383.17,434.96 383.02,435.43 "
                 id="polygon559" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="383.34,435.52 383.49,435.04 384,435.18 383.85,435.65 "
                 id="polygon560" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="379.78,435.49 379.93,435.01 380.44,435.15 380.28,435.62 "
                 id="polygon561" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="380.6,435.71 380.75,435.23 381.26,435.37 381.11,435.84 "
                 id="polygon562" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="381.42,435.93 381.57,435.45 382.08,435.59 381.93,436.06 "
                 id="polygon563" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="382.25,436.15 382.4,435.67 382.9,435.81 382.75,436.28 "
                 id="polygon564" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="383.07,436.37 383.22,435.89 383.73,436.03 383.58,436.5 "
                 id="polygon565" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="379.51,436.34 379.66,435.86 380.17,436 380.01,436.47 "
                 id="polygon566" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="380.33,436.55 380.48,436.08 380.99,436.21 380.84,436.69 "
                 id="polygon567" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="381.15,436.77 381.3,436.3 381.81,436.43 381.66,436.91 "
                 id="polygon568" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="381.98,436.99 382.13,436.52 382.63,436.65 382.48,437.13 "
                 id="polygon569" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="382.8,437.21 382.95,436.74 383.46,436.87 383.31,437.35 "
                 id="polygon570" />
            </g>
            <path
               class="schulz-dashboard-center-icon-styling-6"
               d="m 386.65,435.02 c 0.07,0.15 0,0.35 -0.15,0.46 -0.15,0.11 -0.32,0.08 -0.39,-0.07 -0.07,-0.15 0,-0.35 0.15,-0.46 0.15,-0.11 0.32,-0.08 0.39,0.07 z"
               id="path570" />
            <path
               class="schulz-dashboard-center-icon-styling-74"
               d="m 387.45,435.24 c 0.07,0.15 0,0.35 -0.15,0.46 -0.15,0.11 -0.32,0.08 -0.39,-0.07 -0.07,-0.15 0,-0.35 0.15,-0.46 0.15,-0.11 0.32,-0.08 0.39,0.07 z"
               id="path571" />
          </g>
          <g
             id="g576">
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="407.92,448.74 407.92,447.46 395.11,450.89 395.11,452.17 "
               id="polygon571" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="407.92,462.4 407.92,461.12 395.11,464.55 395.11,465.83 "
               id="polygon572" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="407.92,459.67 407.92,458.39 395.11,461.82 395.11,463.1 "
               id="polygon573" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="407.92,456.93 407.92,455.66 395.11,459.09 395.11,460.36 "
               id="polygon574" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="407.92,454.2 407.92,452.93 395.11,456.36 395.11,457.63 "
               id="polygon575" />
            <polygon
               class="schulz-dashboard-center-icon-styling-75"
               points="407.92,451.47 407.92,450.19 395.11,453.63 395.11,454.9 "
               id="polygon576" />
          </g>
          <g
             id="g579">
            <polygon
               class="schulz-dashboard-center-icon-styling-31"
               points="406.09,433.13 406.09,422.79 396.94,425.25 396.94,435.58 "
               id="polygon577" />
            <polygon
               class="schulz-dashboard-center-icon-styling-65"
               points="406.09,433.13 405.03,432.84 405.03,423.08 406.09,422.79 "
               id="polygon578" />
            <polygon
               class="schulz-dashboard-center-icon-styling-78"
               points="406.09,433.13 405.03,432.84 396.94,435.01 396.94,435.58 "
               id="polygon579" />
          </g>
        </g>
        <g
           id="g582">
          <polygon
             class="schulz-dashboard-center-icon-styling-78"
             points="374.54,420.58 374.54,398.96 392.53,403.78 392.53,425.4 "
             id="polygon580" />
          <polygon
             class="schulz-dashboard-center-icon-styling-70"
             points="410.51,420.58 410.51,398.96 392.53,403.78 392.53,425.4 "
             id="polygon581" />
          <polygon
             class="schulz-dashboard-center-icon-styling-53"
             points="392.53,394.14 374.54,398.96 392.53,403.78 410.51,398.96 "
             id="polygon582" />
        </g>
        <g
           id="g584">
          <path
             class="schulz-dashboard-center-icon-styling-67"
             d="m 392.53,405.17 -17.98,4.82 v -12.53 c 0,-5.32 4.03,-10.72 8.99,-12.05 v 0 c 4.97,-1.33 8.99,1.91 8.99,7.23 z"
             id="path582" />
          <polygon
             class="schulz-dashboard-center-icon-styling-67"
             points="374.54,397.46 386.37,385.11 404.36,389.93 392.53,402.28 "
             id="polygon583" />
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 410.51,409.99 -17.98,4.82 v -12.53 c 0,-5.32 4.03,-10.72 8.99,-12.05 v 0 c 4.97,-1.33 8.99,1.91 8.99,7.23 z"
             id="path583" />
          <polygon
             class="schulz-dashboard-center-icon-styling-78"
             points="374.54,397.46 392.53,402.28 392.53,414.81 374.54,409.99 "
             id="polygon584" />
        </g>
        <polygon
           class="schulz-dashboard-center-icon-styling-21"
           points="378.86,412.19 381.83,412.98 381.83,419.33 386.35,411.38 383.38,410.58 383.38,404.24 "
           id="polygon585" />
        <polygon
           class="schulz-dashboard-center-icon-styling-70"
           points="397.92,414.07 400.72,413.32 400.72,419.3 404.98,409.52 402.18,410.27 402.18,404.28 "
           id="polygon586" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-17"
         id="g587">
        <path
           class="schulz-dashboard-center-icon-styling-31"
           d="M 337.02,492.84 C 330.37,491.06 211.18,521.22 204.54,523 l -131,35.1 c -6.65,1.78 -6.65,4.69 0,6.48 l 39.24,10.51 c 6.65,1.78 17.59,2.07 24.32,0.64 60.56,-14.7 217.57,-57.87 237.21,-65.47 8.5,-3.29 2.14,-7.01 -4.5,-8.79 l -32.78,-8.63 z"
           id="path586" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-9"
         id="g588">
        <path
           class="schulz-dashboard-center-icon-styling-14"
           d="m 328.48,495.66 c -6.65,-1.78 -17.52,-1.51 -24.17,0.27 L 74.96,557.91 c -6.65,1.78 -6.65,4.69 0,6.48 l 29.36,7.86 c 6.65,1.78 13.73,2.19 17.59,1.93 2.86,-0.19 129.83,-34.5 197.58,-53.33 23.73,-6.6 42.24,-12.34 42.79,-12.71 2.13,-1.44 2.94,-3.62 -3.71,-5.4 l -30.1,-7.07 z"
           id="path587" />
      </g>
      <g
         id="g589">
        <path
           class="schulz-dashboard-center-icon-styling-31"
           d="m 144.18,540.43 c -2.33,8.69 0.94,17.12 7.3,18.82 6.36,1.7 13.4,-3.96 15.73,-12.65 2.33,-8.69 -0.94,-17.12 -7.3,-18.82 -6.36,-1.7 -13.41,3.96 -15.73,12.65 z"
           id="path588" />
        <rect
           class="schulz-dashboard-center-icon-styling-31"
           x="155.53"
           y="528.48999"
           width="9.7200003"
           height="32.580002"
           transform="rotate(-165,160.3917,544.77517)"
           id="rect588" />
      </g>
      <g
         id="g590">
        <path
           class="schulz-dashboard-center-icon-styling-31"
           d="m 281.77,503.65 c -2.33,8.69 0.94,17.12 7.3,18.82 6.36,1.7 13.4,-3.96 15.73,-12.65 2.33,-8.69 -0.94,-17.12 -7.3,-18.82 -6.36,-1.7 -13.41,3.96 -15.73,12.65 z"
           id="path589" />
        <rect
           class="schulz-dashboard-center-icon-styling-31"
           x="293.12"
           y="491.70001"
           width="9.7200003"
           height="32.580002"
           transform="rotate(-165,297.97588,507.99382)"
           id="rect589" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-31"
         points="290.68,510.44 190.25,535.69 178.87,552.11 153.02,546.39 155.53,524.75 324.69,479.22 323.59,498.79 316.32,510.83 "
         id="polygon590" />
      <path
         class="schulz-dashboard-center-icon-styling-5"
         d="m 358.89,477.28 c -0.14,-9.26 0.82,-68.01 -2.22,-69.01 -7.06,-2.46 -52.43,-15.14 -56.05,-14.18 -3.62,0.96 -190.74,51.13 -221,59.24 -8.91,2.39 -21.89,5.71 -22.79,12.26 -0.78,5.66 -7.8,67.95 -7.85,68.8 -0.62,10.74 2.29,18.5 6.23,20.39 7.21,3.47 36.43,10.59 48.64,13.06 5.78,0.77 11.15,1.34 15.48,0.23 13.11,-3.36 29.93,-8.02 29.93,-8.02 -0.28,-4.4 -0.29,-12.41 0.65,-17.16 2.18,-10.93 11.33,-18.26 18.89,-17.02 7.2,1.18 12.46,10.68 10.07,26.24 L 286.39,523.3 c 0,0 0.38,-13.21 1.71,-18.56 2.68,-10.8 11.71,-17.43 19.06,-15.46 6.93,1.86 10.35,12.29 9.16,21.55 13.63,-5.56 37.21,-13.21 41.03,-17.69 1.38,-1.62 1.67,-7.46 1.54,-15.87 z"
         id="path590" />
      <g
         id="g592">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 288.8,496.47 -111.44,29.82 v -1.33 c 0,-0.46 0.31,-0.87 0.76,-0.99 l 109.4,-29.27 c 0.65,-0.17 1.29,0.32 1.29,0.99 v 0.78 z"
           id="path591" />
        <path
           class="schulz-dashboard-center-icon-styling-26"
           d="m 288.02,498.76 -109.4,29.27 c -0.65,0.17 -1.29,-0.32 -1.29,-0.99 v -0.78 c 0,0 111.44,-29.82 111.44,-29.82 v 1.33 c 0,0.46 -0.31,0.87 -0.76,0.99 z"
           id="path592" />
      </g>
      <g
         id="g594">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 357.42,477.97 -43.16,11.51 v -1.22 c 0,-0.53 0.36,-0.99 0.87,-1.13 l 40.77,-10.87 c 0.77,-0.2 1.52,0.37 1.52,1.17 z"
           id="path593" />
        <path
           class="schulz-dashboard-center-icon-styling-26"
           d="m 356.5,480.29 -40.83,10.88 c -0.72,0.19 -1.44,-0.35 -1.44,-1.1 v -0.63 c 0,0 43.16,-11.51 43.16,-11.51 v 1.19 c 0,0.55 -0.37,1.03 -0.9,1.17 z"
           id="path594" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-49"
         clip-path="url(#clippath-22)"
         id="g595">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 109.25,569.51 c -2.75,-5.02 -3.17,-12.84 -2.67,-18.51 0.07,-0.85 7.07,-63.13 7.85,-68.8 0.9,-6.55 13.88,-9.87 22.79,-12.26 30.26,-8.11 219.13,-58.76 222.75,-59.72 l 12.71,77.93 -19.72,25.59 -232.9,60.68 -10.8,-4.92 z"
           id="path595" />
      </g>
      <g
         id="g597">
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 108.01,476.73 5.74,1.54 c 0.71,0.19 1.21,0.84 1.21,1.58 v 14.32 c 0,0.83 -0.59,1.54 -1.4,1.7 l -1.14,0.22 c -0.3,0.06 -0.61,0.05 -0.9,-0.03 l -5.1,-1.34 c -1.02,-0.27 -1.73,-1.19 -1.73,-2.24 v -12.84 c 0,-0.94 0.41,-1.82 1.13,-2.43 v 0 c 0.61,-0.51 1.42,-0.69 2.18,-0.48 z"
           id="path596" />
        <g
           class="schulz-dashboard-center-icon-styling-50"
           clip-path="url(#clippath-23)"
           id="g596">
          <polygon
             class="schulz-dashboard-center-icon-styling-17"
             points="112.58,496.86 112.58,480.38 114.47,479.47 114.47,496.86 "
             id="polygon596" />
        </g>
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-23"
         d="M 110.43,534.38 343.25,472 c 1.92,-0.52 3.33,-2.16 3.54,-4.14 l 5.3,-50.48 -229.14,61.41 c -4.04,1.08 -6.99,4.54 -7.42,8.7 l -5.09,46.9 z"
         id="path597" />
      <path
         class="schulz-dashboard-center-icon-styling-23"
         d="m 59.45,466.3 49.72,13.53 c 1.11,0.3 1.83,1.37 1.7,2.51 l -6.59,58.12 c -0.16,1.42 -1.55,2.36 -2.92,1.99 L 51.57,529.02 c -1.11,-0.3 -1.84,-1.37 -1.71,-2.52 l 6.66,-58.22 c 0.16,-1.42 1.55,-2.36 2.93,-1.99 z"
         id="path598" />
      <path
         class="schulz-dashboard-center-icon-styling-23"
         d="m 115.21,489.62 -5.31,49.24 c -0.24,2.22 1.85,3.98 4,3.35 l 3.83,-1.11 -0.17,-50.32 z"
         id="path599" />
      <g
         id="g611">
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 153.32,542.88 c -2.33,8.69 0.94,17.12 7.3,18.82 6.36,1.7 13.41,-3.96 15.73,-12.65 2.33,-8.69 -0.94,-17.12 -7.3,-18.82 -6.36,-1.7 -13.41,3.96 -15.73,12.65 z"
           id="path600" />
        <ellipse
           class="schulz-dashboard-center-icon-styling-5"
           cx="164.83"
           cy="545.96997"
           rx="11.56"
           ry="8.46"
           transform="rotate(-75,164.83636,545.96694)"
           id="ellipse600" />
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 159.81,544.62 c -0.99,3.69 0.4,7.28 3.1,8 2.7,0.72 5.7,-1.68 6.69,-5.38 0.99,-3.69 -0.4,-7.28 -3.1,-8 -2.7,-0.72 -5.7,1.68 -6.69,5.38 z"
           id="path601" />
        <path
           class="schulz-dashboard-center-icon-styling-32"
           d="m 162.95,545.47 c -0.38,1.42 0.15,2.8 1.19,3.07 1.04,0.28 2.19,-0.65 2.57,-2.07 0.38,-1.42 -0.15,-2.79 -1.19,-3.07 -1.04,-0.28 -2.19,0.65 -2.57,2.07 z"
           id="path602" />
        <g
           id="g610">
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 165.68,538.35 -1.64,0.44 c -0.63,0.17 -1.15,-0.25 -1.15,-0.92 v -0.27 c 0,-0.68 0.52,-1.37 1.15,-1.54 l 1.64,-0.44 c 0.63,-0.17 1.15,0.25 1.15,0.92 v 0.27 c 0,0.68 -0.52,1.37 -1.15,1.54 z"
             id="path603" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 165.68,555.8 -1.64,0.44 c -0.63,0.17 -1.15,-0.25 -1.15,-0.92 v -0.27 c 0,-0.68 0.52,-1.37 1.15,-1.54 l 1.64,-0.44 c 0.63,-0.17 1.15,0.25 1.15,0.92 v 0.27 c 0,0.68 -0.52,1.37 -1.15,1.54 z"
             id="path604" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 158.89,546.29 v 2.49 c 0,0.65 -0.5,1.32 -1.11,1.48 v 0 c -0.61,0.16 -1.11,-0.24 -1.11,-0.89 v -2.49 c 0,-0.65 0.5,-1.32 1.11,-1.48 v 0 c 0.61,-0.16 1.11,0.24 1.11,0.89 z"
             id="path605" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 173.05,542.49 v 2.49 c 0,0.65 -0.5,1.32 -1.11,1.48 v 0 c -0.61,0.16 -1.11,-0.24 -1.11,-0.89 v -2.49 c 0,-0.65 0.5,-1.32 1.11,-1.48 v 0 c 0.61,-0.16 1.11,0.24 1.11,0.89 z"
             id="path606" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 160,551.65 1.27,1.23 c 0.42,0.4 0.42,1.24 0,1.87 l -0.05,0.08 c -0.42,0.63 -1.1,0.81 -1.52,0.41 l -1.27,-1.23 c -0.42,-0.4 -0.42,-1.24 0,-1.87 l 0.05,-0.08 c 0.42,-0.63 1.1,-0.81 1.52,-0.41 z"
             id="path607" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 170.01,536.63 1.27,1.23 c 0.42,0.4 0.42,1.24 0,1.87 l -0.05,0.08 c -0.42,0.63 -1.1,0.81 -1.52,0.41 l -1.27,-1.23 c -0.42,-0.4 -0.42,-1.24 0,-1.87 l 0.05,-0.08 c 0.42,-0.63 1.1,-0.81 1.52,-0.41 z"
             id="path608" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 168.45,550.96 1.27,-1.91 c 0.42,-0.63 1.1,-0.81 1.52,-0.41 l 0.05,0.05 c 0.42,0.4 0.42,1.24 0,1.87 l -1.27,1.91 c -0.42,0.63 -1.1,0.81 -1.52,0.41 l -0.05,-0.05 c -0.42,-0.4 -0.42,-1.24 0,-1.87 z"
             id="path609" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 158.44,541.3 1.27,-1.91 c 0.42,-0.63 1.1,-0.81 1.52,-0.41 l 0.05,0.05 c 0.42,0.4 0.42,1.24 0,1.87 l -1.27,1.91 c -0.42,0.63 -1.1,0.81 -1.52,0.41 l -0.05,-0.05 c -0.42,-0.4 -0.42,-1.24 0,-1.87 z"
             id="path610" />
        </g>
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-75"
         d="m 50.74,536.51 50.65,13.64 c 0.82,0.22 1.39,0.97 1.39,1.82 v 0.63 c -0.02,2.61 -2.5,4.5 -5.02,3.82 l -45.5,-12.28 c -1.9,-0.51 -3.23,-2.22 -3.27,-4.18 l -0.04,-2.05 c -0.02,-0.95 0.88,-1.65 1.79,-1.4 z"
         id="path611" />
      <path
         class="schulz-dashboard-center-icon-styling-17"
         d="m 92.79,564.58 c 0.89,-0.21 -0.28,-2.39 -0.66,-3.14 -3.2,-6.4 -22.17,-10.49 -27.87,-12.01 -5.11,-1.37 -7.5,0.68 -8.03,2.03 -0.2,0.52 -0.82,2.67 -0.17,3.24 1.5,1.32 10.78,3.7 15.52,5.09 5.12,1.49 20.18,5.05 21.21,4.8 z"
         id="path612" />
      <polygon
         class="schulz-dashboard-center-icon-styling-75"
         points="88.01,553.79 90.64,547.26 58.27,538.54 59.54,546.11 "
         id="polygon612" />
      <path
         class="schulz-dashboard-center-icon-styling-5"
         d="m 73.79,545.54 c 0.16,0.93 -0.32,1.78 -1.08,1.91 -0.75,0.13 -1.5,-0.52 -1.66,-1.44 -0.16,-0.93 0.32,-1.78 1.08,-1.91 0.75,-0.13 1.5,0.52 1.66,1.44 z"
         id="path613" />
      <g
         id="g616">
        <path
           class="schulz-dashboard-center-icon-styling-30"
           d="m 100.54,552.91 c 0.08,0.94 -0.48,1.74 -1.25,1.8 -0.76,0.06 -1.44,-0.65 -1.52,-1.59 -0.08,-0.94 0.48,-1.74 1.25,-1.8 0.76,-0.06 1.44,0.65 1.52,1.59 z"
           id="path614" />
        <path
           class="schulz-dashboard-center-icon-styling-23"
           d="m 96.98,551.95 c 0.08,0.94 -0.48,1.74 -1.25,1.8 -0.76,0.06 -1.44,-0.65 -1.52,-1.59 -0.08,-0.94 0.48,-1.74 1.25,-1.8 0.76,-0.06 1.44,0.65 1.52,1.59 z"
           id="path615" />
        <path
           class="schulz-dashboard-center-icon-styling-23"
           d="m 93.42,550.98 c 0.08,0.94 -0.48,1.74 -1.25,1.8 -0.76,0.06 -1.44,-0.65 -1.52,-1.59 -0.08,-0.94 0.48,-1.74 1.25,-1.8 0.76,-0.06 1.44,0.65 1.52,1.59 z"
           id="path616" />
      </g>
      <g
         id="g619">
        <path
           class="schulz-dashboard-center-icon-styling-23"
           d="m 115.62,542.24 c 0.08,0.94 -0.48,1.74 -1.25,1.8 -0.76,0.06 -1.44,-0.65 -1.52,-1.59 -0.08,-0.94 0.48,-1.74 1.25,-1.8 0.76,-0.06 1.44,0.65 1.52,1.59 z"
           id="path617" />
        <path
           class="schulz-dashboard-center-icon-styling-23"
           d="m 112.06,541.28 c 0.08,0.94 -0.48,1.74 -1.25,1.8 -0.76,0.06 -1.44,-0.65 -1.52,-1.59 -0.08,-0.94 0.48,-1.74 1.25,-1.8 0.76,-0.06 1.44,0.65 1.52,1.59 z"
           id="path618" />
        <path
           class="schulz-dashboard-center-icon-styling-30"
           d="m 108.49,540.31 c 0.08,0.94 -0.48,1.74 -1.25,1.8 -0.76,0.06 -1.44,-0.65 -1.52,-1.59 -0.08,-0.94 0.48,-1.74 1.25,-1.8 0.76,-0.06 1.44,0.65 1.52,1.59 z"
           id="path619" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-17"
         id="g623">
        <polygon
           points="139.51,442.64 196.38,427.4 198.88,428.07 142.01,443.31 "
           id="polygon619" />
        <polygon
           points="146.64,444.55 203.51,429.31 206.01,429.98 149.14,445.22 "
           id="polygon620" />
        <polygon
           points="153.77,446.46 210.64,431.22 213.14,431.89 156.27,447.13 "
           id="polygon621" />
        <polygon
           points="160.9,448.37 217.77,433.13 220.27,433.8 163.4,449.04 "
           id="polygon622" />
        <polygon
           points="168.03,450.28 224.9,435.04 227.39,435.71 170.53,450.95 "
           id="polygon623" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-17"
         id="g628">
        <polygon
           points="219.47,421.22 276.34,405.98 278.84,406.65 221.97,421.89 "
           id="polygon624" />
        <polygon
           points="226.6,423.13 283.47,407.89 285.97,408.56 229.1,423.8 "
           id="polygon625" />
        <polygon
           points="233.73,425.04 290.6,409.8 293.1,410.47 236.23,425.71 "
           id="polygon626" />
        <polygon
           points="240.86,426.95 297.73,411.71 300.23,412.38 243.36,427.62 "
           id="polygon627" />
        <polygon
           points="247.99,428.86 304.86,413.62 307.35,414.29 250.49,429.53 "
           id="polygon628" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-75"
         points="349.78,426.81 349.47,429.89 114.85,493.38 115.21,489.62 "
         id="polygon629" />
      <path
         class="schulz-dashboard-center-icon-styling-75"
         d="m 140.12,521.53 205.17,-54.37 -0.09,0.82 c -0.15,1.37 -1.13,2.51 -2.46,2.87 L 139.76,525.3 Z"
         id="path629" />
      <g
         id="g636">
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="249.3,529.28 249.3,455.48 264.22,451.48 264.22,525.28 "
           id="polygon630" />
        <polygon
           class="schulz-dashboard-center-icon-styling-23"
           points="251.76,525.74 251.76,457.7 261.76,455.02 261.76,523.06 "
           id="polygon631" />
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="264.22,525.28 264.22,451.48 279.15,447.48 279.15,521.28 "
           id="polygon632" />
        <polygon
           class="schulz-dashboard-center-icon-styling-23"
           points="266.68,521.74 266.68,453.7 276.68,451.02 276.68,519.06 "
           id="polygon633" />
        <g
           id="g635">
          <polygon
             class="schulz-dashboard-center-icon-styling-75"
             points="267.54,506.06 267.54,496.88 269.53,496.34 269.53,505.53 "
             id="polygon634" />
          <polygon
             class="schulz-dashboard-center-icon-styling-75"
             points="258.91,508.4 258.91,499.22 260.91,498.68 260.91,507.87 "
             id="polygon635" />
        </g>
      </g>
      <g
         id="g642">
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="117.56,564.58 117.56,490.78 132.48,486.78 132.48,560.58 "
           id="polygon636" />
        <polygon
           class="schulz-dashboard-center-icon-styling-23"
           points="120.02,561.04 120.02,493 130.02,490.32 130.02,558.36 "
           id="polygon637" />
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="132.48,560.58 132.48,486.78 147.41,482.78 147.41,556.58 "
           id="polygon638" />
        <polygon
           class="schulz-dashboard-center-icon-styling-23"
           points="134.95,557.04 134.95,489 144.94,486.32 144.94,554.36 "
           id="polygon639" />
        <g
           id="g641">
          <polygon
             class="schulz-dashboard-center-icon-styling-75"
             points="135.88,541.4 135.88,532.21 137.88,531.68 137.88,540.86 "
             id="polygon640" />
          <polygon
             class="schulz-dashboard-center-icon-styling-75"
             points="127.26,543.73 127.26,534.55 129.26,534.01 129.26,543.2 "
             id="polygon641" />
        </g>
      </g>
      <g
         id="g644">
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="174.19,468.05 174.19,513.45 169.69,514.66 169.69,469.25 "
           id="polygon642" />
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 345.3,421.54 5.17,-1.28 -5.18,47 c -0.18,1.6 -1.71,2.68 -3.28,2.3 l -0.93,-0.22 4.21,-47.79 z"
           id="path642" />
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="234.57,451.48 234.57,496.89 230.06,498.09 230.06,452.69 "
           id="polygon643" />
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="296.86,434.73 296.86,480.13 292.36,481.34 292.36,435.93 "
           id="polygon644" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-75"
         points="176.36,472.35 176.36,465.85 227.3,452.2 227.3,458.7 "
         id="polygon645" />
      <g
         id="g653">
        <path
           class="schulz-dashboard-center-icon-styling-3"
           d="m 356.66,408.27 c -3.62,0.96 -192.49,51.61 -222.75,59.72 -8.91,2.39 -21.89,5.71 -22.79,12.26 -0.78,5.66 -7.78,67.95 -7.85,68.8 -0.49,5.67 -0.08,13.49 2.67,18.51"
           id="path645" />
        <line
           class="schulz-dashboard-center-icon-styling-3"
           x1="179.33"
           y1="548.03003"
           x2="286.70001"
           y2="519.26001"
           id="line645" />
        <line
           class="schulz-dashboard-center-icon-styling-3"
           x1="117.56"
           y1="564.58002"
           x2="149.10001"
           y2="556.13"
           id="line646" />
        <line
           class="schulz-dashboard-center-icon-styling-3"
           x1="313.04001"
           y1="493.88"
           x2="358.92001"
           y2="481.59"
           id="line647" />
        <line
           class="schulz-dashboard-center-icon-styling-3"
           x1="279.14999"
           y1="502.97"
           x2="289.72"
           y2="500.13"
           id="line648" />
        <line
           class="schulz-dashboard-center-icon-styling-3"
           x1="175.82001"
           y1="530.65002"
           x2="249.02"
           y2="511.04001"
           id="line649" />
        <line
           class="schulz-dashboard-center-icon-styling-3"
           x1="115.21"
           y1="491.35001"
           x2="351"
           y2="428.17001"
           id="line650" />
        <line
           class="schulz-dashboard-center-icon-styling-3"
           x1="171.94"
           y1="465.67001"
           x2="171.94"
           y2="517.87"
           id="line651" />
        <line
           class="schulz-dashboard-center-icon-styling-3"
           x1="232.31"
           y1="449.47"
           x2="232.31"
           y2="533.83002"
           id="line652" />
        <line
           class="schulz-dashboard-center-icon-styling-3"
           x1="294.60999"
           y1="433.06"
           x2="294.60999"
           y2="485.03"
           id="line653" />
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-30"
         d="m 182.62,526.96 -4.02,1.08 c -0.63,0.17 -1.26,-0.31 -1.26,-0.97 v -0.81 l 5.28,-1.42 v 2.11 z"
         id="path653" />
      <polygon
         class="schulz-dashboard-center-icon-styling-30"
         points="241.58,511.17 241.58,509.07 246.86,507.66 246.86,509.76 "
         id="polygon653" />
      <path
         class="schulz-dashboard-center-icon-styling-30"
         d="m 356.52,480.28 -4.38,1.17 v -2.1 l 5.28,-1.42 v 1.17 c 0,0.55 -0.37,1.03 -0.9,1.17 z"
         id="path654" />
      <g
         id="g656">
        <path
           class="schulz-dashboard-center-icon-styling-65"
           d="m 234.57,427.67 -9.56,-2.56 c -1.37,-0.37 -3.6,-0.37 -4.98,0 l -9.56,2.56 c -1.37,0.37 -1.37,0.97 0,1.33 l 9.56,2.56 c 1.37,0.37 3.6,0.37 4.98,0 l 9.56,-2.56 c 1.37,-0.37 1.37,-0.97 0,-1.33 z"
           id="path655" />
        <rect
           class="schulz-dashboard-center-icon-styling-65"
           x="209.42999"
           y="427.42999"
           width="26.17"
           height="0.89999998"
           id="rect655" />
        <path
           class="schulz-dashboard-center-icon-styling-70"
           d="m 234.57,426.77 -9.56,-2.56 c -1.37,-0.37 -3.6,-0.37 -4.98,0 l -9.56,2.56 c -1.37,0.37 -1.37,0.97 0,1.33 l 9.56,2.56 c 1.37,0.37 3.6,0.37 4.98,0 l 9.56,-2.56 c 1.37,-0.37 1.37,-0.97 0,-1.33 z"
           id="path656" />
      </g>
      <g
         id="g658">
        <path
           class="schulz-dashboard-center-icon-styling-65"
           d="m 153.76,448.53 -9.56,-2.56 c -1.37,-0.37 -3.6,-0.37 -4.98,0 l -9.56,2.56 c -1.37,0.37 -1.37,0.97 0,1.33 l 9.56,2.56 c 1.37,0.37 3.6,0.37 4.98,0 l 9.56,-2.56 c 1.37,-0.37 1.37,-0.97 0,-1.33 z"
           id="path657" />
        <rect
           class="schulz-dashboard-center-icon-styling-65"
           x="128.63"
           y="448.29999"
           width="26.17"
           height="0.89999998"
           id="rect657" />
        <path
           class="schulz-dashboard-center-icon-styling-70"
           d="m 153.76,447.63 -9.56,-2.56 c -1.37,-0.37 -3.6,-0.37 -4.98,0 l -9.56,2.56 c -1.37,0.37 -1.37,0.97 0,1.33 l 9.56,2.56 c 1.37,0.37 3.6,0.37 4.98,0 l 9.56,-2.56 c 1.37,-0.37 1.37,-0.97 0,-1.33 z"
           id="path658" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-17"
         id="g662">
        <polygon
           points="324.69,495.03 324.69,493.73 336.01,490.7 336.01,492 "
           id="polygon658" />
        <polygon
           points="324.69,497.04 324.69,495.74 336.01,492.7 336.01,494.01 "
           id="polygon659" />
        <polygon
           points="324.69,499.05 324.69,497.74 336.01,494.71 336.01,496.01 "
           id="polygon660" />
        <polygon
           points="324.69,501.05 324.69,499.75 336.01,496.72 336.01,498.02 "
           id="polygon661" />
        <polygon
           points="324.69,503.06 324.69,501.76 336.01,498.73 336.01,500.03 "
           id="polygon662" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-75"
         points="109.46,482.05 58.19,468.1 57.17,476.94 108.45,490.89 "
         id="polygon663" />
      <polygon
         class="schulz-dashboard-center-icon-styling-75"
         points="51.38,527.54 102.73,541.38 103.53,534.28 52.2,520.44 "
         id="polygon664" />
      <path
         class="schulz-dashboard-center-icon-styling-16"
         d="m 60.43,468.08 47.39,12.9 c 1.06,0.29 1.75,1.31 1.63,2.4 l -56.53,44.49 c -1.06,-0.29 -1.75,-1.31 -1.63,-2.4 l 6.35,-55.49 c 0.15,-1.35 1.48,-2.25 2.79,-1.89 z"
         id="path664" />
      <path
         class="schulz-dashboard-center-icon-styling-16"
         d="M 112.17,534.92 347.86,420.8 124.38,480.7 c -3.94,1.06 -6.82,4.43 -7.24,8.49 l -4.97,45.74 z"
         id="path665" />
      <g
         id="g667">
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 115.74,493.64 5.74,1.54 c 0.71,0.19 1.21,0.84 1.21,1.58 v 14.32 c 0,0.83 -0.59,1.54 -1.4,1.7 l -1.14,0.22 c -0.3,0.06 -0.61,0.05 -0.9,-0.03 l -5.1,-1.34 c -1.02,-0.27 -1.73,-1.19 -1.73,-2.24 v -12.84 c 0,-0.94 0.41,-1.82 1.13,-2.43 v 0 c 0.61,-0.51 1.42,-0.69 2.18,-0.48 z"
           id="path666" />
        <g
           class="schulz-dashboard-center-icon-styling-51"
           clip-path="url(#clippath-24)"
           id="g666">
          <polygon
             class="schulz-dashboard-center-icon-styling-17"
             points="120.31,513.77 120.31,497.29 122.21,496.38 122.21,513.77 "
             id="polygon666" />
        </g>
      </g>
      <g
         id="g668">
        <path
           class="schulz-dashboard-center-icon-styling-65"
           d="m 314.5,406.42 -9.56,-2.56 c -1.37,-0.37 -3.6,-0.37 -4.98,0 l -9.56,2.56 c -1.37,0.37 -1.37,0.97 0,1.33 l 9.56,2.56 c 1.37,0.37 3.6,0.37 4.98,0 l 9.56,-2.56 c 1.37,-0.37 1.37,-0.97 0,-1.33 z"
           id="path667" />
        <rect
           class="schulz-dashboard-center-icon-styling-65"
           x="289.37"
           y="406.17999"
           width="26.17"
           height="0.89999998"
           id="rect667" />
        <path
           class="schulz-dashboard-center-icon-styling-70"
           d="m 314.5,405.51 -9.56,-2.56 c -1.37,-0.37 -3.6,-0.37 -4.98,0 l -9.56,2.56 c -1.37,0.37 -1.37,0.97 0,1.33 l 9.56,2.56 c 1.37,0.37 3.6,0.37 4.98,0 l 9.56,-2.56 c 1.37,-0.37 1.37,-0.97 0,-1.33 z"
           id="path668" />
      </g>
      <g
         id="g680">
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 290.91,506.1 c -2.33,8.69 0.94,17.12 7.3,18.82 6.36,1.7 13.41,-3.96 15.73,-12.65 2.33,-8.69 -0.94,-17.12 -7.3,-18.82 -6.36,-1.7 -13.41,3.96 -15.73,12.65 z"
           id="path669" />
        <ellipse
           class="schulz-dashboard-center-icon-styling-5"
           cx="302.42999"
           cy="509.17999"
           rx="11.56"
           ry="8.46"
           transform="rotate(-75,302.42121,509.17868)"
           id="ellipse669" />
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 297.41,507.84 c -0.99,3.69 0.4,7.28 3.1,8 2.7,0.72 5.7,-1.68 6.69,-5.38 0.99,-3.69 -0.4,-7.28 -3.1,-8 -2.7,-0.72 -5.7,1.68 -6.69,5.38 z"
           id="path670" />
        <path
           class="schulz-dashboard-center-icon-styling-32"
           d="m 300.55,508.68 c -0.38,1.42 0.15,2.8 1.19,3.07 1.04,0.28 2.19,-0.65 2.57,-2.07 0.38,-1.42 -0.15,-2.79 -1.19,-3.07 -1.04,-0.28 -2.19,0.65 -2.57,2.07 z"
           id="path671" />
        <g
           id="g679">
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 303.27,501.56 -1.64,0.44 c -0.63,0.17 -1.15,-0.25 -1.15,-0.92 v -0.27 c 0,-0.68 0.52,-1.37 1.15,-1.54 l 1.64,-0.44 c 0.63,-0.17 1.15,0.25 1.15,0.92 v 0.27 c 0,0.68 -0.52,1.37 -1.15,1.54 z"
             id="path672" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 303.27,519.01 -1.64,0.44 c -0.63,0.17 -1.15,-0.25 -1.15,-0.92 v -0.27 c 0,-0.68 0.52,-1.37 1.15,-1.54 l 1.64,-0.44 c 0.63,-0.17 1.15,0.25 1.15,0.92 v 0.27 c 0,0.68 -0.52,1.37 -1.15,1.54 z"
             id="path673" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 296.48,509.5 v 2.49 c 0,0.65 -0.5,1.32 -1.11,1.48 v 0 c -0.61,0.16 -1.11,-0.24 -1.11,-0.89 v -2.49 c 0,-0.65 0.5,-1.32 1.11,-1.48 v 0 c 0.61,-0.16 1.11,0.24 1.11,0.89 z"
             id="path674" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 310.64,505.71 v 2.49 c 0,0.65 -0.5,1.32 -1.11,1.48 v 0 c -0.61,0.16 -1.11,-0.24 -1.11,-0.89 v -2.49 c 0,-0.65 0.5,-1.32 1.11,-1.48 v 0 c 0.61,-0.16 1.11,0.24 1.11,0.89 z"
             id="path675" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 297.59,514.86 1.27,1.23 c 0.42,0.4 0.42,1.24 0,1.87 l -0.05,0.08 c -0.42,0.63 -1.1,0.81 -1.52,0.41 l -1.27,-1.23 c -0.42,-0.4 -0.42,-1.24 0,-1.87 l 0.05,-0.08 c 0.42,-0.63 1.1,-0.81 1.52,-0.41 z"
             id="path676" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 307.6,499.84 1.27,1.23 c 0.42,0.4 0.42,1.24 0,1.87 l -0.05,0.08 c -0.42,0.63 -1.1,0.81 -1.52,0.41 l -1.27,-1.23 c -0.42,-0.4 -0.42,-1.24 0,-1.87 l 0.05,-0.08 c 0.42,-0.63 1.1,-0.81 1.52,-0.41 z"
             id="path677" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 306.04,514.17 1.27,-1.91 c 0.42,-0.63 1.1,-0.81 1.52,-0.41 l 0.05,0.05 c 0.42,0.4 0.42,1.24 0,1.87 l -1.27,1.91 c -0.42,0.63 -1.1,0.81 -1.52,0.41 l -0.05,-0.05 c -0.42,-0.4 -0.42,-1.24 0,-1.87 z"
             id="path678" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 296.03,504.51 1.27,-1.91 c 0.42,-0.63 1.1,-0.81 1.52,-0.41 l 0.05,0.05 c 0.42,0.4 0.42,1.24 0,1.87 l -1.27,1.91 c -0.42,0.63 -1.1,0.81 -1.52,0.41 l -0.05,-0.05 c -0.42,-0.4 -0.42,-1.24 0,-1.87 z"
             id="path679" />
        </g>
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-1"
         d="m 402.56,429.84 c 14.09,0.7 2.76,41.18 -25.05,61.51 -27.33,19.98 -70.52,40.23 -85.57,45.15 -8.81,2.88 -29.25,9.89 -37.12,7.94 -13.89,-3.44 -10.14,-16.37 -12.87,-20.87"
         id="path680" />
      <path
         class="schulz-dashboard-center-icon-styling-31"
         d="m 236.14,517.9 3.19,-0.89 c 0.44,-0.12 0.82,0.22 0.79,0.73 l -0.06,4.04 c -0.02,0.39 -0.29,0.76 -0.63,0.86 l -3.12,0.93 c -0.44,0.13 -0.82,-0.2 -0.8,-0.7 v -4.08 c 0,-0.41 0.28,-0.79 0.64,-0.89 z"
         id="path681" />
      <polygon
         class="schulz-dashboard-center-icon-styling-76"
         points="240.93,518.8 243.24,523.58 241.31,524.63 238.5,521.15 237.48,521.44 236.25,518.92 238.95,517.46 "
         id="polygon681" />
      <path
         class="schulz-dashboard-center-icon-styling-54"
         d="m 235.84,517.51 1.46,-1.61 c 0.2,-0.22 0.33,0.07 0.27,0.61 v 4.31 c -0.06,0.43 -0.2,0.87 -0.36,1.05 l -1.43,1.64 c -0.2,0.23 -0.33,-0.04 -0.28,-0.58 l -0.02,-4.34 c 0.04,-0.44 0.2,-0.9 0.36,-1.08 z"
         id="path682" />
      <g
         id="g683">
        <polygon
           class="schulz-dashboard-center-icon-styling-31"
           points="78.56,559.45 78.56,553.82 65.19,550.24 65.19,555.87 "
           id="polygon682" />
        <polygon
           class="schulz-dashboard-center-icon-styling-27"
           points="77.71,559.64 77.71,554.01 64.35,550.43 64.35,556.06 "
           id="polygon683" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-17"
         id="g684">
        <path
           class="schulz-dashboard-center-icon-styling-31"
           d="m 447.06,542.72 c -6.57,-1.76 -26.29,2.71 -32.85,4.47 l -129.48,34.69 c -6.57,1.76 -6.57,4.64 0,6.4 l 38.78,10.39 c 6.57,1.76 17.39,2.05 24.04,0.64 61.37,-13.65 129.57,-33.65 136.36,-39.37 6.88,-5.81 2.12,-6.93 -4.45,-8.69 l -32.39,-8.53 z"
           id="path683" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-9"
         id="g685">
        <path
           class="schulz-dashboard-center-icon-styling-15"
           d="m 441.71,546.34 c -6.57,-1.76 -17.32,-1.76 -23.89,0 L 286.14,581.7 c -6.57,1.76 -6.57,4.64 0,6.4 l 29.02,7.77 c 6.57,1.76 13.57,2.17 17.38,1.91 3.82,-0.26 8.55,-1.06 17.31,-4.1 13.54,-4.7 88.16,-23.93 97.62,-26.38 15.33,-3.98 22.26,-7.09 24.37,-8.52 2.11,-1.42 2.9,-3.58 -3.67,-5.34 l -26.47,-7.09 z"
           id="path684" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-31"
         points="354.92,582.86 331.68,577.01 333.49,561.42 465.92,525.66 464.91,543.63 463.15,545.35 356.46,573.94 "
         id="polygon685" />
      <g
         id="g698">
        <g
           id="g686">
          <path
             class="schulz-dashboard-center-icon-styling-31"
             d="m 415.6,545.17 c -2.14,7.98 0.86,15.72 6.71,17.28 5.84,1.57 12.31,-3.64 14.45,-11.62 2.14,-7.98 -0.86,-15.72 -6.71,-17.28 -5.84,-1.57 -12.31,3.64 -14.45,11.62 z"
             id="path685" />
          <rect
             class="schulz-dashboard-center-icon-styling-31"
             x="426.03"
             y="534.20001"
             width="8.9300003"
             height="29.92"
             transform="rotate(-165,430.48604,549.16213)"
             id="rect685" />
        </g>
        <g
           id="g697">
          <path
             class="schulz-dashboard-center-icon-styling-75"
             d="m 424,547.42 c -2.14,7.98 0.86,15.72 6.71,17.28 5.84,1.57 12.31,-3.64 14.45,-11.62 2.14,-7.98 -0.86,-15.72 -6.71,-17.28 -5.84,-1.57 -12.31,3.64 -14.45,11.62 z"
             id="path686" />
          <ellipse
             class="schulz-dashboard-center-icon-styling-5"
             cx="434.57001"
             cy="550.25"
             rx="10.62"
             ry="7.77"
             transform="rotate(-75,434.56966,550.25421)"
             id="ellipse686" />
          <path
             class="schulz-dashboard-center-icon-styling-70"
             d="m 429.01,548.76 c -0.99,3.69 0.4,7.27 3.1,8 2.7,0.72 5.7,-1.68 6.69,-5.38 0.99,-3.69 -0.4,-7.27 -3.1,-8 -2.7,-0.72 -5.7,1.68 -6.69,5.38 z"
             id="path687" />
          <path
             class="schulz-dashboard-center-icon-styling-5"
             d="m 432.85,549.79 c -0.35,1.3 0.14,2.57 1.1,2.82 0.95,0.26 2.01,-0.59 2.36,-1.9 0.35,-1.3 -0.14,-2.57 -1.1,-2.82 -0.95,-0.26 -2.01,0.59 -2.36,1.9 z"
             id="path688" />
          <g
             id="g696">
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 435.35,543.25 -1.51,0.4 c -0.58,0.16 -1.06,-0.23 -1.06,-0.85 v -0.24 c 0,-0.62 0.48,-1.26 1.06,-1.41 l 1.51,-0.4 c 0.58,-0.16 1.06,0.23 1.06,0.85 v 0.24 c 0,0.62 -0.48,1.26 -1.06,1.41 z"
               id="path689" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 435.35,559.28 -1.51,0.4 c -0.58,0.16 -1.06,-0.23 -1.06,-0.85 v -0.24 c 0,-0.62 0.48,-1.26 1.06,-1.41 l 1.51,-0.4 c 0.58,-0.16 1.06,0.23 1.06,0.85 v 0.24 c 0,0.62 -0.48,1.26 -1.06,1.41 z"
               id="path690" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 429.11,550.54 v 2.28 c 0,0.6 -0.46,1.21 -1.02,1.36 v 0 c -0.56,0.15 -1.02,-0.22 -1.02,-0.82 v -2.28 c 0,-0.6 0.46,-1.21 1.02,-1.36 v 0 c 0.56,-0.15 1.02,0.22 1.02,0.82 z"
               id="path691" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 442.12,547.06 v 2.28 c 0,0.6 -0.46,1.21 -1.02,1.36 v 0 c -0.56,0.15 -1.02,-0.22 -1.02,-0.82 v -2.28 c 0,-0.6 0.46,-1.21 1.02,-1.36 v 0 c 0.56,-0.15 1.02,0.22 1.02,0.82 z"
               id="path692" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 430.14,555.47 1.17,1.13 c 0.38,0.37 0.38,1.14 0,1.72 l -0.05,0.07 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -1.17,-1.13 c -0.38,-0.37 -0.38,-1.14 0,-1.72 l 0.05,-0.07 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 z"
               id="path693" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 439.33,541.67 1.17,1.13 c 0.38,0.37 0.38,1.14 0,1.72 l -0.05,0.07 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -1.17,-1.13 c -0.38,-0.37 -0.38,-1.14 0,-1.72 l 0.05,-0.07 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 z"
               id="path694" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 437.89,554.83 1.17,-1.75 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 l 0.05,0.04 c 0.38,0.37 0.38,1.14 0,1.72 l -1.17,1.75 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -0.05,-0.04 c -0.38,-0.37 -0.38,-1.14 0,-1.72 z"
               id="path695" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 428.7,545.96 1.17,-1.75 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 l 0.05,0.04 c 0.38,0.37 0.38,1.14 0,1.72 l -1.17,1.75 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -0.05,-0.04 c -0.38,-0.37 -0.38,-1.14 0,-1.72 z"
               id="path696" />
          </g>
        </g>
      </g>
      <g
         id="g699">
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 414.05,545.85 -49.85,13.36 v 19.5 l 47.95,-12.85 c 1.12,-0.3 1.9,-1.32 1.9,-2.48 z"
           id="path698" />
        <polygon
           class="schulz-dashboard-center-icon-styling-31"
           points="402.68,542.8 414.05,545.85 364.19,559.21 352.82,556.16 "
           id="polygon698" />
        <polygon
           class="schulz-dashboard-center-icon-styling-23"
           points="352.82,575.66 364.19,578.71 364.19,559.21 352.82,556.16 "
           id="polygon699" />
      </g>
      <g
         id="g701">
        <polygon
           class="schulz-dashboard-center-icon-styling-31"
           points="461.55,526.68 472.91,529.72 461.42,532.8 450.05,529.76 "
           id="polygon700" />
        <polygon
           class="schulz-dashboard-center-icon-styling-23"
           points="450.05,549.26 461.42,552.3 461.42,532.8 450.05,529.76 "
           id="polygon701" />
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 472.91,529.72 -11.5,3.08 v 19.5 l 9.34,-2.5 c 1.27,-0.34 2.16,-1.5 2.16,-2.81 v -17.26 z"
           id="path701" />
      </g>
      <g
         id="g716">
        <g
           id="g702">
          <path
             class="schulz-dashboard-center-icon-styling-31"
             d="m 426.5,548.09 c -2.14,7.98 0.86,15.72 6.71,17.28 5.84,1.57 12.31,-3.64 14.45,-11.62 2.14,-7.98 -0.86,-15.72 -6.71,-17.28 -5.84,-1.57 -12.31,3.64 -14.45,11.62 z"
             id="path702" />
          <rect
             class="schulz-dashboard-center-icon-styling-31"
             x="436.92001"
             y="537.12"
             width="8.9300003"
             height="29.92"
             transform="rotate(-165,441.37951,552.08216)"
             id="rect702" />
        </g>
        <g
           id="g715">
          <path
             class="schulz-dashboard-center-icon-styling-75"
             d="m 434.89,550.34 c -2.14,7.98 0.86,15.72 6.71,17.28 5.84,1.57 12.31,-3.64 14.45,-11.62 2.14,-7.98 -0.86,-15.72 -6.71,-17.28 -5.84,-1.57 -12.31,3.64 -14.45,11.62 z"
             id="path703" />
          <path
             class="schulz-dashboard-center-icon-styling-5"
             d="m 437.96,551.16 c -1.52,5.67 0.61,11.16 4.76,12.27 4.15,1.11 8.74,-2.58 10.26,-8.25 1.52,-5.67 -0.61,-11.16 -4.76,-12.27 -4.15,-1.11 -8.74,2.58 -10.26,8.25 z"
             id="path704" />
          <path
             class="schulz-dashboard-center-icon-styling-76"
             d="m 439.9,551.68 c -0.99,3.69 0.4,7.27 3.1,8 2.7,0.72 5.7,-1.68 6.69,-5.38 0.99,-3.69 -0.4,-7.27 -3.1,-8 -2.7,-0.72 -5.7,1.68 -6.69,5.38 z"
             id="path705" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 443.74,552.71 c -0.35,1.3 0.14,2.57 1.1,2.82 0.95,0.26 2.01,-0.59 2.36,-1.9 0.35,-1.3 -0.14,-2.57 -1.1,-2.82 -0.95,-0.26 -2.01,0.59 -2.36,1.9 z"
             id="path706" />
          <g
             id="g714">
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 446.25,546.17 -1.51,0.4 c -0.58,0.16 -1.06,-0.23 -1.06,-0.85 v -0.24 c 0,-0.62 0.48,-1.26 1.06,-1.41 l 1.51,-0.4 c 0.58,-0.16 1.06,0.23 1.06,0.85 v 0.24 c 0,0.62 -0.48,1.26 -1.06,1.41 z"
               id="path707" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 446.25,562.2 -1.51,0.4 c -0.58,0.16 -1.06,-0.23 -1.06,-0.85 v -0.24 c 0,-0.62 0.48,-1.26 1.06,-1.41 l 1.51,-0.4 c 0.58,-0.16 1.06,0.23 1.06,0.85 v 0.24 c 0,0.62 -0.48,1.26 -1.06,1.41 z"
               id="path708" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 440.01,553.46 v 2.28 c 0,0.6 -0.46,1.21 -1.02,1.36 v 0 c -0.56,0.15 -1.02,-0.22 -1.02,-0.82 V 554 c 0,-0.6 0.46,-1.21 1.02,-1.36 v 0 c 0.56,-0.15 1.02,0.22 1.02,0.82 z"
               id="path709" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 453.01,549.98 v 2.28 c 0,0.6 -0.46,1.21 -1.02,1.36 v 0 c -0.56,0.15 -1.02,-0.22 -1.02,-0.82 v -2.28 c 0,-0.6 0.46,-1.21 1.02,-1.36 v 0 c 0.56,-0.15 1.02,0.22 1.02,0.82 z"
               id="path710" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 441.03,558.39 1.17,1.13 c 0.38,0.37 0.38,1.14 0,1.72 l -0.05,0.07 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -1.17,-1.13 c -0.38,-0.37 -0.38,-1.14 0,-1.72 l 0.05,-0.07 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 z"
               id="path711" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 450.22,544.59 1.17,1.13 c 0.38,0.37 0.38,1.14 0,1.72 l -0.05,0.07 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -1.17,-1.13 c -0.38,-0.37 -0.38,-1.14 0,-1.72 l 0.05,-0.07 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 z"
               id="path712" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 448.79,557.75 1.17,-1.75 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 l 0.05,0.04 c 0.38,0.37 0.38,1.14 0,1.72 l -1.17,1.75 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -0.05,-0.04 c -0.38,-0.37 -0.38,-1.14 0,-1.72 z"
               id="path713" />
            <path
               class="schulz-dashboard-center-icon-styling-23"
               d="m 439.59,548.88 1.17,-1.75 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 l 0.05,0.04 c 0.38,0.37 0.38,1.14 0,1.72 l -1.17,1.75 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -0.05,-0.04 c -0.38,-0.37 -0.38,-1.14 0,-1.72 z"
               id="path714" />
          </g>
        </g>
      </g>
      <g
         id="g717">
        <path
           class="schulz-dashboard-center-icon-styling-31"
           d="m 323.07,575.83 c -2.14,7.98 0.86,15.72 6.71,17.28 5.84,1.57 12.31,-3.64 14.45,-11.62 2.14,-7.98 -0.86,-15.72 -6.71,-17.28 -5.84,-1.57 -12.31,3.64 -14.45,11.62 z"
           id="path716" />
        <rect
           class="schulz-dashboard-center-icon-styling-31"
           x="333.48999"
           y="564.85999"
           width="8.9300003"
           height="29.92"
           transform="rotate(-165,337.96119,579.81293)"
           id="rect716" />
      </g>
      <g
         id="g720">
        <polygon
           class="schulz-dashboard-center-icon-styling-5"
           points="484.15,445.36 484.02,445.39 484.13,445.36 432.47,431.52 311.78,463.86 311.78,542.9 363.45,556.75 363.45,556.74 363.45,556.75 484.15,524.41 "
           id="polygon717" />
        <polygon
           class="schulz-dashboard-center-icon-styling-17"
           points="363.45,556.75 363.45,477.7 484.15,445.36 484.15,524.41 "
           id="polygon718" />
        <polygon
           class="schulz-dashboard-center-icon-styling-17"
           points="311.78,542.9 363.45,556.75 363.45,477.7 311.78,463.86 "
           id="polygon719" />
        <polygon
           class="schulz-dashboard-center-icon-styling-17"
           points="309.4,563.65 361.07,577.49 361.07,498.45 309.4,484.6 "
           id="polygon720" />
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-5"
         d="m 278.22,491.9 c -8.18,2.19 -18.43,5.72 -20.93,11.26 -2.74,6.07 -5.68,34.27 -5.47,60.77 0,0.75 -0.83,1.5 -0.84,2.25 -0.1,9.03 1.47,11.12 4.81,12.73 6.63,3.19 33.46,9.73 44.67,12 5.31,0.7 10.24,1.23 14.22,0.21 12.04,-3.09 13.05,-3.44 13.05,-3.44 -0.26,-4.04 -0.27,-5.24 0.6,-9.6 2,-10.04 10.41,-16.77 17.35,-15.63 6.61,1.08 10.46,6.79 9.25,20.4 l 3.01,-0.81 V 498.95 L 304.9,484.74 c -11.78,3.16 -21.26,5.7 -26.68,7.16 z"
         id="path720" />
      <g
         id="g732">
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 331.46,578.08 c -2.14,7.98 0.86,15.72 6.71,17.28 5.84,1.57 12.31,-3.64 14.45,-11.62 2.14,-7.98 -0.86,-15.72 -6.71,-17.28 -5.84,-1.57 -12.31,3.64 -14.45,11.62 z"
           id="path721" />
        <ellipse
           class="schulz-dashboard-center-icon-styling-5"
           cx="342.04001"
           cy="580.90997"
           rx="10.62"
           ry="7.77"
           transform="rotate(-75,342.03816,580.90606)"
           id="ellipse721" />
        <path
           class="schulz-dashboard-center-icon-styling-76"
           d="m 336.47,579.42 c -0.99,3.69 0.4,7.27 3.1,8 2.7,0.72 5.7,-1.68 6.69,-5.38 0.99,-3.69 -0.4,-7.27 -3.1,-8 -2.7,-0.72 -5.7,1.68 -6.69,5.38 z"
           id="path722" />
        <path
           class="schulz-dashboard-center-icon-styling-23"
           d="m 340.31,580.45 c -0.35,1.3 0.14,2.57 1.1,2.82 0.95,0.26 2.01,-0.59 2.36,-1.9 0.35,-1.3 -0.14,-2.57 -1.1,-2.82 -0.95,-0.26 -2.01,0.59 -2.36,1.9 z"
           id="path723" />
        <g
           id="g731">
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 342.82,573.91 -1.51,0.4 c -0.58,0.16 -1.06,-0.23 -1.06,-0.85 v -0.24 c 0,-0.62 0.48,-1.26 1.06,-1.41 l 1.51,-0.4 c 0.58,-0.16 1.06,0.23 1.06,0.85 v 0.24 c 0,0.62 -0.48,1.26 -1.06,1.41 z"
             id="path724" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 342.82,589.94 -1.51,0.4 c -0.58,0.16 -1.06,-0.23 -1.06,-0.85 v -0.24 c 0,-0.62 0.48,-1.26 1.06,-1.41 l 1.51,-0.4 c 0.58,-0.16 1.06,0.23 1.06,0.85 v 0.24 c 0,0.62 -0.48,1.26 -1.06,1.41 z"
             id="path725" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 336.58,581.2 v 2.28 c 0,0.6 -0.46,1.21 -1.02,1.36 v 0 c -0.56,0.15 -1.02,-0.22 -1.02,-0.82 v -2.28 c 0,-0.6 0.46,-1.21 1.02,-1.36 v 0 c 0.56,-0.15 1.02,0.22 1.02,0.82 z"
             id="path726" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="M 349.58,577.72 V 580 c 0,0.6 -0.46,1.21 -1.02,1.36 v 0 c -0.56,0.15 -1.02,-0.22 -1.02,-0.82 v -2.28 c 0,-0.6 0.46,-1.21 1.02,-1.36 v 0 c 0.56,-0.15 1.02,0.22 1.02,0.82 z"
             id="path727" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 337.6,586.13 1.17,1.13 c 0.38,0.37 0.38,1.14 0,1.72 l -0.05,0.07 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -1.17,-1.13 c -0.38,-0.37 -0.38,-1.14 0,-1.72 l 0.05,-0.07 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 z"
             id="path728" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 346.8,572.33 1.17,1.13 c 0.38,0.37 0.38,1.14 0,1.72 l -0.05,0.07 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -1.17,-1.13 c -0.38,-0.37 -0.38,-1.14 0,-1.72 l 0.05,-0.07 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 z"
             id="path729" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 345.36,585.49 1.17,-1.75 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 l 0.05,0.04 c 0.38,0.37 0.38,1.14 0,1.72 l -1.17,1.75 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -0.05,-0.04 c -0.38,-0.37 -0.38,-1.14 0,-1.72 z"
             id="path730" />
          <path
             class="schulz-dashboard-center-icon-styling-23"
             d="m 336.16,576.62 1.17,-1.75 c 0.38,-0.57 1.01,-0.74 1.39,-0.37 l 0.05,0.04 c 0.38,0.37 0.38,1.14 0,1.72 l -1.17,1.75 c -0.38,0.57 -1.01,0.74 -1.39,0.37 l -0.05,-0.04 c -0.38,-0.37 -0.38,-1.14 0,-1.72 z"
             id="path731" />
        </g>
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-17"
         d="m 290,585.82 c 0.66,-0.16 -0.21,-1.77 -0.49,-2.33 -2.37,-4.74 -16.11,-7.63 -20.65,-8.37 -3.87,-0.63 -5.56,-0.03 -5.95,0.98 -0.15,0.39 -0.61,1.98 -0.13,2.4 1.11,0.98 7.99,2.74 11.5,3.77 3.79,1.11 14.95,3.74 15.71,3.55 z"
         id="path732" />
      <path
         class="schulz-dashboard-center-icon-styling-23"
         d="m 256.77,504.55 c 15.91,5.3 34.27,10.25 54.01,14.7 l -4.27,37.38 c -21.69,-5.06 -39.71,-10 -54.21,-14.62 0.35,-12.29 2.26,-30.98 4.48,-37.46 z"
         id="path733" />
      <path
         class="schulz-dashboard-center-icon-styling-75"
         d="m 261.13,535.01 c 0,0 26.1,7.83 44.61,12.01 l -0.78,8 c -20.35,-4.75 -50.87,-13.72 -50.87,-13.72 0.11,-2.42 4.05,-6.29 7.03,-6.29 z"
         id="path734" />
      <path
         class="schulz-dashboard-center-icon-styling-4"
         d="m 305.97,578.59 c -21.69,-5.06 -39.71,-10 -54.21,-14.62"
         id="path735" />
      <polygon
         class="schulz-dashboard-center-icon-styling-75"
         points="307.29,521.42 285.29,515.43 284.64,521.96 306.63,527.95 "
         id="polygon735" />
      <polygon
         class="schulz-dashboard-center-icon-styling-75"
         points="282.03,514.34 260.04,508.35 259.38,514.88 281.38,520.87 "
         id="polygon736" />
      <path
         class="schulz-dashboard-center-icon-styling-4"
         d="m 357.94,498.96 c 0,0 -19.42,5.21 -25.47,6.83 -8.18,2.19 -18.43,5.72 -20.93,11.26 -2.74,6.07 -5.68,34.27 -5.47,60.77 0,0.75 -0.83,1.5 -0.84,2.25 -0.08,7.15 0.89,9.95 2.95,11.6"
         id="path736" />
      <path
         class="schulz-dashboard-center-icon-styling-75"
         d="m 357.94,582.05 v -23.78 l -15.98,4.28 c 1.26,-0.25 2.51,-0.3 3.72,-0.1 6.61,1.08 10.46,6.79 9.25,20.4 l 3.01,-0.81 z"
         id="path737" />
      <path
         class="schulz-dashboard-center-icon-styling-75"
         d="m 277.76,555.4 c 0.33,0.8 0.07,1.66 -0.58,1.93 -0.65,0.27 -1.45,-0.16 -1.78,-0.96 -0.33,-0.8 -0.07,-1.66 0.58,-1.93 0.65,-0.27 1.45,0.16 1.78,0.96 z"
         id="path738" />
      <path
         class="schulz-dashboard-center-icon-styling-75"
         d="m 254.29,554.7 c -0.77,-0.21 -1.4,0.28 -1.4,1.07 v 4.86 c 0,0.8 0.63,1.61 1.4,1.82 l 48.17,12.91 c 0.77,0.21 1.4,-0.28 1.4,-1.07 v -4.86 c 0,-0.8 -0.63,-1.61 -1.4,-1.82 z"
         id="path739" />
      <g
         class="schulz-dashboard-center-icon-styling-17"
         id="g740">
        <path
           d="m 254.32,562.27 c -0.79,-0.11 -0.8,-0.02 -0.04,0.18 l 48.17,12.91 c 0.77,0.21 1.4,-0.28 1.4,-1.07 v -3.91 c 0,-0.8 -0.64,-1.53 -1.43,-1.64 z"
           id="path740" />
      </g>
      <g
         id="g742">
        <path
           class="schulz-dashboard-center-icon-styling-65"
           d="m 315.5,497.71 -12.08,-3.24 c -1.74,-0.47 -4.55,-0.47 -6.29,0 l -12.08,3.24 c -1.74,0.47 -1.74,1.22 0,1.68 l 12.08,3.24 c 1.74,0.47 4.55,0.47 6.29,0 l 12.08,-3.24 c 1.74,-0.47 1.74,-1.22 0,-1.68 z"
           id="path741" />
        <rect
           class="schulz-dashboard-center-icon-styling-65"
           x="283.75"
           y="497.26999"
           width="33.049999"
           height="1.28"
           id="rect741" />
        <path
           class="schulz-dashboard-center-icon-styling-70"
           d="m 315.5,496.57 -12.08,-3.24 c -1.74,-0.47 -4.55,-0.47 -6.29,0 l -12.08,3.24 c -1.74,0.47 -1.74,1.22 0,1.68 l 12.08,3.24 c 1.74,0.47 4.55,0.47 6.29,0 l 12.08,-3.24 c 1.74,-0.47 1.74,-1.22 0,-1.68 z"
           id="path742" />
      </g>
      <g
         id="g745">
        <polygon
           class="schulz-dashboard-center-icon-styling-17"
           points="335.89,500.02 351.63,495.8 314.86,485.95 299.12,490.17 "
           id="polygon742" />
        <polygon
           class="schulz-dashboard-center-icon-styling-70"
           points="335.89,498.9 335.89,480.83 299.12,470.98 299.12,489.05 "
           id="polygon743" />
        <polygon
           class="schulz-dashboard-center-icon-styling-5"
           points="335.89,480.83 351.63,476.61 314.86,466.76 299.12,470.98 "
           id="polygon744" />
        <polygon
           class="schulz-dashboard-center-icon-styling-65"
           points="351.63,494.68 335.89,498.9 335.89,480.83 351.63,476.61 "
           id="polygon745" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-52"
         clip-path="url(#clippath-25)"
         id="g746">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 360.36,499.43 c 0,0 -19.42,5.21 -25.47,6.83 -8.18,2.19 -18.43,5.72 -20.93,11.26 -2.74,6.07 -5.68,34.27 -5.47,60.77 0,0.75 -0.83,1.5 -0.84,2.25 -0.08,7.15 0.89,9.95 2.95,11.6 l 62.14,-5.74 -5.19,-84.21 z"
           id="path745" />
      </g>
      <g
         id="g754">
        <polyline
           class="schulz-dashboard-center-icon-styling-4"
           points="311.78 552.32 311.78 577.84 330.07 572.83"
           id="polyline746" />
        <path
           class="schulz-dashboard-center-icon-styling-23"
           d="m 349.73,536.85 -19.98,5.35 c -1.5,0.4 -2.83,1.3 -3.76,2.55 l -2.08,2.78 c -0.93,1.25 -2.26,2.14 -3.76,2.55 l -8.36,2.24 c 0.24,-10.9 1.45,-21.48 3.86,-31.65 0.5,-2.09 2.11,-3.74 4.19,-4.29 l 28.34,-7.59 c 1.91,-0.51 3.78,0.93 3.78,2.9 v 22.26 c 0,1.36 -0.91,2.55 -2.23,2.9 z"
           id="path746" />
        <g
           id="g753">
          <path
             class="schulz-dashboard-center-icon-styling-32"
             d="m 311.78,577.84 v 6.22 c 0,2.78 1.4,4.6 4.32,4.11 2.93,-0.48 9.02,-2.51 9.02,-2.51 l 1.73,-11.95 z"
             id="path747" />
          <g
             class="schulz-dashboard-center-icon-styling-45"
             clip-path="url(#clippath-26)"
             id="g752">
            <polygon
               class="schulz-dashboard-center-icon-styling-76"
               points="318.21,583.95 319.19,575.81 326.85,573.72 325.13,585.66 "
               id="polygon747" />
            <polygon
               class="schulz-dashboard-center-icon-styling-31"
               points="311.47,585.79 311.78,577.84 319.19,575.81 318.21,583.95 "
               id="polygon748" />
            <g
               id="g751">
              <polygon
                 class="schulz-dashboard-center-icon-styling-23"
                 points="312.85,584.52 312.85,582.98 325.15,579.69 325.15,581.22 "
                 id="polygon749" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-66"
                 points="312.85,582.98 307.58,581.57 319.88,578.28 325.15,579.69 "
                 id="polygon750" />
              <polygon
                 class="schulz-dashboard-center-icon-styling-31"
                 points="307.58,583.11 312.85,584.52 312.85,582.98 307.58,581.57 "
                 id="polygon751" />
            </g>
          </g>
        </g>
        <polygon
           class="schulz-dashboard-center-icon-styling-65"
           points="338.07,551.82 338.07,542.74 340.04,542.22 340.04,551.29 "
           id="polygon753" />
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="340.51,538.18 340.51,512.26 343.62,511.43 343.62,537.34 "
           id="polygon754" />
        <line
           class="schulz-dashboard-center-icon-styling-4"
           x1="341.95999"
           y1="562.54999"
           x2="341.95999"
           y2="510.72"
           id="line754" />
        <path
           class="schulz-dashboard-center-icon-styling-16"
           d="m 313.38,550.52 c 0.22,-10.01 1.33,-19.73 3.55,-29.07 0.46,-1.92 1.94,-3.43 3.85,-3.94 l 26.04,-6.98 c 1.75,-0.47 3.48,0.85 3.48,2.67 l -36.91,37.32 z"
           id="path754" />
      </g>
      <polygon
         class="schulz-dashboard-center-icon-styling-30"
         points="465.5,537.16 465.5,534.26 470.72,532.86 470.72,535.77 "
         id="polygon755" />
      <path
         class="schulz-dashboard-center-icon-styling-16"
         d="m 258.71,506.59 c 14.67,4.89 31.59,9.44 49.78,13.55 0,0 -29.62,9.28 -53.9,20.98 0.32,-11.33 2.09,-28.55 4.12,-34.53 z"
         id="path755" />
      <polygon
         class="schulz-dashboard-center-icon-styling-17"
         points="413.12,508.19 423.18,505.49 423.18,526.98 438.49,491.85 428.44,494.54 428.44,473.05 "
         id="polygon756" />
      <g
         id="g758">
        <polygon
           class="schulz-dashboard-center-icon-styling-31"
           points="282.79,580.97 282.79,575.43 269.62,571.9 269.62,577.45 "
           id="polygon757" />
        <polygon
           class="schulz-dashboard-center-icon-styling-27"
           points="281.96,581.16 281.96,575.62 268.79,572.09 268.79,577.63 "
           id="polygon758" />
      </g>
      <g
         id="g760">
        <g
           class="schulz-dashboard-center-icon-styling-17"
           id="g759">
          <path
             class="schulz-dashboard-center-icon-styling-27"
             d="m 254.59,556.02 c -0.54,-0.14 -0.98,0.19 -0.98,0.75 v 3.66 c 0,0.56 0.44,1.13 0.98,1.28 l 7.41,1.98 c 0.54,0.14 0.98,-0.19 0.98,-0.75 v -3.66 c 0,-0.56 -0.44,-1.13 -0.98,-1.28 z"
             id="path758" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-23"
           d="m 256.06,556.76 c -0.43,-0.11 -0.78,0.15 -0.78,0.6 v 2.66 c 0,0.44 0.35,0.9 0.78,1.01 l 5.88,1.58 c 0.43,0.11 0.78,-0.15 0.78,-0.6 v -2.66 c 0,-0.44 -0.35,-0.9 -0.78,-1.01 z"
           id="path759" />
        <path
           class="schulz-dashboard-center-icon-styling-30"
           d="m 256.04,557.04 c -0.25,-0.07 -0.46,0.09 -0.46,0.36 v 1.58 c 0,0.26 0.21,0.54 0.46,0.6 l 3.51,0.94 c 0.25,0.07 0.46,-0.09 0.46,-0.36 v -1.58 c 0,-0.26 -0.21,-0.54 -0.46,-0.6 z"
           id="path760" />
      </g>
      <g
         id="g762">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 480.45,518.65 -113.27,30.47 v -1.35 c 0,-0.47 0.31,-0.88 0.77,-1 l 111.19,-29.91 c 0.66,-0.18 1.31,0.32 1.31,1 v 0.8 z"
           id="path761" />
        <path
           class="schulz-dashboard-center-icon-styling-25"
           d="m 479.66,520.98 -111.19,29.91 c -0.66,0.18 -1.31,-0.32 -1.31,-1 v -0.8 c 0,0 113.27,-30.47 113.27,-30.47 v 1.35 c 0,0.47 -0.31,0.88 -0.77,1 z"
           id="path762" />
      </g>
      <g
         id="g764">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 480.45,509.58 -113.27,30.47 v -1.35 c 0,-0.47 0.31,-0.88 0.77,-1 l 111.19,-29.91 c 0.66,-0.18 1.31,0.32 1.31,1 v 0.8 z"
           id="path763" />
        <path
           class="schulz-dashboard-center-icon-styling-25"
           d="m 479.66,511.91 -111.19,29.91 c -0.66,0.18 -1.31,-0.32 -1.31,-1 v -0.8 c 0,0 113.27,-30.47 113.27,-30.47 v 1.35 c 0,0.47 -0.31,0.88 -0.77,1 z"
           id="path764" />
      </g>
      <g
         id="g766">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 480.45,500.51 -113.27,30.47 v -1.35 c 0,-0.47 0.31,-0.88 0.77,-1 l 111.19,-29.91 c 0.66,-0.18 1.31,0.32 1.31,1 v 0.8 z"
           id="path765" />
        <path
           class="schulz-dashboard-center-icon-styling-25"
           d="m 479.66,502.84 -111.19,29.91 c -0.66,0.18 -1.31,-0.32 -1.31,-1 v -0.8 c 0,0 113.27,-30.47 113.27,-30.47 v 1.35 c 0,0.47 -0.31,0.88 -0.77,1 z"
           id="path766" />
      </g>
      <g
         id="g768">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 480.45,491.45 -113.27,30.47 v -1.35 c 0,-0.47 0.31,-0.88 0.77,-1 l 111.19,-29.91 c 0.66,-0.18 1.31,0.32 1.31,1 v 0.8 z"
           id="path767" />
        <path
           class="schulz-dashboard-center-icon-styling-25"
           d="m 479.66,493.78 -111.19,29.91 c -0.66,0.18 -1.31,-0.32 -1.31,-1 v -0.8 c 0,0 113.27,-30.47 113.27,-30.47 v 1.35 c 0,0.47 -0.31,0.88 -0.77,1 z"
           id="path768" />
      </g>
      <g
         id="g770">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 480.45,482.38 -113.27,30.47 v -1.35 c 0,-0.47 0.31,-0.88 0.77,-1 l 111.19,-29.91 c 0.66,-0.18 1.31,0.32 1.31,1 v 0.8 z"
           id="path769" />
        <path
           class="schulz-dashboard-center-icon-styling-25"
           d="m 479.66,484.71 -111.19,29.91 c -0.66,0.18 -1.31,-0.32 -1.31,-1 v -0.8 c 0,0 113.27,-30.47 113.27,-30.47 v 1.35 c 0,0.47 -0.31,0.88 -0.77,1 z"
           id="path770" />
      </g>
      <g
         id="g772">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 480.45,473.31 -113.27,30.47 v -1.35 c 0,-0.47 0.31,-0.88 0.77,-1 l 111.19,-29.91 c 0.66,-0.18 1.31,0.32 1.31,1 v 0.8 z"
           id="path771" />
        <path
           class="schulz-dashboard-center-icon-styling-25"
           d="m 479.66,475.64 -111.19,29.91 c -0.66,0.18 -1.31,-0.32 -1.31,-1 v -0.8 c 0,0 113.27,-30.47 113.27,-30.47 v 1.35 c 0,0.47 -0.31,0.88 -0.77,1 z"
           id="path772" />
      </g>
      <g
         id="g774">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 480.45,464.24 -113.27,30.47 v -1.35 c 0,-0.47 0.31,-0.88 0.77,-1 l 111.19,-29.91 c 0.66,-0.18 1.31,0.32 1.31,1 v 0.8 z"
           id="path773" />
        <path
           class="schulz-dashboard-center-icon-styling-25"
           d="m 479.66,466.57 -111.19,29.91 c -0.66,0.18 -1.31,-0.32 -1.31,-1 v -0.8 c 0,0 113.27,-30.47 113.27,-30.47 v 1.35 c 0,0.47 -0.31,0.88 -0.77,1 z"
           id="path774" />
      </g>
      <g
         id="g776">
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 480.45,455.18 -113.27,30.47 v -1.35 c 0,-0.47 0.31,-0.88 0.77,-1 l 111.19,-29.91 c 0.66,-0.18 1.31,0.32 1.31,1 v 0.8 z"
           id="path775" />
        <path
           class="schulz-dashboard-center-icon-styling-25"
           d="m 479.66,457.51 -111.19,29.91 c -0.66,0.18 -1.31,-0.32 -1.31,-1 v -0.8 c 0,0 113.27,-30.47 113.27,-30.47 v 1.35 c 0,0.47 -0.31,0.88 -0.77,1 z"
           id="path776" />
      </g>
      <g
         id="g779">
        <g
           class="schulz-dashboard-center-icon-styling-17"
           id="g777">
          <path
             class="schulz-dashboard-center-icon-styling-27"
             d="m 294.85,566.66 c -0.54,-0.14 -0.98,0.19 -0.98,0.75 v 3.66 c 0,0.56 0.44,1.13 0.98,1.28 l 7.41,1.98 c 0.54,0.14 0.98,-0.19 0.98,-0.75 v -3.66 c 0,-0.56 -0.44,-1.13 -0.98,-1.28 z"
             id="path777" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-23"
           d="m 296.32,567.4 c -0.43,-0.11 -0.78,0.15 -0.78,0.6 v 2.66 c 0,0.44 0.35,0.9 0.78,1.01 l 5.88,1.58 c 0.43,0.11 0.78,-0.15 0.78,-0.6 v -2.66 c 0,-0.44 -0.35,-0.9 -0.78,-1.01 z"
           id="path778" />
        <path
           class="schulz-dashboard-center-icon-styling-30"
           d="m 298.64,568.35 c -0.25,-0.07 -0.46,0.09 -0.46,0.36 v 1.58 c 0,0.26 0.21,0.54 0.46,0.6 l 3.51,0.94 c 0.25,0.07 0.46,-0.09 0.46,-0.36 v -1.58 c 0,-0.26 -0.21,-0.54 -0.46,-0.6 z"
           id="path779" />
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-1"
         d="m 530.32,463.08 c 10.13,2.42 -2.91,47.6 -14.66,64 -19.71,27.53 -76.84,47.93 -91.9,52.85 -8.81,2.88 -29.25,9.89 -37.12,7.94 C 372.75,584.43 376.5,571.5 373.77,567"
         id="path780" />
      <path
         class="schulz-dashboard-center-icon-styling-31"
         d="m 367.96,561.33 3.19,-0.89 c 0.44,-0.12 0.82,0.22 0.79,0.73 l -0.06,4.04 c -0.02,0.39 -0.29,0.76 -0.63,0.86 l -3.12,0.93 c -0.44,0.13 -0.82,-0.2 -0.8,-0.7 v -4.08 c 0,-0.41 0.28,-0.79 0.64,-0.89 z"
         id="path781" />
      <polygon
         class="schulz-dashboard-center-icon-styling-76"
         points="372.75,562.24 375.07,567.01 373.14,568.06 370.33,564.59 369.31,564.87 368.07,562.35 370.78,560.89 "
         id="polygon781" />
      <path
         class="schulz-dashboard-center-icon-styling-54"
         d="m 367.67,560.94 1.46,-1.61 c 0.2,-0.22 0.33,0.07 0.27,0.61 v 4.31 c -0.06,0.43 -0.2,0.87 -0.36,1.05 l -1.43,1.64 c -0.2,0.23 -0.33,-0.04 -0.28,-0.58 l -0.02,-4.34 c 0.04,-0.44 0.2,-0.9 0.36,-1.08 z"
         id="path782" />
      <g
         class="schulz-dashboard-center-icon-styling-8"
         id="g783">
        <path
           class="schulz-dashboard-center-icon-styling-31"
           d="m 636.68,562.29 c -6.51,-1.74 -17.17,-1.74 -23.68,0 l -135.6,33.4 c -6.51,1.74 -1.37,6.38 5.14,8.12 l 37.99,11.04 c 6.51,1.74 19.79,0.51 26.38,-0.89 60.3,-8.54 119.56,-28.92 126.29,-34.6 6.82,-5.76 2.1,-6.87 -4.41,-8.62 l -32.12,-8.46 z"
           id="path783" />
      </g>
      <g
         class="schulz-dashboard-center-icon-styling-10"
         id="g784">
        <path
           class="schulz-dashboard-center-icon-styling-31"
           d="m 619.79,567 c -6.51,-1.74 -17.17,-1.74 -23.68,0 l -118.7,28.69 c -6.51,1.74 2.12,5.4 8.64,7.15 l 28.77,7.7 c 6.51,1.74 13.45,2.15 17.23,1.89 3.78,-0.26 8.48,-1.05 17.16,-4.06 13.43,-4.66 37.06,-11.36 46.66,-14.08 11.14,-3.15 20.26,-4.08 29.63,-6.52 15.2,-3.94 22.07,-7.03 24.16,-8.44 2.09,-1.41 2.88,-3.55 -3.63,-5.29 l -26.24,-7.03 z"
           id="path784" />
      </g>
      <g
         id="g827">
        <path
           class="schulz-dashboard-center-icon-styling-5"
           d="m 504.56,546 -5.72,4.46 c 0,0 0.59,-3.25 1.76,-4.46 1.76,-1.83 3.96,0 3.96,0 z"
           id="path785" />
        <g
           id="g786">
          <path
             class="schulz-dashboard-center-icon-styling-31"
             d="m 608.98,567.72 c -2.11,7.88 0.85,15.52 6.62,17.07 5.77,1.55 12.15,-3.59 14.27,-11.47 2.11,-7.88 -0.85,-15.52 -6.62,-17.07 -5.77,-1.55 -12.15,3.59 -14.27,11.47 z"
             id="path786" />
          <rect
             class="schulz-dashboard-center-icon-styling-31"
             x="619.27002"
             y="556.89001"
             width="8.8100004"
             height="29.540001"
             transform="rotate(-165,623.67884,571.65943)"
             id="rect786" />
        </g>
        <g
           id="g787">
          <path
             class="schulz-dashboard-center-icon-styling-31"
             d="m 519.43,591.76 c -2.11,7.88 0.85,15.52 6.62,17.07 5.77,1.55 12.15,-3.59 14.27,-11.47 2.11,-7.88 -0.85,-15.52 -6.62,-17.07 -5.77,-1.55 -12.15,3.59 -14.27,11.47 z"
             id="path787" />
          <rect
             class="schulz-dashboard-center-icon-styling-31"
             x="529.71997"
             y="580.91998"
             width="8.8100004"
             height="29.540001"
             transform="rotate(-165,534.12394,595.69824)"
             id="rect787" />
        </g>
        <polygon
           class="schulz-dashboard-center-icon-styling-31"
           points="624.52,567.62 559.61,587.4 549.81,599.77 528.55,596.32 530.65,578.27 629.59,550.99 644.56,560.93 639.51,572.35 "
           id="polygon787" />
        <path
           class="schulz-dashboard-center-icon-styling-5"
           d="m 632.95,527.28 c -19.72,-6.36 -59.14,-15.17 -84.37,-7.87 -25.73,7.45 -51.16,32.32 -51.16,32.32 0,0 -15.06,7.77 -22.51,13.76 -7.98,6.41 -7.89,18.87 -6.07,25.66 1.41,5.25 37.15,13.46 45.32,13.39 2.35,0.49 5.96,0.47 9.46,0.43 l 1.62,-0.43 c -0.23,-3.67 -0.08,-7.18 0.71,-11.14 1.82,-9.12 9.45,-15.23 15.76,-14.2 6.01,0.99 10.09,7.58 8.1,20.57 l 9.08,-4.26 c 14.97,-5.02 31.2,-9.45 49.04,-13.14 l 6.64,-0.79 c 0,-4.05 0.28,-7.62 1.39,-12.08 2.23,-9.01 9.77,-14.54 15.9,-12.9 5.78,1.55 8.63,8.02 7.64,15.74 2.59,-1.33 4.04,-2.89 4.85,-5.25 1.45,-4.24 2.35,-10.27 2.14,-12.43 -0.14,-1.41 -0.39,-2.83 -1.41,-3.33 -2.21,-6.41 -6.38,-16.99 -12.13,-24.05 z"
           id="path788" />
        <path
           class="schulz-dashboard-center-icon-styling-23"
           d="m 586.6,530.7 c 14.28,-4.72 24.82,-5.59 44.37,-3.75 l 1.99,0.33 c -19.76,-6.37 -59.18,-15.16 -84.37,-7.87 -6.47,1.87 -12.93,4.85 -18.96,8.26 -0.33,0.21 -0.65,0.42 -0.98,0.64 -5.51,3.21 -10.48,6.51 -15.05,9.88 -3.86,2.87 -7.21,5.6 -9.84,7.85 -2.13,1.83 -4.17,3.67 -6.15,5.52 -0.12,0.11 -0.18,0.17 -0.18,0.17 4.12,6.82 19.29,12.23 48.12,12.89 0,0 15.62,-25.52 41.06,-33.92 z"
           id="path789" />
        <path
           class="schulz-dashboard-center-icon-styling-31"
           d="m 549.81,566.02 c 25.56,-7.69 51.2,-15.06 74.23,-24.6 0.6,-0.25 1.15,-0.45 1.57,-0.72 1.44,-0.94 5.88,-10.32 5.88,-10.32 -11,-2.37 -29.75,-2.51 -41.34,1.6 -28.92,10.27 -40.35,34.03 -40.35,34.03 z"
           id="path790" />
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 592.3,528.89 c -1.55,0.45 -2.77,0.86 -4.73,1.48 -12.45,-4.54 -25.78,-8.07 -39.92,-10.69 l 5.09,-1.29 c 13.07,2.11 26.18,5.7 39.56,10.49 z"
           id="path791" />
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 535.16,524.73 -4.15,2.16 c 7.76,4.41 22.96,7.91 40.96,10.98 1.04,-0.7 2.29,-1.43 3.73,-2.27 -16.64,-3.22 -30.89,-6.75 -40.54,-10.86 z"
           id="path792" />
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 499.73,551.9 c 5.35,6.26 21.38,9.68 44.5,11.21 0,0 2.52,-6.37 -15.6,-10.51 -19.32,-4.42 -28.91,-0.7 -28.91,-0.7 z"
           id="path793" />
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 588.39,533.35 1.89,19.47 4.6,-1.51 -2.31,-19.33 c -1.36,0.4 -2.74,0.84 -4.18,1.37 z"
           id="path794" />
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="623.35,541.05 619.77,529.48 616.91,529.27 620.22,542.33 "
           id="polygon794" />
        <g
           id="g799">
          <path
             class="schulz-dashboard-center-icon-styling-2"
             d="m 590.44,531.95 c 0.86,6.7 2.31,20.89 2.31,20.89 0,0 2.07,2.59 1.66,6.49 -0.67,6.31 -1.52,17.62 -0.94,21.94"
             id="path795" />
          <path
             class="schulz-dashboard-center-icon-styling-2"
             d="m 549.89,565.95 c 2.93,3.11 3.48,14.9 5.37,25.6 l 51,-13.73 c 2.15,-0.58 4.16,-2.47 5.31,-5.02 l 10.89,-21.32 c 1.22,-2.69 1.36,-6.45 -0.44,-9.23 l -3.7,-13.24"
             id="path796" />
          <path
             class="schulz-dashboard-center-icon-styling-2"
             d="m 545.44,564.59 c 0,0 -0.22,1.26 -2.12,2.3 -2.11,1.15 -20.54,8.86 -25.15,11.02 -5.79,2.71 -13.54,4.57 -18.64,3.83 -7.92,-1.15 -19.76,-4.2 -22.56,-5.6 -3.06,-1.53 -5.3,-5.22 -4.87,-7.01"
             id="path797" />
          <path
             class="schulz-dashboard-center-icon-styling-2"
             d="m 644.88,551.28 c 0,0 -3.89,2.56 -4.6,3.22 -1.91,1.77 -4.27,4.49 -4.27,4.49"
             id="path798" />
          <path
             class="schulz-dashboard-center-icon-styling-2"
             d="m 522.29,576.08 c 0,0 7.01,1.96 8.73,7.5"
             id="path799" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 507.25,603.81 c 1.52,-0.16 -6.41,-11.23 -7.15,-12.03 -1.75,-1.91 -7.15,-3.82 -16.52,-6.04 -8.05,-1.91 -9.74,-1.08 -10.59,-0.32 -0.56,0.5 -4.2,6.25 -3.21,7.02 2.31,1.79 7.64,4.1 15.34,6.33 8.34,2.41 20.36,5.23 22.12,5.04 z"
           id="path800" />
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 502.1,601.79 c 1.23,0.23 -4.8,-2.92 -5.37,-3.18 -1.35,-0.61 -5.65,-1.84 -13.16,-3.79 -6.45,-1.68 -7.84,-1.83 -8.56,-1.85 -0.47,-0.01 -3.07,-0.18 -2.37,0.27 1.48,0.96 4.91,2.47 11.07,4.15 6.66,1.81 16.95,4.14 18.39,4.41 z"
           id="path801" />
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 552.55,569.1 c 36.54,-10.73 73.39,-25.59 74.88,-26.21 4.7,-1.96 4.56,-7.57 8.11,-5.29 2.2,1.41 7.23,11.66 0.47,14.4 -2.62,1.06 -13.31,-0.4 -17.38,6.98 -6.58,11.9 -7,15.33 -9.8,17.22 -2.44,1.65 -11.88,4.33 -26.17,7.97 -7.83,1.99 -27.4,7.37 -27.4,7.37 -1.16,-6.48 -2.71,-12.35 -5.06,-16.95 -1.1,-2.17 0.01,-4.81 2.35,-5.49 z"
           id="path802" />
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 523.79,586.15 c -1.75,3.31 -2.82,6.82 -3.05,10.6 -0.09,1.4 -1.39,2.4 -2.77,2.15 -3.34,-0.61 -6.2,-1.7 -8.26,-3.59 -1.19,-1.09 -1.15,-3 0.1,-4.03 3.72,-3.07 7.88,-5.3 12.32,-7.01 1.16,-0.44 2.26,0.79 1.68,1.88 z"
           id="path803" />
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 640.21,561.63 c -1.41,-2.21 -1.57,-3.99 0.6,-5.31 2.17,-1.32 3.33,-2.78 3.4,-0.31 0.13,4.49 -1.37,8.11 -2.25,9.83 -0.16,0.32 -0.65,0.24 -0.69,-0.12 -0.12,-0.89 -0.28,-2.87 -1.05,-4.09 z"
           id="path804" />
        <path
           class="schulz-dashboard-center-icon-styling-31"
           d="m 640.07,543.92 c 1.27,2.62 2.25,5.35 3.08,8.52 l 1.93,-1.11 c -1.04,-4.37 -1.57,-6.63 -2.51,-7.23 -0.78,-0.5 -2.51,-0.18 -2.51,-0.18 z"
           id="path805" />
        <g
           id="g806">
          <polygon
             class="schulz-dashboard-center-icon-styling-31"
             points="491.62,595.97 491.62,590.34 478.25,586.76 478.25,592.38 "
             id="polygon805" />
          <polygon
             class="schulz-dashboard-center-icon-styling-27"
             points="490.78,596.15 490.78,590.53 477.41,586.94 477.41,592.57 "
             id="polygon806" />
        </g>
        <polygon
           class="schulz-dashboard-center-icon-styling-75"
           points="546.15,537.77 549.98,534.27 539.89,531.57 536.06,535.06 "
           id="polygon807" />
        <g
           id="g809">
          <polygon
             class="schulz-dashboard-center-icon-styling-31"
             points="592.25,558.24 592,559.9 584.97,562.53 585.35,560.78 "
             id="polygon808" />
          <polygon
             class="schulz-dashboard-center-icon-styling-75"
             points="592.56,557.89 592.3,559.55 585.27,562.18 585.65,560.43 "
             id="polygon809" />
        </g>
        <g
           id="g811">
          <polygon
             class="schulz-dashboard-center-icon-styling-31"
             points="621.75,547 621.54,548.66 614.6,551.51 614.92,549.75 "
             id="polygon810" />
          <polygon
             class="schulz-dashboard-center-icon-styling-75"
             points="622.04,546.64 621.83,548.3 614.89,551.14 615.21,549.38 "
             id="polygon811" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-16"
           d="m 552.25,565.21 c 38.3,-28.2 76.49,-31.25 76.49,-31.25 l 1.3,-2.84 c -12.29,-1.57 -25.38,-2.93 -39.08,1.89 -28.24,9.94 -38.71,32.2 -38.71,32.2 z"
           id="path811" />
        <g
           id="g816">
          <path
             class="schulz-dashboard-center-icon-styling-17"
             d="m 553.79,566.38 c 0,0 0.15,-0.37 1.71,0.69 1.7,1.15 7.86,2.42 9.42,1.8 2.19,-0.87 2.35,-3.17 1.54,-4.03 -2.51,-2.66 -4.43,-2.62 -5.37,-2.56 -0.94,0.05 -7.3,4.1 -7.3,4.1 z"
             id="path812" />
          <g
             id="g815">
            <path
               class="schulz-dashboard-center-icon-styling-5"
               d="m 551.32,565.62 c 0,0 4.74,-5 6.96,-5.05 1.73,-0.03 5.76,0.13 6.7,2.42 0.93,2.29 -1.89,3.52 -5.47,4.26 -3.59,0.74 -6.03,0.18 -6.9,-0.29 -0.87,-0.47 -1.28,-1.33 -1.28,-1.33 z"
               id="path813" />
            <g
               class="schulz-dashboard-center-icon-styling-44"
               clip-path="url(#clippath-27)"
               id="g814">
              <path
                 class="schulz-dashboard-center-icon-styling-17"
                 d="m 562.9,560.76 c 0,0 0.31,2.48 -3.7,3.44 -2.09,0.5 -8.69,1.51 -8.69,1.51 l 1.61,2.92 13.28,0.25 1.72,-5.72 -2.43,-3.28 -1.78,0.87 z"
                 id="path814" />
            </g>
          </g>
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 471.82,568.83 c -0.69,1.46 1.2,5.6 4.29,7.06 4.5,2.12 15.58,4.75 23.56,6.04 5.81,0.94 18.05,-2.7 22.87,-5.84 -0.78,-0.7 -3.17,-0.7 -5.08,-0.14 -3.87,1.33 -12.22,3.72 -17.1,3.02 -8.42,-1.22 -19.27,-3.76 -22.98,-5.45 -1.88,-0.86 -4.59,-4.54 -3.48,-7.14 -0.69,0.53 -1.71,1.68 -2.09,2.47 z"
           id="path816" />
        <g
           class="schulz-dashboard-center-icon-styling-46"
           clip-path="url(#clippath-28)"
           id="g817">
          <path
             class="schulz-dashboard-center-icon-styling-16"
             d="m 467.59,586.37 c -0.7,-21.16 24.55,-26.67 41.04,-27 11.16,-11.91 39.01,-46.21 78.62,-42.31 l 20.32,-2.71 -22.67,-2.54 -46.74,6.59 -78.41,55.21 7.85,12.75 z"
             id="path817" />
        </g>
        <path
           class="schulz-dashboard-center-icon-styling-75"
           d="m 500.37,578.96 c -8.79,-1.39 -16.28,-3.06 -22.98,-5.45 l -0.94,2.53 c 2.87,1.47 14.02,4.59 23.04,5.87 z"
           id="path818" />
        <path
           class="schulz-dashboard-center-icon-styling-17"
           d="m 500.12,579.75 c -8.6,-1.26 -16.02,-3.05 -22.72,-5.43 l -0.44,1.27 c 4.07,1.74 13.69,4.38 22.71,5.65 z"
           id="path819" />
        <g
           id="g823">
          <path
             class="schulz-dashboard-center-icon-styling-75"
             d="m 527.72,594 c -2.11,7.87 0.85,15.5 6.61,17.04 5.76,1.54 12.14,-3.58 14.25,-11.45 2.11,-7.87 -0.85,-15.5 -6.61,-17.04 -5.76,-1.54 -12.14,3.58 -14.25,11.45 z"
             id="path820" />
          <path
             class="schulz-dashboard-center-icon-styling-5"
             d="m 530.36,594.71 c -1.57,5.87 0.64,11.57 4.94,12.72 4.3,1.15 9.06,-2.68 10.64,-8.55 1.57,-5.87 -0.64,-11.57 -4.94,-12.72 -4.3,-1.15 -9.06,2.68 -10.64,8.55 z"
             id="path821" />
          <path
             class="schulz-dashboard-center-icon-styling-54"
             d="m 542.82,596.32 1.97,3.11 c 0.54,0.85 -0.22,2.34 -1.15,2.27 l -3.41,-0.27 c -0.41,-0.03 -0.84,0.26 -1.11,0.74 l -2.2,4.02 c -0.6,1.1 -1.83,0.94 -1.87,-0.25 l -0.14,-4.33 c -0.02,-0.52 -0.29,-0.9 -0.68,-0.98 l -3.33,-0.62 c -0.91,-0.17 -0.91,-1.76 0,-2.42 l 3.33,-2.41 c 0.4,-0.29 0.67,-0.82 0.68,-1.34 l 0.14,-4.41 c 0.04,-1.21 1.27,-2.03 1.87,-1.25 l 2.2,2.84 c 0.26,0.34 0.7,0.4 1.11,0.15 l 3.41,-2.1 c 0.94,-0.58 1.69,0.51 1.15,1.65 l -1.97,4.16 c -0.23,0.5 -0.23,1.06 0,1.43 z"
             id="path822" />
          <path
             class="schulz-dashboard-center-icon-styling-5"
             d="m 536.44,596.34 c -0.34,1.29 0.14,2.53 1.08,2.78 0.94,0.25 1.98,-0.59 2.33,-1.87 0.34,-1.29 -0.14,-2.53 -1.08,-2.78 -0.94,-0.25 -1.98,0.59 -2.33,1.87 z"
             id="path823" />
        </g>
        <g
           id="g826">
          <ellipse
             class="schulz-dashboard-center-icon-styling-75"
             cx="627.72998"
             cy="572.71002"
             rx="14.75"
             ry="10.8"
             transform="rotate(-75,627.73191,572.71782)"
             id="ellipse823" />
          <path
             class="schulz-dashboard-center-icon-styling-5"
             d="m 619.95,570.63 c -1.57,5.87 0.64,11.57 4.94,12.72 4.3,1.15 9.06,-2.68 10.64,-8.55 1.57,-5.87 -0.64,-11.57 -4.94,-12.72 -4.3,-1.15 -9.06,2.68 -10.64,8.55 z"
             id="path824" />
          <path
             class="schulz-dashboard-center-icon-styling-54"
             d="m 632.41,572.23 1.97,3.11 c 0.54,0.85 -0.22,2.34 -1.15,2.27 l -3.41,-0.27 c -0.41,-0.03 -0.84,0.26 -1.11,0.74 l -2.2,4.02 c -0.6,1.1 -1.83,0.94 -1.87,-0.25 l -0.14,-4.33 c -0.02,-0.52 -0.29,-0.9 -0.68,-0.98 l -3.33,-0.62 c -0.91,-0.17 -0.91,-1.76 0,-2.42 l 3.33,-2.41 c 0.4,-0.29 0.67,-0.82 0.68,-1.34 l 0.14,-4.41 c 0.04,-1.21 1.27,-2.03 1.87,-1.25 l 2.2,2.84 c 0.26,0.34 0.7,0.4 1.11,0.15 l 3.41,-2.1 c 0.94,-0.58 1.69,0.51 1.15,1.65 l -1.97,4.16 c -0.23,0.5 -0.23,1.06 0,1.43 z"
             id="path825" />
          <path
             class="schulz-dashboard-center-icon-styling-5"
             d="m 626.03,572.26 c -0.34,1.29 0.14,2.53 1.08,2.78 0.94,0.25 1.98,-0.59 2.33,-1.87 0.34,-1.29 -0.14,-2.53 -1.08,-2.78 -0.94,-0.25 -1.98,0.59 -2.33,1.87 z"
             id="path826" />
        </g>
      </g>
      <path
         class="schulz-dashboard-center-icon-styling-2"
         d="m 499.9,580.5 c -8.67,-1.28 -17.51,-3.39 -22.93,-5.72"
         id="path827" />
      <path
         class="schulz-dashboard-center-icon-styling-1"
         d="m 659.78,499.11 c 8.74,2 6.04,35.75 6.95,50.89 0.93,15.47 36.22,15.39 20.49,23.51 -8.24,4.25 -20.85,8.31 -28.73,6.36 -13.89,-3.44 -15.57,-24.82 -18.3,-29.31"
         id="path828" />
      <path
         class="schulz-dashboard-center-icon-styling-31"
         d="m 634.09,545.63 3.34,-1.7 c 0.46,-0.24 1.03,0 1.18,0.5 l 0.72,2.27 c 0.12,0.39 -0.05,0.81 -0.41,1 l -3.25,1.73 c -0.45,0.24 -1.02,0.02 -1.19,-0.46 l -0.81,-2.29 c -0.14,-0.4 0.03,-0.84 0.41,-1.03 z"
         id="path829" />
      <polygon
         class="schulz-dashboard-center-icon-styling-76"
         points="639.16,545.79 641.47,550.56 639.55,551.62 636.74,548.14 635.72,548.43 634.48,545.9 637.19,544.45 "
         id="polygon829" />
      <path
         class="schulz-dashboard-center-icon-styling-5"
         d="m 633.61,545.33 0.88,-1.99 c 0.12,-0.28 0.34,-0.04 0.45,0.5 l 0.52,2.45 c 0.09,0.42 0.09,0.88 0,1.1 l -0.85,2.01 c -0.12,0.28 -0.33,0.06 -0.45,-0.46 l -0.55,-2.47 c -0.1,-0.43 -0.09,-0.92 0,-1.14 z"
         id="path830" />
    </g>
  </g>
  `
]
export const factory = [
  '50 40',
  `
  <defs
     id="defs8" />
  
  <path
     style="stroke-miterlimit: 10; stroke-width: .5px;"
     d="m 42.07788,17.72021 c -0.21307,-0.12091 -0.47552,-0.11957 -0.68726,0.0066 l -1.7345,1.0304 L 38.83599,1.63672 C 38.81866,1.28052 38.51806,1 38.15276,1 H 34.99572 C 34.62908,1 34.3272,1.28247 34.31249,1.64062 l -0.86957,20.66394 c -0.002,0.04614 0.0141,0.08728 0.02142,0.1311 l -2.01971,1.19989 v -5.32092 c 0,-0.24243 -0.12823,-0.46686 -0.33728,-0.58978 -0.20905,-0.12354 -0.46747,-0.12689 -0.6792,-0.008 l -10.50568,5.8479 v -5.25012 c 0,-0.24243 -0.12823,-0.46619 -0.33661,-0.58911 -0.21039,-0.12421 -0.46747,-0.12622 -0.6792,-0.0093 L 7.92816,23.80389 C 7.71112,23.92474 7.57617,24.1538 7.57617,24.40228 V 38.3161 c 0,0.37799 0.30591,0.6839 0.6839,0.6839 h 33.47986 c 0.37799,0 0.6839,-0.30591 0.6839,-0.6839 V 18.31464 c 0,-0.24579 -0.13226,-0.4729 -0.34595,-0.59442 z M 37.50024,2.33612 37.61291,4.68933 h -2.05969 l 0.09906,-2.35321 z m -2.00458,3.72101 h 2.1828 l 0.64526,13.47345 c 2.4e-4,0.0056 0.0037,0.01025 0.0041,0.01581 L 34.84057,21.61811 35.49566,6.05714 Z M 20.3573,37.6322 v -5.04578 h 9.39362 v 5.04578 z m 20.69873,0 h -9.93732 v -5.72968 c 0,-0.37805 -0.30585,-0.6839 -0.6839,-0.6839 H 19.6734 c -0.37805,0 -0.6839,0.30585 -0.6839,0.6839 V 37.6322 H 8.94397 V 24.80499 l 9.61072,-5.32892 v 5.25214 c 0,0.24243 0.12823,0.46686 0.33728,0.58972 0.2077,0.12091 0.46619,0.12555 0.6792,0.008 l 10.50568,-5.8479 v 5.35907 c 0,0.24573 0.13226,0.47284 0.34595,0.59436 0.21375,0.12091 0.47552,0.11957 0.68726,-0.0067 l 9.94598,-5.90869 v 18.11609 z"
     id="path2717" />
  `
]
export const fuelcell = [
  '50 40',
  `
  <defs
     id="defs29" />
  
  <g
     id="g3787"
     style="stroke: none"
     transform="translate(5.66825,0.8797)">
    <g
       id="rect28">
      <path
         d="m 28.583,6.8413 v 30.3984 h -3.409 c 0.0969,-0.0792 0.1906,-0.1632 0.2809,-0.2519 0.7735,-0.76 1.1991,-1.7715 1.1984,-2.8477 -1e-4,-1.8749 -1.3097,-3.4541 -3.0742,-3.895 v -0.1103 c 1.7646,-0.4409 3.0741,-2.0201 3.0742,-3.8951 -1e-4,-1.8749 -1.3097,-3.4541 -3.0742,-3.895 v -0.1103 c 1.7646,-0.4409 3.0741,-2.0201 3.0742,-3.8951 -1e-4,-1.8748 -1.3097,-3.4539 -3.0741,-3.8949 v -0.0725 c 1.765,-0.4453 3.0745,-2.0409 3.0741,-3.9353 -7e-4,-1.5598 -0.8899,-2.9169 -2.1899,-3.5953 h 4.1196 m 1,-1 h -7.0039 v 1.5391 c 1.6974,2e-4 3.0735,1.3685 3.0742,3.0566 4e-4,1.6889 -1.3759,3.0582 -3.074,3.0586 h -2e-4 v 1.8262 c 1.6978,3e-4 3.0741,1.3512 3.0742,3.0176 -1e-4,1.6664 -1.3764,3.0173 -3.0742,3.0176 v 1.8652 c 1.6978,3e-4 3.0741,1.3512 3.0742,3.0176 -1e-4,1.6664 -1.3764,3.0173 -3.0742,3.0176 v 1.8652 c 1.6978,3e-4 3.0741,1.3512 3.0742,3.0176 10e-4,1.6667 -1.3748,3.0186 -3.0729,3.0195 h -0.0013 v 1.0801 h 7.0039 z"
         id="path2884" />
    </g>
    <g
       id="rect30">
      <path
         d="m 15.3343,6.8413 c -1.2956,0.6734 -2.1809,2.0151 -2.181,3.5567 10e-5,1.8749 1.3096,3.4541 3.0742,3.895 v 0.124 c -1.7646,0.4409 -3.0741,2.0201 -3.0742,3.8951 10e-5,1.8749 1.3096,3.4541 3.0742,3.895 v 0.124 c -1.7646,0.4409 -3.0741,2.0201 -3.0742,3.8951 10e-5,1.8749 1.3096,3.4541 3.0742,3.895 v 0.124 c -1.7646,0.4409 -3.0741,2.0202 -3.0742,3.8961 -2e-4,1.0767 0.4259,2.0881 1.1996,2.8478 0.0899,0.0883 0.1832,0.1719 0.2797,0.2507 H 11.3369 V 6.8413 h 3.9974 m 1.8932,-1 h -6.8906 v 32.3984 h 6.8906 V 37.1596 C 15.5294,37.1593 14.153,35.808 14.1533,34.1413 V 34.14 c 10e-5,-1.6664 1.3764,-3.0173 3.0742,-3.0176 v -1.8789 c -1.6978,-3e-4 -3.0741,-1.3512 -3.0742,-3.0176 10e-5,-1.6664 1.3764,-3.0173 3.0742,-3.0176 v -1.8789 c -1.6978,-3e-4 -3.0741,-1.3512 -3.0742,-3.0176 10e-5,-1.6664 1.3764,-3.0173 3.0742,-3.0176 v -1.8789 c -1.6978,-3e-4 -3.0741,-1.3512 -3.0742,-3.0176 10e-5,-1.6664 1.3764,-3.0173 3.0742,-3.0176 v -1.5391 0 z"
         id="path2887" />
    </g>
    <g
       id="rect50">
      <path
         d="M 21.5795,6.8422 V 37.2406 H 18.2272 V 6.8422 h 3.3523 m 1,-1 h -5.3523 v 32.3984 h 5.3523 z"
         id="path2890" />
    </g>
    <g
       style="isolation: isolate;"
       id="g2895">
      <path
         d="m 4.2124,24.1987 c 0,0.0283 -0.0093,0.0527 -0.0273,0.0752 -0.018,0.0225 -0.0479,0.04 -0.0894,0.0547 -0.042,0.0137 -0.0977,0.0244 -0.167,0.0332 -0.0693,0.0078 -0.1572,0.0127 -0.2627,0.0127 -0.1084,0 -0.1982,-0.0049 -0.269,-0.0127 C 3.3262,24.353 3.2705,24.3423 3.23,24.3286 3.19,24.314 3.1607,24.2964 3.1426,24.2739 3.1245,24.2514 3.1157,24.227 3.1157,24.1987 V 22.018 H 1.0972 v 2.1807 c 0,0.0283 -0.0083,0.0527 -0.0254,0.0752 -0.0166,0.0225 -0.0459,0.04 -0.0874,0.0547 -0.0415,0.0137 -0.0972,0.0244 -0.167,0.0332 -0.0693,0.0078 -0.1582,0.0127 -0.2666,0.0127 -0.106,0 -0.1938,-0.0049 -0.2651,-0.0127 C 0.2149,24.353 0.1587,24.3423 0.1168,24.3286 0.0753,24.314 0.0455,24.2964 0.0274,24.2739 0.0093,24.2514 1e-4,24.227 1e-4,24.1987 V 19.103 c 0,-0.0283 0.0093,-0.0527 0.0273,-0.0752 0.018,-0.0225 0.0479,-0.041 0.0894,-0.0547 0.042,-0.0137 0.0981,-0.0244 0.1689,-0.0332 0.0713,-0.0078 0.1592,-0.0127 0.2651,-0.0127 0.1084,0 0.1973,0.0049 0.2666,0.0127 0.0698,0.0088 0.1255,0.0195 0.167,0.0332 0.0415,0.0137 0.0708,0.0322 0.0874,0.0547 0.0171,0.0225 0.0254,0.0469 0.0254,0.0752 v 1.9805 H 3.1158 V 19.103 c 0,-0.0283 0.0088,-0.0527 0.0269,-0.0752 0.0181,-0.0225 0.0474,-0.041 0.0874,-0.0547 0.0405,-0.0137 0.0962,-0.0244 0.167,-0.0332 0.0708,-0.0078 0.1606,-0.0127 0.269,-0.0127 0.1055,0 0.1934,0.0049 0.2627,0.0127 0.0693,0.0088 0.125,0.0195 0.167,0.0332 0.0415,0.0137 0.0713,0.0322 0.0894,0.0547 0.0181,0.0225 0.0273,0.0469 0.0273,0.0752 v 5.0957 z"
         id="path2893" />
    </g>
    <g
       style="isolation: isolate;"
       id="g2899">
      <path
         d="m 8.1509,26.5229 c 0,0.041 -0.002,0.0742 -0.0054,0.1035 -0.0034,0.0273 -0.0088,0.0508 -0.0156,0.0703 -0.0068,0.0176 -0.0161,0.0293 -0.0273,0.0371 -0.0107,0.0078 -0.0234,0.0117 -0.0371,0.0117 H 6.5137 c -0.0303,0 -0.0571,-0.002 -0.0791,-0.0078 C 6.4121,26.7318 6.3941,26.7221 6.3804,26.7045 6.3662,26.6889 6.3565,26.6654 6.3501,26.6361 6.3438,26.6049 6.3408,26.5658 6.3408,26.517 c 0,-0.0469 0.002,-0.0859 0.0063,-0.1191 C 6.351,26.3667 6.3588,26.3374 6.37,26.312 6.3807,26.2847 6.3954,26.2612 6.4125,26.2358 6.4301,26.2124 6.4525,26.185 6.4804,26.1557 l 0.4673,-0.5 C 7.0405,25.558 7.1157,25.4702 7.1728,25.3901 7.2294,25.31 7.2744,25.2358 7.3061,25.1713 7.3383,25.1049 7.3598,25.0443 7.372,24.9877 7.3837,24.933 7.3896,24.8803 7.3896,24.8295 7.3896,24.7846 7.3823,24.7397 7.3676,24.6986 7.3529,24.6575 7.3315,24.6224 7.3031,24.5912 7.2743,24.5619 7.2386,24.5365 7.1957,24.5209 7.1522,24.5033 7.1019,24.4936 7.0434,24.4936 c -0.082,0 -0.1548,0.0117 -0.2178,0.0312 -0.0635,0.0215 -0.1191,0.0449 -0.167,0.0703 -0.0479,0.0254 -0.0879,0.0488 -0.1196,0.0703 -0.0322,0.0215 -0.0571,0.0332 -0.0752,0.0332 -0.0127,0 -0.0234,-0.0039 -0.0322,-0.0137 C 6.4223,24.6771 6.415,24.6634 6.4096,24.6439 6.4037,24.6244 6.3993,24.599 6.3959,24.5658 6.3925,24.5326 6.3905,24.4935 6.3905,24.4467 c 0,-0.0332 10e-4,-0.0586 0.0034,-0.0801 0.002,-0.0215 0.0049,-0.041 0.0093,-0.0566 0.0039,-0.0156 0.0098,-0.0312 0.0166,-0.043 0.0068,-0.0118 0.019,-0.0254 0.0366,-0.043 0.0171,-0.0156 0.0493,-0.0371 0.0957,-0.0625 0.0469,-0.0254 0.104,-0.0508 0.1724,-0.0762 0.0679,-0.0234 0.1431,-0.043 0.2251,-0.0605 0.082,-0.0175 0.1675,-0.0254 0.2563,-0.0254 0.1406,0 0.2632,0.0176 0.3682,0.0527 0.105,0.0371 0.1919,0.0859 0.2617,0.1484 0.0693,0.0645 0.1211,0.1387 0.1553,0.2246 0.0342,0.0879 0.0513,0.1816 0.0513,0.2812 0,0.0879 -0.0083,0.1738 -0.0254,0.2578 -0.0166,0.0859 -0.0513,0.1777 -0.104,0.2754 -0.0527,0.0977 -0.1274,0.207 -0.2231,0.3242 -0.0962,0.1191 -0.2231,0.2578 -0.3818,0.4141 L 6.9936,26.302 h 1.063 c 0.0142,0 0.0269,0.0039 0.0391,0.0117 0.0117,0.0098 0.0215,0.0215 0.0298,0.0391 0.0088,0.0176 0.0146,0.041 0.019,0.0684 0.0039,0.0293 0.0063,0.0625 0.0063,0.1016 z"
         id="path2897" />
    </g>
    <g
       id="g2240">
      <g
         style="isolation: isolate;"
         id="g2903">
        <path
           d="m 35.6328,21.5688 c 0,0.4307 -0.0488,0.8164 -0.1445,1.1562 -0.0957,0.3398 -0.2383,0.6279 -0.4277,0.8643 -0.1885,0.2373 -0.4229,0.418 -0.7021,0.542 -0.2793,0.125 -0.6016,0.1875 -0.9688,0.1875 -0.3613,0 -0.6777,-0.0537 -0.9473,-0.1592 -0.2696,-0.1055 -0.4941,-0.2666 -0.6738,-0.4834 -0.1797,-0.2168 -0.3145,-0.4922 -0.4043,-0.8271 -0.0898,-0.3349 -0.1348,-0.7305 -0.1348,-1.1885 0,-0.4199 0.0479,-0.7979 0.1445,-1.1338 0.0957,-0.3359 0.2383,-0.6221 0.4277,-0.8574 0.1885,-0.2354 0.4229,-0.416 0.7021,-0.542 0.2792,-0.126 0.6035,-0.1885 0.9717,-0.1885 0.3525,0 0.6631,0.0527 0.9326,0.1562 0.2695,0.1045 0.4951,0.2656 0.6758,0.4824 0.1816,0.2168 0.3174,0.4902 0.4102,0.8203 0.0918,0.3311 0.1387,0.7207 0.1387,1.1709 z m -0.9922,0.0557 c 0,-0.2725 -0.0195,-0.5215 -0.0576,-0.7441 -0.0381,-0.2236 -0.1035,-0.415 -0.1963,-0.5742 -0.0918,-0.1592 -0.2148,-0.2822 -0.3682,-0.3691 -0.1533,-0.0879 -0.3447,-0.1309 -0.5752,-0.1309 -0.2324,0 -0.4258,0.0488 -0.582,0.1465 -0.1553,0.0977 -0.2812,0.2285 -0.377,0.3916 -0.0958,0.1631 -0.1641,0.3535 -0.2031,0.5723 -0.04,0.2178 -0.0596,0.4482 -0.0596,0.6924 0,0.2832 0.0195,0.5381 0.0576,0.7646 0.0381,0.2256 0.1025,0.4189 0.1943,0.5801 0.0908,0.1602 0.2129,0.2832 0.3662,0.3672 0.1533,0.084 0.3467,0.126 0.5791,0.126 0.2324,0 0.4258,-0.0479 0.582,-0.1445 0.1553,-0.0957 0.2812,-0.2266 0.377,-0.3926 0.0958,-0.166 0.1641,-0.3594 0.2031,-0.5801 0.04,-0.2207 0.0596,-0.4561 0.0596,-0.7051 z"
           id="path2901" />
      </g>
      <g
         style="isolation: isolate;"
         id="g2907">
        <path
           d="m 38.6631,25.9526 c 0,0.04 -10e-4,0.0742 -0.0049,0.1025 -0.0039,0.0283 -0.0088,0.0518 -0.0156,0.0703 -0.0068,0.0176 -0.0156,0.0303 -0.0273,0.0381 -0.0107,0.0078 -0.0234,0.0117 -0.0371,0.0117 h -1.5518 c -0.0303,0 -0.0566,-0.0029 -0.0791,-0.0088 -0.0225,-0.0049 -0.04,-0.0156 -0.0547,-0.0322 -0.0137,-0.0156 -0.0234,-0.0391 -0.0293,-0.0693 -0.0068,-0.0303 -0.0098,-0.0703 -0.0098,-0.1191 0,-0.0459 0.002,-0.085 0.0059,-0.1182 0.0049,-0.0322 0.0117,-0.0615 0.0234,-0.0869 0.0107,-0.0264 0.0254,-0.0508 0.043,-0.0752 0.0166,-0.0244 0.0391,-0.0508 0.0674,-0.0801 l 0.4668,-0.501 c 0.0938,-0.0967 0.168,-0.1855 0.2256,-0.2656 0.0566,-0.0801 0.1016,-0.1533 0.1338,-0.2188 0.0312,-0.0664 0.0537,-0.127 0.0654,-0.1826 0.0117,-0.0556 0.0176,-0.1084 0.0176,-0.1582 0,-0.0459 -0.0078,-0.0898 -0.0215,-0.1309 -0.0146,-0.041 -0.0361,-0.0762 -0.0654,-0.1074 -0.0283,-0.0303 -0.0645,-0.0547 -0.1074,-0.0713 -0.043,-0.0176 -0.0938,-0.0264 -0.1523,-0.0264 -0.082,0 -0.1543,0.0107 -0.2178,0.0312 -0.0625,0.0205 -0.1182,0.0439 -0.166,0.0693 -0.0488,0.0264 -0.0889,0.0498 -0.1201,0.0713 -0.0322,0.0215 -0.0576,0.0322 -0.0752,0.0322 -0.0127,0 -0.0234,-0.0039 -0.0322,-0.0127 -0.0088,-0.0078 -0.0166,-0.0215 -0.0225,-0.041 -0.0049,-0.0195 -0.0098,-0.0459 -0.0137,-0.0781 -0.0029,-0.0332 -0.0049,-0.0732 -0.0049,-0.1201 0,-0.0322 0.001,-0.0586 0.0029,-0.0801 0.0019,-0.0215 0.0059,-0.041 0.0098,-0.0566 0.0039,-0.0156 0.0098,-0.0303 0.0166,-0.042 0.0068,-0.0117 0.0195,-0.0254 0.0361,-0.043 0.0176,-0.0166 0.0498,-0.0371 0.0967,-0.0635 0.0459,-0.0254 0.1035,-0.0508 0.1719,-0.0752 0.0684,-0.0234 0.1426,-0.0439 0.2246,-0.0615 0.082,-0.0166 0.168,-0.0244 0.2568,-0.0244 0.1406,0 0.2627,0.0176 0.3682,0.0527 0.1045,0.0361 0.1924,0.085 0.2617,0.1484 0.0693,0.0634 0.1211,0.1387 0.1553,0.2246 0.0342,0.0869 0.0508,0.1807 0.0508,0.2812 0,0.0869 -0.0078,0.1738 -0.0244,0.2578 -0.0166,0.085 -0.0518,0.1768 -0.1045,0.2744 -0.0527,0.0986 -0.127,0.207 -0.2236,0.3252 -0.0957,0.1191 -0.2227,0.2568 -0.3809,0.4141 l -0.3154,0.3232 h 1.0635 c 0.0137,0 0.0273,0.0039 0.0391,0.0127 0.0118,0.0088 0.0215,0.0215 0.0303,0.0381 0.0078,0.0176 0.0146,0.041 0.0186,0.0693 0.004,0.0283 0.0059,0.0625 0.0059,0.1016 z"
           id="path2905" />
      </g>
    </g>
    <g
       style="isolation: isolate;"
       id="g2912">
      <path
         d="m 15.2339,1.5513 c 0,0.1001 -0.0239,0.1704 -0.0723,0.2104 -0.0479,0.0396 -0.1245,0.0596 -0.229,0.0596 h -2.7261 c -0.1089,0 -0.1875,-0.0205 -0.2358,-0.061 -0.0479,-0.0405 -0.0718,-0.1104 -0.0718,-0.209 0,-0.0972 0.0239,-0.1655 0.0718,-0.2056 0.0483,-0.0396 0.127,-0.0596 0.2358,-0.0596 h 2.7261 c 0.0522,0 0.0972,0.0044 0.1343,0.0127 0.0371,0.0088 0.0688,0.0234 0.0947,0.0444 0.0264,0.0205 0.0449,0.0483 0.0557,0.083 0.0112,0.0347 0.0166,0.0762 0.0166,0.125 z"
         id="path2910" />
    </g>
    <g
       style="isolation: isolate;"
       id="g2916">
      <path
         d="m 27.4072,1.5415 c 0,0.0601 -0.0039,0.1104 -0.0098,0.1509 -0.0068,0.0405 -0.0166,0.0732 -0.0293,0.0977 -0.0127,0.0245 -0.0273,0.042 -0.0449,0.0527 -0.0166,0.0107 -0.0352,0.0161 -0.0547,0.0161 h -0.998 v 1.0864 c 0,0.0215 -0.0049,0.04 -0.0156,0.0562 -0.0107,0.0162 -0.0293,0.0298 -0.0547,0.0415 -0.0264,0.0117 -0.0605,0.021 -0.1025,0.0273 -0.043,0.0063 -0.0967,0.0093 -0.1611,0.0093 -0.0644,0 -0.1172,-0.0029 -0.1602,-0.0093 C 25.7334,3.0639 25.6993,3.0547 25.6739,3.043 25.6475,3.0313 25.629,3.0176 25.6173,3.0015 25.6056,2.9854 25.5997,2.9668 25.5997,2.9453 V 1.8589 H 24.6046 C 24.586,1.8589 24.5675,1.8535 24.5519,1.8428 24.5363,1.8321 24.5216,1.8145 24.5089,1.7901 24.4952,1.7657 24.4855,1.733 24.4777,1.6924 24.4709,1.6519 24.467,1.6016 24.467,1.5415 c 0,-0.0576 0.0029,-0.1074 0.0098,-0.1489 0.0059,-0.0415 0.0156,-0.0747 0.0273,-0.0991 0.0117,-0.0249 0.0244,-0.0425 0.04,-0.0532 0.0146,-0.0107 0.0322,-0.0161 0.0508,-0.0161 h 1.0049 V 0.1411 c 0,-0.0215 0.0059,-0.041 0.0176,-0.0591 C 25.6291,0.0639 25.6477,0.0488 25.674,0.0371 25.6994,0.0254 25.7336,0.0161 25.7765,0.0098 25.8194,0.0035 25.8722,0 25.9367,0 c 0.0645,0 0.1182,0.0034 0.1611,0.0098 0.042,0.0063 0.0762,0.0156 0.1025,0.0273 0.0254,0.0117 0.0439,0.0269 0.0547,0.0449 0.0108,0.018 0.0156,0.0376 0.0156,0.0591 v 1.083 h 1.0078 c 0.0176,0 0.0342,0.0054 0.0498,0.0161 0.0156,0.0107 0.0303,0.0283 0.042,0.0532 0.0117,0.0244 0.0205,0.0576 0.0273,0.0991 0.0059,0.0415 0.0098,0.0913 0.0098,0.1489 z"
         id="path2914" />
    </g>
    <rect
       id="rect30-9"
       x="11.7418"
       y="4.6564999"
       width="4.0812998"
       height="1.1823" />
    <rect
       id="rect30-9-1"
       x="24.0406"
       y="4.6574001"
       width="4.0812998"
       height="1.1822" />
  </g>
  `
]
export const generic = [
  '50 40',
  `
  <defs
   id="defs5" />
  </sodipodi:namedview>
   <g
     id="path3756"
     transform="translate(4.49692,0.5)">
    <path
       d="m 22.26434,2.00304 v 15.91139 l 2.61798,-0.85055 12.51492,-4.06594 1.08884,3.35147 -12.51502,4.06646 -2.61848,0.85082 1.6187,2.22714 7.73465,10.64196 -2.85088,2.07077 L 22.1228,25.56342 20.50495,23.33652 18.88682,25.56321 11.152,36.207 8.29859,34.13525 l 7.7341,-10.6449 1.61798,-2.22691 -2.61786,-0.85075 -12.51271,-4.06638 1.08878,-3.35109 12.51171,4.0656 2.61807,0.85073 V 2.00304 h 3.52569 M 16.73865,0 V 15.15871 L 2.32478,10.47502 0,17.63029 14.41466,22.31477 5.5046,34.57821 11.59466,38.99997 20.50472,26.73895 29.41239,39 35.49995,34.57824 26.58911,22.31798 41.00616,17.6335 38.68139,10.47783 24.26434,15.16175 V 0.00304 h -7.52563 z"
       id="path2154" />
  </g>
  `
]
export const grid = [
  '50 40',
  `
  <defs
     id="defs7" />
  
  <path
     style="fill-opacity:1; stroke-miterlimit: 10; stroke-width: .5px;"
     d="m 27.989964,1.8849786 -9.81e-4,0.00276 -3.976158,10.6362314 -0.685137,1.832745 1.898203,-0.474553 8.971079,-2.242968 -12.327559,26.43119 c -0.0076,0.01506 -0.01385,0.02591 -0.01622,0.0317 -0.0028,6.27e-4 -0.0061,0.0013 -0.0098,0.002 l 4.529467,-18.413484 0.405487,-1.648394 -1.648904,0.403456 -9.222663,2.256609 -0.146989,-2.45e-4 -0.0024,-0.0024 4.620853,-18.7784409 c 0.07029,-0.032489 0.09176,-0.036186 0.124875,-0.036186 h 7.486806 m 0.06789,-1.0286956 h -7.554705 c -0.298214,0 -0.49702,0.099408 -0.695826,0.1988158 -0.198806,0.099398 -0.298214,0.298204 -0.397622,0.4970198 L 14.737676,20.53831 c -0.09941,0.397621 0,0.695825 0.298214,0.894641 0.198806,0.198806 0.397612,0.298204 0.695825,0.298204 h 0.298214 l 9.34402,-2.286284 -4.572587,18.588569 c -0.05514,0.259576 0,0.497019 0.09941,0.695825 0.0994,0.198806 0.257949,0.35161 0.568901,0.397612 0.07167,0.0106 0.153236,0.01684 0.229903,0.01684 0.03267,0 0.06446,-0.0012 0.09418,-0.0035 0.486782,-0.01613 0.796881,-0.212104 0.995687,-0.609716 L 35.214947,11.890166 c 0.09941,-0.298214 0.111146,-0.771767 0,-0.99404 -0.125728,-0.251476 -0.453185,-0.336282 -0.751399,-0.336282 -0.0994,0 -0.242052,0.01211 -0.342039,0.03807 l -9.145172,2.286293 3.976158,-10.6362322 c 0.0994,-0.099408 0.0994,-0.2982139 0.0994,-0.3976218 0,-0.298204 -0.0994,-0.4970198 -0.298204,-0.6958258 C 28.554883,0.9556909 28.356077,0.856283 28.057864,0.856283 Z"
   />
  `
]
export const heatingelement = [
  '49.999998 40',
  `
  <defs
     id="defs912" />
  
  <g
     id="g1577"
     transform="translate(-0.02268035,-0.54294373)">
    <path
       style="stroke-miterlimit: 10;stroke-width: .5px;"
       d="M 46.88857,30.857764 H 3.1558104 c -0.7793348,0 -1.4132347,-0.614477 -1.4132347,-1.369019 V 4.9626735 c 0,-0.7550755 0.6339098,-1.3690191 1.4132347,-1.3690191 H 46.88857 c 0.779815,0 1.414215,0.6139436 1.414215,1.3690191 V 29.488756 c 0,0.754531 -0.6344,1.36902 -1.414215,1.36902 z M 3.1558104,4.7053676 c -0.2488746,0 -0.4138183,0.154706 -0.4138183,0.2573059 V 29.488756 c 0,0.102059 0.1649437,0.257307 0.4138183,0.257307 H 46.88857 c 0.248874,0 0.414798,-0.155252 0.414798,-0.257307 V 4.9626735 c 0,-0.1026003 -0.165924,-0.2573059 -0.414798,-0.2573059 z"
       id="path1055" />
    <path
       style="stroke-miterlimit: 10;stroke-width: .5px;"
       d="m 26.39451,37.3909 -0.7832,-0.62305 c 0.42676,-0.53516 0.72461,-1.08105 0.91211,-1.66895 0.63379,-1.98633 -0.15332,-4.11133 -0.98633,-6.3623 -1.1958,-3.22949 -2.55078,-6.8916 0.375,-10.67383 l 0.79102,0.6123 c -2.58643,3.34375 -1.3877,6.58203 -0.22852,9.71484 0.85547,2.31055 1.74023,4.69922 1.00195,7.0127 -0.22168,0.69531 -0.58594,1.36426 -1.08203,1.98828 z"
       id="path1057" />
    <path
       id="path5222"
       d="m 24.95698,14.43791 -2.80658,6 h 5.56481 z" />
    <path
       d="m 28.13767,20.70877 h -6.41309 l 3.23438,-6.91504 z m -5.56152,-0.542 h 4.71582 l -2.33691,-5.08496 z"
       id="path1060" />
    <path
       style="stroke-miterlimit: 10;stroke-width: .5px;"
       d="m 36.84666,37.3909 -0.7832,-0.62305 c 0.42676,-0.53516 0.72461,-1.08105 0.91211,-1.66895 0.63379,-1.98633 -0.15332,-4.11133 -0.98633,-6.3623 -1.19531,-3.22949 -2.55078,-6.8916 0.375,-10.67334 l 0.79102,0.61133 c -2.58594,3.34424 -1.3877,6.58252 -0.22754,9.71533 0.85449,2.30957 1.73926,4.69922 1.00098,7.0127 -0.22168,0.69531 -0.58594,1.36426 -1.08203,1.98828 z"
       id="path1064" />
    <path
       id="path5222-2"
       d="m 35.4092,14.43791 -2.80658,6 h 5.56481 z" />
    <path
       d="m 38.58982,20.70877 h -6.41309 l 3.23438,-6.91504 z m -5.56152,-0.542 h 4.71582 l -2.33691,-5.08496 z"
       id="path1067" />
    <path
       style="stroke-miterlimit: 10;stroke-width: .5px;"
       d="m 15.94285,37.38992 -0.7832,-0.62109 c 0.42627,-0.53711 0.72461,-1.08301 0.9126,-1.6709 0.63281,-1.98535 -0.15381,-4.11035 -0.98682,-6.36035 -1.1958,-3.23047 -2.55078,-6.8916 0.375,-10.6748 l 0.79102,0.6123 c -2.58643,3.34375 -1.3877,6.58301 -0.22803,9.71484 0.85498,2.31055 1.73926,4.69922 1.00146,7.0127 -0.22217,0.69434 -0.58594,1.36328 -1.08203,1.9873 z"
       id="path1071" />
    <path
       id="path5222-3"
       d="m 14.50505,14.43791 -2.80658,6 h 5.56481 z" />
    <path
       d="m 17.68601,20.70877 h -6.41309 l 3.23389,-6.91504 z m -5.56152,-0.542 h 4.71582 l -2.3374,-5.08496 z"
       id="path1074" />
  </g>
  `
]
export const heatpump = [
  '50 40',
  `
  <g
     id="g1026"
     transform="translate(5.75,0.75)">
    <path
       style="stroke-miterlimit: 10; stroke-width: .5px;"
       d="m 19.25,33.69531 c -7.96484,0 -14.44482,-6.48047 -14.44482,-14.44531 0,-7.96484 6.47998,-14.44482 14.44482,-14.44482 7.96484,0 14.44531,6.47998 14.44531,14.44482 0,7.96484 -6.48047,14.44531 -14.44531,14.44531 z m 0,-28.00049 c -7.47412,0 -13.55518,6.08105 -13.55518,13.55518 0,7.47461 6.08105,13.55469 13.55518,13.55469 7.47461,0 13.55469,-6.08008 13.55469,-13.55469 0,-7.47412 -6.08008,-13.55518 -13.55469,-13.55518 z m -1.125,24.54541 c -0.26953,0 -0.56543,-0.02148 -0.88086,-0.08789 -0.46582,-0.09961 -0.92676,-0.26465 -1.33398,-0.47852 -0.41699,-0.21289 -0.77588,-0.47754 -1.06201,-0.78516 -0.28906,-0.32031 -0.48779,-0.69141 -0.59521,-1.10742 -0.10498,-0.41211 -0.14062,-0.83887 -0.1001,-1.20215 0.03613,-0.44238 0.16211,-0.79297 0.39551,-1.08984 0.1626,-0.22168 0.40234,-0.42969 0.63428,-0.63086 l 0.24316,-0.21484 c 0.29248,-0.26562 0.57568,-0.56738 0.8335,-0.85059 0.22803,-0.25098 0.46338,-0.51074 0.60645,-0.74902 0.09961,-0.18066 0.16895,-0.38672 0.19971,-0.59961 0.0166,-0.12207 0.05225,-0.38086 0.0054,-0.49023 -0.04639,-0.10645 -0.16309,-0.2168 -0.29785,-0.34375 -0.23145,-0.21191 -0.30762,-0.23926 -0.33057,-0.24316 -0.05908,0.0098 -0.25342,0.1377 -0.40967,0.24023 l -0.10889,0.07129 c -0.48682,0.30273 -0.96582,0.53027 -1.47217,0.69922 -0.63916,0.21289 -1.4043,0.35059 -2.09961,0.37793 -0.71484,0.03516 -1.38232,-0.07129 -1.92041,-0.29004 C 9.93946,22.26465 9.53419,21.96191 9.15528,21.5127 8.80714,21.11231 8.55421,20.65625 8.38575,20.12208 8.21827,19.60157 8.10987,18.95362 8.08106,18.29933 c -0.0293,-0.6665 0.0498,-1.35107 0.22266,-1.92725 0.16406,-0.54639 0.44434,-1.05908 0.81152,-1.48145 0.32959,-0.37988 0.70703,-0.65527 1.15332,-0.84033 0.45215,-0.16943 0.92822,-0.22656 1.31982,-0.16113 0.45703,0.06152 0.79736,0.28223 1.04199,0.46729 0.29492,0.22363 0.56982,0.49268 0.87305,0.79639 l 0.32031,0.32861 c 0.24023,0.24951 0.49609,0.51611 0.74023,0.72461 0.32666,0.27881 0.63818,0.42725 0.90479,0.54492 0.30713,0.13574 0.53369,0.19434 0.64355,0.2041 0.06934,0.0083 0.12109,-0.01074 0.26367,-0.0625 0.23047,-0.08252 0.30811,-0.20508 0.3457,-0.29834 0.10938,-0.26318 0.04883,-0.50146 0.01074,-0.60547 l -0.03711,-0.08447 0.002,-4.9e-4 c -0.04932,-0.11279 -0.15967,-0.35889 -0.28516,-0.61377 -0.16602,-0.27783 -0.50391,-0.89746 -0.71191,-1.57959 -0.15527,-0.51025 -0.22607,-1.05859 -0.21484,-1.67725 0.0093,-0.51953 0.09033,-1.06982 0.22363,-1.50977 0.14844,-0.43604 0.3584,-0.79004 0.66504,-1.13037 0.29443,-0.32471 0.68506,-0.62695 1.16016,-0.89844 0.43311,-0.23828 0.99707,-0.45459 1.55273,-0.59619 0.25391,-0.05957 0.49121,-0.09131 0.73438,-0.09814 0.21387,-0.00635 0.43555,0.00439 0.66602,0.02344 0.4541,0.0376 0.96289,0.13916 1.43164,0.28564 0.50586,0.14746 0.9082,0.33984 1.25781,0.604 0.3584,0.28076 0.7041,0.67236 0.93164,1.05176 0.24219,0.41455 0.28418,0.77588 0.29395,1.10547 0.0078,0.25977 0.0029,0.65039 -0.12988,1.03857 -0.11035,0.31836 -0.30957,0.63428 -0.59277,0.94141 -0.1377,0.14258 -0.28613,0.27148 -0.43945,0.40332 -0.11035,0.0957 -0.22461,0.19336 -0.33398,0.2998 -0.20605,0.19092 -0.37012,0.38818 -0.52441,0.57275 l -0.10449,0.12451 c -0.18359,0.21729 -0.33496,0.40088 -0.48535,0.62695 -0.15039,0.22559 -0.25391,0.43701 -0.30664,0.62793 -0.07812,0.28369 -0.07617,0.45996 -0.07324,0.50684 9.8e-4,0.11426 0.0068,0.12305 0.02734,0.15283 0,-0.0054 0.03711,0.0249 0.08496,0.06738 0.07031,0.0625 0.14453,0.12939 0.21387,0.20361 0.09766,0.10645 0.20508,0.22363 0.25488,0.24512 -9.8e-4,4.9e-4 0.05664,0.01318 0.27539,-0.09277 0.16992,-0.08252 0.37598,-0.20557 0.59473,-0.33496 0.15039,-0.08936 0.30664,-0.18164 0.45996,-0.26758 0.38574,-0.22412 0.79004,-0.40967 1.19336,-0.54834 0.42773,-0.13916 0.82617,-0.20898 1.30078,-0.22852 0.47461,-0.02979 0.97266,0.0034 1.42676,0.09814 0.48438,0.08008 0.93066,0.24121 1.27148,0.4624 0.3877,0.23633 0.65723,0.57471 0.89941,0.90039 0.23438,0.32471 0.45508,0.7041 0.65918,1.13379 0.20703,0.47021 0.32324,0.88867 0.36914,1.32812 0.06445,0.42725 0.06836,0.89893 0.0088,1.34326 -0.04199,0.35938 -0.12305,0.73242 -0.24805,1.13184 -0.09473,0.30957 -0.21582,0.6709 -0.44434,1.01855 -0.22363,0.3418 -0.48828,0.63672 -0.76465,0.85449 -0.31934,0.24219 -0.64062,0.39844 -0.98828,0.4834 -0.36426,0.08887 -0.74707,0.10254 -1.13574,0.04199 -0.4541,-0.05566 -0.85352,-0.18848 -1.17578,-0.39258 -0.32422,-0.20703 -0.55273,-0.48438 -0.75488,-0.72852 l -0.06738,-0.08301 c -0.19336,-0.24414 -0.39648,-0.47266 -0.61523,-0.69238 -0.17871,-0.17871 -0.40332,-0.36035 -0.70605,-0.57324 -0.25977,-0.18164 -0.51172,-0.31836 -0.69043,-0.37598 -0.2793,-0.10156 -0.53418,-0.07031 -0.56445,-0.0625 -0.0088,0.02148 -0.04688,0.07031 -0.10449,0.13574 l -0.12402,0.1416 c -0.1416,0.14941 -0.3252,0.35645 -0.49023,0.54492 -0.0127,0.0127 -0.02539,0.02441 -0.03613,0.03418 0.03711,0.06836 0.10059,0.17773 0.21094,0.35059 0.19336,0.30273 0.4502,0.7168 0.66992,1.14844 0.22363,0.45605 0.38867,0.92871 0.46777,1.33691 0.05859,0.2959 0.07324,0.54492 0.08496,0.74414 l 0.01074,0.15723 c 0.01953,0.22656 0.0293,0.35645 0.0098,0.66211 -0.0098,0.29688 -0.0498,0.75488 -0.18066,1.16602 -0.12109,0.41699 -0.34473,0.78613 -0.7002,1.15332 -0.31836,0.31934 -0.75684,0.66113 -1.14844,0.89941 -0.37109,0.22559 -0.70703,0.36816 -1.12402,0.47656 -0.42871,0.1084 -0.92725,0.15137 -1.26562,0.1748 -0.14062,0.0088 -0.29199,0.0166 -0.45215,0.0166 z m -1.67871,-9.76269 c 0.35742,0 0.65332,0.22559 0.896,0.44629 0.22168,0.20996 0.4248,0.40234 0.54443,0.6748 0.13574,0.31348 0.10205,0.66504 0.06006,0.96973 -0.04639,0.32227 -0.15039,0.63086 -0.30957,0.91992 -0.19629,0.32715 -0.46191,0.62012 -0.71875,0.90234 -0.27637,0.30469 -0.58008,0.62598 -0.89355,0.91113 l -0.25879,0.22852 c -0.2041,0.17676 -0.39697,0.34473 -0.50928,0.49805 -0.13281,0.16895 -0.19531,0.35547 -0.21826,0.63574 -0.02979,0.26953 -0.0015,0.59082 0.07666,0.89551 0.07178,0.2793 0.19922,0.51758 0.38916,0.72852 0.21338,0.22852 0.48145,0.42578 0.81494,0.5957 0.33594,0.17676 0.72852,0.31641 1.10986,0.39746 0.39746,0.08398 0.77295,0.07324 1.08838,0.05371 0.30322,-0.02051 0.74805,-0.05859 1.10352,-0.14844 0.33008,-0.08594 0.58691,-0.19531 0.88477,-0.37598 0.3291,-0.2002 0.71289,-0.49902 0.97559,-0.76172 0.25195,-0.26074 0.39844,-0.49805 0.4834,-0.78906 0.1084,-0.34082 0.13574,-0.74023 0.14258,-0.94922 0.01562,-0.25879 0.0078,-0.36133 -0.0078,-0.54297 l -0.01172,-0.18164 c -0.01074,-0.16699 -0.02148,-0.37598 -0.07031,-0.625 -0.06445,-0.33008 -0.20703,-0.73438 -0.39062,-1.11035 -0.20312,-0.39746 -0.44434,-0.78418 -0.625,-1.06836 -0.23242,-0.36523 -0.35547,-0.58691 -0.38574,-0.78711 -0.05176,-0.3418 0.15625,-0.53711 0.30859,-0.67969 0.1582,-0.17969 0.35156,-0.39844 0.49023,-0.54395 l 0.10449,-0.12012 c 0.10254,-0.11816 0.17578,-0.19824 0.25586,-0.26172 0.20605,-0.1875 0.47363,-0.1875 0.63379,-0.1875 0.18066,0 0.42773,0 0.74219,0.11719 0.32129,0.10254 0.67383,0.32227 0.91016,0.48828 0.21875,0.15234 0.54199,0.38867 0.8252,0.67285 0.24414,0.24316 0.46875,0.49707 0.68359,0.76855 0.23242,0.28223 0.39746,0.48242 0.60254,0.61328 0.20898,0.13281 0.48535,0.2207 0.82129,0.2627 0.28613,0.04395 0.55176,0.0332 0.80273,-0.02637 0.22656,-0.05469 0.44043,-0.16016 0.6543,-0.32227 0.19238,-0.15234 0.39551,-0.38086 0.56445,-0.6377 0.14746,-0.22656 0.23926,-0.47168 0.33789,-0.79492 0.10938,-0.34766 0.17969,-0.66699 0.21484,-0.97852 0.0498,-0.37109 0.04688,-0.75586 -0.0078,-1.12061 -0.03809,-0.36426 -0.13184,-0.69775 -0.2959,-1.06982 -0.17578,-0.36914 -0.36816,-0.70215 -0.56738,-0.97803 -0.19434,-0.26172 -0.39355,-0.51416 -0.65527,-0.67334 -0.25,-0.16162 -0.5791,-0.27734 -0.96191,-0.34131 -0.3877,-0.08057 -0.81445,-0.11035 -1.21582,-0.0835 -0.40039,0.01611 -0.72559,0.07275 -1.06543,0.18359 -0.3418,0.11719 -0.69238,0.27881 -1.03516,0.47754 -0.15332,0.08545 -0.30273,0.17432 -0.44727,0.25977 -0.24121,0.14355 -0.4707,0.27881 -0.65918,0.37012 -0.28711,0.13867 -0.62793,0.26074 -0.98828,0.12109 -0.24023,-0.09375 -0.41797,-0.28809 -0.54785,-0.43018 -0.08301,-0.08984 -0.13672,-0.13721 -0.1875,-0.18164 -0.07031,-0.0625 -0.13574,-0.12207 -0.18945,-0.18066 -0.16797,-0.23486 -0.22168,-0.41943 -0.22168,-0.68115 -0.01172,-0.19873 0.02539,-0.48047 0.10547,-0.76807 0.07812,-0.28271 0.2207,-0.58008 0.42383,-0.88525 0.16992,-0.25439 0.33887,-0.4624 0.5459,-0.70752 l 0.10156,-0.12109 c 0.17676,-0.21143 0.36621,-0.43604 0.59473,-0.64795 0.11621,-0.1123 0.24219,-0.22119 0.36523,-0.32764 0.13184,-0.11328 0.25977,-0.22217 0.37207,-0.33936 0.19141,-0.20703 0.33203,-0.42383 0.39941,-0.62061 0.06543,-0.18994 0.0918,-0.41992 0.08301,-0.72266 -0.0088,-0.26416 -0.03809,-0.45068 -0.1709,-0.67871 C 23.17288,9.9355 22.90042,9.62788 22.63382,9.41841 22.37601,9.22407 22.07425,9.0815 21.66214,8.96138 21.25101,8.83296 20.79886,8.74263 20.41409,8.7104 20.21878,8.69429 20.03421,8.68061 19.84866,8.68989 h -0.0019 c -0.18164,0.00537 -0.36133,0.0293 -0.54785,0.07275 -0.4707,0.12012 -0.9707,0.31104 -1.3291,0.5083 -0.38232,0.21826 -0.70801,0.46826 -0.93555,0.71924 -0.22559,0.25 -0.37354,0.49902 -0.47852,0.80615 -0.10352,0.34375 -0.17285,0.81787 -0.18066,1.25244 -0.0093,0.52393 0.04883,0.98242 0.17676,1.40186 0.13184,0.43359 0.36621,0.94971 0.64258,1.41602 0.18018,0.36475 0.29199,0.5918 0.34863,0.75098 0.09033,0.21729 0.24463,0.73096 0.0024,1.31445 -0.14893,0.36768 -0.43213,0.64258 -0.7959,0.77148 -0.24609,0.09033 -0.44287,0.1626 -0.71777,0.13818 -0.30762,-0.02783 -0.67139,-0.16553 -0.92188,-0.27637 -0.34814,-0.15332 -0.72559,-0.34229 -1.12402,-0.68262 -0.26416,-0.22559 -0.54297,-0.51367 -0.80322,-0.78418 l -0.30811,-0.31689 c -0.33936,-0.33887 -0.55371,-0.54297 -0.78223,-0.71631 -0.23975,-0.18164 -0.42432,-0.26758 -0.63623,-0.29639 -0.24951,-0.04102 -0.57422,9.8e-4 -0.86084,0.10889 -0.30127,0.12549 -0.57031,0.32227 -0.80762,0.59619 -0.19922,0.229 -0.46973,0.61475 -0.63135,1.15381 -0.14502,0.48291 -0.21094,1.06299 -0.18652,1.63232 0.02588,0.57715 0.11963,1.14209 0.26416,1.59131 0.1333,0.42383 0.32275,0.7666 0.59766,1.08203 0.29102,0.34473 0.57812,0.56152 0.93604,0.70801 0.41992,0.1709 0.9502,0.25 1.54932,0.22559 0.60596,-0.02441 1.29883,-0.14941 1.85303,-0.33301 0.43896,-0.14746 0.85645,-0.3457 1.27637,-0.60645 l 0.09814,-0.06445 c 0.31494,-0.20703 0.5874,-0.38574 0.90186,-0.38574 z"
       id="path280" />
    <path
       style="stroke-miterlimit: 10; stroke-width: .5px;"
       d="m 36.25,1.2 c 0.57897,0 1.05,0.47103 1.05,1.05 v 34 c 0,0.57897 -0.47103,1.05 -1.05,1.05 h -34 C 1.67103,37.3 1.2,36.82897 1.2,36.25 v -34 C 1.2,1.67103 1.67103,1.2 2.25,1.2 h 34 m 0,-0.95 h -34 c -1.10457,0 -2,0.89543 -2,2 v 34 c 0,1.10457 0.89543,2 2,2 h 34 c 1.10457,0 2,-0.89543 2,-2 v -34 c 0,-1.10457 -0.89543,-2 -2,-2 z"
       id="path282" />
  </g>
  `
]
export const pv = [
  '50 40',
  `
  <defs
     id="defs9" />
  
  <g
     id="g471"
     transform="matrix(0.98145523,0,0,0.98145523,8.4624794,0.94616557)">
    <path
       id="SolarInput_Sun_Icon"
       data-name="SolarInput Sun Icon"
       style="stroke-miterlimit: 10; stroke-width: .5px;"
       d="M 16.87108,1.56202 19.6688,5.35247 C 18.76764,5.12762 17.86829,5.01423 16.97984,5.01423 c -0.97709,0 -1.9672,0.1371 -2.95858,0.40882 L 16.87108,1.56201 M 7.86522,4.42159 12.55599,5.92264 C 12.52477,5.93538 12.49357,5.94824 12.46236,5.96124 11.09331,6.53169 9.89139,7.34289 8.78869,8.44084 8.46517,8.73075 8.1564,9.05848 7.86522,9.41978 V 4.42159 m 18.01172,0 v 4.7814 C 25.66804,8.95761 25.44638,8.71727 25.21174,8.48162 24.30161,7.46598 23.01793,6.59483 21.49731,5.96124 21.43407,5.93489 21.37077,5.90907 21.30749,5.88381 L 25.87693,4.42159 M 7.13321,10.45873 c -0.32206,0.52209 -0.61228,1.09046 -0.86478,1.69646 -0.48831,1.17196 -0.78958,2.3511 -0.89961,3.51747 H 5.08608 l -2.72195,-3.68781 4.7691,-1.52612 m 19.72384,0.0794 4.52098,1.44672 -2.72195,3.68781 h -0.06522 c -0.11004,-1.16637 -0.4113,-2.34551 -0.89961,-3.51747 -0.23584,-0.56599 -0.51281,-1.1034 -0.83419,-1.61706 M 16.87108,0.25 c -0.21752,0 -0.32628,0.10876 -0.43504,0.21752 L 13.0645,5.03541 7.62654,3.29526 C 7.56284,3.26341 7.50844,3.25021 7.45793,3.25021 7.33596,3.25021 7.23656,3.32711 7.08274,3.40402 6.97398,3.51278 6.86522,3.7303 6.86522,3.83906 V 9.49454 L 1.42725,11.2347 c -0.21752,0.10875 -0.32628,0.21751 -0.32628,0.32627 -0.10876,0.21752 0,0.32628 0.10876,0.5438 l 3.37154,4.56789 h 1.74015 c 0,-1.41387 0.32628,-2.82774 0.87008,-4.13285 0.54379,-1.30511 1.30511,-2.50147 2.28394,-3.37154 0.97884,-0.97884 2.06643,-1.74015 3.37154,-2.28395 1.30512,-0.5438 2.71899,-0.87008 4.13286,-0.87008 1.41387,0 2.82774,0.32628 4.13286,0.87008 1.30511,0.5438 2.50146,1.30511 3.37153,2.28395 0.97884,0.97883 1.74015,2.06643 2.28395,3.37154 0.5438,1.30511 0.87008,2.71898 0.87008,4.13285 h 1.52263 l 3.37154,-4.56789 c 0.10876,-0.10876 0.10876,-0.32628 0.10876,-0.5438 0,-0.21752 -0.21752,-0.32627 -0.32628,-0.32627 L 26.87694,9.49454 V 3.83906 c 0,-0.21752 -0.10876,-0.32628 -0.21752,-0.43504 C 26.44191,3.29526 26.33315,3.29526 26.11563,3.29526 L 20.67766,5.03541 17.30612,0.46752 C 17.19736,0.35876 17.0886,0.25 16.87108,0.25 Z" />
    <path
       id="SolarInput_Icon"
       data-name="SolarInput Icon"
       style="stroke-miterlimit: 10; stroke-width: .5px;"
       d="m 31.75,19.49718 c 0.21774,0 0.39245,0.07331 0.54984,0.2307 0.15739,0.15739 0.2307,0.3321 0.2307,0.54984 v 5.8 c 0,0.21774 -0.07331,0.39245 -0.2307,0.54984 -0.12074,0.12074 -0.38281,0.2307 -0.54984,0.2307 h -5.8 c -0.21774,0 -0.39245,-0.07331 -0.54984,-0.2307 -0.15739,-0.15739 -0.2307,-0.3321 -0.2307,-0.54984 v -5.8 c 0,-0.21774 0.07331,-0.39245 0.2307,-0.54984 0.15739,-0.15739 0.3321,-0.2307 0.54984,-0.2307 h 5.8 m -12,0 c 0.21774,0 0.39245,0.07331 0.54984,0.2307 0.15739,0.15739 0.2307,0.3321 0.2307,0.54984 v 5.8 c 0,0.21774 -0.07331,0.39245 -0.2307,0.54984 -0.12074,0.12074 -0.38281,0.2307 -0.54984,0.2307 h -5.8 c -0.21774,0 -0.39245,-0.07331 -0.54984,-0.2307 -0.15739,-0.15739 -0.2307,-0.3321 -0.2307,-0.54984 v -5.8 c 0,-0.21774 0.07331,-0.39245 0.2307,-0.54984 0.15739,-0.15739 0.3321,-0.2307 0.54984,-0.2307 h 5.8 m -12,0 c 0.21774,0 0.39245,0.07331 0.54984,0.2307 0.15739,0.15739 0.2307,0.3321 0.2307,0.54984 v 5.8 c 0,0.21774 -0.07331,0.39245 -0.2307,0.54984 C 8.1791,26.7483 7.91703,26.85826 7.75,26.85826 h -5.8 c -0.21774,0 -0.39245,-0.07331 -0.54984,-0.2307 -0.15739,-0.15739 -0.2307,-0.3321 -0.2307,-0.54984 v -5.8 c 0,-0.21774 0.07331,-0.39245 0.2307,-0.54984 0.15739,-0.15739 0.3321,-0.2307 0.54984,-0.2307 h 5.8 m 24,10.8 c 0.21774,0 0.39245,0.07331 0.54984,0.2307 0.15739,0.15739 0.2307,0.3321 0.2307,0.54984 v 5.8 c 0,0.21774 -0.07331,0.39245 -0.2307,0.54984 -0.12074,0.12074 -0.38281,0.2307 -0.54984,0.2307 h -5.8 c -0.21774,0 -0.39245,-0.07331 -0.54984,-0.2307 -0.15739,-0.15739 -0.2307,-0.3321 -0.2307,-0.54984 v -5.8 c 0,-0.21774 0.07331,-0.39245 0.2307,-0.54984 0.15739,-0.15739 0.3321,-0.2307 0.54984,-0.2307 h 5.8 m -12,0 c 0.21774,0 0.39245,0.07331 0.54984,0.2307 0.15739,0.15739 0.2307,0.3321 0.2307,0.54984 v 5.8 c 0,0.21774 -0.07331,0.39245 -0.2307,0.54984 -0.12074,0.12074 -0.38281,0.2307 -0.54984,0.2307 h -5.8 c -0.21774,0 -0.39245,-0.07331 -0.54984,-0.2307 -0.15739,-0.15739 -0.2307,-0.3321 -0.2307,-0.54984 v -5.8 c 0,-0.21774 0.07331,-0.39245 0.2307,-0.54984 0.15739,-0.15739 0.3321,-0.2307 0.54984,-0.2307 h 5.8 m -12,0 c 0.21774,0 0.39245,0.07331 0.54984,0.2307 0.15739,0.15739 0.2307,0.3321 0.2307,0.54984 v 5.8 c 0,0.21774 -0.07331,0.39245 -0.2307,0.54984 C 8.1791,37.5483 7.91703,37.65826 7.75,37.65826 h -5.8 c -0.21774,0 -0.39245,-0.07331 -0.54984,-0.2307 -0.15739,-0.15739 -0.2307,-0.3321 -0.2307,-0.54984 v -5.8 c 0,-0.21774 0.07331,-0.39245 0.2307,-0.54984 0.15739,-0.15739 0.3321,-0.2307 0.54984,-0.2307 h 5.8 m 24,-11.71946 h -5.8 c -0.5,0 -0.9,0.2 -1.2,0.5 -0.3,0.3 -0.5,0.7 -0.5,1.2 v 5.8 c 0,0.5 0.2,0.9 0.5,1.2 0.3,0.3 0.7,0.5 1.2,0.5 h 5.8 c 0.4,0 0.9,-0.2 1.2,-0.5 0.3,-0.3 0.5,-0.7 0.5,-1.2 v -5.8 c 0,-0.5 -0.2,-0.9 -0.5,-1.2 -0.3,-0.3 -0.7,-0.5 -1.2,-0.5 z m -12,0 h -5.8 c -0.5,0 -0.9,0.2 -1.2,0.5 -0.3,0.3 -0.5,0.7 -0.5,1.2 v 5.8 c 0,0.5 0.2,0.9 0.5,1.2 0.3,0.3 0.7,0.5 1.2,0.5 h 5.8 c 0.4,0 0.9,-0.2 1.2,-0.5 0.3,-0.3 0.5,-0.7 0.5,-1.2 v -5.8 c 0,-0.5 -0.2,-0.9 -0.5,-1.2 -0.3,-0.3 -0.7,-0.5 -1.2,-0.5 z m -12,0 h -5.8 c -0.5,0 -0.9,0.2 -1.2,0.5 -0.3,0.3 -0.5,0.7 -0.5,1.2 v 5.8 c 0,0.5 0.2,0.9 0.5,1.2 0.3,0.3 0.7,0.5 1.2,0.5 h 5.8 c 0.4,0 0.9,-0.2 1.2,-0.5 0.3,-0.3 0.5,-0.7 0.5,-1.2 v -5.8 c 0,-0.5 -0.2,-0.9 -0.5,-1.2 -0.3,-0.3 -0.7,-0.5 -1.2,-0.5 z m 24,10.8 h -5.8 c -0.5,0 -0.9,0.2 -1.2,0.5 -0.3,0.3 -0.5,0.7 -0.5,1.2 v 5.8 c 0,0.5 0.2,0.9 0.5,1.2 0.3,0.3 0.7,0.5 1.2,0.5 h 5.8 c 0.4,0 0.9,-0.2 1.2,-0.5 0.3,-0.3 0.5,-0.7 0.5,-1.2 v -5.8 c 0,-0.5 -0.2,-0.9 -0.5,-1.2 -0.3,-0.3 -0.7,-0.5 -1.2,-0.5 z m -12,0 h -5.8 c -0.5,0 -0.9,0.2 -1.2,0.5 -0.3,0.3 -0.5,0.7 -0.5,1.2 v 5.8 c 0,0.5 0.2,0.9 0.5,1.2 0.3,0.3 0.7,0.5 1.2,0.5 h 5.8 c 0.4,0 0.9,-0.2 1.2,-0.5 0.3,-0.3 0.5,-0.7 0.5,-1.2 v -5.8 c 0,-0.5 -0.2,-0.9 -0.5,-1.2 -0.3,-0.3 -0.7,-0.5 -1.2,-0.5 z m -12,0 h -5.8 c -0.5,0 -0.9,0.2 -1.2,0.5 -0.3,0.3 -0.5,0.7 -0.5,1.2 v 5.8 c 0,0.5 0.2,0.9 0.5,1.2 0.3,0.3 0.7,0.5 1.2,0.5 h 5.8 c 0.4,0 0.9,-0.2 1.2,-0.5 0.3,-0.3 0.5,-0.7 0.5,-1.2 v -5.8 c 0,-0.5 -0.2,-0.9 -0.5,-1.2 -0.3,-0.3 -0.7,-0.5 -1.2,-0.5 z" />
  </g>
  `
]
export const rest = [
  '49.999998 39.999999',
  `
  <!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs49" />
   <g
     id="g318"
     transform="matrix(0.98893229,0,0,0.98893229,5.3944619,0.3944668)">
    <path
       id="path6"
       d="m 13.60029,13.87419 c 0.32014,-0.82167 0.76638,-1.53168 1.3396,-2.13326 0.57518,-0.60443 1.26879,-1.07296 2.08083,-1.40862 0.81096,-0.33958 1.71806,-0.50741 2.722,-0.50741 1.29501,0 2.37565,0.17746 3.24297,0.53452 0.86625,0.35599 1.56379,0.79937 2.09349,1.32712 0.52864,0.5297 0.90799,1.10007 1.13592,1.70932 0.22704,0.6121 0.34154,1.18354 0.34154,1.71128 0,0.8741 -0.1145,1.59571 -0.34154,2.16126 -0.22793,0.56555 -0.51116,1.04871 -0.84878,1.45018 -0.33851,0.40165 -0.71109,0.74408 -1.12237,1.02641 -0.40932,0.28322 -0.79741,0.56555 -1.16214,0.84878 -0.36473,0.28233 -0.68879,0.60533 -0.97113,0.97005 -0.28322,0.36384 -0.46175,0.8206 -0.53345,1.36689 v 1.03997 h -3.69402 v -1.23205 c 0.0544,-0.78386 0.20564,-1.43966 0.45105,-1.96829 0.24648,-0.52864 0.53345,-0.98075 0.86144,-1.35512 0.32888,-0.37258 0.67524,-0.69753 1.04086,-0.97113 0.36384,-0.27448 0.70039,-0.54807 1.01179,-0.81881 0.30855,-0.27555 0.56074,-0.57519 0.75282,-0.90406 0.19101,-0.32692 0.27752,-0.74016 0.25897,-1.23205 0,-0.83914 -0.20475,-1.45892 -0.61603,-1.85967 -0.40932,-0.40254 -0.97969,-0.60247 -1.71021,-0.60247 -0.49189,0 -0.91566,0.09506 -1.27183,0.28626 -0.35617,0.19119 -0.64706,0.4482 -0.87588,0.76727 -0.22793,0.32014 -0.39683,0.6945 -0.50545,1.12148 -0.10969,0.43072 -0.16391,0.88855 -0.16391,1.38329 H 13.095 c 0.0173,-0.98736 0.18513,-1.88857 0.50527,-2.71112 z m 7.97696,12.04984 v 3.62072 h -3.69339 v -3.62072 z" />
    <path
       style="stroke-miterlimit: 10; stroke-width: .5px;"
       d="M 19.82471,39.3999 C 9.03125,39.3999 0.25,30.61865 0.25,19.82471 0.25,9.03077 9.03125,0.25 19.82471,0.25 c 10.79346,0 19.5752,8.78125 19.5752,19.57471 0,10.79346 -8.78125,19.5752 -19.5752,19.5752 z m 0,-38.00049 c -10.15967,0 -18.4253,8.26563 -18.4253,18.4253 0,10.15967 8.26562,18.4248 18.42529,18.4248 10.15967,0 18.4248,-8.26465 18.4248,-18.4248 0,-10.16015 -8.26464,-18.4253 -18.42479,-18.4253 z"
       id="path153" />
  </g>
  `
]
export const trafo = [
  '50.000002 40.000001',
  `
  <!-- Generator: Adobe Illustrator 23.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<defs
   id="defs15" />
<style
   type="text/css"
   id="style2">
	.st0{fill:#9DBF26;}
</style>
<switch
   id="switch10"
   transform="matrix(0.42477181,0,0,0.42477181,-35.043619,-40.256005)"
   style="fill:#87be22;fill-opacity:1">
	<g
   i:extraneous="self"
   id="g8"
   style="fill:#87be22;fill-opacity:1">
		<g
   id="g6"
   style="fill:#87be22;fill-opacity:1">
			<path
   class="st0"
   d="m 171.04,139.24 v -5.2 h 15.67 v -2.5 h -4.79 v -5.22 h -2.5 v 0.15 c -2.92,0.18 -5.72,0.22 -8.38,0.13 v -7.53 h -2.5 v 7.4 c -19.69,-1.28 -32.05,-9.43 -38.69,-15.56 v -1.97 h -2.02 c -1.19,-1.24 -2.11,-2.32 -2.78,-3.17 v -2.05 h -2.5 v 5.22 h -8.38 V 96.46 h -2.5 v 12.47 h -4.52 c -1.95,-1.84 -3.2,-3.36 -3.86,-4.22 v -0.99 h -2.5 v 5.22 H 96 v 2.5 h 12.11 c 1.05,0.89 2.23,1.83 3.56,2.79 v 2.41 H 96 v 2.5 h 15.67 v 45.51 h 2.5 v -45.51 h 5.59 c 8.3,4.22 20.38,8.11 37.89,8.43 v 3.97 h -4.79 v 2.5 h 15.67 v 5.2 h -15.67 v 2.5 h 15.67 v 45.51 h 2.5 v -45.51 h 15.67 v -2.5 z m -56.87,-23.32 c 0.22,0.14 0.42,0.28 0.65,0.42 0.16,0.1 0.33,0.2 0.49,0.3 h -1.14 z m -8.78,-6.98 h -2.1 v -2.25 c 0.55,0.63 1.25,1.4 2.1,2.25 z m 6.28,2.5 v 1.27 c -0.58,-0.43 -1.13,-0.85 -1.65,-1.27 z m 14.53,-2.5 h -1.15 v -1.27 c 0.35,0.39 0.73,0.81 1.15,1.27 z m 31.92,17.38 h -0.22 c -15.23,-0.26 -26.71,-3.36 -35.15,-7.18 h 7.1 v -2.5 h -12.06 c -1.3,-0.73 -2.5,-1.46 -3.61,-2.19 v -3.01 h 14.54 c 5.54,5.15 15.05,11.81 29.4,14.88 z m 10.42,5.22 h -8.38 v -4.82 c 2.64,0.48 5.44,0.83 8.38,1.05 z m 2.5,0 v -3.62 c 1.14,0.05 2.29,0.08 3.48,0.08 1.74,0 3.23,-0.1 4.9,-0.24 v 3.78 z"
   id="path4"
   style="fill:#87be22;fill-opacity:1" />
		</g>
	</g>
</switch>
  `
]
export const user = [
  '50 40',
  `
  <defs
     id="defs7" />
  
  <g
     id="g829"
     transform="matrix(1.0144476,0,0,1.0144476,4.8904277,0.93007818)">
    <path
       style="fill-opacity:1;stroke-miterlimit: 10; stroke-width: .5px;"
       d="M 5.14329,37.34667 5.14153,20.18016 c 0.08044,-0.6679 0.7364,-1.00029 1.29857,-0.60688 0.0768,0.05375 0.3088,0.31588 0.3088,0.37926 v 15.67383 l 0.11469,0.11469 h 8.06629 V 25.11344 h 9.78659 v 10.62762 h 8.06629 l 0.11469,-0.11469 v -14.8328 c 0,-0.02027 0.16354,-0.30354 0.20906,-0.34741 0.51246,-0.49384 1.36878,-0.13737 1.39648,0.57686 l 8e-5,16.32364 H 23.11087 L 22.99618,26.71904 H 16.65019 L 16.5355,37.34666 H 5.14329 Z"
       id="path152" />
    <path
       style="fill-opacity:1;stroke-miterlimit: 10; stroke-width: .5px;"
       d="m 39.39635,19.14973 v 0.45875 c -0.2989,0.66943 -0.95031,0.81513 -1.48911,0.30401 C 32.08541,14.51053 26.55995,8.75998 20.70446,3.39743 20.59221,3.29463 19.85371,2.63023 19.79544,2.6404 L 1.78008,19.877 C 1.23837,20.41441 0.56625,20.31101 0.25,19.60848 V 19.14973 L 19.85091,0.34667 39.39635,19.14974 Z"
       id="path154" />
    <path
       style="fill-opacity:1;stroke-miterlimit: 10; stroke-width: .5px;"
       d="m 32.89744,3.09362 v 6.61359 c 0,0.33284 -0.46541,0.7177 -0.80452,0.7319 -0.36546,0.0153 -0.87755,-0.36332 -0.87755,-0.7319 V 4.69923 h -5.1609 c -0.31775,0 -0.52535,-0.58831 -0.5005,-0.87941 0.02236,-0.26196 0.32525,-0.7262 0.57696,-0.7262 z"
       id="path156" />
  </g>
  `
]
export const wallboxPlugged = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     id="g8086">
    <circle
       style="clip-rule:evenodd;fill:none;fill-rule:evenodd;stroke-width:0.048949;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       class="svg-dashboard-background"
       cx="5.036613"
       cy="24.807751"
       r="0.52538627"
       id="circle4298" />
    <g
       id="g12091"
       transform="matrix(0.06227178,0,0,0.06227178,0.09128791,-10.486419)"
       style="clip-rule:evenodd;fill:inherit;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision">
      <g
         id="g8448"
         transform="matrix(0.82963076,0,0,0.82963076,43.017454,-537.38326)">
        <g
           id="g1328"
           transform="matrix(4.3890375,0,0,4.3890375,-649.37502,0.03065548)">
          <g
             id="g1320">
            <path
               id="GridInput_Icon-3"
               style="clip-rule:evenodd;fill:inherit;stroke:none;fill-rule:nonzero;stroke-width:3;stroke-dasharray:none;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
               class="svg-dashboard-background"
               d="m 285.41207,234.61359 v 87.77953 h 57.55842 v -87.77953 z m 6.77931,6.77953 h 43.99999 v 78 h -43.99999 z m 16.62407,17.88694 c -0.36868,0 -0.60688,0.11947 -0.84543,0.23875 -0.23856,0.11928 -0.35769,0.35779 -0.47697,0.59634 l -5.63841,22.934 c -0.11927,0.48795 -2.4e-4,0.84562 0.3576,1.08417 0.24939,0.23856 0.48759,0.35812 0.84542,0.35812 h 0.35812 l 11.28768,-2.76521 -5.51904,22.45703 c -0.11928,0.2494 9e-5,0.60688 0.11937,0.84543 0.11927,0.23856 0.35789,0.3577 0.71572,0.47697 h 0.3576 c 0.60724,0 0.96498,-0.23861 1.20354,-0.71572 l 15.00787,-32.18304 c 0.11928,-0.36868 0.23847,-0.84572 -0.11937,-1.20355 h 0.0103 c -0.24939,-0.23856 -0.48759,-0.3576 -0.84542,-0.3576 h -0.35812 l -11.04945,2.76469 4.80384,-12.84934 c 0.11928,-0.11927 0.11937,-0.35821 0.11937,-0.47749 0,-0.36867 -0.11957,-0.60688 -0.35812,-0.84543 -0.24941,-0.23856 -0.48811,-0.35812 -0.84594,-0.35812 z"
               inkscape:original-d="m 285.41207,234.61359 v 87.77953 h 57.55842 v -87.77953 z m 6.77931,6.77953 h 43.99999 v 78 h -43.99999 z m 16.62407,17.88694 c -0.36868,0 -0.60688,0.11947 -0.84543,0.23875 -0.23856,0.11928 -0.35769,0.35779 -0.47697,0.59634 l -5.63841,22.934 c -0.11927,0.48795 -2.4e-4,0.84562 0.3576,1.08417 0.24939,0.23856 0.48759,0.35812 0.84542,0.35812 h 0.35812 l 11.28768,-2.76521 -5.51904,22.45703 c -0.11928,0.2494 9e-5,0.60688 0.11937,0.84543 0.11927,0.23856 0.35789,0.3577 0.71572,0.47697 h 0.3576 c 0.60724,0 0.96498,-0.23861 1.20354,-0.71572 l 15.00787,-32.18304 c 0.11928,-0.36868 0.23847,-0.84572 -0.11937,-1.20355 h 0.0103 c -0.24939,-0.23856 -0.48759,-0.3576 -0.84542,-0.3576 h -0.35812 l -11.04945,2.76469 4.80384,-12.84934 c 0.11928,-0.11927 0.11937,-0.35821 0.11937,-0.47749 0,-0.36867 -0.11957,-0.60688 -0.35812,-0.84543 -0.24941,-0.23856 -0.48811,-0.35812 -0.84594,-0.35812 z"
               sodipodi:nodetypes="ccccccccccsscccscccscsccccscccscss" />
            <path
               style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
               id="rect355"
               width="72.288063"
               height="7.02315"
               x="-350.33539"
               y="320.91077"
               transform="scale(-1,1)"
               d="m -350.33539,320.91077 h 72.28806 v 7.02315 h -72.28806 z"
               sodipodi:type="rect" />
          </g>
          <g
             id="g1367"
             transform="matrix(-1,0,0,1,369.85621,179.44072)">
            <path
               id="path2861"
               inkscape:transform-center-x="-0.48253742"
               inkscape:transform-center-y="-0.18569867"
               d="m 110.56432,109.98032 -2.25347,6.11067 c 1.95893,-3.0358 -0.97607,1.18496 0.28623,1.52728 0.40737,0.11041 0.52805,-2.10725 2.4009,-4.17713 1.79047,-1.9789 5.8793,-0.67311 6.0333,-1.19043 l 0.70657,-2.37366 c -1.15806,-0.11483 -4.20585,-0.92892 -6.66797,-1.82101 -0.45743,1.02934 -1.50174,4.67407 -2.24086,6.60622 z"
               style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3.2667;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
               sodipodi:nodetypes="ccssscccc"
               inkscape:original-d="m 110.56432,109.98032 -2.25347,6.11067 c 1.95893,-3.0358 -0.97607,1.18496 0.28623,1.52728 0.40737,0.11041 0.52805,-2.10725 2.4009,-4.17713 1.79047,-1.9789 5.8793,-0.67311 6.0333,-1.19043 l 0.70657,-2.37366 c -1.15806,-0.11483 -4.20585,-0.92892 -6.66797,-1.82101 -0.45743,1.02934 -1.50174,4.67407 -2.24086,6.60622 z" />
            <path
               style="fill:none;stroke:inherit;stroke-width:2.5;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
               d="m 78.633311,127.53734 c 8.60448,0.11417 12.12384,7.02847 18.803605,6.39588 7.622214,-0.72184 10.840444,-16.14995 10.840444,-16.14995"
               id="path772"
               sodipodi:nodetypes="csc" />
          </g>
        </g>
      </g>
      <g
         id="g10370"
         transform="matrix(0.57550515,0,0,0.57550515,8.9079305,324.91701)">
        <path
           style="fill:none;stroke:inherit;stroke-width:30.2362;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
           d="M 144.72441,570.92913 H 69.133854 c 0,0 0.0403,-178.88889 0,-226.77165 -0.0454,-53.92715 34.015746,-90.70866 34.015746,-90.70866 0,0 -57.131136,-6.67226 -71.811016,-18.89764 -7.33994,-6.11269 -9.49298,-26.81335 0,-37.79528 9.49298,-10.98194 32.62709,-12.10485 56.69291,-11.33858 45.011886,1.4332 37.795276,34.53209 37.795276,34.53209 0,0 78.69,-167.487578 102.04724,-178.154138 38.06696,-17.38405 273.67577,-16.435 313.70079,0 39.09177,16.0518 102.04724,180.283468 102.04724,180.283468 0,0 -8.41313,-34.89097 37.79528,-36.66142 24.44337,-0.93653 49.84381,2.8128 56.69291,11.33858 9.38087,11.67733 7.76356,32.77177 0,37.79528 -12.51657,8.09901 -71.81102,18.89764 -71.81102,18.89764 0,0 34.42758,40.65681 34.01575,90.70866 -0.39003,47.40194 0,226.77165 0,226.77165 -25.54973,-0.0144 -39.23653,0.0632 -75.59055,0 -0.0132,-21.64458 -0.002,-60.13167 0,-75.59055 h 30.23622 -540.47245 30.23623 z"
           id="path7705"
           sodipodi:nodetypes="ccscszscsscssscsccccccc" />
        <path
           style="fill:none;stroke:inherit;stroke-width:30.2362;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
           d="m 281.23801,415.88947 207.07653,-0.33584"
           id="path7707" />
        <path
           style="fill:none;stroke:inherit;stroke-width:30.2362;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
           d="m 179.68538,226.99212 h 411.96851 c 0,0 -55.21954,-137.822528 -72.73944,-145.349498 -17.85734,-7.67194 -243.49246,-9.62677 -259.28843,0.65229 -14.30427,9.30835 -79.94064,144.697208 -79.94064,144.697208 z"
           id="path7713"
           sodipodi:nodetypes="ccssc" />
        <ellipse
           style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:34.2032;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:markers"
           id="path10013"
           cx="181.99602"
           cy="336.61871"
           rx="39.591309"
           ry="39.080318" />
        <ellipse
           style="fill:none;fill-opacity:1;stroke:inherit;stroke-width:34.2032;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:markers"
           id="path10013-3"
           cx="579.00861"
           cy="336.61871"
           rx="39.591309"
           ry="39.080318" />
      </g>
    </g>
  </g>
  `
]
export const wallboxUnplugged = [
  '50 40',
  `
  <defs
     id="defs13" />
  
  <g
     transform="matrix(0.07358277,0,0,0.07358277,9.9138551,0.99999877)"
     style="clip-rule:evenodd;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
     id="g5448">
    <circle
       style="clip-rule:evenodd;fill:none;fill-rule:evenodd;stroke-width:0.786055;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       class="svg-dashboard-background"
       cx="64.822495"
       cy="249.84024"
       r="8.4369879"
       id="circle4298" />
    <g
       id="g12704"
       transform="translate(-194.97722,-145.77635)">
      <g
         id="g10901"
         transform="matrix(5.6531358,0,0,5.6531358,-127.96311,-659.86111)">
        <path
           style="fill:none;stroke:inherit;stroke-width:2.74924;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
           d="m 68.361149,215.2975 c -7.86693,-0.0562 -7.80298,-10.06941 -7.80298,-10.06941 v -4.52493 -6.51003 c 0.0203,-4.32279 -0.0114,-5.91849 0,-7.91042 0,-1.10948 0,-5.26142 0,-3.32845 v -5.10828"
           id="path2847"
           sodipodi:nodetypes="ccccccc" />
        <path
           id="path2861"
           inkscape:transform-center-x="0.59666271"
           inkscape:transform-center-y="0.15996054"
           d="m 60.466619,170.47649 -0.41643,6.49961 c 1.0114,-3.46851 -0.59743,1.41419 0.71007,1.38214 0.42194,-0.0103 -0.0951,-2.17032 1.10937,-4.6885 1.15147,-2.40747 5.44291,-2.32251 5.44291,-2.86226 v -2.47659 c -1.14269,0.22034 -4.29607,0.30962 -6.91037,0.15706 -0.14475,1.11706 -0.10581,4.90825 -0.26296,6.97097 z"
           style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3.2667;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
           sodipodi:nodetypes="ccssscccc"
           inkscape:original-d="m 60.466619,170.47649 -0.41643,6.49961 c 1.0114,-3.46851 -0.59743,1.41419 0.71007,1.38214 0.42194,-0.0103 -0.0951,-2.17032 1.10937,-4.6885 1.15147,-2.40747 5.44291,-2.32251 5.44291,-2.86226 v -2.47659 c -1.14269,0.22034 -4.29607,0.30962 -6.91037,0.15706 -0.14475,1.11706 -0.10581,4.90825 -0.26296,6.97097 z" />
      </g>
      <g
         id="g1320"
         transform="matrix(5.4463561,0,0,5.4463561,-1311.198,-1132.0128)">
        <path
           id="GridInput_Icon-3-5"
           style="clip-rule:evenodd;fill:inherit;stroke:none;fill-rule:nonzero;stroke-width:3;stroke-dasharray:none;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
           class="svg-dashboard-background"
           d="m 285.41207,234.61359 v 87.77953 h 57.55842 v -87.77953 z m 6.77931,6.77953 h 43.99999 v 78 h -43.99999 z m 16.62407,17.88694 c -0.36868,0 -0.60688,0.11947 -0.84543,0.23875 -0.23856,0.11928 -0.35769,0.35779 -0.47697,0.59634 l -5.63841,22.934 c -0.11927,0.48795 -2.4e-4,0.84562 0.3576,1.08417 0.24939,0.23856 0.48759,0.35812 0.84542,0.35812 h 0.35812 l 11.28768,-2.76521 -5.51904,22.45703 c -0.11928,0.2494 9e-5,0.60688 0.11937,0.84543 0.11927,0.23856 0.35789,0.3577 0.71572,0.47697 h 0.3576 c 0.60724,0 0.96498,-0.23861 1.20354,-0.71572 l 15.00787,-32.18304 c 0.11928,-0.36868 0.23847,-0.84572 -0.11937,-1.20355 h 0.0103 c -0.24939,-0.23856 -0.48759,-0.3576 -0.84542,-0.3576 h -0.35812 l -11.04945,2.76469 4.80384,-12.84934 c 0.11928,-0.11927 0.11937,-0.35821 0.11937,-0.47749 0,-0.36867 -0.11957,-0.60688 -0.35812,-0.84543 -0.24941,-0.23856 -0.48811,-0.35812 -0.84594,-0.35812 z"
           inkscape:original-d="m 285.41207,234.61359 v 87.77953 h 57.55842 v -87.77953 z m 6.77931,6.77953 h 43.99999 v 78 h -43.99999 z m 16.62407,17.88694 c -0.36868,0 -0.60688,0.11947 -0.84543,0.23875 -0.23856,0.11928 -0.35769,0.35779 -0.47697,0.59634 l -5.63841,22.934 c -0.11927,0.48795 -2.4e-4,0.84562 0.3576,1.08417 0.24939,0.23856 0.48759,0.35812 0.84542,0.35812 h 0.35812 l 11.28768,-2.76521 -5.51904,22.45703 c -0.11928,0.2494 9e-5,0.60688 0.11937,0.84543 0.11927,0.23856 0.35789,0.3577 0.71572,0.47697 h 0.3576 c 0.60724,0 0.96498,-0.23861 1.20354,-0.71572 l 15.00787,-32.18304 c 0.11928,-0.36868 0.23847,-0.84572 -0.11937,-1.20355 h 0.0103 c -0.24939,-0.23856 -0.48759,-0.3576 -0.84542,-0.3576 h -0.35812 l -11.04945,2.76469 4.80384,-12.84934 c 0.11928,-0.11927 0.11937,-0.35821 0.11937,-0.47749 0,-0.36867 -0.11957,-0.60688 -0.35812,-0.84543 -0.24941,-0.23856 -0.48811,-0.35812 -0.84594,-0.35812 z"
           sodipodi:nodetypes="ccccccccccsscccscccscsccccscccscss" />
        <path
           style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
           id="rect355-3"
           width="72.288063"
           height="7.02315"
           x="-350.33539"
           y="320.91077"
           transform="scale(-1,1)"
           d="m -350.33539,320.91077 h 72.28806 v 7.02315 h -72.28806 z"
           sodipodi:type="rect" />
      </g>
    </g>
  </g>
  `
]
export const wallboxWarning = [
  '50 40',
  `
  <defs
     id="defs8142" />
  
  <g
     transform="matrix(0.0613994,0,0,0.0613994,4.2236859,0.99999951)"
     inkscape:label="#GridInput_Icon"
     style="clip-rule:evenodd;fill:inherit;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
     id="g8139">
    <circle
       style="clip-rule:evenodd;fill:none;fill-rule:evenodd;stroke-width:0.786055;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
       class="svg-dashboard-background"
       cx="64.822495"
       cy="249.84024"
       r="8.4369879"
       id="circle4298" />
    <g
       id="g12245"
       transform="translate(-76.12888,-43.305828)">
      <g
         id="g12024"
         transform="translate(159.65939,-2.6682392)">
        <g
           id="g10901"
           transform="matrix(5.653143,0,0,5.653143,-282.84318,-657.19362)">
          <path
             style="fill:none;stroke:inherit;stroke-width:2.74924;stroke-linecap:butt;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
             d="m 68.361149,215.2975 c -7.86693,-0.0562 -7.80298,-10.06941 -7.80298,-10.06941 v -4.52493 -6.51003 c 0.0203,-4.32279 -0.0114,-5.91849 0,-7.91042 0,-1.10948 0,-5.26142 0,-3.32845 v -5.10828"
             id="path2847"
             sodipodi:nodetypes="ccccccc" />
          <path
             id="path2861"
             inkscape:transform-center-x="0.59666271"
             inkscape:transform-center-y="0.15996054"
             d="m 60.290124,173.23122 -0.06984,1.09012 c -0.09394,1.46618 0.0093,2.64896 0.0042,2.76181 -6.98e-4,0.0155 -0.0013,0.0309 -0.0019,0.0463 -0.02684,0.74027 0.73073,0.60248 0.800461,-0.19301 0.02455,-0.28004 0.0597,-0.59311 0.11693,-0.93151 0.225303,-1.33227 1.309146,-3.38175 2.506767,-3.9593 1.64111,-0.79142 3.66578,-0.86742 3.66578,-1.23816 v -1.39882 c 0,-0.59523 -0.476448,-0.99596 -1.069542,-0.94844 -0.759084,0.0608 -1.739125,0.0974 -2.78482,0.10306 -1.688275,0.009 -3.146039,1.29111 -3.181245,2.97905 -0.02116,1.01436 -0.04268,2.10238 -0.08515,3.02565 -0.02265,0.49239 -0.02626,0.49046 0.0062,-0.004 l 0.08763,-1.33349 a 0.00225803,0.00225803 3.7127985 0 1 0.0045,3e-4 z"
             style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:3.2667;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers"
             sodipodi:nodetypes="ccssscccc" />
        </g>
        <g
           id="g12016">
          <path
             id="GridInput_Icon-3-5"
             style="clip-rule:evenodd;fill:inherit;stroke:none;fill-rule:nonzero;stroke-width:16.3391;stroke-dasharray:none;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision"
             class="svg-dashboard-background"
             d="m 113.73047,148.44531 a 10.893816,10.893816 0 0 0 -10.89453,10.89258 V 626.52344 H 416.32032 V 274.35352 l -36.92188,0.0137 v 324.94727 a 10.871373,10.871373 0 0 1 -10.87109,10.87109 H 153.9375 A 14.178329,14.178329 0 0 1 139.75977,596.00586 V 196.25391 a 10.884481,10.884481 0 0 1 10.88281,-10.88477 h 162.53906 l 21.29883,-36.92383 z m 116.56836,134.3418 c -2.00796,0 -3.30429,0.65114 -4.60352,1.30078 -1.29927,0.64965 -1.94801,1.94882 -2.59765,3.24805 l -30.70899,124.90625 c -0.64959,2.65755 -10e-4,4.60507 1.94727,5.9043 1.35827,1.29929 2.65659,1.95117 4.60547,1.95117 h 1.94922 l 61.47656,-15.06055 -30.05859,122.3086 c -0.64965,1.35833 7.5e-4,3.30624 0.65039,4.60547 0.64959,1.29928 1.94957,1.94807 3.89843,2.59765 h 1.94727 c 3.30725,0 5.25541,-1.29992 6.55469,-3.89844 L 327.09766,355.3711 c 0.64964,-2.00796 1.29854,-4.60777 -0.65039,-6.55664 h 0.0566 c -1.35827,-1.29928 -2.65465,-1.94727 -4.60352,-1.94727 h -1.95117 l -60.17969,15.05859 26.16407,-69.98242 c 0.64963,-0.64959 0.65039,-1.95192 0.65039,-2.60156 0,-2.00792 -0.65195,-3.30429 -1.95118,-4.60352 -1.35836,-1.29929 -2.65855,-1.95117 -4.60742,-1.95117 z" />
          <path
             id="rect355-3"
             d="M 438.24177,618.45064 H 81.659726 A 18.934372,18.934372 0 0 0 62.72539,637.38498 19.584998,19.584998 0 0 0 82.575477,656.70127 H 437.45924 a 18.973133,18.973133 0 0 0 18.97317,-18.97317 v -1.08682 a 18.190641,18.190641 0 0 0 -18.19064,-18.19064 z"
             style="fill:inherit;fill-opacity:1;stroke:inherit;stroke-width:16.3391;stroke-linejoin:round;stroke-dasharray:none;paint-order:markers" />
        </g>
      </g>
      <g
         id="g11920"
         transform="translate(-85.44232,36.013631)">
        <path
           id="path7883"
           inkscape:transform-center-x="0.00019802826"
           inkscape:transform-center-y="-6.9424446"
           d="m 738.73212,222.50499 -191.37825,-0.003 c -21.69932,2.2e-4 -30.49446,-13.96844 -19.64461,-31.19942 L 623.40055,39.333193 c 10.84984,-17.230978 28.44064,-17.230763 39.29004,4.56e-4 l 95.68697,151.971901 c 10.8494,17.23123 2.05388,31.1997 -19.64544,31.19944 z"
           style="fill:none;stroke:#c2002d;stroke-width:38.2358;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:markers" />
        <g
           id="g11914">
          <path
             style="fill:none;stroke:#c2002d;stroke-width:30.2362;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none;stroke-opacity:1"
             d="M 643.04321,88.247788 V 140.33155"
             id="path8302"
             sodipodi:nodetypes="cc" />
          <circle
             id="path11832"
             style="fill:#c2002d;fill-opacity:1;stroke:#c2002d;stroke-width:0;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none;stroke-opacity:1;paint-order:normal"
             cx="643.04321"
             cy="178.65967"
             r="15.118108" />
        </g>
      </g>
    </g>
  </g>
  `
]
